import { GroupUserRoleEnum, isPrimaryGroupUserRole, PaymentAlertEnum } from '../../app/react/types/customers';
import { EChargeInnerStep } from '../../app/react/types/payment';
import {
	ActivityEnum,
	AttendanceEntityTypeEnum,
	AvailabilityStatusEnum,
	CART_ERROR_CODES,
	CartItemDescriptionEnum,
	CustomerInMembershipTypeEnum,
	CustomerTypeEnum,
	DiscountMethodsEnum,
	EmployeeStatus,
	FeeTypeEnum,
	FilterGroupEnum,
	FuturePaymentStatusEnum,
	GenderEnum,
	GlResourceTypeEnum,
	IdAndNameDto,
	InvalidResourceDto,
	InvalidResourceReasonsEnum,
	LinkedAccountStatus,
	MaintenanceTimingEnum,
	MembershipStatusEnum,
	MembershipTypeEnum,
	MetaTypeEnum,
	OnlineBookingViewsEnum,
	ParticipantRegistrationValidationEnum,
	PaymentMethodTypeEnum,
	PaymentStatusEnum,
	PriceDto,
	ProblematicSlotDto,
	Product,
	ProductSubTypesEnum,
	RequiredProductDto,
	ProductTypesEnum,
	ProgramTypesEnum,
	PublishingStatusEnum,
	ReservationExtendedEnum,
	ReservationStatusEnum,
	ReservationTypeEnum,
	ResourceNameTypeEnum,
	ResourceSubTypeEnum,
	ResourceTypeEnum,
	SlotNotesFilterEnum,
	SlotTypeEnum,
	SportsEnum,
	TippingModeEnum,
	PlatformsEnum,
	AuditActionNameEnum,
	AuditActionTypeEnum,
	AuditActorTypeEnum,
	AuditAreaEnum,
	AuditActionDetailsResponseDto,
} from '@bondsports/types';
import { BAY_RESOURCE_SUB_TYPE } from '../../app/react/types/bayResourceSubType';
import { EXTERNAL_VALIDATION_TERMS_TYPE } from '../../app/react/types/entitlementGroupExternalValidation';
import { BooleanString, CustomPaymentPlanAllocationEnum, DayPickerEnum } from '../../app/react/types/enums';
import { DisplayRoleEnum } from '../../app/react/types/orders';
import {
	capitalizeFirstLetter,
	CHARACHERS,
	CurrencySymbolEnum,
	formatStreet,
	formatTransactionFee,
	IOption,
	Pricify,
	TagColorsMapper,
} from '@bondsports/utils';
import { capitalize, groupBy, memoize, round, upperFirst } from 'lodash';
import { EDateTimeFormats } from '../../app/react/types/times';
import { formatDate, formatToDayAndTime, setTimezone } from '../../app/react/lib/dates';
import { MorMenuEnum } from '@app/react/components/settings/PromoCodes/types/enums';
import {
	CATEGORIES_PATH,
	PORTALS_PATH,
	RENTAL_PRODUCTS_PATH,
	RESERVATIONS_PATH,
} from '@app/react/pages/reservations/utils/paths';
import { PASSES_LIST_PATH } from '@app/react/pages/rentals/paths';
import {
	ACCOUNTING_CODES_PATH,
	ACCOUNTING_CODES_PROFILE_PATH,
	ORG_BANK_ACCOUNTS_PATH,
	CONVERSION_ANALYTICS_PATH,
	EMPLOYEES_ACCOUNTS_PATH,
	ENTITLEMENT_GROUPS_PATH,
	FACILITIES_PATH,
	MANAGE_PAYMENT_METHODS_PATH,
	ORGANIZATION_PATH,
	PROMO_CODES_PATH,
	RECONCILIATION_PATH,
	ROLES_MANAGEMENT_PATH,
	SCANNERS_AUDIO_PATH,
	SCANNERS_TEST_PATH,
	SPACES_PATH,
	TAXES_PATH,
	TAXES_PROFILE_PATH,
} from '@app/react/pages/settings/paths';
import { INSTRUCTORS_PAGE } from '@app/react/components/settings/Instructors/paths';
import { RowActionsEnum } from '@app/react/components/settings/Instructors/types';
import { EmployeeFieldsEnum } from '@app/react/components/settings/InstructorsProfile/components/MainDetails/types';
import { RowMangePaymenMethodActionsEnum } from '@app/react/components/customers/ManagePaymentMethods/types';
import { CURRENT_PAGE, SUPPORT_EMAIL } from '@app/react/lib/constants';
import { RESERVATIONS_LABELS } from '@app/react/pages/reservations/utils/types';
import {
	DateTimeFormats,
	errorCode as dateTimeErrorCodes,
	format24HToAmPm,
	isValidDate,
	TimeUnit,
	formatDate as formatDateBondTimePackage,
} from '@bondsports/date-time';
import dayjs from 'dayjs';
import { AdditionalStatusesEnum } from '@app/react/types/rentalProduct';
import { CommerceProductInventoryFilterStatusEnum } from '@bondsports/types';
import { DurationMinutesEnum } from '@app/react/types/duration';
import { VisibilityEnum } from '@app/react/components/calendar/newReservation/NewReservationTypes';
import { MoreMenuEnumEmployee } from '@app/react/components/settings/EmployeesAccounts/types/enums';
import { MoreMenuEnumRole } from '@app/react/components/settings/RolesManagement/types/enums';
import { SETTINGS_TABS } from '@app/react/components/settings/types';
import { toFixed } from '@bondsports/general';
import {
	ParticipantsTabs,
	SignWaiverEnum,
} from '@app/react/components/activites/session/participants/participants/types/enums';
import { SectionToEditEnum } from '@app/react/types/NewReservation';
import { MEMBERSHIPS_PATH } from '../../app/react/pages/membership/hooks/path';
import { COMMERCE_KIOSK_PATH, PRODUCTS_MANAGE_PATH } from '../../app/react/pages/commerce/utils/paths';
import { MembershipRenewalTypeEnum } from '../../app/react/pages/membership/types/enums';
import { DeleteType } from '@app/react/components/shared/RemoveFromReservation/components/enums';
import { WaitlistColumnDef } from '@app/react/components/activites/session/participants/waitlist/types/types';
import { QueryParamsErrorCodesEnum } from 'auth';
import { ECalendarMode } from '@app/react/stores/calendarStore';
import { ProductType } from '@app/react/components/activites/session/types/enum';
import { RegistrationStatusEnum } from '../../app/react/types/session';
import { OrganizationTaxesTabsEnum } from '@app/react/components/settings/OrganizationTaxes/types/enums';
import { getCustomerPagePath } from '@app/react/lib/paths';
import { SessionRegistrationFlowEnum } from '@app/react/components/activites/session/products/purchase/types/enums';
import {
	IAddonWithQuantity,
	IResourceFieldTypes,
} from '@app/react/components/activites/shared/PurchaseSummaryStep/types';
import { TerminalPaymentMethodCaptureEnum } from '@app/react/types/organization';
import { FloatingPanelToneEnum, formatPercentage } from 'ui';
const SPORTS_MAP: Record<SportsEnum, string> = {
	1: 'Softball',
	2: 'Basketball',
	3: 'Football',
	4: 'Soccer',
	5: 'Bowling',
	6: 'Bocceball',
	7: 'Cornhole',
	8: 'Dodgeball',
	9: 'Frisbee',
	10: 'Hockey',
	11: 'Kickball',
	12: 'Lacrosse',
	13: 'Pingpong',
	14: 'Rugby',
	15: 'Skeeball',
	16: 'Tennis',
	17: 'Volleyball',
	18: 'Wiffleball',
	19: 'Badminton',
	20: 'Fitness',
	21: 'Golf',
	22: 'Pilates',
	23: 'Running',
	24: 'Skiing',
	25: 'Snowboarding',
	26: 'Yoga',
	27: 'Broomball',
	28: 'Cricket',
	29: 'Crossfit',
	30: 'Cycling',
	31: 'Field Hockey',
	32: 'Racquetball',
	33: 'Spinning',
	34: 'Squash',
	35: 'Surfing',
	36: 'Swimming',
	37: 'Wind Surfing',
	38: 'Adventure',
	39: 'Boxing',
	40: 'Baseball',
	41: 'Dance',
	42: 'Kickboxing',
	43: 'Martial Arts',
	44: 'Outdoors',
	45: 'Rowing',
	46: 'Sailing',
	47: 'Sup',
	48: 'Triathlon',
	49: 'Handball',
	50: 'Catchball',
	51: 'Blitzball',
	52: 'Roller Derby',
	53: 'Ice Skating',
	54: 'Pickleball',
	55: 'Axe-throwing',
	56: 'Futsal',
	57: 'Birthday',
	58: 'Corporate Events',
	59: 'Curling',
	60: 'Gymnastics',
	61: 'Figure Skating',
	62: 'Cheer',
	63: 'Ninja & Parkour',
	999: 'Other',
};

const SPACE_SUB_RESOURCE_TYPE_MAP: Record<ResourceSubTypeEnum, string> & Record<typeof BAY_RESOURCE_SUB_TYPE, string> = {
	[ResourceSubTypeEnum.COURT]: 'court',
	[ResourceSubTypeEnum.FIELD]: 'field',
	[ResourceSubTypeEnum.ROOM]: 'room',
	[ResourceSubTypeEnum.DIAMOND]: 'diamond',
	[ResourceSubTypeEnum.RINK]: 'rink',
	[ResourceSubTypeEnum.STUDIO]: 'studio',
	[ResourceSubTypeEnum.POOL]: 'pool',
	[ResourceSubTypeEnum.BATTING_CAGE]: 'batting cage',
	[ResourceSubTypeEnum.SHELTER]: 'shelter',
	[ResourceSubTypeEnum.GOLF_SIMULATOR]: 'golf simulator',
	[ResourceSubTypeEnum.BAY]: 'bay',
};

const AUDIT_ENTITY_TYPE_LABELS: Record<ResourceNameTypeEnum, string> = {
	[ResourceNameTypeEnum.EVENT]: 'Event',
	[ResourceNameTypeEnum.VENUE]: 'Venue',
	[ResourceNameTypeEnum.TEAM]: 'Team',
	[ResourceNameTypeEnum.LEAGUE]: 'League',
	[ResourceNameTypeEnum.USER]: 'User',
	[ResourceNameTypeEnum.ORGANIZATION]: 'Organization',
	[ResourceNameTypeEnum.APP]: 'App',
	[ResourceNameTypeEnum.FEED]: 'Feed',
	[ResourceNameTypeEnum.MATCH]: 'Match',
	[ResourceNameTypeEnum.ROUND]: 'Round',
	[ResourceNameTypeEnum.PORTAL]: 'Portal',
	[ResourceNameTypeEnum.LEAGUE_SEASON]: 'Season',
	[ResourceNameTypeEnum.TOURNAMENT]: 'Tournament',
	[ResourceNameTypeEnum.MEMBERSHIP]: 'Membership',
	[ResourceNameTypeEnum.DIVISION]: 'Division',
	[ResourceNameTypeEnum.GAMESLOT]: 'Game slot',
	[ResourceNameTypeEnum.SPACE]: 'Space',
	[ResourceNameTypeEnum.RESERVATION]: 'Reservation',
	[ResourceNameTypeEnum.INVOICE]: 'Invoice',
	[ResourceNameTypeEnum.CUSTOMER]: 'Customer',
	[ResourceNameTypeEnum.PACKAGE]: 'Package',
	[ResourceNameTypeEnum.FACILITY]: 'Facility',
	[ResourceNameTypeEnum.PROGRAM]: 'Program',
	[ResourceNameTypeEnum.PROGRAM_SEASON]: 'Program season',
	[ResourceNameTypeEnum.PRODUCT]: 'Product',
	[ResourceNameTypeEnum.GROUP]: 'Group',
	[ResourceNameTypeEnum.VARIANT]: 'Variant',
	[ResourceNameTypeEnum.SLOT]: 'Slot',
	[ResourceNameTypeEnum.ADDON]: 'Add-on',
	[ResourceNameTypeEnum.GOODS]: 'Goods',
	[ResourceNameTypeEnum.FEE]: 'Fee',
	[ResourceNameTypeEnum.PAYMENT_METHOD]: 'Payment method',
	[ResourceNameTypeEnum.DISCOUNT]: 'Discount',
	[ResourceNameTypeEnum.ACTIVITY]: 'Activity',
	[ResourceNameTypeEnum.PROGRAM_TYPE]: 'Program type',
	[ResourceNameTypeEnum.TAX]: 'Tax',
	[ResourceNameTypeEnum.PUNCH_PASS]: 'Punch pass',
	[ResourceNameTypeEnum.APPLICATION]: 'Application',
	[ResourceNameTypeEnum.INSTRUCTOR]: 'Instructor',
	[ResourceNameTypeEnum.PRICE]: 'Price',
	[ResourceNameTypeEnum.SEGMENT]: 'Segment',
	[ResourceNameTypeEnum.EMPLOYEE]: 'Employee',
	[ResourceNameTypeEnum.ROLE]: 'Role',
};

export const MEMBERSHIP_TYPE_LABELS = {
	[MembershipTypeEnum.FIXED]: 'Fixed',
	[MembershipTypeEnum.ROLLING]: 'Rolling',
};

export const TIME_UNIT_LABELS = {
	[TimeUnit.DAY]: 'Daily',
	[TimeUnit.WEEK]: 'Weekly',
	[TimeUnit.MONTH]: 'Monthly',
	[TimeUnit.YEAR]: 'Yearly',
};

export const TIME_UNITS = {
	[TimeUnit.DAY]: 'day',
	[TimeUnit.WEEK]: 'week',
	[TimeUnit.MONTH]: 'month',
	[TimeUnit.YEAR]: 'year',
};

const AUDIT_ACTION_TYPE_LABELS: Record<AuditActionTypeEnum, string> = {
	[AuditActionTypeEnum.CREATE]: 'Created',
	[AuditActionTypeEnum.UPDATE]: 'Updated',
	[AuditActionTypeEnum.MASS_EDIT]: 'Mass edited',
	[AuditActionTypeEnum.DELETE]: 'Deleted',
	[AuditActionTypeEnum.CANCEL]: 'Canceled',
	[AuditActionTypeEnum.ARCHIVE]: 'Archived',
	[AuditActionTypeEnum.REFUND]: 'Refunded',
	[AuditActionTypeEnum.PURCHASE]: 'Purchased',
	[AuditActionTypeEnum.VOID]: 'Voided',
};

const INVENTORY_STATUS_LABEL_SEPARATOR = ': ';

const GENDER_MAP = {
	[GenderEnum.OTHER]: 'Gender Neutral',
	[GenderEnum.MALE]: 'Male',
	[GenderEnum.FEMALE]: 'Female',
};

const getEnvironmentLabel = (): string | null => {
	if (typeof window === 'undefined') return null;

	// Production builds - no label
	if (process.env.PRODUCTION === 'true') return null;

	const host = window.location.hostname;

	// Production URL - no label
	if (host === 'backoffice.bondsports.co') return null;

	// Netlify deploy previews: deploy-preview-{PR#}--{branch}.netlify.app
	// Example: deploy-preview-3196--squad-b-backoffice.netlify.app → "PR-3196 (squad-b)"
	const deployPreview = host.match(/^deploy-preview-(\d+)--(.+?)\.netlify\.app$/i);
	if (deployPreview) {
		const branch = deployPreview[2].replace(/-backoffice$/, '');
		return `PR-${deployPreview[1]} (${branch})`;
	}

	// Netlify branch deploys: {branch}.netlify.app or {branch}--{repo}.netlify.app
	// Example: squad-b-backoffice.netlify.app → "squad-b"
	const netlifyBranch = host.match(/^([^.]+?)(?:--[^.]+)?\.netlify\.app$/i);
	if (netlifyBranch) {
		return netlifyBranch[1].replace(/-backoffice$/, '');
	}

	// BondSports environments: backoffice.{env}.bondsports.co
	// Example: backoffice.dev.bondsports.co → "Dev"
	const subdomain = host.match(/^backoffice\.([^.]+)\.bondsports\.co$/i);
	if (subdomain) return capitalize(subdomain[1]);

	// Local development
	if (host.includes('.local') || host === 'localhost') return 'Local';

	return null;
};

export const SPOTS_MAP = {
	[SessionRegistrationFlowEnum.AVAILABLE]: 'Full',
	[SessionRegistrationFlowEnum.FULL]: 'Full',
	[SessionRegistrationFlowEnum.WAITLIST]: 'Waitlist',
};

export const TranslationEn = {
	nameConcat: (firstName: string, lastName: string) => `${firstName} ${lastName}`,
	appendText: (text: string, appendedText: string) => `${text} ${appendedText}`,
	lastNameFirstNameConcat: (lastName: string, firstName: string) => `${lastName}, ${firstName}`,
	isLoading: 'Loading...',
	loading: { title: 'Loading...', description: 'This may take a few moments, please be patient.' },
	more: 'more...',
	itemVoided: '-- Item voided --',
	genericError: 'Sorry, seems like something went wrong',
	errorLoadingPage: 'Error loading this page, Please contact Support.',
	common: {
		yes: 'Yes',
		no: 'No',
		all: 'All',
		actions: 'Actions',
		error: 'Error',
		comingSoonLower: 'Coming soon',
		somethingWentWrongFallback: 'Something went wrong !!!',
	},
	dates: {
		timeTypeOptions: {
			hours: 'Hours',
			days: 'Days',
			months: 'Months',
		},
		hoursRange: (from: string, to: string) => `${from} - ${to}`,
	},
	accessibility: {
		showMore: 'Show more',
		replaceCustomer: 'Replace customer',
		selectReceiptDeliveryMethod: 'Select receipt delivery method',
	},
	symbols: { percent: '%', dollar: '$' },
	wrongPathMessage: 'Oops,looks like wrong path',
	pageTitles: {
		appName: (() => {
			const env = getEnvironmentLabel();
			return env ? `Bond Sports [${env}]` : 'Bond Sports';
		})(),
		titleWithAppName: (title: string) => {
			const env = getEnvironmentLabel();
			return env ? `${title} - Bond Sports [${env}]` : `${title} - Bond Sports`;
		},
		calendar: 'Calendar',
		rentals: 'Rentals',
		programs: 'Programs',
		customers: 'Customers',
		memberships: 'Memberships',
		communications: 'Communications',
		settings: 'Settings',
		forms: 'Forms',
		commerce: 'Commerce',
		billing: 'Billing',
	},
	facilityAccess: {
		urlBlocked: {
			mainLabel: 'This content belongs to a facility outside of your current access.',
			subLabel: 'Please contact your manager if you need to view information for this location.',
		},
		disabledTooltip: 'This setting is only available to users with access to all facilities.',
		modificationsDisabledTooltip: 'Modifications are only available to users with access to all facilities.',
		unknownFacility: 'Other Facility',
	},
	dataGridCommonColumnHeaders: {
		reservationStatus: 'Status',
		actions: 'Actions',
	},
	billing: {
		title: 'Billing',
		breadcrumbs: [{ label: 'Billing', to: '/client/billing' }],
		tabs: {
			invoices: 'Invoices',
		},
		invoices: {
			table: {
				subject: 'invoices',
				loadingMessage: 'Loading invoices...',
				noDataMessage: 'No invoices found',
				errorMessage: 'Unable to load invoices',
				actionBar: {
					searchPlaceholder: 'Search by invoice ID, name, email,…',
				},
			},
			columns: {
				invoiceId: 'Invoice ID',
				payingUserName: 'Customer',
				payingUserId: 'Paying User ID',
				createdAt: 'Created Date',
				dueDate: 'Due Date',
				totalAmount: 'Total Amount',
				paidAmount: 'Paid Amount',
				balanceDue: 'Balance Due',
				paymentStatus: 'Payment Status',
				paymentMethod: 'Payment Method',
				agingDays: 'Aging',
				purchaseSource: 'Purchase Source',
			},
			notDue: 'Not Due',
			platforms: {
				backoffice: 'Backoffice',
				consumer: 'Consumer',
				consumer_checkout: 'Consumer',
				mobile: 'Mobile',
				cron: 'Cron',
				import: 'Import',
				other: 'Other',
			},
			filters: {
				dueDate: 'Due Date',
				dueDateFrom: 'Due Date From',
				dueDateTo: 'Due Date To',
				createdDateRangePlaceholder: 'Created date range',
				dueDateRangePlaceholder: 'Due date range',
				payingUserType: 'Paying User Type',
				anonymousPayingUser: 'Anonymous',
				nonAnonymousPayingUser: 'Non-anonymous',
				savedDateRanges: {
					lastWeek: 'Last Week',
					lastMonth: 'Last Month',
					lastQuarter: 'Last Quarter',
					lastYear: 'Last Year',
				},
			},
		},
		customerInvoices: {
			table: {
				subject: 'invoices',
				loadingMessage: 'Loading invoices...',
				noDataMessage: 'No invoices found',
				errorMessage: 'Unable to load invoices',
				actionBar: {
					searchPlaceholder: 'Search by invoice ID, name, email,…',
				},
			},
			columns: {
				invoiceId: 'Invoice ID',
				payingUserName: 'Customer',
				payingUserId: 'Paying User ID',
				createdAt: 'Created Date',
				dueDate: 'Due Date',
				totalAmount: 'Total Amount',
				paidAmount: 'Paid Amount',
				balanceDue: 'Balance Due',
				paymentStatus: 'Payment Status',
				paymentMethod: 'Payment Method',
				agingDays: 'Aging',
				purchaseSource: 'Purchase Source',
			},
			notDue: 'Not Due',
			platforms: {
				backoffice: 'Backoffice',
				consumer: 'Consumer',
				consumer_checkout: 'Consumer Checkout',
				mobile: 'Mobile',
				cron: 'Cron',
				import: 'Import',
				other: 'Other',
			},
			filters: {
				dueDate: 'Due Date',
				dueDateFrom: 'Due Date From',
				dueDateTo: 'Due Date To',
				createdDateRangePlaceholder: 'Created date range',
				dueDateRangePlaceholder: 'Due date range',
				savedDateRanges: {
					lastWeek: 'Last Week',
					lastMonth: 'Last Month',
					lastQuarter: 'Last Quarter',
					lastYear: 'Last Year',
				},
			},
		},
	},
	editNotesModal: { successMessage: 'Notes updated!' },
	errorModalBody: {
		title: 'Error',
		buttonText: 'close',
		somethingWentWrong: 'Something went wrong:',
		pleaseTryAgainLater: 'Please try again later.',
	},
	errorMessages: {
		genericError: 'An error occurred. Please try again.',
		networkError: 'Network error. Please check your connection and try again.',
		serverError: 'Server error. Please try again later or contact support.',
		validationError: 'Please check your selections and try again.',
		unauthorized: 'You are not authorized to perform this action.',
		forbidden: 'You do not have permission to perform this action.',
		notFound: 'The requested resource could not be found.',
		conflict: 'A conflict occurred. Please try again.',
		tooManyRequests: 'Too many requests. Please wait a moment and try again.',
		internalServerError: 'Internal server error. Please contact support.',
		badGateway: 'Service temporarily unavailable. Please try again later.',
		serviceUnavailable: 'Service is currently unavailable. Please try again later.',
		httpStatusMapper: {
			400: 'Please check your selections and try again.',
			401: 'You are not authorized to perform this action.',
			403: 'You do not have permission to perform this action.',
			404: 'The requested resource could not be found.',
			409: 'A conflict occurred. Please try again.',
			500: 'Internal server error. Please contact support.',
			502: 'Service temporarily unavailable. Please try again later.',
		},
		gatewayTimeout: 'Request timed out. Please try again.',
	},
	inviteLink: {
		success: {
			title: 'Success',
			message: 'Your invite link has been generated successfully!',
		},
		modal: {
			copiedMessage: 'Invite link copied',
			title: 'Generate Invite Link for {groupName}',
			selectProducts: 'Select Products',
			selectProductsPlaceholder: 'Select products...',
			validFrom: 'Valid From (default: today)',
			validFromPlaceholder: 'Select start date (optional)',
			validUntil: 'Valid Until (default: 30 days)',
			validUntilPlaceholder: 'Select end date (optional)',
			generateLink: 'Generate Link',
			generating: 'Generating...',
			cancel: 'Cancel',
			generatedLink: 'Generated Invite Link:',
			productsError: {
				noSessionInfo: 'Unable to load products: No session information found.',
				noProducts:
					'No products found for this session. Please add products to the session before generating invite links.',
				loadFailed: 'Failed to load products. Please try again or contact support if the problem persists.',
				retry: 'Retry',
			},
		},
	},
	confirmationAlert: {
		title: 'Please confirm your action',
		message: '',
		confirmButtonText: 'OK',
		cancelButtonText: 'CANCEL',
	},
	globalScanNotification: {
		title: 'Recent Scans',
		emptyState: 'No recent scans',
		unknownCode: 'Unknown Code',
		failedScan: 'Scan failed',
		loading: 'Loading...',
		viewCustomer: 'View Customer',
		viewAllScans: 'View all scans',
		minimize: 'Minimize',
		dismiss: 'Dismiss',
		moveToBottom: 'Move to bottom',
		moveToTop: 'Move to top',
		expandAriaLabel: (count: number, tone: FloatingPanelToneEnum) => {
			const scans = count === 1 ? '1 recent scan' : `${count} recent scans`;
			switch (tone) {
				case FloatingPanelToneEnum.ERROR:
					return `${scans}, latest scan failed. Click to expand.`;
				case FloatingPanelToneEnum.WARNING:
					return `${scans}, latest scan needs attention. Click to expand.`;
				case FloatingPanelToneEnum.LOADING:
					return `${scans}, checking in. Click to expand.`;
				case FloatingPanelToneEnum.SUCCESS:
					return `${scans}. Click to expand.`;
				default: {
					const _exhaustive: never = tone;
					return _exhaustive;
				}
			}
		},
		toneAriaLabel: (tone: FloatingPanelToneEnum) => {
			switch (tone) {
				case FloatingPanelToneEnum.ERROR:
					return 'Latest scan failed';
				case FloatingPanelToneEnum.WARNING:
					return 'Latest scan needs attention';
				case FloatingPanelToneEnum.LOADING:
					return 'Latest scan is in progress';
				case FloatingPanelToneEnum.SUCCESS:
					return 'Latest scan succeeded';
				default: {
					const _exhaustive: never = tone;
					return _exhaustive;
				}
			}
		},
		relativeTime: {
			justNow: 'Just now',
			minutesAgo: (count: number) => (count === 1 ? '1 minute ago' : `${count} minutes ago`),
			hoursAgo: (count: number) => (count === 1 ? '1 hour ago' : `${count} hours ago`),
			daysAgo: (count: number) => (count === 1 ? '1 day ago' : `${count} days ago`),
		},
		waiver: {
			signed: 'Waiver signed',
			notSigned: 'Waiver not signed',
			expired: 'Waiver expired',
		},
		balance: {
			outstandingWithAmount: (amount: string) => `Outstanding: ${amount}`,
			outstandingCount: (count: number) => (count === 1 ? '1 unpaid invoice' : `${count} unpaid invoices`),
			overdueWithAmount: (amount: string) => `Overdue: ${amount}`,
			overdueCount: (count: number) => (count === 1 ? '1 overdue invoice' : `${count} overdue invoices`),
		},
		status: {
			notFound: 'Not found',
			checkingIn: 'Checking in...',
			checkInFailed: 'Check-in failed',
			checkInInterrupted: 'Check-in interrupted',
			failedToProcess: 'Failed to process scan',
			noMembershipsOrEvents: 'No memberships or events to check in',
			checkedIn: 'Checked in',
			checkedInWith: (items: string) => `Checked in: ${items}`,
			alreadyCheckedIn: 'Already checked in',
			alreadyCheckedInWith: (items: string) => `Already checked in: ${items}`,
			membershipCheckInFailed: (count: number) =>
				count === 1 ? '1 membership check-in failed' : `${count} membership check-ins failed`,
			eventCheckInFailed: 'Event check-in failed',
		},
		membership: {
			one: '1 membership',
			multiple: (count: number) => `${count} memberships`,
			unpaidActiveCount: (count: number) => (count === 1 ? '1 unpaid membership' : `${count} unpaid memberships`),
		},
	},
	sportsErrorModalBody: {
		title: 'Error',
		message: 'There was an error loading the sports. Please try again later.',
	},
	duration: {
		day: 'day',
		days: 'days',
		daysCapital: 'Days',
		h: 'h',
		hr: 'hr',
		hoursCapital: 'Hours',
		hourCapital: 'Hour',
		min: 'min',
		perSlot: 'Per Slot',
		Hrs: 'Hrs',
		Min: 'Min',
	},
	time: {
		today: 'Today',
		tomorrow: 'Tomorrow',
		units: {
			year: 'y',
			month: 'm',
			week: 'w',
			day: 'd',
			hour: 'h',
			minute: 'min',
			secound: 's',
		},
		suffix: (value: number, unit: string) => `${value}${unit}`,
		prefix: (value: number, unit: string) => `${unit}${value}`,
		breackts: (parts: string[], separator: string) => `(${parts.join(separator)})`,
		separator: ', ',
	},
	to: 'to',
	tooltips: {
		notPlatformUser:
			'This feature is only available to platform users. If you would like to join, please add a Stripe payment method.',
		rowFacilitiesOutOfAccess: "You don't have access to one of the facilities of this row",
		resourceFacilitiesOutOfAccess: "You don't have access to any of the facilities of this resource",
		invoiceFacilitiesOutOfAccess: "You don't have access to one or more facilities on this invoice",
		lineItemFacilitiesOutOfAccess: "You don't have access to one or more facilities on this line item",
	},
	organizationSwitcher: {
		placeholder: 'Select Organization',
		searchPlaceholder: 'Search organization...',
		searchAria: 'Search organizations',
		listAria: 'Organizations',
		switchAria: 'Switch organization',
		loadFailed: 'Failed to load organizations. Try again.',
		switchFailed: 'Failed to switch organization. Please try again.',
	},
	sideMenu: {
		organizationFallback: 'organization',
		organizationLogo: (orgName: string) => `${orgName} logo`,
		organizationLogoPlaceholder: (orgName: string) => `${orgName} logo placeholder`,
		goToSettingsAria: (orgName: string) => `Go to ${orgName} settings`,
		currentOrganizationAria: (orgName?: string) => `Current organization: ${orgName || 'Not set'}`,
		permissionsLoadFailed: 'Failed to load navigation permissions.',
		permissionsRetry: 'Retry',
		logout: 'Log out',
		userAria: (userName: string) => `User: ${userName}`,
		reporting: 'Reporting',
		opensInNewTab: '(opens in new tab)',
		mainNavAria: 'Main navigation',
		primaryNavAria: 'Primary navigation',
		openNavAria: 'Open navigation menu',
		closeNavAria: 'Close navigation menu',
		expandSidebarAria: 'Expand sidebar',
		collapseSidebarAria: 'Collapse sidebar',
		renderError: 'Navigation failed to load. Refresh the page.',
	},
	table: {
		sortedAsc: 'sorted ascending',
		sortedDesc: 'sorted descending',
		noRecords: (records: string) => `No ${records} available`,
		rowsErrorMessage: 'We could not load the records. Please refresh the page or try again.',
		enhancedTableLabel: 'enhanced table',
		selectAllAriaLabel: 'select all desserts',
		ageYears: (years: number) => `${years} yrs`,
		timeRangeWithDuration: (startTime: string, endTime: string, duration: string) =>
			`${startTime} - ${endTime} \n          (${duration})`,
	},
	defaultFacilityColumn: 'Facilities',
	facilitySwitcher: {
		allFacilities: 'All Facilities',
		searchPlaceholder: 'Search facility...',
	},
	facilityController: {
		error: 'No POS stations found.',
		pairOneHere: ' Pair one here',
		online: 'Online',
		stationNotPaired: 'Station not paired',
		mismatchTooltip: (activeFacility: string, stationFacility: string) =>
			`You're viewing ${activeFacility} data, but your station is linked to ${stationFacility}. All payments will be recorded at ${stationFacility}.`,
		cancel: 'Cancel',
		openRegister: 'Open Register',
		closeRegister: 'Close Register',
		shiftId: 'Shift ID',
		open: {
			title: 'Open Cash Register',
			inputLabel: 'Cash Amount?',
			checkbox: "I approve I've checked the amount",
		},
		close: {
			title: 'Close Cash Register',
			inputLabel: 'Cash Amount?',
			checkbox: "I approve I've checked the amount",
		},
	},
	notesFilterOptions: {
		[SlotNotesFilterEnum.WITHOUT_NOTES]: 'Without Notes',
		[SlotNotesFilterEnum.WITH_PUBLIC_NOTES]: 'With Public Notes',
		[SlotNotesFilterEnum.WITH_PRIVATE_NOTES]: 'With Private Notes',
	},
	bank: {
		modal: {
			title: 'Bank Account Details',
			subTitle:
				'Please complete your bank account details in order to receive daily payouts from Bond Sports. If you do not complete this step we will not be able to transfer funds from your customer`s payment. {contact support} for any questions',
			subTitlePart1:
				'Please complete your bank account details in order to receive daily payouts from Bond Sports. If you do not complete this step we will not be able to transfer funds from your customer`s payment. Contact',
			subTitlePart2: 'for any questions',
			owner: 'Bank Account Owner',
			accNumber: 'Account Number',
			routeNumber: 'Routing Number',
			currency: 'Account Currency',
			address: 'Billing Address',
			mainButton: 'Submit',
			closeButton: 'Close',
			errors: {
				owner: 'Please provide a valid account owner',
				routingNumber: 'Please provide a valid routing number',
				address: 'Please provide a valid address',
				accountNumber: 'Please provide a valid account number',
			},
		},
	},
	stripeConnect: {
		pending: 'Pending',
		connected: 'Connected',
		missingRequirements: 'Missing requirements',
		underValidation: 'Account is being validated',
		fetchingLink: 'Fetching link',
		autoGenerateAccount: 'Auto generate account',
		connectAccount: 'Connect account',
		updateAccount: 'Update account',
		canceledOnboarding: 'Canceled onboarding',
	},
	notes: {
		publicNote: 'Public note',
		privateNote: 'Private note',
		viewNotes: 'View Notes',
		notesList: {
			buttons: {
				addNewNote: 'ADD NEW NOTE',
			},
			loading: {
				title: 'Loading...',
				description: 'This may take a few moments, please be patient.',
			},
			note: {
				dateAndTime: (date: Date, timezone: string) => {
					timezone ??= Intl.DateTimeFormat().resolvedOptions().timeZone;
					const dateWithTimezone = setTimezone(date, timezone);

					const displayDate: string = formatDate(dateWithTimezone, EDateTimeFormats.DAY_FORMAT);
					const displayTime: string = formatDate(dateWithTimezone, EDateTimeFormats.H12_ampm);

					return `${displayDate} - ${displayTime}`;
				},
				notedBy: 'Noted by',
			},
			noData: () => 'No notes have been added yet. Notes you create will appear here.',
		},
		editNote: {
			title: 'Edit Note',
		},
		addNote: {
			title: 'New Note',
			pinToTop: 'Pin to top',
			pinToTopAndDisplay: 'Pin to top and display in customer overview',
			pinToTopAndDisplayTooltip:
				'This note will pop up as a reminder at the bottom of the screen whenever the customer’s overview page is accessed.',
			pinToTopAndDisplayTooltipMaxLimit:
				'Maximum number of notes displayed in the customer’s overview page has been reached. To enable this option you must first disable the overview display of an existing note.',
			contentInputPlaceHolder: 'Type here...',
			titleInputPlaceHolder: 'Note Title *',
			buttons: {
				save: 'save',
				cancel: 'cancel',
			},
		},
		archiveNote: {
			title: 'Deleting Note',
			description: 'Are you sure you want to delete this note permanently?',
		},
	},
	errors: {
		somethingWentWrong: 'Something went wrong. Please try again or refresh the page.',
		paymentFailed: 'Payment Failed',
		chargeCouldNotBeCompleted:
			'The charge could not be completed. Please check the payment method and try again. If the card was declined, ask the customer to use a different payment method.',
		failedToReturnPrimaryUser: 'Failed to return primary user',
		failedToLoadProducts: 'Failed to load products',
		tryLater: 'Please try later',
		approve: 'Approve',
		refresh: 'Try to refresh the page or',
		noProducts:
			'No rental product is configured for this schedule and activity. Please contact your administrator to set up a product, or adjust the selected time slot.',
		goBack: 'go back',
		goBackButton: 'Go Back',
		missingSessionOrGroup: 'Missing session or group information',
		invalidServerResponse: 'Invalid response from server',
		unexpectedError: 'An unexpected error occurred',
		purchase: {
			generalError:
				'The payment could not be processed. Please try charging again. If the problem continues, ask the customer to use a different payment method.',
			missingReservationId: 'Something went wrong. Please close and reopen the reservation, then try again.',
		},
		time: {
			startTimeEndTime: 'Start time must be before End time',
		},
		invalid: 'Invalid',
	},
	station: {
		tryAgain: 'Try Again',
		messages: {
			tryingAgain: 'trying again',
			disconnected: 'Terminal is Disconnected',
			failed: 'Terminal connection failed. Please check the terminal power and network, then try again.',
			connected: 'Terminal is Connected',
			reconnecting: 'Reconnecting to Terminal...',
			readerNotFound: 'Terminal reader not found at this location',
			missingOrganizationId: 'Missing organization id',
		},
		saveCardPrompt: {
			[TerminalPaymentMethodCaptureEnum.REQUIRE]: {
				title: 'Card Saving',
				description: 'Your card will be saved for future payments. This is required to complete your purchase.',
				required: true,
				formType: 'selection',
				selectionButtons: [
					{
						id: 'true',
						style: 'primary',
						text: 'Approve',
					},
				],
			},
			[TerminalPaymentMethodCaptureEnum.ASK]: {
				title: 'Card Saving',
				description: 'Would you like to save your card to your account for faster checkouts in the future?',
				required: true,
				formType: 'selection',
				selectionButtons: [
					{
						id: 'true',
						style: 'primary',
						text: 'Yes',
					},
					{
						id: 'false',
						style: 'secondary',
						text: 'No',
					},
				],
			},
		},
	},
	activityTimes: {
		pluralizeDayOfWeek: (dayOfWeek: string) => `${dayOfWeek}s`,
		dateRange: (startDate: string, endDate: string, dayOfWeek?: string) =>
			`${dayOfWeek ? `${dayOfWeek} ` : ''}${startDate} - ${endDate}`,
		noActivityTimes: '-',
	},
	viewMore: (count: number) => `+${count} more`,
	daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
	months: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	],
	gender: {
		1: 'Gender Neutral',
		2: 'Male',
		3: 'Female',
	},
	genderSessions: {
		1: 'Co-Ed',
		2: 'Male',
		3: 'Female',
	},
	amenities: {
		1: 'Heat',
		2: 'AC',
		3: 'WIFI',
		4: 'Restrooms',
		5: 'Drinking Fountain',
		6: 'Free Parking',
		7: 'Concessions',
		8: 'Shelters',
		9: 'Portable Restrooms',
		10: 'Lights',
		11: 'Locker Room',
		12: 'Paid Parking',
		13: 'Accessible',
	},
	sports: SPORTS_MAP,
	levelOfPlayLabels: {
		1: 'Beginner',
		2: 'Intermediate',
		3: 'Advanced',
		4: 'Semi Pro',
	} as Record<number, string>,
	payments: {
		applyPaymentMethod: {
			membershipRolling: 'Apply to future membership payments',
			installments: 'Apply to future scheduled payments',
			combinedCase: 'Apply to future scheduled and membership payments',
		},
		limitedMethodNotice:
			'Mobile Wallet Restricted to automated plan installments only. Cannot be re-used for one-time charges.',
		remainingDue: 'Remaining Due',
		payment: 'Payment',
		schedulePayment: 'Schedule Payments',
		confirmScheduledPayments: 'Scheduled Payments',
		installmentsPreview: 'Installments Preview',
		selectPaymentMethod: 'Select Payment Method',
		feeWarning: 'Notice! Some payment methods may include a transaction fee.',
		selectMethodFeeWarning: (percentVal: string, fixedVal: string, methodType: string) => {
			const feeText = formatTransactionFee(percentVal, fixedVal);
			const method = methodType || `payment method`;
			return `Payment with a ${method} includes a ${feeText} transaction fee`;
		},
		invoiceCreatedWarning: (invoiceId: number) => `Please notice! Invoice ${invoiceId} has been created.`,
		goToInvoice: 'GO TO INVOICE',
		publicNote: {
			add: 'Add public note',
			label: 'Public note',
			tooltip: 'The public note is visible to the customer.',
			clear: 'Clear',
			createFailed: 'The public note could not be saved.',
		},
		error: {
			unknownStripeError: 'unknown error happened on stripe',
			saveUserPaymentMethodFailed: 'Failed to save user payment method',
			noPaymentMethodFound: 'No payment method found',
			stripeCardElementMissing: 'should never happen - stripe failed to create the card element',
		},
		installmentsTable: {
			labels: {
				amount: 'Amount',
				method: 'Method',
				status: 'Status',
				date: 'Date',
			},
		},
		newCardButton: 'Add',
		newCard: {
			cardNumber: 'Card Number',
			expirationDate: 'Expiration Date',
			securityCode: 'Security Code',
			address: 'Billing Address',
			nameOnCard: 'Name on Card',
		},
		terminalError: {
			firstLine: 'Could not connect to terminal',
			secondLine: 'To resolve this issue, view the ',
			thirdLine: 'or reconnect from ',
			faqLink: 'FAQ Document',
			stationSetup: 'Setup Station',
		},
		methods: {
			balance: 'Credit Balance',
			cash: 'Cash',
			card: 'Card on File',
			us_bank_account: 'ACH',
			check: 'Check',
			other: 'Other',
			migrated: 'Migrated',
			newAch: 'ACH Details',
			newCard: 'Card Details',
			[PaymentMethodTypeEnum.CARD_ON_TERMINAL]: 'Card Terminal',
			swipe: 'Swipe',
			[EChargeInnerStep.SCHEDULED_CHARGE]: 'Scheduled charge',
			[PaymentMethodTypeEnum.GIFT_CARD]: 'Gift Card',
			[PaymentMethodTypeEnum.NOT_SET]: 'Not Set',
		},
		chooseAmount: {
			check: 'Enter check number',
			cash: 'Choose the amount of cash received',
		},
		chargingAmount: (val: string) => `Charging amount - ${val}`,
		addCreditCardFeeNotice: (percentVal: string, fixedVal: string, methodType: string) => {
			const feeText = formatTransactionFee(percentVal, fixedVal);
			const method = methodType || `payment method`;
			return `Please notice! This ${method} will include a transaction fee of ${feeText}`;
		},
		totalPaidMessageWithAmount(totalPaidAmount: string) {
			return `${this.totalPaid} ${totalPaidAmount}`;
		},
		enterCheckNumber: 'Enter check number',
		enterGiftCardNumber: 'Enter gift card number',
		errors: {
			notSupportCash:
				'Refunds for cash or check payments cannot be processed here. Please handle these refunds manually and record them separately.',
			noSupportMultipleCard: {
				void: 'Voiding is not supported for invoices with multiple credit or debit card payments. Please void each payment individually.',
				refund:
					'Refunding is not supported for invoices with multiple credit or debit card payments. Please refund each payment individually.',
			},
			paymentToLarge:
				'The payment amount cannot exceed the invoice total. Please enter an amount equal to or less than the total due.',
			notEnoughCreditBalance:
				'The amount entered exceeds the available credit balance. Please enter an amount equal to or less than the credit balance.',
			invaildAmount: 'Invalid amount',
		},
		stripePaymentDeclineErrorCodes: {
			unknown: 'unknown error happened on stripe',
			generic_decline: 'Payment declined.',
			insufficient_funds: 'Insufficient funds.',
			lost_card: 'Card reported lost.',
			stolen_card: 'Card reported stolen.',
			expired_card: 'Card expired.',
			incorrect_cvc: 'Incorrect CVC.',
			processing_error: 'Processing error.',
			incorrect_number: 'Incorrect card number.',
			card_velocity_exceeded: 'Too many failed attempts. Please try again tomorrow.',
			restricted_card: 'Card is blocked. Contact support@bondsports.co for assistance.',
		},
		terminalStorage: {
			title: 'Card Storage: ',
			options: {
				[TerminalPaymentMethodCaptureEnum.NONE]: "Don't Save",
				[TerminalPaymentMethodCaptureEnum.ASK]: 'Ask Customer',
				[TerminalPaymentMethodCaptureEnum.REQUIRE]: 'Require Save',
			},
		},
		custom: 'Custom',
		paymentRequest: 'payment Request',
		manageDiscounts: {
			noProducts: 'It seems that there is no products yet...',
		},
		totalPaid: 'Total Paid',
		totalDue: 'Total Due',
		howMuchToCharge: 'How much to charge?',
		manualDiscount: 'Manual Discount',
		cart: {
			cart: 'Cart',
			clearCart: 'Clear Cart',
			tooManyItems: 'You have reached the max quantity of products in the cart',
			switchPayingCustomer: {
				clickHere: 'Click here',
				toSelect: 'to select a different customer to charge.',
				errorModal: {
					title: 'Error',
					description:
						'We could not load alternative customers for this cart. Please remove the current cart owner, re-add them, then try selecting an alternative customer again.',
					mainButton: 'okay',
				},
				selectedCustomerNotInFamilyModal: {
					title: 'Error',
					description:
						'One or more customers in this cart are not linked to the selected cart owner. Please remove them from the cart before continuing.',
					mainButton: 'okay',
				},
			},
		},
		refund: {
			reasonToRefund: 'Reason To Refund',
			reasonToRefundTextArea: 'Reason To Refund (optional)',
			selectReason: 'Select a reason',
		},
		whichPaymentMethod: 'Which payment method?',
		back: 'Back',
		subTitle: {
			chargingAmount: 'Charge total',
			feeAmount: 'Transaction fee',
			pricePerPayment: 'Price per payment',
		},
		useExisting: 'Use existing',
		isGuest: 'Guest',
		or: 'or',
		switchCards: 'Switch card',
		swipeCard: 'Swipe card',
		enterManually: 'Enter manually',
		purchaseCompleted: 'Purchase Completed!',
		items: {
			subTotal: 'Subtotal',
			taxInc: 'Tax inc',
			taxIncWithPercentage: (percentage: number) => `Tax inc (${percentage}%)`,
			taxExc: 'Tax',
			taxExcWithPercentage: (percentage: number) => `Tax (${percentage}%)`,
			discount: (name: string, percentage: number) => `${name} (${percentage}%)`,
			refunded: 'Refunded',
			totalRefund: 'Total Refund',
			membershipDiscount: 'Membership Discount',
			fee: (feeDesc: string) => `Fees (${feeDesc})`,
		},
		searchByInvoice: 'Search by Invoice no.',
		searchByPayment: 'Search by Payment no.',
		refunds: {
			refund: 'Refund',
			refundMessageWithAmount: (amount: string) => `Refund ${amount}`,
			defaultMessage:
				'Select the purchased line items that are being returned / refunded. Refund / return can be with partial amount up to the total paid amount. Quantity selected is up to the quantity that was paid for.',
			refundByItems: 'Refund By Items',
			manual: 'Manual Amount',
			inputLabel: 'How much to refund?',
			inputHelper: ' is available for refund as charged',
			inputHelperWithAmount: (amount: string) => `${amount}${TranslationEn.payments.refunds.inputHelper}`,
			completed: 'Refund Completed',
			totalRefunded: 'Total refunded',
			totalPaid: 'Total paid',
			isAvailable: ' is available for refund in ',
			asCharged: 'as charged',
			cancelPunchPass: {
				title: 'Cancel punch pass?',
				description: 'Do you want to cancel the punch pass as part of this refund?',
				activeSlotsWarning: (count: number) =>
					`${count} upcoming ${count === 1 ? 'slot is' : 'slots are'} booked with this punch pass. Canceling the punch pass will not cancel ${
						count === 1 ? 'this slot' : 'these slots'
					}, they must be canceled manually.`,
				yes: 'Yes',
				no: 'No',
			},
		},
		sendReceipt: {
			mainTitle: 'Send receipt',
			successMessage: 'The receipt was sent successfully',
			sendReceiptTo: 'Send receipt to',
			contactMethod: {
				email: 'email',
				phone: 'phone',
			},
			placeholders: {
				email: 'your@mail.com',
				phone: 'your phone',
			},
			send: 'Send',
			skip: 'Skip',
		},
		void: {
			cancel: 'Cancel',
			void: 'Void',
			voidMessageWithAmount: (amount: string) => `Void ${amount}`,
			defaultMessage: 'Select items to void',
			totalVoid: 'Total Void',
			voidItems: 'Void Items',
			reservationTooltip:
				'Reservation line items cannot be voided here. Manage the reservation from the reservation page.',
		},
		addPaymentActionButton: 'Add Payment',
		completed: {
			paymentMethod: 'Payment method',
			fees: 'Transaction fee',
			tip: 'Tip',
			subtotal: 'Subtotal',
			total: 'Total',
			totalDue: 'Total Due',
			purchaseCompleted: 'Payment Received',
			send: 'SEND',
			print: 'PRINT RECEIPT',
			skip: 'SKIP',
		},
		changeDue: 'Change due',
		changeDueWithAmount: (amount: string): string => `${TranslationEn.payments.changeDue} ${amount}`,
		tables: {
			subject: 'payments',
		},
		removePaymentMethod: {
			dialog: {
				confirmation: {
					title: 'Remove Payment Method',
					description:
						'The Payment method will be removed permanently from the customer account. Are you sure you wish to remove it?',
					mainButton: 'Yes, Remove',
					subButton: 'Cancel',
				},
				successMessage: 'Payment method has been removed successfully!',
				paymentPlanError: {
					title: 'Error',
					description:
						// eslint-disable-next-line max-len
						'This payment method is connected to an active payment schedule.\nTo remove this payment method, you must first change the payment method for all associated scheduled payments.',
					contactInfo: 'To replace payment method please contact support at support@bondsports.co',
					button: 'Change payment method',
					cancel: 'Cancel',
				},
				multipleOrganizationsError: {
					title: 'Error',
					cannotBeRemoved: 'The payment method cannot be removed.',
					pleaseContact: 'Please contact ',
					supportEmail: 'support@bondsports.co',
					forAssistance: ' for assistance.',
					button: 'Okay',
					cancel: 'Cancel',
				},
			},
		},
		schedule: {
			rolling: {
				title: 'Rolling',
				repeat: 'Repeat',
				count: 'Count',
				startDate: 'Starting Date',
				datePlaceholder: 'Select',
				duration: {
					weekly: 'Weekly',
					monthly: 'Monthly',
				},
			},
			custom: {
				title: 'Custom',
			},
		},
	},
	customers: {
		customer: 'Customer',
		allCustomers: 'Customers',
		pageTabs: {
			customers: 'Customers',
			checkIns: 'Check-ins',
		},
		ageSuffix: 'yrs',
		birthDateWithAge: (age: number, formattedDate: string) =>
			`(${age}${TranslationEn.customers.ageSuffix}) ${formattedDate}`,
		searchPlaceHolder: 'Search by name',
		searchLinkedAccounts: (names: string) => `Account: ${names}`,
		filterPlaceHolder: 'All',
		addCustomer: 'Add A Customer',
		mergeCustomersButton: 'Merge Customers',
		addNewCustomerModal: {
			title: 'New Customer',
			description: 'Select account type',
			actionButtonText: 'Continue',
			radios: {
				individual: 'Individual account',
				family: 'Family account',
				business: 'Business account',
			},
			tryAgainText:
				'An account with that email already exists. Please use a different email address or search for the existing customer.',
		},
		noColorWarning: 'Please note that the customer profile was created without a color set',
		detailsPage: {
			title: 'New individual account',
			cancel: 'CANCEL',
			create: 'CREATE ACCOUNT',
			personalDetails: 'Personal Details',
			firstName: 'First Name',
			lastName: 'Last Name',
			gender: 'Gender',
			dob: 'Date of Birth',
			phoneNumber: 'Phone no.',
			email: 'Email',
			selectColorSet: 'Select Color Set',
			registrationLink: 'Send registration link to phone number',
			addressDetails: 'Address Details',
			address: 'Address',
			street: 'Street Name & Number',
			city: 'City',
			state: 'State',
			zip: 'Zip Code',
			notesDetails: 'Notes',
			notes: 'Notes (Optional)',
			notesDescription: 'Add here important details on your customer (such as medical condition etc...)',
			pinTop: 'Pin to Top',
			addMore: 'Add more',
			emergencyDetails: 'Emergency Contact',
			contactName: 'Contact Name',
			documentDetails: 'Documents',
			upload: 'upload',
			forms: 'Forms',
			editColorModal: {
				title: 'Edit customer color',
				description:
					'This customer may already have events with different colors. Changing the customer color will edit all the events.',
				mainButton: 'Change all',
				subButton: 'Change only future events',
				successMessage: 'Color changed successfully',
				errorMessage: 'We could not update the color. Please try again or refresh the page.',
			},
			unsavedProfilePicture: 'Save Customer to use this updated photo.',
			accountRole: 'Account Role',
			memberTitle: 'Title',
			memberTitleInfo: 'Optional job title or responsibility label',
			businessAccountRoleInfo:
				'Determines this person’s access level. Staff have access only to their own account data. Managers and Administrators can manage all members, but can’t view anyone else’s payment methods.',
			accountRoleInfo: 'A customer must be over 18 years of age and have an email address to be an account Primary.',
			accountRoleMultiOrgTooltip: {
				multipleOrgs:
					'This account’s role can’t be changed if they are registered with other organizations. Contact Bond Sports for support.',
				lastPrimary:
					'This account’s role can’t be changed because they are the only Primary. Make another member a Primary first, then change this account’s role.',
			},
			accountRoleOptions: {
				primary: 'Primary',
				dependent: 'Dependent',
				admin: 'Administrator',
				finance: 'Finance',
				manager: 'Manager',
				staff: 'Staff',
			},
			underagePrimaryWarning: {
				title: 'Underage Primary',
				description:
					'The family member you’ve selected is under the age of eighteen. Are you sure you want to save them as primary?',
				confirm: 'Save',
				cancel: 'Cancel',
			},
			underageAdminWarning: {
				title: 'Underage Admin',
				description:
					'The member you’ve selected is under the age of eighteen. Are you sure you want to save them as admin?',
				confirm: 'Save',
				cancel: 'Cancel',
			},
		},
		listColumns: {
			id: 'ID',
			lastName: 'Last Name',
			firstName: 'First Name',
			email: 'Email',
			waiver: 'Waiver',
			birthDate: 'Age',
			balance: 'Credit',
			accountBalance: 'Account Balance',
			creditBalance: 'Credit Balance',
			membershipStatus: 'Membership',
			accountType: 'Account',
			status: 'Status',
		},
		pagination: {
			showing: 'Showing',
			to: 'to',
			of: 'of',
			subject: 'customers',
			backToTop: 'Back to top',
			selected: 'selected',
			selectedCount: (count: number) => `(${count} selected)`,
			showingFooter: (start: number, end: number, total: number, subject: string, selectedSuffix: string) =>
				`Showing ${start} to ${end} of ${total} ${subject}${selectedSuffix ? ` ${selectedSuffix}` : ''}`,
			indexOfTotal: (current: number, total: number) => `${current} of ${total}`,
		},
		tables: {
			invoices: 'invoices',
		},
		customerHeader: {
			lastActivity: 'Last Activity',
			lastActivityWithDate: (date: string) => `${TranslationEn.customers.customerHeader.lastActivity} ${date}`,
			lastCheckin: 'Last checked in:',
			lastCheckinWithDateTime: (date: string, time: string) => `Last checked in: ${date} - ${time}`,
			accountId: (id: number) => `#${id}`,
			editProfile: 'EDIT PROFILE',
			checkInButtonText: 'Check In',
			moreMenuOptions: {
				linkToAccount: 'Link to account',
				unlinkFromAccount: 'Unlink from account',
				mergeCustomer: 'Merge customer',
				assignPass: 'Assign a pass',
			},
			customerAccountModal: {
				title: 'Customer Account',
				description: 'Select a new or existing account to link',
				actionButtonText: 'Continue',
				radios: {
					newFamilyAccount: 'New family account',
					existingFamilyAccount: 'Existing family account (Coming Soon)',
				},
			},
			switchGroupTypeModal: {
				title: 'Switch Accounts',
				descriptionToBusiness:
					'The selected family’s primary members will be saved as administrators of the business account. All dependents of the family account will be added as staff.',
				descriptionToFamily:
					'The selected business account’s administrators will be saved as primary members of the family account. All staff members will be added as dependents.',
				currentAccount: 'Current Account:',
				futureAccount: 'Future Account:',
				confirm: 'Switch',
				cancel: 'Cancel',
				successMessage: 'Accounts switched successfully',
				errorMessage: 'Failed to update account type. Please try again.',
			},
			customerCheckinModal: {
				title: 'Check In Customer',
				description: 'Select any of the membership(s) or event(s) you would like to check the customer into',
				subject: 'memberships',
				emptyTableMessage: 'There are no memberships associated with this customer',
				cancelButtonText: 'Cancel',
				actionButtonText: 'Check In',
				eventCheckinSuccessMessage: (name, eventTitle) =>
					`${name} has successfully been checked in to "${eventTitle}"!`,
				membershipCheckinSuccessMessage: (name, membershipCount) =>
					`${name} has successfully been checked in to ${
						membershipCount > 1 ? `${membershipCount} memberships!` : 'their membership!'
					}`,
				eventAndMembershipCheckinSuccessMessage: (name, eventTitle, membershipCount) =>
					`${name} has successfully been checked in to "${eventTitle}" and ${
						membershipCount > 1 ? `${membershipCount} memberships!` : 'their membership!'
					}`,
				membershipCheckinFailMessage: name => `${name} has no memberships.`,
				table: {
					name: 'Name',
					type: 'Type',
				},
			},
			assignPassModal: {
				manualIdentifierEntry: {
					title: 'Assign New Pass',
					bodyCopy: 'Scan or enter pass ID below',
					existingPassesInfo: 'This customer already has a pass:',
					minLengthError: min => `Pass ID must be at least ${min} characters long`,
					validFromAlways: 'Always',
					passIdTH: 'Pass ID',
					startDateTH: 'Start Date',
					assignButton: 'Assign',
					cancelButton: 'Cancel',
				},
				assignNewPass: {
					title: 'Assign New Pass',
					bodyCopy: 'Would you like to assign this pass to this customer?',
					passIDTH: 'Pass ID',
					passOwnerTH: 'New Pass Owner',
					assignButton: 'Assign',
					cancelButton: 'Cancel',
					successToast: 'Customer pass assigned',
					errorToast: 'There was an issue assigning the pass.  Please try again.',
				},
				assignNewPassOverridingExistingPasses: {
					title: 'Pass Already Assigned',
					bodyCopy:
						'This customer has already been assigned passes. Would you like to override them with the new pass?',
					currentPassTH: 'Current Pass ID',
					newPassTH: 'New Pass ID',
					overrideWarning: 'Override will deactivate all current passes.',
					assignButton: 'Override',
					cancelButton: 'Cancel',
					successToast: 'Customer pass assigned',
					errorToast: 'There was an issue assigning the pass.  Please try again.',
				},
				passAlreadyAssignedToSameCustomer: {
					title: 'Pass Already Assigned',
					bodyCopy: 'This pass is already assigned to this customer.',
					currentPassTH: 'Current Pass ID',
					newPassTH: 'New Pass ID',
					assignButton: 'Okay',
				},
				passAlreadyAssignedToDifferentCustomer: {
					title: 'Pass Already Assigned',
					bodyCopy:
						'This pass is assigned to another customer.  Would you like to reassign this pass to this customer instead?  This will revoke the current assignment of this pass.',
					currentPassOwnerTH: 'Current Owner',
					newPassOwnerTH: 'New Owner',
					assignButton: 'Revoke & Reassign',
					cancelButton: 'Cancel',
					successToast: 'Customer pass assigned',
					errorToast: 'There was an issue assigning the pass.  Please try again.',
				},
			},
		},

		editCustomerErrors: {
			emailAlreadyExists: {
				title: 'Email Already in Use',
				description:
					'This email address is already associated with another account. Please use a different email or merge the accounts if they belong to the same customer.',
				primaryButton: 'OKAY',
			},
			crossOrganizationAccess: {
				title: 'Unable to Edit Customer',
				description:
					"This customer's profile can't be edited through the system at this time. Please contact support for help.",
				primaryButton: 'OKAY',
			},
			genericError: {
				title: 'Update Failed',
				description: 'Failed to update customer. Please try again.',
				primaryButton: 'OKAY',
			},
		},

		tabs: {
			customerDetails: 'Customer Details',
			overview: 'Overview',
			membership: 'Memberships',
			payments: 'Payments',
			invoices: 'Invoices',
			checkIns: 'Check-ins',
			activities: 'Activities',
			methods: 'Payment Methods',
		},
		checkIns: {
			table: {
				subject: 'check-ins',
				loadingMessage: 'Loading check-ins...',
				noDataMessage: 'No check-ins found',
				errorMessage: 'Unable to load check-ins',
				actionBar: {
					searchPlaceholder: 'Search by name, email, membership,…',
					searchPlaceholderCustomer: 'Search by membership or event',
					searchPlaceholderFamily: 'Search by member, email, membership,…',
				},
			},
			columns: {
				customerName: 'Customer',
				customerEmail: 'Email',
				checkinDate: 'Check-in Date',
				entityType: 'Type',
				entityName: 'Membership / Event',
				facilityName: 'Facility',
				requestingUserName: 'Checked in by',
			},
			filters: {
				checkinDateRangePlaceholder: 'Check-in date range',
			},
			entityTypes: {
				[AttendanceEntityTypeEnum.MEMBERSHIP]: 'Membership',
				[AttendanceEntityTypeEnum.EVENT]: 'Event',
			},
		},
		overview: {
			memberships: {
				title: 'memberships',
				membershipStatusMapper: {
					[MembershipStatusEnum.ACTIVE]: 'Active',
					[MembershipStatusEnum.ACTIVE_CANCELLED]: 'Auto-Renewal Canceled',
					[MembershipStatusEnum.CANCELLED]: 'Cancelled',
					[MembershipStatusEnum.EXPIRED]: 'Expired',
					[MembershipStatusEnum.PAUSED]: 'Paused',
					[MembershipStatusEnum.PAUSE_PENDING]: 'Pause Scheduled',
					[MembershipStatusEnum.PAUSED_CANCELLED]: 'Auto-Renewal Canceled',
					[MembershipStatusEnum.PENDING]: 'Pending',
				},
				membershipStatusText: {
					[MembershipStatusEnum.PAUSE_PENDING]: (startDate: string) => `Pause starts ${startDate}`,
					[MembershipStatusEnum.PAUSED]: (endDate: string) => `Paused until ${endDate}`,
				},
				footer: {
					noAlerts: 'No membership alerts',
					noDataText: 'No memberships associated with this customer',
					viewAll: 'View all memberships',
				},
				showing: 'Showing',
				alerts: 'alerts',
				showingAlertsMessage: (showingAlerts: number, totalAlerts: number) =>
					`${TranslationEn.customers.overview.memberships.showing} ${showingAlerts}/${totalAlerts} ${TranslationEn.customers.overview.memberships.alerts}`,
				errorMessage: `We could not load memberships for this customer. Please refresh the page. If the problem continues, contact ${SUPPORT_EMAIL}.`,
			},
			payments: {
				title: 'payments',

				invoiceNumber: 'Inv.',
				invoiceNumberMessageWithId: (invoiceId: string | number) =>
					`${TranslationEn.customers.overview.payments.invoiceNumber} ${invoiceId}`,
				paymentAlertMapper: {
					[PaymentAlertEnum.NOT_PAID]: 'Unpaid',
					[PaymentAlertEnum.FAILED]: 'Failed',
				},
				footer: {
					noDataText: 'No invoices associated with this customer',
					noAlerts: 'No payment alerts',
					viewAll: 'View all invoices',
				},
				errorMessage: `We could not load invoices for this customer. Please refresh the page. If the problem continues, contact ${SUPPORT_EMAIL}.`,
			},
			waiver: {
				viewWaivers: 'View Waivers and Documents',
				missingWaiver: 'Missing Waiver',
				expiredWaiver: 'Waiver Expired',
			},
			linkedAccounts: { noLinkedAccounts: 'No linked accounts' },
			events: {
				title: 'Weekly Schedule',
				viewSchedule: 'View full schedule',
				noEvents(days: number) {
					return `Not attending any events in the next ${days} days.`;
				},
				errorMessage: 'Error loading Events for this customer. Please contact customer support.',
				addOnsTooltipTitle: 'Add-Ons',
			},
		},
		activitiesTab: {
			close: 'Close',
			unknownPayment: 'Unknown',
			viewDetails: 'View details',
			financials: {
				title: 'Financials',
				viewInvoice: 'view invoice',
				viewReceipt: 'view receipt',
			},
			sections: {
				programs: 'Programs',
				passes: 'Passes',
				schedule: 'Schedule',
				ariaLabel: 'Activity section',
			},
			facilityOptions: {
				error: 'Error loading facilities. Please try again.',
				retry: 'Try again',
			},
			addonsModal: {
				columns: {
					name: 'Name',
					quantity: 'Quantity',
					timePeriod: 'Time Period',
				},
			},
			schedule: {
				rental: 'Rental',
				rentals: 'Rentals',
				typeFallback: 'Program',
				today: 'Today',
				todayButton: 'Today',
				previousWeek: 'Previous week',
				nextWeek: 'Next week',
				allParticipants: 'All participants',
				allTypes: 'All types',
				cancelled: 'Cancelled',
				complete: 'Complete',
				noData: 'No activity in this week.',
				loading: 'Loading schedule...',
				error: 'Error loading the schedule. Please contact customer support.',
				overflow(shown: number, total: number) {
					return `Showing the first ${shown} of ${total} activities this week.`;
				},
				drawer: {
					title: 'Details',
					viewInPrograms: 'View in Programs',
					viewReservation: 'View reservation',
					when: 'When',
					where: 'Where',
					facility: 'Facility',
					instructor: 'Instructor',
					participant: 'Participant',
					type: 'Type',
					team: 'Team',
					division: 'Division',
					role: 'Role',
					jersey: 'Jersey',
					payment: 'Payment',
					approval: 'Approval',
					notes: 'Notes',
					punches: 'Punches',
				},
			},
			programs: {
				subject: 'programs',
				noData: 'No programs found for this customer.',
				error: 'Error loading programs. Please contact customer support.',
				loading: 'This may take a few moments, please be patient.',
				searchPlaceholder: 'Search programs',
				viewSession: 'View session',
				subtypes: {
					ariaLabel: 'Program type',
					all: 'All',
					classes: 'Classes',
					clinics: 'Clinics',
					camps: 'Camps',
					lessons: 'Private Lessons',
					leaguesClubs: 'Leagues & Clubs',
				},
				columns: {
					participant: 'Participant',
					program: 'Program',
					facility: 'Facility',
					type: 'Type',
					starts: 'Starts',
					ends: 'Ends',
					status: 'Status',
					payment: 'Payment',
					registered: 'Registered',
				},
				drawer: {
					programTitle: 'Program',
					scheduleTitle: 'Schedule',
					participant: 'Participant',
					product: 'Product',
					programType: 'Program Type',
					facility: 'Facility',
					sport: 'Sport',
					dates: 'Session dates',
					sessionStatus: 'Session status',
					teamTitle: 'Team',
					division: 'Division',
					team: 'Team',
					role: 'Role',
					jersey: 'Jersey',
					noEvents: 'No events scheduled',
				},
				status: {
					active: 'Active',
					expired: 'Expired',
				},
			},
			passes: {
				subject: 'passes',
				noData: 'No passes found for this customer.',
				error: 'Error loading passes. Please contact customer support.',
				loading: 'This may take a few moments, please be patient.',
				searchPlaceholder: 'Search passes',
				columns: {
					participant: 'Participant',
					pass: 'Pass',
					facilities: 'Facilities',
					punchesLeft: 'Punches left',
					purchased: 'Purchased',
					expires: 'Expires',
					status: 'Status',
					payment: 'Payment',
				},
				drawer: {
					passTitle: 'Pass',
					redeemedTitle: 'Redeemed',
					participant: 'Participant',
					allowance: 'Allowance',
					unlimitedAllowance: 'Unlimited',
					allowancePerWindow(quantity: number, window: number, unit: string) {
						return window === 1 ? `${quantity} per ${unit}` : `${quantity} per ${window} ${unit}s`;
					},
					price: 'Price',
				},
				scope: {
					global: 'Global Pass',
					session: 'Session Pass',
					rental: 'Rental Pass',
				},
				facilityList(names: string[]) {
					return names.join(', ');
				},
				status: {
					active: 'Active',
					expired: 'Expired',
					cancelled: 'Cancelled',
				},
			},
			details: {
				program: {
					sessionResources: 'Session Resources',
					close: 'Close',
					viewInvoice: 'view invoice',
					viewAddons: 'view add-ons',
					addonError: 'An error occurred while fetching addons',
					addonTypes: {
						perPurchase: 'per purchase',
						perSegment: 'per segment',
						perEvent: 'per event',
					},
					previous: 'previous',
					next: 'next',
					loading: {
						title: 'Loading...',
					},
					removedFromSession: 'All events have been removed on:',
					eventsError: 'Error loading schedule',
					scheduleTitle: 'Segment Schedule',
					addonsTitle: 'Add-Ons',
				},
				punchPass: {
					loading: {
						title: 'Loading...',
					},
					redeemedOn: 'Redeemed on:',
					noData: 'No Redeemed Passes Yet',
					eventsError: 'Error loading punch pass schedule',
				},
			},
		},
		customerPage: {
			gender: 'GENDER',
			email: 'Email',
			phoneNumber: 'Phone No.',
			dateOfBirth: 'Date Of Birth',
			age: 'Age',
			address: 'Address',
			city: 'City',
			zip: 'Zip Code',
			customerColorSet: 'color set',
			edit: 'Edit',
			pastDue: 'Past Due',
			waiver: {
				noWaiver: 'This customer has not completed a waiver or form',
				title: 'waivers & documents',
				errorInFetchingQuestionnaires: `We could not load waivers and documents for this customer. Please refresh the page or contact ${SUPPORT_EMAIL}.`,
				columns: {
					id: 'ID',
					name: 'Name',
					dateCompleted: 'Date Completed',
					type: 'Type',
					validUntil: 'Valid Until',
				},
				generalWaiver: 'General Waiver',
				form: 'Form',
				printForm: {
					customerDetails: {
						title: 'CUSTOMER DETAILS',
						details: {
							dateSigned: 'Date signed',
							participantName: 'Participant name',
							primary: 'Primary / Guardian (if applicable)',
							emailAddress: 'Email address',
							phoneNumber: 'Phone number',
							address: 'Address',
						},
					},
				},
			},
			externalValidations: {
				title: 'External validations',
				verified: 'Verified',
				notVerified: 'Not verified',
				externalId: (externalId: string) => `ID: ${externalId}`,
				lastVerifiedAt: (date: string) => `Last confirmed ${date}`,
			},
			paymentMethods: 'Payment Methods',
			noPaymentMethods: 'No associated payment methods',
			addPaymentMethodButton: 'Add',
			customerProfile: 'Customer Profile',
			downloadPDF: 'Download as PDF',
			changeAccountType: 'Change account type',
			linkedAccountsBlock: {
				title: 'Linked Accounts',
				noLinkedAccounts: 'This member has not been linked to any accounts',
				noOtherMembers: 'No other members have been linked to this account',
				fetchError: 'We could not load linked accounts. Please refresh the page or try again.',
			},
			customerAccountNotes: 'Customer Account Notes',
			accountRole: 'Account Role',
		},
		familyPage: {
			errorFetchingData: 'We could not load this family account. Please refresh the page or try again.',
			viewProfile: 'View Profile',
			creditBalance: 'Credit Balance',
			addFamilyMember: '+ Add a Member',
			familyProfile: 'Family Profile',
			businessProfile: 'Business Profile',
			familyDetails: 'Family Details',
			businessDetails: 'Business Details',
			customerAccountNotes: 'Customer Account Notes',
			overview: {
				familyDetails: 'Family Details',
				accountName: 'Account Name',
				registrationDate: 'Registration Date',
				phone: 'Phone',
				email: 'Email',
				address: 'Address',
				city: 'City',
				zipCode: 'Zip Code',
			},
			memberCard: {
				balanceWithAmount: (amount: string) => `${TranslationEn.customers.listColumns.balance}: ${amount}`,
			},
			menuOptions: {
				ariaLabel: 'Account Menu',
				mergeFamily: 'Merge with Another Family',
			},
			mergeFamily: {
				picker: {
					title: 'Merge family',
					description: 'Search and select the family account you want to merge with this family.',
					confirmButton: 'Continue',
					cancelButton: 'Cancel',
				},
				validationError: 'Unable to validate the selected families. Please try again.',
			},
			addFamilyMemberFlow: {
				step1: {
					title: 'New Member',
					description: 'Select a new or existing individual account to link',
					actionButtonText: 'Continue',
					radios: {
						newIndividualAccount: 'New individual account',
						existingIndividualAccount: 'Existing individual account',
					},
				},
				step2: {
					title: 'New Member',
					description: 'Search for existing individual account to link',
				},
				step3: {
					title: 'Customer Account',
					description: 'Are you sure you want to link this account to the family:',
					descriptionBusiness: 'Are you sure you want to link this account to the business:',
					mainButton: 'Yes, i’m sure',
				},
				step4: {
					title: 'New Member',
					description: 'Individual has been successfully linked to family account',
					descriptionBusiness: 'Individual has been successfully linked to business account',
					mainButton: 'View',
				},
				error: {
					title: 'Error',
					mainButton: 'close',
					linkedMember:
						'This customer is already linked to a family account. You can view their linked account from their profile page.',
					linkedMemberBusiness: 'This customer is already linked to a business account.',
					alreadyInFamily: 'This customer is already linked to:',
				},
			},
			createNewMemberForm: {
				formTitle: 'Add Family Member',
				formTitleBusiness: 'Add Business Member',
				formDescription: 'Add new member to the account',
				mainButton: 'Add member',
				toggleLabel: "Use family account's contact details",
				toggleLabelBusiness: "Use business account's contact details",
			},
		},
		switchAccountType: {
			toBusiness: 'Switch to Business',
			toFamily: 'Switch to Family',
		},
		tags: {
			individual: 'Individual',
			user: 'Individual',
			employee: 'Employee',
			organization: 'Organization',
			family: 'Family',
			business: 'Business',
			primary: 'Primary',
			admin: 'Administrator',
			finance: 'Finance',
			manager: 'Manager',
			billing: 'Default billing',
			dependent: 'Dependent',
			staff: 'Staff',
			independent: 'Independent',
			setAsBillingUser: 'Switch to default billing',
			setAsBillingUserSuccess: 'Default billed primary has been updated!',
			setAsBillingUserError: 'Failed to update billing user',
			active: 'Active',
			inactive: 'Inactive',
			archived: 'Archived',
			expire: 'Expire',
			pending: 'Pending',
			paid: 'Paid',
			void: 'Voided',
			not_paid: 'Unpaid',
			partial: 'Partially paid',
			charged: 'Charged',
			refunded: 'Refunded',
			future: 'Upcoming',
			succeeded: 'Paid',
			canceled: 'Canceled',
			scheduled: 'Scheduled Payments',
			failed: 'Failed',
			retry_in_progress: 'Failed',
			past_due: 'Unpaid',
			disputed: 'Disputed',
			chargeback: 'Chargeback',
		},
		filterLabels: {
			not_paid: 'Unpaid',
			partial: 'Partially paid',
			paid: 'Paid',
			refunded: 'Refunded',
			void: 'Voided',
			purchase_order: 'Purchase order',
			scheduled: 'Scheduled',
			pending: 'Pending',
			disputed: 'Disputed',
			chargeback: 'Chargeback',
		},
		alternativeTags: {
			paid: 'Charged',
			refunded: 'Refunded',
		},
		chargeInstallments: {
			feeWarning: 'Notice! Some payment methods may include a transaction fee.',
			title: 'Scheduled Payments',
			subTitle: 'Select any scheduled payments you would like to pay now. First select any failed payments.',
			subTitleFirstLine: 'Select any scheduled payments you would like to pay now.',
			subTitleSecondLine: 'First select any failed payments.',
			subject: 'scheduled payments',
			next: 'Next',
			back: 'Back',
			cancel: 'cancel',
		},
		managePaymentMethods: {
			header: {
				title: 'replace payment methods',
				breadcrumb: {
					label: 'Connected Resources',
					to: MANAGE_PAYMENT_METHODS_PATH,
				},
			},
			noDataPage: {
				title: 'There are no active payment plans & memberships for this payment method.',
				description: 'Once resources are connected, they will appear here.',
				noMethods: 'There are payment methods found for user',
			},
			table: {
				actions: {
					search: {
						placeholder: 'Search by product',
					},
					filters: {
						categories: {
							resourceTypes: {
								title: 'RESOURCE TYPE',
								options: {
									[ResourceNameTypeEnum.MEMBERSHIP]: 'Membership',
									[ResourceNameTypeEnum.INVOICE]: 'Payment Plan',
								},
							},
							facility: 'FACILITY',
							activity: 'ACTIVITY',
						},
					},
				},
				subject: 'connected resources',
				columns: {
					name: 'Product',
					type: 'Type',
					id: 'ID',
					method: 'Payment Method',
					invoice: 'Invoice ID',
				},
				rowActionsPopup: {
					[RowMangePaymenMethodActionsEnum.REPLACE]: { label: 'Replace Payment Method' },
					status: {
						[RowMangePaymenMethodActionsEnum.REPLACE]: {
							label: 'Replace payment Method',
							successMessage: 'Payment method was replaced',
							errorMessage: 'Payment method was not replaced',
						},
					},
				},
			},
			addNewMethod: 'Add New Payment Method',
			errors: {
				noMethods: 'No payment methods found for user',
				anonymousUser: 'Anonymous user cannot manage payment methods',
			},
		},
		paymentsInvoices: {
			dueDate: 'Due Date',
			removeDueDate: {
				moreMenuButton: 'Remove Due Date',
				title: 'Remove Due Date',
				subTitle: 'Are you sure you want to remove the due date from this invoice?',
				actionButton: "I'm sure",
				subButton: 'Cancel',
				successMessage: 'Invoice due date removed!',
				errorMessage: 'Failed to remove due date, try again later.',
			},
			setDueDateActions: {
				moreMenuEditButton: 'Edit Due Date',
				popupEditTitle: 'Edit Due Date',
				popupAddTitle: 'Add Due Date',
				moreMenuAddButton: 'Add Due Date',
				subTitle: 'Due date controls when this invoice is expected to be paid.',
				actionButton: 'Save',
				subButton: 'Cancel',
				successMessage: 'Invoice due date updated!',
				errorMessage: 'Failed to update invoice due date, try again later.',
				warning:
					'The selected due date is before the final scheduled payment on this invoice. Invoice may appear past due while payments are still pending.',
			},
			discountRestrictedTitle: (isInvoice: boolean) =>
				isInvoice
					? 'A discount cannot be applied to this invoice in its current state. Check whether the invoice has pending payments, scheduled payments, or reservation items - each of those blocks discounts.'
					: 'A discount cannot be applied to this line item in its current state. Check whether the invoice has pending payments, scheduled payments, or reservation items - each of those blocks discounts.',
			discountRestrictedReservation:
				'Discounts cannot be applied to invoices that contain reservation items. To discount a reservation, go to the reservation and adjust the price directly.',
			discountRestrictedPending:
				'Discounts cannot be applied to invoices with pending payments. Please wait for all payments to settle first.',
			discountRestrictedSchedulePayments:
				'To add a discount, you must first cancel or remove all scheduled payments on this invoice.',
			discountRestricted: (status: string) => `Discounts on invoices with ${status} payments are currently unsupported`,
			discountRestrictedPrice: 'Cannot apply a discount to a price of 0.',
			discountRemoveTitle:
				'A discount cannot be removed from this invoice in its current state. If the invoice has scheduled payments, cancel them first and then remove the discount.',
			discountRemove:
				'Discounts cannot be removed from invoices with scheduled payments. Cancel the scheduled payments first, then remove the discount.',
			discountRemoveWithSchedulePayment: 'Cancel all scheduled payments on this invoice before removing the discount.',
			downloadFailed:
				'We could not download the invoice. Please try again. If the problem continues, try refreshing the page.',
			downloadFailedPayment:
				'We could not download the receipt. Please try again. If the problem continues, try refreshing the page.',
			downloadSuccess: 'Invoice downloaded successfully. Please check your downloads folder.',
			downloadSuccessPayment: 'Receipt downloaded successfully. Please check your downloads folder.',
			fee: 'Fee',
			feeWarning: 'Notice! Some payment methods may include a transaction fee.',
			billingInfoFeeWarning: '(Transaction fee may apply)',
			billingInfoFeePaid: '(Transaction fee included)',
			invoice: 'Invoice',
			invoiceNum: 'Invoice No. ',
			invoiceNumMessageWithId: (id: string | number) => `${TranslationEn.customers.paymentsInvoices.invoiceNum}${id}`,
			downloadReceipt: 'Download Receipt',
			sendReceipt: 'Send Receipt',
			printReceipt: 'Print Receipt',
			receiptNum: 'Receipt No.',
			receiptNumMessageWithId: (id: string | number) => `${TranslationEn.customers.paymentsInvoices.receiptNum} ${id}`,
			receiptActions: {
				downloadReceipt: 'Download Receipt',
				sendReceipt: 'Send Receipt',
				printReceipt: 'Print Receipt',
			},
			issueRefund: 'Issue Refund',
			printInvoice: 'Print invoice',
			charge: 'Charge',
			chargeWithAmount: (amount: string) => `${TranslationEn.customers.paymentsInvoices.charge} ${amount}`,
			continue: 'Continue',
			scheduledPayments: 'Scheduled Payments',
			chargeBalance: 'Charge Balance',
			downloadInvoice: 'Download invoice',
			sendInvoice: 'Send Invoice',
			downloadAsPDF: 'Download as PDF',
			copyLink: 'Copy Invoice link',
			copyInvoiceLinkSuccessMessage: 'Link copied',
			scheduleWithNoPaymentMethod: 'Schedule payment due dates without payment method',
			schedulePayments: 'Schedule payments',
			schedulePayment: 'Schedule payment',
			paymentsSchedule: 'payments Schedule',
			shareInvoice: 'Share invoice',
			changeVisibility: 'Change Visibility',
			addDiscount: 'Add discount',
			addDiscountToInvoice: 'Add discount to invoice',
			billingInfo: 'Billing Info',
			purchaseDate: 'Purchase Date',
			amountDue: 'Amount Due',
			amount: 'Amount',
			totalReceived: 'Total Received',
			status: 'Status',
			payment: 'Payment',
			paymentMethodNotice: 'Notice! Some payment methods may include a transaction fee.',
			info: 'Info',
			paymentInfo: 'Payment Info',
			paymentMethod: 'Payment Method',
			paymentDetails: 'Payment Details',
			createdOn: 'Created On',
			total: 'Total',
			openBalance: (balance: number) => `Open Balance ${Pricify(balance, CurrencySymbolEnum.USD)}`,
			totalPaid: 'Total Paid',
			totalRefund: 'Total Refund',
			feesAndTips: 'Fees & Tips',
			[FeeTypeEnum.TIP]: 'Tip',
			[FeeTypeEnum.TRANSACTION]: 'Transaction fee',
			feeType: 'Type',
			customerDetails: 'Customer Details',
			purchasedItems: 'Purchased Items',
			purchasedItemsWithCount: (items: number) =>
				`${TranslationEn.customers.paymentsInvoices.purchasedItems} (${items ?? 0})`,
			addItem: {
				linkLabel: 'Add item',
				modalTitle: 'Add items to invoice',
				modalDescription: 'Select commerce products to add to this invoice.',
				addToInvoice: 'Add to invoice',
				addAndCharge: 'Add & charge',
				scheduledAddToInvoiceTooltip:
					"Items can't be added to an invoice with an active payment plan. Cancel the plan, add the items, then rebuild it, or charge now.",
				cancel: 'Cancel',
				selectLabel: 'Products',
				selectPlaceholder: 'Search products',
				selectedItems: {
					unitPrice: 'Unit price',
					tax: 'Tax',
					inclusiveSuffix: 'inc',
					remove: (productLabel: string) => `Remove ${productLabel}`,
				},
				noSellableFacilityError: (productLabel: string) =>
					`"${productLabel}" is not sold at any facility you have access to.`,
				successToast: 'Items added to invoice!',
				errorToast: 'Failed to add items to invoice. Please try again.',
			},
			items: 'Items',
			itemsAmount: (amount: string) => (amount ? `${amount} ${+amount === 1 ? 'Item' : 'Items'}` : '-'),
			quantity: 'Qty',
			tax: 'Tax',
			method: 'Method',
			receiptId: 'Receipt ID',
			date: 'Date',
			addReasonForDiscount: 'Add reason for discount',
			apply: 'Apply',
			next: 'Next',
			back: 'Back',
			remove: 'Remove',
			discount: 'Discount',
			subject: 'Scheduled Payments',
			chargeSchedulePayments:
				'Charge customer will cancel schedule payments action and all future schedule payment will be deleted',
			selectScheduledPayments:
				'Select any scheduled payments you would like to pay now. First select any failed payments.',
			rescheduleWarning:
				'Click on ‘schedule payment’ will cancel schedule payments action and all future payments will be deleted',
			abortScheduledPaymentsRequest: {
				title: 'Are you sure?',
				message: 'Please confirm that you want to cancel your request to schedule payments.',
			},
			invoicesNums: (invoices: number[]) => invoices.join(', '),
			header: {
				steps: {
					customerList: 'Customers',
					customer: 'Customer',
					invoiceList: 'Invoices',
					invoice: (val: string) => `Invoice #${val ?? 0}`,
					reservation: (val: string) => `Reservation #${val ?? 0}`,
				},
				tabs: {
					details: 'details',
					schedule: 'schedule',
				},
			},
			invoiceOrigin: {
				createdBy: (name: string) => `Created by ${name}`,
				badges: {
					backoffice: 'Backoffice',
					consumer: 'Consumer',
					consumer_checkout: 'Consumer',
					import: 'Import',
					mobile: 'Mobile',
					cron: 'Automation',
					unknown: 'Unknown',
				},
			},
			paymentRequestSuccess: 'Payment request was sent successfully to customer',
			setInvoiceToPublicSuccessMessage: 'The invoice is public to anyone with the invoice link',
			setInvoiceToPrivateSuccessMessage: 'The invoice is private, accessible only to the customer',
			paymentRequestError:
				"The payment request could not be sent. Please check the customer's email address and try again.",
			voidToggle: 'Voided items',
			scheduleTab: {
				columns: {
					description: 'Description',
					addons: 'Add Ons',
					dayTime: 'Day & Time',
					resource: 'Resource',
					event: 'Event Name',
				},
				info: {
					title: 'Schedule #',
					schedule: 'Schedule',
					participant: 'Participant',
					program: 'Program',
					products: 'Products',
					sessions: 'Sessions',
					more: 'More...',
					moreWithCount: (count: number) =>
						`${count} ${TranslationEn.customers.paymentsInvoices.scheduleTab.info.more}`,
					scheduleTitleWithIndex: (index: number) =>
						`${TranslationEn.customers.paymentsInvoices.scheduleTab.info.title}${index}`,
				},
			},
			voidMenu: 'Void items',
			voidModal: {
				title: 'Void Options',
				subTitle: 'Total due - ',
				subTitleWithAmount: (amount: string) =>
					`${TranslationEn.customers.paymentsInvoices.voidModal.subTitle}${amount}`,
				optionLabel: 'Choose void method',
				voidAllWarning: 'You are about to void the entire invoice',
				voidAllWarningNonVoidableItems: 'Can’t void all items. Use “Choose items” to continue.',
				voidPartialPaymentWarning:
					'You will be redirected to refund the amount paid before you can proceed to void the entire invoice',
				voidSucceeded: 'Invoice voided successfully',
				voidAllSucceeded: 'Invoice voided successfully',
				buttons: {
					all: 'Void All',
					items: 'Choose Items',
					cancel: 'Cancel',
					submit: 'Apply',
				},
				noVoidAvailable: {
					title:
						'This invoice cannot be voided because the paid amount is greater than the remaining item value. Please issue a refund first, then void.',
					description:
						'The paid amount is greater than all of the remaining items. You can refund part or all of the paid amount and then proceed to void the invoice.',
					mainButton: 'ISSUE REFUND',
					subButton: 'Cancel',
				},
			},
			filter: {
				dueDateOptions: {
					hasDueDate: 'Has Due Date',
					noDueDate: 'No Due Date',
				},
				overdueOptions: {
					overdue: 'Exceeded Due Date',
					title: 'Past Due',
				},
			},
			voidPage: {
				breadcrumbs: {
					customerList: 'Customer List',
					customer: 'Customer',
					invoice: 'Invoice',
					void: 'Void Invoice',
					refund: 'Issue a refund',
				},
				header: {
					buttons: {
						cancel: 'Cancel',
						void: 'Void Items',
						voidAmount: 'Void',
						voidAmountMessageWithAmount: (amount: string) =>
							`${TranslationEn.customers.paymentsInvoices.voidPage.header.buttons.voidAmount} ${amount}`,
					},
					invoiceNumber: 'Invoice no.',
					title: 'Void Invoice',
				},
			},
			loadingInovices: 'Loading invoices...',
			noInvoices: 'No invoices found',
			invoiceNotes: {
				createdBy: 'Created by',
				timeFormat: `MMM D, YYYY ${String.fromCharCode(8226)} hh:mm A`, // 8226 -> dot separator
				deleteConfirmation: 'Note deleted successfully',
				add: 'Add',
				addNote: 'Add Note',
				showMore: 'showMore',
				showLess: 'showLess',
				fetchFailed: 'We could not load notes for this invoice. Please refresh the page and try again.',
				deleteNoteModal: {
					title: ' Delete note',
					description: 'You are about to delete this note',
					mainButton: 'DELETE NOTE',
					cancelButton: 'Cancel',
				},
			},
			noRefundAllowedError: {
				title:
					'This invoice includes reservation items and cannot be refunded directly. To refund, go to the reservation page and use the Delete Event option.',
				message: 'To refund an event, please go to the reservation page and select the "Delete event" option',
			},
			visibilitySelect: {
				private: 'Only the customer',
				public: 'Anyone with the link',
				defaultLabel: 'Share the invoice with customers (General access)',
			},
			shareInvoiceModal: {
				title: 'Share Invoice',
				emailPlaceholder: 'Insert email',
				cancel: 'Cancel',
				shareInvoice: 'Share Invoice',
				emailLabel: 'Share invoice with',
				memoLabel: 'Add a memo to customer (optional)',
				copyInvoiceLink: 'Copy link',
				copiedInvoiceLink: 'Copied',
				errors: {
					cannotShareInvoice: 'Unable to share invoice, please try again',
				},
			},
			changeVisibilityModal: {
				title: 'Change Visibility',
				description: 'Change the visibility of this invoice to make it public or private',
				mainButton: 'Save',
				cancel: 'Cancel',
				copyLink: 'Copy Invoice Link',
				copiedLink: 'Copied',
				errors: {
					cannotChangeVisibility: 'Unable to change invoice visibility, please try again',
				},
			},
			discounts: {
				title: 'Delete discounts',
				content:
					'The discount for the lineItem/total invoice\nwill be removed from the invoice.\nAre you sure you want to continue?',
				mainButton: 'APPROVE',
				subButton: 'Cancel',
				failedToAddDiscount:
					'We could not apply the discount. Please try again. If the problem continues, refresh the page.',
				failedToRemoveDiscount:
					'We could not remove the discount. Please try again. If the problem continues, refresh the page.',
			},
		},
		membershipStatus: {
			redirectLink: 'View',
		},
		addACustomer: {
			breadcrumbLabels: { customers: 'Customers', addCustomer: 'Add Customer' },
		},

		newFamilyAccount: {
			title: 'New Family Account',
			addFamilyMemberInfo: {
				title: 'Add Family Member',
				tryAgainText:
					'An account with that email already exists. Please use a different email address or search for the existing customer.',
				description:
					"Add the primary family member. The primary customer is the payment holder and can access all other family members' details.",
			},
			breadcrumbLabels: { customers: 'Customers', addCustomer: 'Add Customer' },
			createFamilyErrorModal: {
				errorMessage:
					"We could not create the family account. The selected individual is not yet linked to a family. Please go to the individual's profile to link them first.",
				tryAgainText:
					"Go to the individual's customer profile and link them to a family before creating a family account.",
			},
		},
		newBusinessAccount: {
			title: 'New Business Account',
			form: {
				businessDetails: 'Business Details',
				personalAndContactDetails: 'Personal & Contact Details',
				businessName: 'Business Name',
				colorSet: 'Color Set',
				phoneNumber: 'Phone',
				email: 'Email',
				address: 'Address',
				copyBusinessContact: 'Copy email & contact details from business',
				accountRole: 'Account Role',
				title: 'Title',
			},
			addFamilyMemberInfo: {
				title: 'Add Administrator',
				tryAgainText: 'Please try again with a different email.',
				description:
					'Add the first Administrator to the business account. This person will receive an invitation email.',
			},
			createFamilyErrorModal: {
				errorMessage: 'Business account creation has failed! \n Individual account currently has no linked business.',
				tryAgainText: 'Please go to individual’s profile to try again.',
			},
		},
		newLinkedFamilyAccount: {
			header: { title: 'New Family Account', breadcrumb: { customer: 'Customer', addCustomer: 'Add Customer' } },
			actionButtons: { createAccount: 'Create Account' },
			details: {
				title: 'Add Family Account Details',
				description:
					'Once the family account is created this member will be the account primary member. More members can then be added.',
				familyAccountDetails: 'Family Account Details',
				accountName: 'Account Name',
			},
			primaryFamilyDetails: {
				title: 'Primary Family Account Member',
				description:
					'This member will be the account primary member, their information will be the family account information by default unless otherwise defined.',
				personalDetails: { title: 'Personal Details' },
				emergencyContact: { title: 'Emergency Contact' },
			},
			successMessage: 'Family Account created successfully',
		},
		newLinkedBusinessAccount: {
			header: { title: 'New Business Account', breadcrumb: { customer: 'Customer', addCustomer: 'Add Customer' } },
			details: {
				title: 'Add Business Account Details',
				description:
					'Once the business account is created this member will be the account admin. More members can then be added.',
			},
			primaryFamilyDetails: {
				title: 'Business Admin',
			},
			successMessage: 'Business Account created successfully',
		},
		editFamilyAccount: {
			familyAccountDetails: { title: 'FAMILY ACCOUNT DETAILS', accountName: 'Account Name' },
			businessAccountDetails: { title: 'BUSINESS ACCOUNT DETAILS', accountName: 'Account Name' },
			primaryMemberInfo: {
				title: 'Primary Family Account Member',
				description:
					'The account primary member’s information will be the family account information by default unless otherwise defined.',
			},
			adminMemberInfo: {
				title: 'Business Admin',
				description:
					'The account admin’s information will be the business account information by default unless otherwise defined.',
			},
			personalDetails: {
				title: 'PERSONAL DETAILS',
				firstName: 'First Name',
				lastName: 'Last Name',
				gender: 'Gender',
				dateOfBirth: 'Date Of Birth',
				selectColorSet: 'Select Color Set',
			},
			contactDetails: {
				title: 'CONTACT DETAILS',
				address: 'Address',
				city: 'City',
				state: 'State',
				zipCode: 'Zip code',
				phoneNo: 'Phone no.',
				email: 'Email',
				emailNote: 'Email is sent to complete registration',
			},
			emergencyContact: {
				title: 'EMERGENCY CONTACT',
				contactName: 'Contact Name',
				phoneNo: 'Phone no.',
				fieldLabelWithRequiredIndicator: (label: string, isRequired: boolean) => (isRequired ? `${label} *` : label),
			},
			successMessage: 'Family Account was edited successfully',
			successMessageBusiness: 'Business Account was edited successfully',
		},
		leaveFormWarningModal: {
			title: 'Information not saved',
			description: 'Are you sure you want to leave? \n The information you have entered will not be saved.',
			primaryButton: "YES, I'M SURE",
			secondaryButton: 'CANCEL',
		},
		underageIndependentWarning: {
			title: 'This customer is under 18',
			description: (isEdit = false, accountRole?: GroupUserRoleEnum) =>
				`This customer is under 18. Are you sure you want to ${isEdit ? 'continue with' : 'create'} ${
					accountRole === GroupUserRoleEnum.PRIMARY
						? 'a primary'
						: isPrimaryGroupUserRole(accountRole)
							? 'an administrator'
							: 'an independent'
				} account?`,
			primaryButton: 'CONTINUE',
			secondaryButton: 'CANCEL',
		},
		account: 'Account',
		linkedAccountName: (name: string, isFamily: boolean) =>
			`${name}${isFamily ? ` ${TranslationEn.customers.account}` : ''}`,
		membershipTab: {
			membership: 'Membership',
			startDate: 'Start date',
			endDate: 'End date',
			renewal: 'Renewal',
			payment: 'Payment',
			invoice: 'Invoice',
			receipt: 'Receipt',
			status: 'Status',
			customerName: 'Customer Name',
			searchPlaceholder: 'Search by Membership',
			searchPlaceholderFamily: 'Search by Membership or Customer',
			filter: 'Filter',
			filterOptions: {
				membershipStatus: {
					title: 'MEMBERSHIP STATUS',
					active: 'Active',
					cancelled: 'Canceled', //the reason for key is with double 'l's is the BE enum MembershipStatusEnum
					expired: 'Expired',
					paused: 'Paused',
					pending: 'Pending',
				},
				paymentStatus: {
					title: 'PAYMENT STATUS',
					paid: 'Paid',
					partial: 'Partially Paid',
					['not_paid']: 'Unpaid',
					refunded: 'refunded',
					void: 'Void',
				},
				renewalType: {
					title: 'RENEWAL TYPE',
					['fix_membership']: 'Fixed',
					['rolling_membership']: 'Rolling',
				},
			},
			noMemberships: 'There are no memberships associated with this customer',
			noMatchFilter: 'No memberships match this filter',
			noMatchSearch: 'No membership matched this search',
			errorLoadingMemberships: `We could not load memberships for this customer. Please refresh the page. If the problem continues, contact ${SUPPORT_EMAIL}.`,
			cancellationDatePrefix: 'on',
			replacePaymentMethodMissingPayer: 'Unable to identify the billing account for this membership. Please try again.',
			more: {
				viewMembership: 'View membership',
				viewInvoice: 'View invoice',
				cancelMembership: 'Cancel membership',
				cancelAutoRenewal: 'Cancel auto renewal',
				pauseMembership: 'Pause membership',
				undoPauseMembership: 'Cancel scheduled pause',
				editPause: 'Edit pause',
				manageFamilyMembers: 'Manage family members',
				replacePaymentMethod: 'Replace payment method',
			},
			manageFamilyMembers: {
				header: 'Manage family members',
				subtitle: 'Select the family members you want to add to the membership',
				save: 'Save',
				seatsLeft: (remaining: number, total: number) => `${remaining} of ${total} seats left`,
				seatsOverBy: (overBy: number, total: number) => `${overBy} over the ${total} seat limit`,
				seatsSelectedUncapped: (selected: number) =>
					selected === 1 ? `${selected} member selected` : `${selected} members selected`,
				overCapacityWarning: (overBy: number, maxMembers: number) =>
					`You're selecting ${overBy} ${overBy === 1 ? 'member' : 'members'} above the ${maxMembers}-seat limit for this membership.`,
				successSaving: (firstName: string, additionalCount: number) =>
					additionalCount === 0
						? `${firstName} was added to the membership`
						: `${firstName} and ${additionalCount} more were added to the membership`,
				successRemoving: (firstName: string, additionalCount: number) =>
					additionalCount === 0
						? `${firstName} was removed from the membership`
						: `${firstName} and ${additionalCount} more were removed from the membership`,
				successUpdated: 'Family members were updated',
				viewFamilyMembershipsLink: 'View family memberships',
				errorLoading: 'Unable to load family members. Please try again.',
				errorSaving: 'Unable to save family member changes. Please try again.',
				missingFamilyAccount: 'Family account not found for this membership.',
				missingPackageContext: 'This membership cannot be managed because it is missing package information.',
			},
			dataGrid: {
				subject: 'memberships',
				columns: {
					membership: 'Membership',
					customer: 'Customer',
					startDate: 'Start date',
					renewalEndDate: 'Renewal / End date',
					type: 'Type',
					renewalMethod: 'Renewal method',
					audience: 'Audience',
					price: 'Price',
					status: 'Status',
					payment: 'Payment',
				},
				typeLabels: {
					rolling: 'Rolling',
					fixed: 'Fixed',
					everyMonths: (numMonths: number) => `Every ${numMonths} months`,
				},
				renewSubLabels: {
					autoRenewCancelled: 'Auto-renew canceled',
					renewing: 'Renewing',
				},
				paymentStatusLabels: {
					[PaymentStatusEnum.FULLY_PAID]: 'Paid',
					[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partially Paid',
					[PaymentStatusEnum.NOT_PAID]: 'Unpaid',
					[PaymentStatusEnum.PENDING]: 'Scheduled Payments',
					[PaymentStatusEnum.REFUNDED]: 'Refunded',
					[PaymentStatusEnum.VOID]: 'Voided',
					[PaymentStatusEnum.RETRY_IN_PROGRESS]: 'Pending',
				},
				membershipStatusLabels: {
					[MembershipStatusEnum.ACTIVE]: 'Active',
					[MembershipStatusEnum.ACTIVE_CANCELLED]: 'Active',
					[MembershipStatusEnum.PAUSED]: 'Paused',
					[MembershipStatusEnum.PAUSED_CANCELLED]: 'Paused',
					[MembershipStatusEnum.PAUSE_PENDING]: 'Active',
					[MembershipStatusEnum.PENDING]: 'Upcoming',
					[MembershipStatusEnum.CANCELLED]: 'Canceled',
					[MembershipStatusEnum.EXPIRED]: 'Expired',
				},
				statusTooltips: {
					pauseScheduled: (date: string) => `Pause scheduled to start on ${date}`,
					autoRenewCancelled: 'Auto-renew has been canceled',
					autoRenewCancelledOn: (date: string) => `Auto-renew canceled on ${date}`,
					activeUntil: (date: string) => `Active until ${date}`,
					cancelledImmediatelyOn: (date: string) => `Canceled immediately on ${date}`,
					cancelledImmediately: 'Canceled immediately',
					cancelledEndOfPeriodOn: (date: string) => `Canceled at end of period on ${date}`,
					cancelledEndOfPeriod: 'Canceled at end of period',
					reason: (reason: string) => `Reason: ${reason}`,
				},
			},
		},
		mergeCustomers: {
			title: 'Merge Customers',
			breadcrumbLabels: (id?: number) => [
				id ? { label: 'Customer', to: getCustomerPagePath(id) } : { label: 'Customers', to: `/` },
				{
					label: 'Merge',
					to: '#',
				},
			],
			successMessage: 'Accounts merged successfully',
			errorMessage: 'Failed to merge accounts. Please try again later.',
			noCustomerDetailsSelectedError: 'No customer details selected',
			familyMergeWarningModal: {
				title: 'Family Merge Required',
				description:
					'The customers you selected belong to different family accounts. To merge these customers, you must first combine their families into one account.',
				info: 'After merging families, all members from both families will be combined under one family account. You can then merge individual duplicate customers.',
				confirmButtonText: 'CONTINUE',
				cancelButtonText: 'CANCEL',
			},
			overview: {
				title: 'Merge Customer Accounts',
				description:
					'Review the selected customer profiles before proceeding. If any contact details conflict, you’ll be prompted to choose which to keep.\nAll other data — including billing history, balances, memberships, and waivers — will merge automatically.',
				mainButton: 'Continue',
				noDataCard: {
					description: 'Add a customer whose account you\nwould like to merge with.',
					button: 'Click to Select Customer',
				},
				addButton: 'Add Customer',
				waiver: 'Waiver',
				membership: 'Membership',
				tooltipErrors: {
					familyMerge:
						'You can only merge two families at a time. Please complete this merge before adding more customers.',
				},
			},
			preview: {
				title: 'Merge Preview',
				description:
					'This is the information the merged customer profile will contain. Please review carefully before completing the merge - this action cannot be reversed.',
				mainButton: 'MERGE',
				subButton: 'EDIT DETAILS',
				backButton: 'GO BACK',
				content: {
					gender: 'Gender',
					dateOfBirth: 'Date of Birth',
					age: 'Age',
					phone: 'Phone',
					address: 'Address',
					email: 'Email',
					paymentMethods: 'Payment Methods',
					familyMembers: 'Family Members:',
					memberships: 'Memberships',
					waivers: 'Waivers',
					errors: {
						familyMembers: 'Error loading family members',
					},
				},
			},
			selectCustomerModal: {
				title: 'Select Customer',
				description: 'Select the customer you would like to merge with.',
				cancelButton: 'CANCEL',
				confirmButton: 'Add to merge',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
			},
			customerDetailsModal: {
				detailsStep: {
					title: 'Customer Details',
					description: 'Select the details to keep when customers are merged:',
					mainButton: 'preview',
					secondButton: 'Cancel',
					radios: {
						name: 'Name:',
						birthday: 'Birthday:',
						gender: 'Gender:',
						phone: 'Phone Number:',
						address: 'Address:',
						email: 'Email:',
						photo: 'Photo:',
						emergencyContact: 'Emergency Contact:',
						paymentMethods: {
							label: 'Payment Methods:',
							tooltip:
								'Only one account’s saved payment methods can be retained — you’ll need to choose which one to keep.',
							tooltipAriaLabel: 'Payment methods tooltip',
						},
					},
				},
				paymentMethodsStep: {
					header: {
						header: 'Assign New Payment Method',
						body: 'Some memberships or payment plans are linked to payment methods that won’t be transferred. To ensure uninterrupted billing, please select a new payment method to assign.',
						subText: 'Notice! Some payment methods may include a transaction fee.',
					},
				},
				phoneLabelBuilder: (name: string, phone: any) => `${name}${name && phone ? ' - ' : ''}${phone}`,
			},
			mergingFamiliesAlert: {
				title: 'Merge Families',
				description:
					'Choose which family to keep. The selected family’s primary account will remain primary, and all members from the other family will be added as dependents.',
				primaryButton: 'MERGE FAMILIES',
				cancelButton: 'CANCEL',
				currentMembers: 'Current Members:',
				membersToBeAdded: 'Members to be Added:',
				familyLabelBuilder: (name: string, membersCount: number) => `${name} (${membersCount} members)`,
				successToast:
					'Families have been merged. You can now merge individual duplicate customers within the same family account.',
				failedToMergeFamiliesToast: 'Failed to merge families.',
				failedToMergeFamiliesError: 'Failed to merge families',
			},
			okayButton: 'OKAY',
			unableToMergeAlert: {
				title: 'Unable to Merge These Accounts',
				description:
					'Both customers are connected to multiple Bond organizations, ' +
					'so this merge requires support assistance. Please {contact support} and we’ll take care of it',
				primaryButton: 'OKAY',
			},
			multipleFamiliesAlert: {
				title: 'Merging Customer Families',
				description: "Merging separate families isn't currently supported. For assistance, please {contact support}",
				primaryButton: 'OKAY',
			},
			conflictNamesPlaceholder: '{conflictNames}',
			conflictNames: {
				separator: ', ',
				overflowFn: (count: number) => `+${count} more`,
				withFoldersFn: (seasonName: string | undefined, folderNames: string[]) =>
					seasonName ? `${seasonName} (${folderNames.join(', ')})` : folderNames.join(', '),
			},
			duplicateMembershipsAlert: {
				title: 'Duplicate Memberships Detected',
				description:
					'Both customers are active members of {conflictNames}. Cancel the membership for one of them, then you’ll be able to proceed with the merge.',
				primaryButton: 'VIEW MEMBERS',
			},
			duplicateProgramsAlert: {
				title: 'Duplicate Registrations Detected',
				description:
					'Both customers are registered for {conflictNames}. Remove the registration from one of them, then you’ll be able to proceed with the merge.',
				primaryButton: 'VIEW PARTICIPANTS',
			},
			differentGroupsAlert: {
				title: 'Conflicting Group Assignments',
				descriptionFn: (folderType: MetaTypeEnum.GROUP | MetaTypeEnum.TEAM) =>
					`The customers are assigned to different ${
						folderType === MetaTypeEnum.TEAM ? 'teams' : 'groups'
					} in {conflictNames}. Remove one of them, then you’ll be able to proceed with the merge.`,
				primaryButton: 'VIEW GROUPS',
			},
			businessAccountNotSupportedAlert: {
				title: 'Business Accounts Cannot Be Merged',
				description:
					'A business account cannot be merged with another account. Customers of the same business account can be merged, but not customers belonging to two different accounts.',
				primaryButton: 'OKAY',
			},
			areYouSureAlert: {
				title: 'Are you sure?',
				description:
					'Merging these accounts will permanently combine their personal info, billing history, and activity. Payment methods may also be carried over if present. This cannot be undone. Are you sure you want to continue?',
				primaryButton: "I'M SURE",
				secondaryButton: 'CANCEL',
			},
		},
	},
	rentals: {
		title: 'Manage Rental Products',
		steps: {
			rentals: 'Rentals',
			reservations: 'Reservations',
		},
		archiveProduct: {
			title: 'Archive Product',
			description:
				'After Archiving, the product will be removed from the main list and you will be able to find it in the archive',
			archive: 'Archive',
			cancel: 'Cancel',
		},
		addNewProduct: '+ New Rental Product',
		sportsFilterPlaceHolder: 'Filter by activities',
		resourcesFilterPlaceHolder: 'Filter by resources',
		searchByNamePlaceHolder: 'Search by name',
		more: 'More...',
		productsList: {
			tooltipOverflowCount: (count: number) => `+${count} More...`,
		},
		rentalsTable: {
			columns: {
				id: 'ID',
				glCode: 'GL Code',
				name: 'Product Name',
				category: 'Category',
				activities: 'Activity type',
				duration: 'Duration',
				availability: 'Availability',
				space: 'Spaces',
				instructor: 'Instructors',
				price: 'Price',
				priceType: 'Price Type',
				online: 'Online',
				status: 'Status',
				accountingCodes: 'accounting codes',
				facilities: 'Facilities',
				actions: 'Actions',
			},
			columnsFormat: {
				price: (prices: PriceDto[]) => {
					const price: PriceDto = prices[0];
					const priceString: string = Pricify(price.price, CurrencySymbolEnum[price.currency]);

					if (prices.length > 1 && !price.isDefault) {
						return `${priceString}+`;
					}
					return priceString;
				},
				viewMore: (count: number) => `+${count} more...`,
			},
			tableAction: {
				duplicateSuccess: (productName: string) => `Product '${productName}' has been duplicated successfully`,
				edit: 'Edit Product Details',
				deactivate: 'Deactivate Product',
				activate: 'Activate/Deactivate Product',
				updateStatus: (status: ActivityEnum) =>
					status === ActivityEnum.ACTIVE ? 'Deactivate Product' : 'Activate Product',
				successMessage: (status: ActivityEnum) =>
					status === ActivityEnum.ACTIVE ? 'Product has been activated' : 'Product has been deactivated',
				errorMessage: 'An error occurred while updating the product status',
				duplicateFailure: (productName: string) => `Failed to duplicate product: ${productName}`,
				archive: 'Archive product',
				unarchive: 'Unarchive product',
				archiveStatus: (status: AdditionalStatusesEnum) =>
					status === AdditionalStatusesEnum.ARCHIVED ? 'Unarchive Product' : 'Archive Product',
				duplicate: 'Duplicate product',
				view: 'View product',
				createProduct: 'Create Rental Product',
			},
			pagination: {
				subjects: {
					rentalsList: 'rental products',
				},
			},
			actions: {
				search: {
					placeholder: 'Search by name',
				},
				filters: {
					headers: {
						space: 'SPACE',
						activity: 'ACTIVITY',
						instructor: 'INSTRUCTOR',
						status: 'STATUS',
					},
					activities: {
						activityTypes: {
							title: 'Filter by activities',
						},
					},
					statusOptions: {
						[ActivityEnum.ACTIVE]: 'Active',
						[ActivityEnum.INACTIVE]: 'Inactive',
						[AdditionalStatusesEnum.ARCHIVED]: 'Archived',
						availableOnline: 'Available',
						notAvailableOnline: 'Not Available',
					},
					archiveFilter: {
						title: 'Archive',
						includeArchived: 'Include archived',
					},
				},
			},
			state: {
				loading: 'Loading rental products...',
				noData: 'No rental products found.',
			},
		},
		passesTable: {
			columns: {
				id: 'ID',
				name: 'Pass Name',
				category: 'Category',
				facilities: 'Facilities',
				space: 'Spaces',
				quantity: 'Qty',
				price: 'Price',
				online: 'Online',
				status: 'Status',
				actions: 'Actions',
			},
			columnsFormat: {
				viewMore: (count: number) => `+${count} more...`,
				punches: (quantity: number) => (quantity === 1 ? '1 Punch' : `${quantity} Punches`),
				duration: (amount: number, unit: string) => {
					const pluralizable = !['min', 'hr', 'sec'].includes(unit);
					const suffix = pluralizable && amount > 1 ? 's' : '';
					return `${amount} ${unit}${suffix}`;
				},
			},
			tableAction: {
				purchase: 'Purchase Pass',
				edit: 'Edit Pass Details',
				updateStatus: (status: ActivityEnum) => (status === ActivityEnum.ACTIVE ? 'Deactivate Pass' : 'Activate Pass'),
				successMessage: (status: ActivityEnum) =>
					status === ActivityEnum.ACTIVE ? 'Pass has been activated' : 'Pass has been deactivated',
				errorMessage: 'An error occurred while updating the pass status',
				archiveStatus: (status: AdditionalStatusesEnum) =>
					status === AdditionalStatusesEnum.ARCHIVED ? 'Unarchive Pass' : 'Archive Pass',
				duplicate: 'Duplicate Pass',
				duplicateSuccess: (productName: string) => `Pass '${productName}' has been duplicated successfully`,
				duplicateFailure: (productName: string) => `Failed to duplicate pass: ${productName}`,
				createPass: 'Create Rental Pass',
			},
			archiveProduct: {
				title: 'Archive Pass',
				description:
					'After Archiving, the pass will be removed from the main list and you will be able to find it in the archive',
				archive: 'Archive',
				cancel: 'Cancel',
			},
			pagination: {
				subjects: {
					passesList: 'passes',
				},
			},
			actions: {
				filters: {
					statusOptions: {
						[ActivityEnum.ACTIVE]: 'Active',
						[ActivityEnum.INACTIVE]: 'Inactive',
						[AdditionalStatusesEnum.ARCHIVED]: 'Archived',
						availableOnline: 'Available',
						notAvailableOnline: 'Not Available',
					},
					archiveFilter: {
						title: 'Archive',
						includeArchived: 'Include archived',
					},
				},
			},
			state: {
				loading: 'Loading passes...',
				noData: 'No passes found.',
			},
		},
		categoriesTable: {
			columns: {
				id: 'ID',
				name: 'Name',
				bookingType: 'Booking Type',
				primaryResource: 'Primary Resource',
				products: 'Products',
				advanceBooking: 'Advance Booking',
				vip: 'VIP',
				minNotice: 'Min. Notice',
				duration: 'Duration',
				approvalType: 'Approval',
				tipEligible: 'Tip Eligible',
				actions: 'Actions',
			},
			columnsFormat: {
				viewMore: (count: number) => `+${count} more...`,
			},
			tableAction: {
				edit: 'Edit Category',
				duplicate: 'Duplicate Category',
				archive: 'Archive Category',
				archiveDisabledWithProducts: 'Remove products from this category before archiving',
				create: 'Create Category',
			},
			confirmation: {
				archive: {
					title: 'Archive Category',
					message: 'This removes the category from lists. It can only be archived when it has no products.',
					confirmButtonText: 'Archive',
				},
			},
			successMessages: {
				archive: 'Category archived',
			},
			notifications: {
				notSupported: (actionLabel: string) => `${actionLabel} is not supported yet.`,
			},
			filters: {
				approvalType: {
					autoBook: 'Auto-book',
					request: 'Request',
				},
				vipBookingEnabled: {
					yes: 'Yes',
					no: 'No',
				},
				tipEligible: {
					yes: 'Yes',
					no: 'No',
				},
				bookingType: {
					[ResourceNameTypeEnum.INSTRUCTOR]: 'Instructor',
					[ResourceNameTypeEnum.SPACE]: 'Space',
				},
			},
			labels: {
				subject: 'categories',
				loadingMessage: 'Loading categories...',
				noDataMessage: 'No categories found.',
				errorMessage: 'Failed to load categories',
			},
		},
		portalsTable: {
			columns: {
				id: 'ID',
				name: 'Name',
				facilities: 'Facilities',
				categories: 'Product Categories',
				activities: 'Activities',
				view: 'View',
				status: 'Status',
				actions: 'Actions',
			},
			tableActions: {
				create: 'Create Portal',
				edit: 'Edit Portal',
				view: 'View Portal',
				duplicate: 'Duplicate Portal',
				publish: 'Publish Portal',
				unpublish: 'Unpublish Portal',
				publishSuccess: 'Portal published successfully',
				unpublishSuccess: 'Portal unpublished successfully',
				statusUpdateError: 'Failed to update portal status',
			},
			duplicate: {
				copyOf: (name: string) => `${name} copy`,
				success: (name: string) => `Successfully duplicated '${name}'`,
			},
			filters: {
				facility: 'Facility',
				category: 'Category',
				activity: 'Activity',
				status: {
					draft: 'Draft',
					published: 'Published',
					unpublished: 'Unpublished',
				},
			},
			strings: {
				subject: 'portals',
				loadingMessage: 'Loading portals...',
				noDataMessage: 'No portals found.',
				errorMessage: 'Failed to load portals',
			},
		},
		portalForm: {
			header: {
				title: 'Portal Profile',
				breadcrumb: { label: 'Portal Profile', to: '#' },
			},
			dialog: {
				title: 'Information not saved',
				description: 'Are you sure you want to leave?',
				secondaryDescription: 'The information you have entered will not be saved.',
				buttons: {
					primary: "YES, I'M SURE",
					secondary: 'CANCEL',
				},
			},
			emptyState: {
				title: 'Portal not found',
				description: 'This portal may have been deleted or you don’t have access.',
			},
			actions: {
				publish: 'Publish Portal',
				unpublish: 'Unpublish Portal',
				goToLivePage: 'Go to Live Page',
			},
			messages: {
				update: {
					success: (name: string) => `'${name}' updated successfully!`,
					publish: (name: string) => `${name} published!`,
					unpublish: (name: string) => `${name} unpublished!`,
				},
				create: {
					success: (name: string) => `${name} created successfully!`,
				},
			},
			buttons: {
				back: 'Back',
			},
			mainDetails: {
				title: 'Portal Settings',
				tooltip:
					'Portals are live booking pages where customers can book rentals and lessons. Use the settings below to control what’s available.',
				productsCount: (count: number = 0): string => `${count} matching products available`,
				generalDetails: {
					title: 'General Details',
					all: 'Select All',
					inputs: {
						name: 'Name',
						categories: 'Product Categories',
						defaultCategory: 'Default Category',
						facilities: 'Facilities',
						defaultFacility: 'Default Facility',
						activities: 'Activities',
						defaultActivity: 'Default Activity',
					},
					resourceTypes: {
						[ResourceTypeEnum.SPACE]: 'Space',
						[ResourceTypeEnum.INSTRUCTOR]: 'Instructor',
					},
				},
				displaySettings: {
					title: 'Display Settings',
					tooltip: 'Choose how customers can view available slots on your booking page and which view they see first.',
					inputs: {
						views: 'Display Options',
						defaultView: 'Default Display',
					},
					viewOptions: [
						{ label: 'Grid', value: OnlineBookingViewsEnum.MATRIX },
						{ label: 'List', value: OnlineBookingViewsEnum.LIST },
						//{ label: 'Calendar', value: OnlineBookingViewsEnum.CALENDAR },
					],
				},
				startTime: {
					toggleLabel: 'Preferred Start Time',
					toggleTooltip: 'Allow customers to filter availability by a preferred booking start time on the portal.',
					intervalsLabel: 'Start Time Intervals',
					intervalsTooltip:
						'Choose which time intervals bookings can start on. For example: Selecting :00 and :30 allows bookings at 5:00, 5:30, 6:00, etc.',
					intervalOptions: [
						{ label: ':00', value: 0, additionalRows: [{ additionals: ['On the hour'] }] },
						{ label: ':15', value: 15, additionalRows: [{ additionals: ['15 minutes past'] }] },
						{ label: ':30', value: 30, additionalRows: [{ additionals: ['30 minutes past'] }] },
						{ label: ':45', value: 45, additionalRows: [{ additionals: ['45 minutes past'] }] },
					],
				},
			},
		},
		categoryProfile: {
			buttons: {
				back: 'Back',
			},
			header: {
				title: 'Category Profile',
				breadcrumb: { label: 'Category Profile', to: '#' },
			},
			options: {
				timeUnits: {
					days: 'Days',
					hours: 'Hours',
					minutes: 'Minutes',
					weeks: 'Weeks',
					months: 'Months',
				},
				onlineBookingTypes: {
					space: 'Space',
					instructor: 'Instructor',
				},
				slotStartTime: {
					automatic: 'Automatic (recommended)',
					onTheHour: 'On the hour (:00)',
					quarterPast: '15 minutes past (:15)',
					halfPast: '30 minutes past (:30)',
					quarterTo: '45 minutes past (:45)',
				},
			},
			emptyState: {
				missingCategory: {
					title: 'Category not found',
					description: 'This category may have been deleted or you don’t have access.',
				},
			},
			labels: {
				mainDetails: 'Main Details',
				generalDetails: 'General Details',
				categoryName: 'Category Name',
				onlineBookingType: 'Primary Booking Type',
				onlineBookingTypeTooltip:
					'This setting controls what customers book online. Once set, it cannot be changed.\n\nChoose Instructor to set up lesson bookings. Customers book a specific staff member, and a space is assigned automatically.\n\nChoose Space to set up space bookings. Customers book a space, and you can optionally assign staff later.',
				categoryDescription: 'Category Description',
				categoryNameTooltip:
					'A Category groups reservation products that share online booking rules.\n\nCategories control:\n\n- Booking windows\n- VIP access for members\n- Duration rules\n- Approval workflow\n\nProducts assigned to the same category appear together in the online booking portal.',
				onlineBookingConstraints: 'Online Booking Constraints',
				advanceBookingWindow: 'Advance Booking Window',
				advanceBookingWindowTooltip:
					'Specify how far in the future a customer can see available slots when they are booking online (Note: see VIP Access to set up membership-specific booking windows!)',
				minBookingNotice: 'Minimum Booking Notice',
				minBookingNoticeTooltip:
					'Limit how close to the slot start time your customer can book online, giving you time to react to the request properly.',
				maxSequentialHours: 'Max Sequential Hours',
				maxHoursTotalPerDay: 'Max Hours Total (per day)',
				duration: 'Duration',
				defaultOnlineSlot: 'Default Online Slot',
				incrementDuration: 'Increment Duration',
				minBookingDuration: 'Min Booking Duration',
				maxBookingDuration: 'Max Booking Duration',
				slotStartTime: 'Slot Start Time',
				slotStartTimeTooltip:
					'Choose when booking slots start. Slots can begin at the first available time or snap to a specific minute mark (:00, :15, :30, :45), while still respecting booking rules such as product schedules, minimum notice, and duration increments. To let customers choose their preferred start time, enable Preferred Start Time in Portal Settings.',
				slotStart: 'Slot Start',
				offerOverlappingStartTimes: 'Offer overlapping start times',
				offerOverlappingStartTimesTooltip:
					'When selected, customers can choose more start times based on the configured time increments.',
				vipAccess: 'VIP Access',
				vipAccessTooltip:
					'Select memberships to give them "early access" to reserve spaces / instructors in this category online',
				tipping: 'Tipping',
				tipEligible: 'Tip Eligible',
				vipAccessTitle: 'VIP Access Title',
				memberships: 'Memberships',
				membershipsPlaceholder: 'Select',
				addVipSettings: 'Add VIP Settings',
				onlineBookingApproval: 'Online Booking Approval',
				approvalTypeAutoBook: 'Auto-book',
				approvalTypeAutoBookDescription: '(All customers can book and pay online without need for approval)',
				approvalTypeRequestApproval: 'Request & Approval',
				approvalTypeRequestApprovalDescription: '(All customer bookings are sent to staff for review and approval)',
				autoAssignResources: 'Auto-assign resources',
				autoAssignResourcesTooltip:
					'Customers book a time. They do not pick a space. The system assigns the next open space from the list below.',
				autoAssignInstructorTooltip:
					'Customers book a time and a count. They do not pick a space or an instructor. For each one, the system assigns the next open space and the next open instructor from the lists below.',
				maxResourcesPerBooking: 'Max resources per booking',
				maxResourcesPerBookingTooltip:
					'How many resources one online booking can take in the same timeslot. Default is 1. When auto-assign is on, customers pick a count and the system assigns that many. When customers pick resources, they can choose up to this many for the same timeslot.',
				resourceDisplayNameSingular: 'Resource name (singular)',
				resourceDisplayNameSingularTooltip:
					'Optional. Shown when the customer books one resource, for example "1 bay". Leave blank to use the default.',
				resourceDisplayNameSingularPlaceholder: 'bay',
				resourceDisplayNamePlural: 'Resource name (plural)',
				resourceDisplayNamePluralTooltip:
					'Optional. Shown in the count dropdown, for example "How many bays?". Leave blank to use the default.',
				resourceDisplayNamePluralPlaceholder: 'bays',
				autoAssignInstructorGroup: 'Instructors',
				autoAssignResourceOrderHelp:
					'Drag to set which space is tried first. New spaces are added at the end. Spaces removed from this category are skipped.',
				autoAssignInstructorOrderHelp:
					'Drag to set the order each list is tried. The first open space is paired with the first open instructor. A count of 2 takes the next two of each. This does not tie an instructor to a specific space. New resources are added at the end.',
				autoAssignNoResources:
					'No eligible resources on this category yet. Add resources to products in this category, then set their order here.',
				autoAssignResourcesLoadError:
					'Could not load resources for this category. The saved assignment order was kept.',
				resourceSubType: (subType: ResourceSubTypeEnum | typeof BAY_RESOURCE_SUB_TYPE) =>
					capitalize(SPACE_SUB_RESOURCE_TYPE_MAP[subType]),
			},
			notifications: {
				saveSuccess: (params: { categoryName: string; isCreate: boolean }) =>
					`Category with name "${params.categoryName}" ${params.isCreate ? 'created' : 'updated'}`,
				saveError: (params: { categoryName: string; isCreate: boolean }) =>
					`Failed to ${params.isCreate ? 'create' : 'update'} category "${params.categoryName}"`,
			},
			errors: {
				missingCategoryId: 'missing_category_id',
				createProductCategoryFailed: 'create_product_category_failed',
				updateProductCategoryFailed: 'update_product_category_failed',
				resourceOrderLoadError:
					'Could not load the current resources, so this category was not saved. Try again before saving a resource order.',
			},
			validation: {
				toastTitle: 'Please fix the following issues before saving:',
				requiredCategoryTitle: 'Category Name is required.',
				requiredOnlineBookingType: 'Online booking type is required.',
				minBookingDurationAtLeast: (minutes: number) =>
					`Min booking duration must be an integer and at least ${minutes} minutes.`,
				maxBookingDurationAtLeast: (minutes: number) =>
					`Max booking duration must be an integer and at least ${minutes} minutes.`,
				incrementDurationAtLeast: (minutes: number) =>
					`Increment duration must be an integer and at least ${minutes} minutes.`,
				defaultOnlineSlotAtLeast: (minutes: number) =>
					`Default online slot must be an integer and at least ${minutes} minutes.`,
				minBookingDurationMaxHours: (hours: number) => `Min booking duration cannot exceed ${hours} hours.`,
				maxBookingDurationMaxHours: (hours: number) => `Max booking duration cannot exceed ${hours} hours.`,
				incrementDurationMaxHours: (hours: number) => `Increment duration cannot exceed ${hours} hours.`,
				defaultOnlineSlotMaxHours: (hours: number) => `Default online slot cannot exceed ${hours} hours.`,
				maxDurationGteMinDuration: 'Max booking duration must be greater than or equal to min booking duration.',
				defaultBetweenMinAndMax: 'Default online slot must be between min booking duration and max booking duration.',
				defaultIncrementsOfStep: 'Default online slot must be in increments of the selected increment duration.',
				maxSequentialExceedsMaxDaily: 'Max sequential hours cannot exceed max hours total per day.',
				vipDuplicateMembership:
					'VIP memberships cannot appear in multiple VIP settings (duplicate membership selected).',
				vipAdvanceWindowPositiveInteger: (index: number) =>
					`VIP setting #${index}: advance booking window must be a positive integer.`,
				vipMinNoticePositiveInteger: (index: number) =>
					`VIP setting #${index}: minimum booking notice must be a positive integer.`,
				schemaMaxDurationGteMinDuration: 'Max duration must be greater than or equal to min duration.',
				schemaDefaultBetweenMinAndMax: 'Default duration must be between min duration and max duration.',
				schemaDefaultIncrementsOfStep: 'Default duration must be in increments of duration step.',
				schemaVipDuplicateMembership: 'VIP memberships cannot appear in multiple VIP settings.',
				incrementExceedsMaxDuration: 'Increment duration cannot exceed max booking duration.',
				defaultBelowMinDuration: 'Default online slot must be greater than or equal to min booking duration.',
				defaultAboveMaxDuration: 'Default online slot must be less than or equal to max booking duration.',
				noticeMustBeLessThanAdvance: 'Minimum booking notice must be less than the advance booking window.',
				vipNoticeMustBeLessThanAdvance: (index: number) =>
					`VIP setting #${index}: minimum booking notice must be less than the advance booking window.`,
			},
		},
		emptyState: {
			primary: 'Turn your resources into income',
			secondary: "Looks like you haven't created any rental products yet",
			rentalProductCreation: 'CREATE RENTAL PRODUCT',
		},
		conflicts: {
			title: 'Change created new conflict',
			oldConflictTitle: 'Change still has conflict',
			mainButton: 'Approve',
			confirmMainButton: 'Confirm changes',
			subButton: 'Back to editing',
			bodyTitle: 'By changing this event, new conflicts have been created on',
			oldConflictBodyTitle: 'By changing this event you kept the same conflicts',
			conflictDetails: (resourceName: string, dateTimeText: string) => `${resourceName} | ${dateTimeText}`,
		},
	},
	products: {
		products: 'Products',
		productDetails: 'Product Details',
		notifications: {
			addedSuccess: (productName: string) => `${productName} added successfully`,
			editedSuccess: (productName: string) => `${productName} edited successfully`,
			addedWithInventoryFailure: (productName: string) =>
				`${productName} was created, but inventory could not be saved. Update stock on the product edit page.`,
		},
		title: 'Create New Product',
		taxes: {
			title: 'Taxes',
		},

		deleteConfirmation: {
			title: 'Archive Product',
			description:
				'After Archiving the product will be removed from the main list and you could find it in the archive',
			archive: 'Archive',
			unarchiveTitle: 'Unarchive Product',
			unarchiveDescription: 'After unarchiving, the product will be restored to the main list.',
			unarchive: 'Unarchive',
			cancel: 'Cancel',
		},
		productsTable: {
			columns: {
				id: 'ID',
				product: 'Product',
				category: 'Category',
				variants: 'Variants',
				addon: 'Add-on',
				price: 'Price',
				inventory: 'Inventory',
				status: 'Status',
				actions: 'Actions',
			},
			tableAction: {
				edit: 'Edit Product',
				editInventory: 'Edit Inventory',
				updateStatus: (status: ActivityEnum) =>
					status === ActivityEnum.ACTIVE ? 'Deactivate Product' : 'Activate Product',
				archiveStatus: (status: AdditionalStatusesEnum) =>
					status === AdditionalStatusesEnum.ARCHIVED ? 'Unarchive Product' : 'Archive Product',
				successMessage: (status: ActivityEnum) =>
					status === ActivityEnum.ACTIVE ? 'Product has been activated' : 'Product has been deactivated',
				errorMessage: 'An error occurred while updating the product status',
				createProduct: 'Create Product',
			},
			pagination: {
				subjects: {
					productsList: 'products',
				},
			},
			actions: {
				filters: {
					statusOptions: {
						[ActivityEnum.ACTIVE]: 'Active',
						[ActivityEnum.INACTIVE]: 'Inactive',
						[AdditionalStatusesEnum.ARCHIVED]: 'Archived',
					},
					archiveFilter: {
						title: 'Archive',
						includeArchived: 'Include archived',
					},
					inventoryOptions: {
						[CommerceProductInventoryFilterStatusEnum.NOT_TRACKED]: 'Not tracked',
						[CommerceProductInventoryFilterStatusEnum.IN_STOCK]: 'In stock',
						[CommerceProductInventoryFilterStatusEnum.LOW_STOCK]: 'Low stock',
						[CommerceProductInventoryFilterStatusEnum.SOLD_OUT]: 'Sold out',
						[CommerceProductInventoryFilterStatusEnum.OVERSOLD]: 'Oversold',
					},
				},
			},
			state: {
				loading: 'Loading products...',
				noData: 'No products found.',
			},
		},
		inventory: {
			title: 'Inventory',
			trackInventory: 'Track inventory quantity',
			currentStock: 'Current stock',
			lowStockThreshold: 'Low stock threshold',
			invalidStockDraft: 'Enter a whole number for every stock and threshold field.',
			requiresFacilityScope:
				'Select a facility in the facility switcher to set stock for that facility. Stock is tracked per facility.',
			stockAppliesToFacility: (facilityName: string): string => `Stock applies to ${facilityName}.`,
			multiFacilityDeferQuantity:
				'This product is assigned to multiple facilities. Select one of those facilities in the switcher to set stock for it here, or set remaining stock later from Edit inventory.',
			untracked: 'Not tracked',
			inStock: (quantity: number) => `In stock${INVENTORY_STATUS_LABEL_SEPARATOR}${quantity}`,
			lowStock: (quantity: number) => `Low stock${INVENTORY_STATUS_LABEL_SEPARATOR}${quantity}`,
			oversold: (quantity: number) => `Oversold by${INVENTORY_STATUS_LABEL_SEPARATOR}${quantity}`,
			soldOut: 'Sold out',
			variesByVariant: 'Varies by variant',
			variesByFacility: 'Varies by facility',
			scopeLabel: 'Inventory tracking',
			sharedPool: 'Shared pool',
			perVariant: 'Per variant',
			sameInventory: 'Same stock for all variants',
			stockColumn: 'Stock',
			thresholdColumn: 'Low stock threshold',
			replenishStockSingle: 'Replenish stock for selected item',
			replenishStock: 'Replenish stock for selected items',
			replenishStockDescription:
				'Return selected inventory quantities to stock when reducing balance or voiding. Does not apply when leaving balance.',
			editModal: {
				title: 'Edit inventory',
				variantTitle: 'Edit variant inventory',
				variantDescription: (productName: string, facilityName: string): string =>
					`Update stock for each variant of ${productName} at ${facilityName}`,
				facilityLabel: 'Facility',
				quantityLabel: 'Quantity',
				thresholdLabel: 'Low stock threshold',
				save: 'Save',
				cancel: 'Cancel',
				successMessage: 'Inventory updated successfully',
				errorMessage: 'Failed to update inventory',
			},
		},
		breadCrumbs: {
			step1: 'commerce',
			step2: 'manage',
			create: 'create',
		},
		buttons: {
			newProduct: 'New Product',
		},
		form: {
			name: 'Name',
			imagePlaceholderLabel: 'Product',
			imageRemoveLabel: 'Remove photo',
			uploadPhotoButton: 'Upload',
			unit: 'Unit',
			category: 'Category',
			productCategory: 'Product Category',
			facilitiesTooltip: 'Select one or more facilities this product applies to.',
			allCategories: 'All Categories',
			description: 'Description',
			asAddon: 'Item can be sold as add-ons',
			price: 'Price',
			variant: 'Variant',
			createButton: 'Create Product',
			remove: 'Remove',
			reset: 'Reset Values',
			samePrice: 'Same price for all variants',
			newVariant: 'New Variant',
			save: 'Save',
			pricing: 'Pricing',
			pricingPreviewOnly: 'Pricing (preview only)',
			useVariants: 'Use Variants',
			variantSeedFailed:
				'This product’s saved variants could not be loaded, so pricing and variants cannot be edited and the product cannot be saved. Refresh the page, and contact support if the problem persists.',
			variantLabel: (number: number): string => `Variant ${number}`,
		},
		list: {
			columns: {
				id: 'ID',
				product: 'Product',
				category: 'Category',
				variants: 'Variants',
			},
			filters: {
				allCategories: 'All categories',
				searchPlaceholder: 'Search product name or ID',
			},
		},
		manageProducts: 'Manage',
		kiosk: {
			title: 'Kiosk',
			productCard: {
				price: 'Price',
				quantity: 'Quantity',
				remainingInventory: 'Remaining inventory',
				selectOptionsForInventory: 'Select options',
				addToCart: 'ADD TO CART',
				addToCartButton: 'Add to cart',
				noSellableFacility:
					'This product is not sold at any facility you have access to. Check the product facilities or your facility access.',
			},
		},
		kioskHeader: {
			allTab: 'All',
			filters: 'Kiosk filters',
			showAddons: 'Show add-ons',
			searchPlaceholder: 'Search product name or ID',
		},
		productCard: {
			quantity: 'Quantity',
			priceLabel: 'price',
			addToCart: 'ADD TO CART',
			addonLabel: 'Add-on',
			addonTooltip: 'Add-on product',
		},
		facilitySelectModal: {
			title: 'Select facility',
			description: 'Choose which facility to attribute this sale to.',
			actionButtonText: 'Add',
			cancel: 'Cancel',
			searchPlaceholder: 'Search facility...',
			noResults: 'No facilities found',
			loadingStock: 'Loading...',
		},
		management: {
			title: 'Commerce Management',
			breadcrumbs: [
				{ label: 'Commerce', to: COMMERCE_KIOSK_PATH },
				{ label: 'Manage', to: PRODUCTS_MANAGE_PATH },
			],
		},
		tabs: {
			products: 'Products',
			categories: 'Categories',
		},
		categoriesTable: {
			confirmation: {
				delete: {
					title: 'Delete Category',
					message: 'Are you sure you want to delete this category?',
					confirmButtonText: 'Delete',
				},
			},
			columns: {
				name: 'Name',
				products: '# of Products',
				stations: 'Stations',
				tipEligible: 'Tip Eligible',
				actions: 'Actions',
			},
			tableAction: {
				edit: 'Edit Category',
				create: 'Create Category',
				delete: 'Delete Category',
			},
			successMessages: {
				delete: 'Category deleted successfully',
			},
			filters: {
				tipping: {
					eligible: 'Tip Eligible',
					notEligible: 'Not Tip Eligible',
				},
			},
			labels: {
				subject: 'categories',
				loadingMessage: 'Loading categories...',
				noDataMessage: 'No categories found.',
				errorMessage: 'Failed to load categories',
			},
			allStations: 'All Stations',
		},
		categoryProfile: {
			title: 'Category Profile',
			breadcrumbs: { label: 'Category Profile', to: '' },
			sections: {
				mainDetails: 'Main Details',
				generalDetails: 'General Details',
				categoryDescription: 'Category Description',
				availabilityAndTipping: 'Availability & Tipping',
			},
			fields: {
				categoryName: 'Category Name',
				color: 'Color Set',
				description: 'Category Description',
				stations: 'Stations',
				tippingEligible: 'Tipping Eligible',
				tippingEligibleTooltipFirstPart: 'To collect tips, ensure tipping is enabled in ',
				tippingEligibleTooltipLink: 'Settings',
				tippingEligibleTooltipSecondPart:
					'. Items in this category will only prompt for a tip if that setting is active',
			},
			supportedImageTypes: 'Supported image file types: JPG, PNG, Gif, Webp, Tiff',
			notifications: {
				createSuccess: 'Category created successfully',
				updateSuccess: 'Category updated successfully',
				saveError: 'Failed to save category',
			},
			emptyState: {
				missingCategory: { title: 'Category not found', description: 'The requested category does not exist.' },
			},
			buttons: { back: 'Back to Categories' },
		},
	},
	portals: {
		portalForm: {
			footer: {
				cancel: 'CANCEL',
				save: 'SAVE',
			},
		},
	},
	memberships: {
		header: {
			title: 'Memberships',
			breadcrumbs: { label: 'Memberships', to: MEMBERSHIPS_PATH },
		},
		table: {
			subject: 'memberships',
			loadingMessage: 'Loading Memberships...',
			noDataMessage: 'No matching memberships found. Try adjusting your filters or adding a new one.',
			errorMessage: 'Failed to load memberships',

			filters: {
				search: { placeholder: 'Search' },
				categories: {},
			},
			columns: {
				name: 'Name',
				customerType: 'Customer Type',
				activityType: 'Activity',
				gender: 'Gender',
				questionnaires: 'Form',
				price: 'Price',
				maxMembers: 'Family Capacity',
				ageRange: 'Ages',
				membershipType: 'Type',
				isAutoRenewal: 'Auto Renewal',
				renewal: 'Billing',
				requiredProducts: 'Required Products',
			},
			cells: {
				ageRange: {
					noMinAge: 'no min age',
					noMaxAge: 'no max age',
					noMinAndMaxAge: 'No min and max age',
					rangeDisplay: (minAge: string | number, maxAge: string | number) => `${minAge} - ${maxAge}`,
				},
				customerTypes: {
					[CustomerInMembershipTypeEnum.INDIVIDUAL]: 'Individual',
					[CustomerInMembershipTypeEnum.FAMILY]: 'Family',
				},
				gender: {
					[GenderEnum.OTHER]: 'Gender Neutral',
					[GenderEnum.MALE]: 'Male',
					[GenderEnum.FEMALE]: 'Female',
				},
				membershipTypes: {
					[MembershipTypeEnum.FIXED]: 'Fixed',
					[MembershipTypeEnum.ROLLING]: 'Rolling',
				},
				renewal: {
					[MembershipRenewalTypeEnum.ANNUALLY]: 'Annually',
					[MembershipRenewalTypeEnum.QUARTERLY]: 'Quarterly',
					[MembershipRenewalTypeEnum.MONTHLY]: 'Monthly',
					[MembershipRenewalTypeEnum.FIXED]: 'One-Time',
				},
				name: {
					subtitle: (gatingMembersCount: number) =>
						!gatingMembersCount ? '' : `Gating ${gatingMembersCount} memberships`,
				},
			},
			actions: {
				editMembership: 'Edit Membership',
				viewMembership: 'View Membership',
				purchaseMembership: 'Purchase',
				purchaseMembershipUnavailable: 'Purchase is unavailable for memberships without a price.',
				goToPublicMembershipPage: 'View Public Page',
			},
			tableAction: {
				createMembersihp: {
					label: 'Create Membership',
					tooltip: 'Create Membership',
				},
			},
		},
		purchase: {
			selectCustomerModal: {
				title: 'Select Customer',
				description: 'Select the customer you would like to purchase the membership for.',
				cancelButton: 'cancel',
				confirmButton: 'Add to cart',
				continueButton: 'Continue',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
			},
			activationDateModal: {
				title: 'Select membership activation date',
				dateLabel: 'Activation date',
				cancelButton: 'cancel',
			},
		},
		selectPage: {
			title: 'Create your first membership',
			button: 'Create',
			view: 'VIEW',
			purchase: 'PURCHASE',
			edit: 'EDIT',
			cancel: 'CANCEL',
			save: 'Save',
			create: 'CREATE MEMBERSHIP',
			selectCustomerFamilyPopup: 'Purchase Family Membership',
			selectCustomerIndividualPopup: 'Purchase Individual Membership',
			saveAndPublish: 'Save and Publish',
			familyMembersSelection: {
				male: 'Male',
				female: 'Female',
				familyMembersTable: {
					name: 'Name',
					birthDate: 'Birth Date',
					gender: 'Gender',
					role: 'Role',
					primary: 'Primary',
					dependent: 'Dependent',
					subject: 'family members',
					loadingMessage: 'Loading family members…',
					noDataMessage: 'No family members available.',
					errorMessage: 'Unable to load family members.',
				},
				header: 'Add family members',
				subtitle: 'Select the family members you want to add to the membership',
				continue: 'Continue',
				back: 'Back',
			},
			notMatchingUserModal: {
				title: "Customer type doesn't match",
				description: "The selected customer type doesn't match the membership's type, please pick another customer",
				mainButton: 'OK, THANKS',
			},
		},
		detailsPage: {
			title: 'CREATE MEMBERSHIP',
			detailCardTitle: 'MEMBERSHIP DETAILS',
			formsCardTitle: 'Forms',
			name: 'Membership Name',
			description: 'Description',
			customerType: 'Customer Type',
			activity: 'Activity',
			facility: 'Facility',
			forms: 'Forms',
			numberOfPeople: 'Number of people',
			tagline: 'Tagline',
		},
		settingsPage: {
			settingCardTitle: 'Membership Settings',
			ageRange: 'Age',
			gender: 'Gender',
			from: 'From',
			to: 'To',
			tagsLabel: 'Tags',
			tagsDesc: 'To separate between tags use commas or hit return. Hit backspace to remove.',
			tagsInfo: '',
		},
		pricingPage: {
			title: 'Pricing',
			membershipPrice: 'Membership Price',
			gating: {
				title: 'Gating',
				subtitle: 'Membership Gating',
				tooltip: `Use Allow this membership to be a gate to make it a required product for other memberships.
Use Gate this membership with other memberships to add required memberships for this one.
Customers must hold or purchase all selected memberships to complete checkout. This option isn't available if the membership itself is set as a gate.`,
				none: 'None',
				allowGating: 'Allow this membership to be a gate for other memberships',
				selectRequired: 'Select required membership(s)',
				label: 'Required Memberships',
			},
			membershipTaxHelper: 'Note: Tax settings will apply on renewal, when applicable.',
		},
		typePage: {
			title: 'Create Membership',
			typeTitle: 'Membership Type',
			fixTitle: 'Fixed Membership',
			rollingTitle: 'Rolling Membership',
			dateTitle: 'Dates',
			registrationDateTitle: 'Registration Dates',
			startDate: 'Start Date',
			endDate: 'End Date',
			renewalTitle: 'Renewal',
			renewalLabel: 'Renewal Frequency',
		},
		renewalType: {
			annually: 'Annually',
			quarterly: 'Quarterly',
			monthly: 'Monthly',
			default: 'Fixed',
		},
		dashboard: {
			title: 'Membership',
			membershipImageAlt: 'Membership image',
			ageRangeDisplay: (minAgeYears: number, maxAgeYears: number) => `${minAgeYears} - ${maxAgeYears}`,
			details: 'Details',
			members: 'Members',
			edit: 'EDIT',
			past: 'Past members',
			customerType: 'Customer Type',
			numberOfPeople: 'Number of people',
			facility: 'Facility',
			membershipType: 'Membership Type',
			date: 'Dates',
			registrationDate: 'Registration Dates',
			price: 'Price',
			unitPrice: 'Unit Price',
			forms: 'Forms',
			addsOnsList: 'Adds Ons List',
			age: 'Age',
			maxMembers: 'Max Members',
			gender: 'Gender',
			activity: 'Activity',
			memberTypeFixed: 'Fixed',
			memberTypeRolling: 'Rolling',
			viewButton: 'VIEW',
			editButton: 'Edit',
			noForms: {
				main: 'It seems that no forms have been uploaded for this membership yet',
				secondary: 'Add forms from the edit button',
			},
			noAddsOns: {
				main: 'It seems that no Add Ons have been uploaded for this membership yet',
				secondary: 'Add Add Ons from the edit button',
			},
			customerTypes: {
				individual: 'Individual',
				organization: 'Organization',
				family: 'Family',
				rollingMembership: 'Rolling',
				fixedMembership: 'Fixed',
			},
			toast: {
				multiFacility: 'This membership includes facilities outside your current view.',
				unassociated: "This membership is not associated with the facility you're currently viewing.",
			},
		},
		footer: {
			defaultNext: 'NEXT',
			defaultCancel: 'CANCEL',
			createMembership: 'Create',
			updateMembership: 'Update',
			continue: 'Continue',
		},
		members: {
			searchPlaceHolder: 'Search by first name, last name, or email',
			cancelMembership: {
				cancellationReason: 'Cancellation reason',
				popupNotification: 'Member removed successfully.',
				toolTipContent: 'Cancel Membership',
				failedToCancel: `We could not cancel this membership. Please try again. If the problem continues, contact ${SUPPORT_EMAIL}.`,
				membershipCanceled: 'Membership cancelled',
				cancelMembershipModal: {
					title: 'Cancel Membership',
					description: "Are you sure you want to cancel this member's membership?",
					mainButton: "Yes, I'm sure",
					cancel: 'Cancel',
					fixedDescription:
						'Would you like to cancel the automatic renewal of this membership, or to cancel the membership immediately?',
					fixedMainButton: 'Cancel Auto Renewal',
					fixedSecondButton: 'Cancel Immediately',
					expiredAutoRenewDescription:
						'This membership is expired and still set to renew. Cancel automatic renewal so it will not be billed again.',
					placeholder: 'Cancellation reason',
				},
				refundModal: {
					title: "'s membership was cancelled",
					cancelledTitle: (fullName: string) => `${fullName}'s membership was cancelled`,
					description: 'Would you like to refund this customer?',
					mainButton: 'Go to invoice',
					secondButton: 'Done',
				},
			},
			pauseMemberships: {
				pauseMembership: 'Pause Membership',
				undoPause: 'Undo Pause',
				pauseMembershipModal: {
					title: 'Pause Membership',
					summaryDescription: (membershipName: string) => `Changes made to ${membershipName}`,
					historyTitle: 'Pause History',
					historyDescription: 'This membership was paused within the past year',
					empty: {
						noHistory: 'No history for pause',
						noHisotryDescription: 'This membership has not been paused before.',
					},
					next: 'Next',
					pause: 'Pause',
					update: 'Update',
					cancel: 'Cancel',
					back: 'Back',
					warning: 'This pause will apply to all family members on this membership.',
					historyWarning: 'This membership has been paused before.',
					historyLink: 'View history',
				},
				summary: {
					title: 'Summary',
					paused: 'Paused',
					pauseScheduled: 'Pause Scheduled',
					reactivationDate: 'Membership Reactivation Date',
					impactedBillingDate: 'Impacted Billing Date',
					pauseDate: 'Pause Date',
					duration: 'Duration',
					reason: 'Reason',
					description: 'Description',
				},
				form: {
					startDate: {
						label: 'Pause Start Date',
						placeholder: 'Select start date...',
					},
					duration: {
						label: 'Pause Duration',
						placeholder: 'Select duration...',
					},
					reason: {
						label: 'Pause Reason',
						placeholder: 'Select',
					},
					description: {
						label: '',
						placeholder: 'Type note here',
					},
				},
				pauseReasonsByKey: {
					travel: 'Travel',
					personal_reasons: 'Personal Reasons',
					medical_reasons: 'Medical Reasons',
					financial_constraints: 'Financial Constraints',
					seasonal_break: 'Seasonal Break',
					lack_of_time: 'Lack of Time',
					maternity_paternity_leave: 'Maternity / Paternity Leave',
					other: 'Other',
				},
				pauseHistoryStatusByKey: {
					pending: 'To Reactivate',
					paused: 'To Reactivate',
					resumed: 'Reactivated',
					cancelled: 'Pause Canceled',
				},
				pauseSuccess: 'Membership pause has been scheduled successfully!',
				pauseFailed: 'Failed to pause membership',
				pauseEditSuccess: 'Membership pause has been updated successfully!',
				pauseHistorySuccess: 'Membership pause history fetched successfully',
				pauseHistoryFailed: 'Failed to fetch membership pause history',
				pauseEditFailed: 'Failed to edit pause membership',
				undoPauseSuccess: 'Membership pause has been canceled successfully!',
				undoPauseFailed: 'Failed to undo membership pause',
			},
			membersTable: {
				price: 'Price',
				name: 'Customer Name',
				tel: 'Tel',
				cancelledAt: 'Cancelled At',
				regDate: 'Registration Date',
				status: 'Status',
				email: 'Email',
				cancelStatus: 'Cancellation Status',
				cancelReason: 'Cancellation Reason',
				cancellationStatus: {
					immediate: 'Immediate',
					auto: 'Auto renewal',
				},
				subject: 'members',
			},
		},
		tags: {
			autoRenewalCancel: 'Auto-Renewal Canceled',
			immediateCancel: 'Immediate Canceled',
			pauseScheduled: 'Pause Scheduled',
		},
	},
	currency: {
		USD: {
			symbol: '$',
		},
		CAD: {
			symbol: '$',
		},
	},
	reservations: {
		pageTitle: 'Rentals',
		breadcrumbs: {
			basic: [{ label: RESERVATIONS_LABELS.RENTALS, to: RESERVATIONS_PATH }],
			reservations: { label: RESERVATIONS_LABELS.RESERVATIONS, to: RESERVATIONS_PATH },
			products: { label: RESERVATIONS_LABELS.PRODUCTS, to: RENTAL_PRODUCTS_PATH },
			passes: { label: RESERVATIONS_LABELS.PASSES, to: PASSES_LIST_PATH },
			categories: { label: RESERVATIONS_LABELS.CATEGORIES, to: CATEGORIES_PATH },
			portals: { label: RESERVATIONS_LABELS.BOOKING_PORTALS, to: PORTALS_PATH },
		},
		products: {
			noProducts: {
				welcome: 'Welcome! 🎉',
				description: "Create a Product and let's get started",
				button: 'create Product',
			},
		},
		table: {
			loadingMessage: 'Loading rentals...',
			subject: 'reservations',
		},
		tabs: {
			reservations: {
				label: 'Reservations',
				link: 'details',
				active: false,
			},
			rental: {
				label: 'Rental Products',
				link: 'rentals',
				active: false,
			},
		},
		filterRow: {
			status: 'Status',
			space: 'Spaces',
			customer: 'Search by customer',
			newReservation: '+ NEW RESERVATION',
			manageProducts: 'MANAGE PRODUCTS',
			filterByStatuses: {
				reservationStatuses: 'Reservation',
				paymentStatuses: 'Payment',
			},
		},
		listColumns: {
			id: 'ID',
			event: 'Reservation',
			customer: 'Customer',
			space: 'Spaces',
			facility: 'Facilities',
			instructor: 'Instructors',
			date: 'Date',
			time: 'Time',
			price: 'Price',
			status: 'Status',
			paymentStatus: 'Payment Status',
			reservationStatus: 'Reservation Status',
			reservationType: 'Reservation Type',
			activityType: 'Activity Type',
			actions: 'Edit',
		},
		emptyState: {
			primary: 'There are no reservations for this facility',
			secondary: 'Go create one and make some money!',
		},
		reservationsListBody: {
			statuses: {
				reservation: {
					approved: 'Approved',
					'awaiting client': 'Awaiting Client',
					'awaiting admin': 'Awaiting Admin',
					planned: 'Planned',
					canceled: 'Canceled',
					rejected: 'Rejected',
				},
				payment: {
					paid: 'Paid',
					unpaid: 'Unpaid',
					fully_paid: 'Paid',
					purchase_order: `Order`,
					partial: 'Partial',
					pending: 'Pending',
					refunded: 'Refunded',
					not_paid: 'Unpaid',
					void: 'Void',
				},
			},
			moreMenuOptions: {
				view: 'View Reservation',
				reject: 'Reject Reservation',
				approve: 'Approve Reservation',
				reApprove: 'Reapprove',
				review: 'Send for review',
				reminder: 'Send reminder to customer',
				invoiceAttachedTooltip: 'This reservation has an invoice attached',
				internalProgram: 'Internal program',
				internalReservationTooltip: 'This is an internal reservation',
			},
			reservationTypes: {
				rental: 'Customer',
				internal: 'Internal',
			},
			repeatOnDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
			emptyList: {
				noReservations: 'No reservations yet',
				noResults: 'There are no reservations for this facility.\n Go create one and make some money!',
				statusFilter: 'Status',
				filter: 'Filter',
			},
			tableSubject: 'reservations',
			columnBody: {
				viewMore: (count: number) => `+${count} more...`,
				date: {
					repeatEvery: (numDays: number) => ` every ${numDays} days`,
				},
			},
		},
	},
	removeAddon: {
		select: {
			title: 'Delete add on completed!',
			description: 'Total price of the deleted add on is ',
			explainer: 'Select how to issue this refund',
			secondaryButton: 'NOT NOW',
			primaryButton: 'APPROVE',
			bodyText:
				'This add on was deleted from the reservation. To continue with the process select one of the following options.',
		},
		adjust: {
			title: 'Adjust Invoice',
			description: 'Total price of the deleted add on is ',
			explainer: 'Select how to manage this invoice',
			secondaryButton: 'NOT NOW',
			primaryButton: 'APPROVE',
			bodyText: 'This addon has been deleted. \nYou can proceed with one of the following actions:',
		},
		refund: {
			title: 'Issue a refund',
			description: 'Total price of the deleted add on is ',
			secondaryButton: 'CANCEL',
			primaryButton: 'APPROVE',
			bodyText: 'Total amount to refund',
			secondaryText:
				'Select your preferred payment method. Return amount can be divided between several payment methods.',
		},
	},
	removeSlot: {
		select: {
			title: 'Delete event completed!',
			description: 'Total price of the deleted event is',
			explainer: 'Select how to issue this refund',
			secondaryButton: 'NOT NOW',
			primaryButton: 'APPROVE',
			bodyText:
				'This event was deleted from the reservation.\nTo continue with the process select one of the following options',
			secondaryText: 'NOTE: The payment plan will be canceled and needs to be updated',
		},
		adjust: {
			title: 'Adjust invoice',
			description: 'Total price of the deleted event is',
			explainer: 'Select how to manage this invoice',
			secondaryButton: 'NOT NOW',
			primaryButton: 'APPROVE',
			bodyText: 'This event has been deleted. \nYou can proceed with one of the following actions:',
			secondaryText: 'NOTE: The payment plan will be canceled and needs to be updated',
		},
		refund: {
			title: 'Issue a refund',
			description: 'Total price of the deleted event is',
			secondaryButton: 'CANCEL',
			primaryButton: 'APPROVE',
			bodyText: 'Total amount to refund',
			secondaryText:
				'Select your preferred payment method. Return amount can be divided between several payment methods.',
		},
		summary: {
			title: 'Delete event completed!',
			description: 'Total price of the deleted event is',
			secondaryButton: 'PRINT RECEIPT',
			primaryButton: 'SEND RECEIPT',
			bodyText:
				'This event was deleted from the reservation. To continue with the process select one of the following options',
			secondaryText: 'NOTE: The payment plan will be canceled and needs to be updated',
			tertiaryButton: 'Skip',
		},
	},
	singleReservationDisplay: {
		loading: 'Loading...',
		toasts: {
			multiFacilityReservation:
				'This reservation includes items from multiple facilities. You are currently viewing the full overview.',
			reservationNotAssociatedWithFacility:
				"This reservation is not associated with the facility you're currently viewing.",
		},
		header: {
			tagMappers: {
				reservationTypeLabels: {
					[ReservationTypeEnum.INTERNAL]: 'Internal',
					[ReservationTypeEnum.RENTAL]: 'Customer',
				},
				approvalStatusLabels: {
					[ReservationStatusEnum.APPROVED]: 'Approved',
					[ReservationStatusEnum.AWAITING_ADMIN]: 'Awaiting Admin',
					[ReservationStatusEnum.CANCELED]: 'Canceled',
					[ReservationStatusEnum.REJECTED]: 'Rejected',
					[ReservationStatusEnum.PLANNED]: 'Planned',
				},
			},

			prevStep: 'Reservations',
			reject: 'Reject',
			approve: 'Approve',
			lastActivity: 'Last activity',
			lastActivityWithDate: (formattedDate: string): string =>
				`${TranslationEn.singleReservationDisplay.header.lastActivity} ${formattedDate}`,
			notPaid: 'Not paid',
			popUpMenu: {
				details: 'Request details',
				pdf: 'Download pdf',
				editTitle: 'Change Reservation Name',
				viewHistory: 'View History',
			},
			waivers: 'Waiver',
			notes: 'Notes',
			forms: 'Forms',
			amountInvoiced: (formattedPrice: string) => `Amount invoiced: ${formattedPrice}`,
			amountPaid: (formattedPrice: string) => `Amount paid: ${formattedPrice}`,
			amountRemaining: (formattedPrice: string) => `Remaining price: ${formattedPrice}`,
		},
		editTitleModal: {
			title: 'Reservation Name',
			successMessage: 'Reservation name updated successfully',
		},
		formsDialog: {
			title: 'Form:',
			completed: (date: string) =>
				`Completed: ${capitalize(formatDateBondTimePackage(date, DateTimeFormats.MONTH_DAY_COMMA_YEAR))}`,
			dateCompleted: (date: string) =>
				`Date completed: ${capitalize(formatDateBondTimePackage(date, DateTimeFormats.MONTH_DAY_COMMA_YEAR))}`,
			completedBy: (name: string) => `Completed by: ${name}`,
			viewAnswers: 'view form answers',
			reservationLabel: (reservationId: number) => `Reservation: #${reservationId}`,
			noFormsFound: 'No forms found for this reservation',
			loadFailed: 'Failed to load reservation forms. Please try again.',
		},
		customerDetails: {
			title: 'CUSTOMER DETAILS',
			profileButton: 'VIEW',
		},
		reservationDetails: {
			title: 'RESERVATION DETAILS',
			noNotes: 'There is no notes for this reservation',
			edit: 'EDIT',
			publicNotesTooltip: 'Public notes',
			privateNotesTooltip: 'Private notes',
			notes: 'View notes',
			editNotesTitle: 'Reservation Notes',
			editDetailsPage: {
				pageTitle: 'Edit reservation details',
				titleLabel: 'reservation title',
				notesLabel: 'Notes',
				publicNotes: 'Public notes',
				privateNotes: 'Private notes',
				errors: {
					wrongId:
						'We could not save your changes because the reservation could not be identified. Please reload the page and try again.',
				},
			},
		},
		resources: {
			addonsItemsCount: (count: number) => `${count} item${count > 1 ? 's' : ''}`,
			errors: {
				receiptPrint: {
					message: 'We could not print the receipt. Please refresh the page and try again.',
				},
			},
			title: 'EVENTS',
			invoice: 'INVOICE ORDER',
			allSlotsInvoiced:
				'All slots in this reservation have already been invoiced. To make changes, go to the existing invoice.',
			someSlotsInvoiced:
				'Some of the selected slots are already on an invoice. Only the uninvoiced slots will be included.',
			internalReservation:
				'Internal reservations cannot be invoiced. Only customer-facing reservations can generate an invoice.',
			noSlotsSelected: 'No slots are selected. Please select at least one slot to create an invoice.',
			notSameInvoice:
				'The selected slots belong to different invoices. Please select slots from the same invoice to proceed.',
			editSlots: 'EDIT SLOTS',
			emptyState: 'No series matches the filters that were applied.',
			notesModal: {
				public: 'Public notes',
				private: 'Private notes',
			},
			editEvent: 'Edit Event',
			paymentInvoicePopup: {
				editEvent: 'Edit Event',
				title: 'Change slots into invoice',
				main: 'Please note that this selected slots will be turn into an active invoice to charge your customer',
				invoiceSlots: 'PLACE INVOICE ORDER',
				cancel: 'CANCEL',
				error:
					'We could not create the invoice for the selected slots. Please try again or contact support if the issue persists.',
				successPopupMessage: 'Slots invoiced successfully',
			},
			filters: {
				selectAll: 'Select All',
				clear: 'Clear',
				month: 'MONTH',
				days: 'DAYS',
				sports: 'SPORT TYPE',
				series: 'SERIES',
				approvalStatus: 'APPROVAL STATUS',
				paymentStatus: 'PAYMENT STATUS',
				invoiceNumber: 'INVOICE NUMBER',
				invoice: 'invoice',
			},
			reservationActionOptions: { addSegment: 'Add Segment' },
			columns: {
				space: 'Space Name',
				event: 'Event Name',
				addons: 'Add-Ons',
				maintenance: 'Maintenance',
				date: 'Date',
				time: 'Time',
				price: 'Price',
				status: 'Status',
				private: 'Private',
				public: 'Public',
				allDay: 'All day',
				addonsPricing: 'Addons:',
				slotPricing: 'Slot:',
			},
			moreMenuOptions: { duplicate: 'Duplicate', delete: 'Delete Event', adjust: 'Adjust Invoice' },
			actions: {
				deleteEvent: {
					subtitle: 'The payment was refunded',
					subtitleMulti: 'The payments were refunded',
					subtitleFail: 'No payments were refunded, there was an issue',
					subtitleMultiMixed: 'Some payments were refunded, but there was an issue',
					moreInfo: {
						line1: (subject: string) => `In order to cancel the ${subject}, there will be some financial implications.`,
						line2: `You will need to refund the payment or leave the invoice amount as is.`,
						line3: `NOTE: At the end of the action review the payment plan to confirm that it is still valid`,
					},
					delete: 'DELETE',
					cancel: 'CANCEL',
					customError: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
					[DeleteType.ALL]: {
						title: 'Delete All Events',
						subject: 'events',
						description: null,
						warning: (count: number) =>
							`All ${count} selected slots will be deleted. Note: Any slots that were already deleted will remain unchanged.`,
					},
					[DeleteType.EVENT]: {
						title: 'Delete Event(s)',
						subject: 'event(s)',
						description: (totalPrice: number) => `Total price of the event(s) to be deleted is ${Pricify(totalPrice)}`,
						total: 'Total',
						punches: 'Punches',
						punchesRemoved: (count: number) =>
							count === 1 ? '1 punch will be removed' : `${count} punches will be removed`,
						unusablePassPunches: (count: number) =>
							count === 1
								? "1 punch is on an expired or cancelled pass and can't be returned"
								: `${count} punches are on an expired or cancelled pass and can't be returned`,
						event: { items: 'items', item: 'items' },
					},
					[DeleteType.ADDON]: {
						title: 'Delete add-on(s)',
						subject: 'add-on',
						description: (totalPrice: number) => `Total price of the add-on(s) to be deleted is ${Pricify(totalPrice)}`,
						addon: { items: 'items', item: 'item' },
					},
					successModal: {
						title: 'Delete event completed',
						description: 'Invoice line item was deleted',
						buttonText: 'APPROVE',
					},
					remainingInvoiceModal: {
						title: 'The invoice will remain with the previous balance',
						description: 'The deleted event had a sum of',
						descriptionWithBalance: (remainingBalance: string) => `The deleted event had a sum of ${remainingBalance}`,
						buttonText: 'APPROVE',
					},
					remainingInvoiceVoidModal: {
						title: 'Invoice line item was voided',
						description: 'The invoice will remain with a balance of',
						descriptionWithBalance: (remainingBalance: string) =>
							`The invoice will remain with a balance of ${remainingBalance}`,
						buttonText: 'APPROVE',
					},
					failureModal: {
						title: 'Event(s) could not be deleted',
						failToRefund: 'Event(s) could not be refunded',
						description: `The event could not be removed from this reservation. Please try again, or contact ${SUPPORT_EMAIL} if the problem continues.`,
						buttonText: 'APPROVE',
					},
				},
			},
		},
		slotsDataGrid: {
			title: 'Events',
			actions: {
				duplicate: 'Duplicate',
				delete: 'Delete Event',
				adjust: 'Adjust Invoice',
				invoice: 'Invoice Order',
				edit: 'Edit',
				editNotes: 'Edit Notes',
				addNotes: 'Add Notes',
			},
			columns: {
				eventDetails: 'Event Details',
				private: 'Private',
				public: 'Public',
				spaceName: 'Space Name',
				instructorsNames: 'Instructors',
				addons: 'Add-ons',
				maintenance: 'Maint.',
				dateRange: 'Dates',
				price: 'Price',
				slotType: 'Slot Type',
				status: 'Status',
				notes: 'Notes',
				days: 'Days',
				months: 'Months',
				paymentStatus: 'Payment Status',
				approvalStatus: 'Approval Status',
				invoices: 'Invoices',
				segments: 'Segments',
				facilities: 'Facilities',
				activities: 'Activities',
				products: 'Products',
			},
			editNotes: { title: 'Slot Notes' },
			maintenanceTiming: {
				[MaintenanceTimingEnum.AFTER]: 'After',
				[MaintenanceTimingEnum.BEFORE]: 'Before',
				[MaintenanceTimingEnum.AT_THE_BEGINING]: 'At the Beginning',
				[MaintenanceTimingEnum.AT_THE_END]: 'At the End',
			},
			durationUnitTypes: {
				minutes: 'Min',
				hours: 'Hrs',
			},
			slotTypes: {
				[SlotTypeEnum.EXTERNAL]: 'Rental',
				[SlotTypeEnum.INTERNAL]: 'Internal',
				[SlotTypeEnum.MAINTENANCE]: 'Maintenance',
				[SlotTypeEnum.CUSTOM]: 'Custom',
				[SlotTypeEnum.PUNCH_PASS]: 'Punch Pass',
			},
			invoiceLabel: (val: string) => `Invoice #${val ?? 0}`,
			slotPriceTooltip: (slot: string) => `Slot: ${slot}`,
			addonsPriceTooltip: (addons: string) => `Add-ons: ${addons}`,
			addonsQuantity: (title: string, quantity: number) => `${title} X${quantity}`,
			tooltips: {
				invoiceDisabledTooltip: 'Some of the selected slots already have an invoice',
				notSameInvoiceDisabledTooltip: 'Some of the selected slots are not on the same invoice',
				canceledEventDisabledTooltip: 'Some of the selected slots are already canceled',
				mixedSlotTypesDisabledTooltip: 'Punch pass events and rental events must be deleted separately',
				unloadedPunchPassSlotsDisabledTooltip: 'Scroll to load all selected punch pass events before deleting them',
				canceledSlotsCannotBeInvoiced: 'Canceled slots cannot be invoiced',
				canceledSlotsCannotBeEdited: 'Canceled slots cannot be edited',
				awaitingAdminCannotBeInvoiced: 'Admin approval is required before invoicing',
				mixedSlotTypesCannotBeEdited: 'Slots of different types cannot be edited together',
				mixedSlotTypesCannotBeDeleted: 'Slots of different types cannot be deleted together',
				punchPassWithoutAddonsCannotBeInvoiced: 'Punch pass slots without add-ons cannot be invoiced',
				invoice: 'Invoice Order',
				edit: 'Edit',
				add: 'Add Segment',
				cancel: 'Cancel',
				delete: 'Delete',
			},
		},
		invoices: {
			title: 'INVOICE',
			charge: 'Charge',
			notChargeable: 'This invoice cannot be charged',
			chargeMissingPayer: 'Unable to identify the billing account for this invoice. Please try again.',
			total: 'Total',
			searchPlaceholder: 'Search',
			emptyState: {
				main: 'No invoices have been submitted for this reservation.',
				secondary: 'You can create invoice from invoice by selecting the resource line item',
			},
			columns: {
				date: 'Date',
				id: 'Invoice no.',
				items: 'Items',
				total: 'Total',
				status: 'Status',
			},
			actions: {
				itemsAdded: 'Items added to invoice',
				goToInvoice: 'Go to Invoice',
				goToReservation: 'Go to reservation',
			},
		},
		events: {
			actions: {
				invoiceEvent: {
					title: 'Invoice event',
					description: 'Which invoice would you like to add the events to?',
				},
			},
		},
		allSelected: {
			title: 'All selected',
			description: "All selected events will be invoiced. Selected slots with invoices won't be affected.",
		},
		addonsDataGrid: {
			title: 'ADD ONS',
			emptyState: 'This reservation has no reservation add ons',
			actions: {
				delete: 'Delete',
				adjust: 'Adjust Invoice',
				invoice: 'Invoice Order',
				edit: 'Edit',
				add: 'New Add-on',
			},
			columns: {
				productId: 'ID',
				product: 'Product',
				category: 'Category',
				quantity: 'Quantity',
				unitPrice: 'Price',
				totalPrice: 'Total Price',
				status: 'Status',
				paymentStatus: 'Payment Status',
				approvalStatus: 'Approval Status',
			},
			tooltips: {
				invoiceDisabledTooltip: 'Some of the selected add-ons already have an invoice',
				notSameInvoiceDisabledTooltip: 'Some of the selected add-ons are not on the same invoice',
				canceledAddonDisabledTooltip: 'Some of the selected add-ons are already canceled',
				canceledAddonsCannotBeInvoiced: 'Canceled add-ons cannot be invoiced',
				canceledReservationCannotBeInvoiced: 'Add-ons on a canceled reservation cannot be invoiced',
				invoice: 'Invoice Order',
				edit: 'Edit',
				add: 'New Add-on',
				delete: 'Delete Add-on(s)',
			},
		},
		addons: {
			paymentInvoicePopup: {
				title: 'Change addons into invoice',
				main: 'Please note that this selected addons will be turn into an active invoice to charge your customer',
				invoiceAddons: 'PLACE INVOICE ORDER',
				cancel: 'CANCEL',
				error:
					'We could not create the invoice for the selected add-ons. Please try again or contact support if the issue persists.',
				successPopupMessage: 'Addons invoiced successfully',
			},
			actions: {
				editAddon: {
					buttonText: 'NEW ADD ON',
					title: 'Edit add on',
					selectLabel: 'Add on',
					selectPlaceHolder: 'Choose an answer',
					qtyPlaceHolder: 'Qty',
					priceRadio: { label: 'Price', default: 'Default', custom: 'Custom' },
					pricePerUnit: 'Price per unit',
					taxIncl: '(tax included)',
					cancelBtn: 'CANCEL',
					addBtn: 'UPDATE',
					addToOrder: 'Add to order',
					total: 'Total:',
					failedToAdd:
						'We could not add this add-on to the reservation. Please try again. If the problem continues, refresh the page.',
					selectAction: {
						title: 'Edit add on',
						subtitle: 'Would you like to edit the add on?',
						description: 'Approving of the changes will replace the existing data with the requested changes.',
						descriptionIncrease: 'The difference in price will be added to the invoice.',
						descriptionDecrease: 'The difference in price will be removed from the invoice.',
						panel: { items: 'items', item: 'item' },
						customError: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
						backToEdit: 'Back to editing',
						current: 'ADD TO CURRENT INVOICE',
						multiple: 'ADD TO EXISTING INVOICE',
						order: 'Add to order',
						dismiss: 'Dismiss',
						confirm: 'CONFIRM CHANGES',
						approve: 'APPROVE',
						refund: 'CONTINUE TO REFUND',
						originalTotal: 'Original total price was',
						purchaseOrder: 'The selected addon is in order status',
						newTotal: 'Total price changed to',
						totalRemove: 'Total price to remove',
						totalAdd: 'Total price to add',
					},
					couldNotRefundTitle: 'This event could not be refunded',
					couldNotRefundMessage: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
					scheduledPaymentWarning:
						'NOTE: At the end of the action review the payment plan to confirm that it is still valid',
				},
				newAddon: {
					buttonText: 'NEW ADD ON',
					title: 'Add new add on',
					selectLabel: 'Add on',
					selectPlaceHolder: 'Choose an answer',
					qtyPlaceHolder: 'Qty',
					priceRadio: { label: 'Price', default: 'Default', custom: 'Custom' },
					pricePerUnit: 'Price per unit',
					taxIncl: '(tax included)',
					cancelBtn: 'CANCEL',
					addBtn: 'ADD',
					addToInvoice: 'Add to invoice',
					subtotal: 'Subtotal:',
					subtotalPrefix: (label: string) => `${label} `,
					failedToAdd:
						'We could not add this add-on to the reservation. Please try again. If the problem continues, refresh the page.',
					cannotAttributeFacility: 'This add-on cannot be attributed to a facility on this reservation.',
					selectAction: {
						title: 'Add add on',
						subtitle: (totalPrice: string) => `Total - ${totalPrice}`,
						description: 'Please add the add on to one of the following options',
						panel: {
							items: 'items',
							item: 'item',
							qtyLabel: (qty: number, itemLabel: string) => `${qty} ${itemLabel}`,
						},
						customError: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
						newInvoice: 'NEW INVOICE',
						current: 'ADD TO CURRENT INVOICE',
						multiple: 'ADD TO EXISTING INVOICE',
						order: 'Add to order',
						dismiss: 'Dismiss',
					},
				},
				deleteAddon: {
					title: 'Delete add on',
					description: 'Total price of the add on to be deleted is',
					descriptionWithAmount(amount: string): string {
						return `${this.description} ${amount}`;
					},
					moreInfo: {
						line1: 'In order to delete the add on, there will be some financial implications.',
						line2: 'You will need to refund the payment or leave the invoice amount as is.',
						line3: 'NOTE: At the end of the action review the payment plan to confirm that it is still valid',
					},
					panel: { items: 'items', item: 'item', qtyLabel: (qty: number, itemLabel: string) => `${qty} ${itemLabel}` },
					total: 'Total',
					delete: 'delete',
					cancel: 'cancel',
					customError: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
					successModal: {
						'refund-and-void': {
							title: 'This add on could not be refunded',
							description: `We could not process this refund automatically. Please contact ${SUPPORT_EMAIL} for help completing the refund.`,
							buttonText: 'Approve',
							sub: 'Dismiss',
						},
						directDelete: {
							title: 'Are you sure you want to delete the add on?',
							description: 'Deleting the add on will affect the price and other aspects of the reservation',
							action: 'Delete',
							sub: 'Dismiss',
						},
						ignore: {
							title: 'The invoice will remain with the previous balance',
							description: 'The deleted addon had a sum of',
							buttonText: 'Approve',
							sub: 'Dismiss',
						},
						void: {
							title: 'Invoice line item was voided',
							description: 'Invoice will remain with balance of',
							buttonText: 'Approve',
							sub: 'Dismiss',
						},
						return: {
							title: 'Something went wrong',
							description: `Something went wrong. Please try again, or contact ${SUPPORT_EMAIL} if the problem continues.`,
							buttonText: 'Try Again',
							sub: 'Dismiss',
						},
						fail: {
							title: 'This add on could not be deleted',
							description: `The add-on could not be removed from this reservation. Please try again, or contact ${SUPPORT_EMAIL} if the problem continues.`,
							buttonText: 'APPROVE',
							sub: 'Dismiss',
						},
						title: 'Delete add on completed',
						subtitle: 'Total price of the deleted add on is',
						description:
							'This add on was deleted from the reservation.\nTo continue with the process select one of the following options',
						buttonText: 'APPROVE',
						sub: 'Dismiss',
					},
				},
			},
		},
		payments: {
			title: 'PAYMENT',
			emptyState: 'No payments have been submitted for this reservation.',
			totalCharged: 'Total charged',
			remaining: 'Remaining payment',
			columns: {
				date: 'Date',
				id: 'Receipt ID',
				method: 'Method',
				amount: 'Amount',
				total: 'Total',
				status: 'Status',
			},
			method: {
				0: 'Card',
				2: 'Cash',
				3: 'Check',
				5: 'Card-on-terminal',
				6: 'Other',
			},
		},
		duplicateEvent: { title: 'Duplicate Event' },
	},
	actionRaw: {
		dateRange: {
			clear: 'CLEAR',
			placeholder: 'Select a date range',
			notAfterError: (time: string) => {
				return `Session ends on ${time}`;
			},
			notBeforeError: (time: string) => {
				return `Session start on ${time}`;
			},
			predefinedRanges: {
				today: 'Today',
				nextSevenDays: 'Next 7 days',
				nextThirtyDays: 'Next 30 days',
				futureEvents: 'Future events',
				PastEvents: 'Past events',
				AllEvents: 'All events',
			},
			picker: {
				btnSubmit: 'apply',
				btnCancel: 'CANCEL',
			},
		},
	},
	activities: {
		noProgramsForActivity: 'There are no programs matching this activity type',
		noProgramProucts: 'There are no program products for this activity type',
		moveToArchive: 'Move to archive',
		unarchiveConfirmTitle: (programName: string) => `Unarchive ${programName}?`,
		unarchiveConfirmBody:
			'It will be restored as Unpublished. Publish it when you are ready for customers to see it.',
		unarchiveSuccess: 'Program unarchived successfully',
		unarchiveFailure: 'Could not unarchive program, please try again later',
		programsTable: {
			columns: {
				id: 'ID',
				name: 'Program Name',
				activity: 'Activity',
				age: 'Age',
				gender: 'Gender',
				schedule: 'Schedule',
				actions: 'Actions',
				publishingStatus: 'Status',
			},
			scheduleStatus: {
				current: 'Current',
				upcoming: 'Upcoming',
				past: 'Past',
				archive: 'Archive',
			},
			currentSessionTooltip: (sessionName: string) => `Current session: ${sessionName}`,
			subject: 'Programs',
			loadingMessage: 'Loading programs...',
			noDataMessage: 'No programs matching filters',
			searchPlaceholder: 'Program or Session Name',
			filterLabels: {
				includeAllOrgPrograms: {
					header: 'All organization programs',
					yes: 'Include all organization programs',
				},
			},
		},
		programCard: { select: 'select' },
		addProgram: 'Add Program',
		tabDoesNotExist: 'This tab does not exist',
		chooseProgram: 'Choose A Program',
		whatYouWantToCreate: 'What Are You Creating Today?',
		emptyState: {
			title: 'No programs yet',
			description: 'Create programs to start capturing registrations from your customers',
		},
		archiveSuccess: 'Program archived successfully',
		programPortals: {
			sections: {
				portals: 'Portals',
				segment_tags: 'Segment Tags',
			},
			table: {
				columns: {
					id: 'ID',
					name: 'Name',
					status: 'Status',
					sellBy: 'Sell by',
					scheduleSummary: 'Schedule',
					facilities: 'Facilities',
					programs: 'Programs',
					sessions: 'Sessions',
					actions: 'Actions',
				},
				views: {
					session: 'By Session',
					segment: 'By Segment Tag',
					event: 'By Event',
				},
				schedule: {
					current: 'Current',
					future: 'Future',
					past: 'Past',
				},
				actions: {
					create: 'Create portal',
					view: 'View portal',
					edit: 'Edit',
					publish: 'Publish',
					unpublish: 'Unpublish',
					archive: 'Archive',
					duplicate: 'Duplicate',
					segments: 'Segments',
					copyOf: (name: string) => `Copy of ${name}`,
					statusSuccess: (name: string) => `Updated ${name}`,
					statusError: 'Failed to update portal status',
				},
				strings: {
					subject: 'program portals',
					loadingMessage: 'Loading program portals...',
					noDataMessage: 'No program portals found.',
					errorMessage: 'Failed to load program portals',
				},
			},
			form: {
				createTitle: 'New program portal',
				editTitle: 'Edit program portal',
				header: {
					title: 'Program Portal',
					programs: { label: 'Programs', to: '/program_portals/portals' },
					portals: { label: 'Portals', to: '/program_portals/portals' },
					profile: { label: 'Program Portal', to: '#' },
				},
				emptyState: {
					title: 'Portal not found',
					description: 'This portal may have been deleted or you don’t have access.',
				},
				steps: {
					details: 'Portal settings',
					segments: 'Segment preview',
				},
				buttons: {
					back: 'Back',
				},
				intro: 'A portal allows you to sell different programs and sessions to shoppers in one shopping experience.',
				sections: {
					settings: 'Portal Details',
					general: 'General Details',
					resources: 'Offerings',
					browse: 'Browse modes',
				},
				fields: {
					name: 'Portal Name',
					description: 'Description',
					photo: 'Photo',
					photoHint: 'Supported image file types: JPG, PNG, GIF, Webp, Tiff',
				},
				resources: {
					intro: 'Select the sessions this portal offers for registration.',
					facilities: 'Facilities',
					programType: 'Program Type',
					programs: 'Programs',
					sessions: 'Sessions',
					viewAll: 'View all',
					viewLess: 'View less',
				},
				modes: {
					title: 'Browse By',
					intro: 'Select how shoppers browse and buy. Each choice you turn on becomes a way to shop the portal.',
					order: 'Order',
					displayAs: (mode: string) => `Display ${mode} As`,
					displayPluralAs: (mode: string) => `Display ${mode}s As`,
					defaultView: 'Online Default View',
					defaultViewOption: (label: string) => `By ${label}`,
					segmentsHint: 'Next opens the segment preview for the sessions on this portal.',
					sessionDescription: 'Shoppers browse session by session and make their picks inside each one.',
					segmentDescription: 'Shoppers pick a week or block first, then a session that runs it.',
					eventDescription: 'Shoppers pick individual dates and times from one calendar across the portal.',
					sessionTitle: 'Session',
					sessionPlural: 'Sessions',
					segmentTitle: 'Segment',
					segmentPlural: 'Segments',
					eventTitle: 'Event',
					eventPlural: 'Events',
					unavailable: 'This browse mode is not available yet.',
				},
				orders: {
					ALPHABETICAL_ASC: 'Name A to Z',
					ALPHABETICAL_DESC: 'Name Z to A',
					DATE_ASC: 'Date ascending',
					DATE_DESC: 'Date descending',
				},
				actions: {
					publish: 'Publish',
					unpublish: 'Unpublish',
					archive: 'Archive',
					manageSegments: 'Manage segments',
				},
				validation: {
					nameRequired: 'Portal name is required',
					descriptionRequired: 'Description is required',
					facilitiesRequired: 'Select at least one facility',
					programTypesRequired: 'Select at least one program type',
					programsRequired: 'Select at least one program',
					sessionsRequired: 'Select at least one session',
					singularRequired: 'Singular label is required',
					browseModeRequired: 'Turn on at least one browse mode',
					defaultViewRequired: 'Online Default View is required',
					defaultView: 'Default view must be an enabled browse mode',
				},
				errors: {
					load: 'Failed to load the portal',
					save: 'Failed to save the portal',
					status: 'Failed to update portal status',
				},
				messages: {
					saved: (name: string) => `Saved ${name}`,
					status: (name: string) => `Updated ${name}`,
				},
			},
			segments: {
				title: 'Portal segments',
				unavailable: 'By Segment Tag is off',
				unavailableDescription: 'Save this portal with By Segment Tag enabled before opening the segments inventory.',
				back: 'Back to portals',
				backToPortal: 'Back to portal',
				assignTitle: 'Assign segment tag',
				columns: {
					name: 'Segment',
					session: 'Session',
					startDate: 'Start',
					endDate: 'End',
					sport: 'Activity',
					age: 'Age',
					tag: 'Tag',
					actions: 'Actions',
				},
				filters: {
					session: 'Session',
					tagStatus: 'Tag status',
					tagged: 'Tagged',
					untagged: 'Untagged',
				},
				actions: {
					assign: 'Assign tag',
					remove: 'Remove tag',
					save: 'Save',
					cancel: 'Cancel',
				},
				errors: {
					load: 'Failed to load the portal',
					save: 'Failed to update the segment tag',
				},
				messages: {
					saved: 'Segment tag updated',
				},
				strings: {
					subject: 'segments',
					loadingMessage: 'Loading segments...',
					noDataMessage: 'No segments found.',
					errorMessage: 'Failed to load segments',
				},
			},
		},
		segmentTags: {
			picker: {
				label: 'Segment tag',
				placeholder: 'Search or type a tag',
			},
			rename: {
				title: 'Rename tag',
				name: 'Name',
				save: 'Save',
				cancel: 'Cancel',
				success: 'Tag renamed',
			},
			table: {
				columns: {
					id: 'ID',
					name: 'Name',
					actions: 'Actions',
				},
				actions: {
					rename: 'Rename',
					delete: 'Delete',
					deleteConfirm: (name: string) => `Delete the tag "${name}"? Assigned tags cannot be deleted.`,
					deleteSuccess: 'Tag deleted',
				},
				strings: {
					subject: 'segment tags',
					loadingMessage: 'Loading segment tags...',
					noDataMessage: 'No segment tags yet. Tags are created when you assign a new name on a segment.',
					errorMessage: 'Failed to load segment tags',
				},
			},
		},
		tabs: {
			popular: 'Popular',
			leagues: 'Leagues (Legacy)',
			tournaments: 'Tournaments (Legacy)',
			camps: 'Camps',
			classes: 'Classes',
			club_teams: 'Club Teams (Legacy)',
			private_lessons: 'Private Lessons',
			events: 'Events',
			clinics: 'Clinics',
			program_passes: 'Program Passes',
			program_portals: 'Portals',
			leagues_v2: 'Leagues',
			tournaments_v2: 'Tournaments',
			club_teams_v2: 'Club Teams',
		},
		session: {
			reportsComingSoon: 'Coming soon',
			wrongPath: 'Oops,looks like wrong path',
			duplicate: {
				title: 'Session Duplication',
				description: 'Select the aspects of the original session that you wish to duplicate.',
				mainButton: 'DUPLICATE',
				secondaryButton: 'CANCEL',
				basicInfomation: 'Basic Information',
				basicInfomationDescription:
					'Duplicates the session’s name, color, descriptions, accounting code, age range, gender, max capacity, membership gating, form, etc',
				schedule: 'Schedule',
				scheduleDescription:
					'Duplicates the session schedule, using the latest activity times,\nincluding edits and one-off changes.\nReview carefully for complex schedules',
				registrationDates: 'Registration Dates',
				registrationDatesDescription:
					"Duplicates the session's registration open and close dates,\nincluding early bird or late fees if applicable",
				products: 'Products',
				productsDescription:
					'Duplicates the session products, including quantity, pricing, and related settings. Products won’t be duplicated if the session type changes between Event-based and Segment-based scheduling',
				divisions: 'Divisions',
				divisionsDescription:
					'Duplicates the division structure from the original session. Does not include teams unless Teams is also selected',
				teams: 'Teams',
				teamsDescription:
					'Duplicates teams from the original session. Teams stay in their matching divisions when Divisions is also selected',
			},
			teamBuilder: {
				title: 'Team Builder',
				unassignedPlayers: 'Unassigned Players',
				players: 'players',
				teams: 'Teams',
				searchPlaceholder: 'Search players...',
				createTeam: 'Create Team',
				selectAll: 'Select all',
				selected: (count: number) => `${count} selected`,
				clear: 'Clear',
				noSearchResults: 'No players match your search.',
				noUnassignedPlayers: 'All players have been assigned to teams.',
				noTeams: 'No teams yet. Create a team to get started.',
				noTeamsHint: 'Create your first team to start building rosters by dragging players over.',
				noTopLevelTeams: 'No top-level teams in this session.',
				noTopLevelTeamsHint: 'Teams may still exist inside divisions. Select a division to view them.',
				noDivisions:
					'No divisions or teams are set up for this session yet. Create a division first to start building teams.',
				playerCount: (count: number) => `${count} player${count !== 1 ? 's' : ''}`,
				division: 'Division',
				allDivisions: 'All Divisions',
				dragHint: 'Drag players to assign',
				moveBack: 'Move to Unassigned',
				expandDetails: 'View Details',
				createTeamDialog: {
					title: 'Create New Team',
					nameLabel: 'Team Name',
					namePlaceholder: 'Enter team name',
					create: 'Create',
					creating: 'Creating...',
					cancel: 'Cancel',
				},
				playerCard: {
					info: 'Info',
					age: 'Age',
					ageWithValue(age: number) {
						return `${this.age} ${age}`;
					},
					waiverSigned: 'Signed',
					waiverUnsigned: 'Unsigned',
					leadRoles: {
						captain: 'Captain',
						coach: 'Coach',
						organizer: 'Organizer',
						starAriaLabel: (role: string) => `Team role: ${role}`,
					},
				},
				statuses: {
					paid: 'Paid',
					unpaid: 'Unpaid',
					partial: 'Partial',
				},
				gender: {
					male: 'Male',
					female: 'Female',
					other: 'Other',
					maleShort: 'M',
					femaleShort: 'F',
					otherShort: 'O',
				},
				playerDetails: {
					title: 'Player Details',
					formResponses: 'Registration Answers',
					noResponses: 'No form responses available.',
					age: 'Age',
					gender: 'Gender',
					email: 'Email',
					payment: 'Payment',
					waiver: 'Waiver',
				},
				moving: 'Moving...',
				save: 'Save',
				saving: 'Saving...',
				saveSuccess: (count: number) => `Saved ${count} player change${count === 1 ? '' : 's'}`,
				saveError: "Couldn't save all changes. Please try again.",
				savePartialFailure: (succeeded: number, total: number, failedTeamNames: string[]) =>
					`Saved ${succeeded} of ${total} changes. ${total - succeeded} failed: ${failedTeamNames.join(', ')}.`,
				truncationWarning: {
					rosters: (pageSize: number) =>
						`Showing the first ${pageSize} teams. Some teams are not visible — contact support if your league exceeds this limit.`,
					unassigned: (pageSize: number) =>
						`Showing the first ${pageSize} unassigned players. Some players are not visible — contact support if your roster exceeds this limit.`,
				},
				restrictions: {
					capacityCount: (current: number, max: number) => `${current}/${max} players`,
					overCapacity: (current: number, max: number) => `Over capacity: ${current}/${max} players`,
					overMaleCapacity: (current: number, max: number) => `Over male roster limit: ${current}/${max}`,
					overFemaleCapacity: (current: number, max: number) => `Over female roster limit: ${current}/${max}`,
					genderNotAllowed: (gender: string, allowed: string) =>
						`Gender restriction: ${gender} not in allowed (${allowed})`,
					ageTooYoung: (age: number, min: number) => `Below minimum age: ${age} (min ${min})`,
					ageTooOld: (age: number, max: number) => `Above maximum age: ${age} (max ${max})`,
					bornTooEarly: (date: string, required: string) =>
						`Born before cutoff: ${date} (required on or after ${required})`,
					bornTooLate: (date: string, required: string) =>
						`Born after cutoff: ${date} (required on or before ${required})`,
					playersWithViolations: (count: number) => `${count} player${count !== 1 ? 's' : ''} with violations`,
					teamHasWarnings: 'This team has restriction violations',
					playerHasWarnings: 'This player violates team restrictions:',
					playerHasWarningsAriaLabel(violations: string[]) {
						return `${this.playerHasWarnings} ${violations.join(' ')}`;
					},
					genericViolation: (message: string) => `Restriction violation: ${message}`,
				},
				createSuccess: 'Team created successfully',
				createError: 'Failed to create team',
				divisionSwitchConfirm: {
					title: 'Discard unsaved changes?',
					description: 'Switching divisions will discard your unsaved player moves. Are you sure you want to continue?',
					discard: 'Discard changes',
					cancel: 'Keep editing',
				},
				teamRemovedDuringEdit: (count: number) =>
					`Moved ${count} player${count === 1 ? '' : 's'} back to Unassigned because their team was removed.`,
			},
			competition: {
				noOnboardingData: 'No onboarding data available',
				tabs: {
					rules: 'Rules',
					scores: 'Scores',
					standings: 'Standings',
					publicDisplay: 'Public Display',
				},
				ariaLabels: {
					tabList: 'Scores & Standings tabs',
					tab: 'Scores & Standings tab',
				},
				placeholders: {
					scoresComingSoon: 'Scores - Coming Soon',
					standingsComingSoon: 'Standings - Coming Soon',
					publicDisplayComingSoon: 'Public Display - Coming Soon',
				},
				loading: 'Loading...',
				creatingCompetition: 'Creating competition...',
				loadError: 'Failed to load competition',
				breadcrumbs: {
					competition: 'Competition',
				},
				errors: {
					organizationIdRequired: 'Organization ID is required',
					organizationAndStageRequired: 'Organization ID and Stage ID are required',
					fetchOnboardingFailed: 'Failed to fetch onboarding data',
					fetchCompetitionFailed: 'Failed to fetch competition',
					fetchGameFailed: 'Failed to fetch game',
					fetchScoresFailed: 'Failed to fetch stage scores',
					createGameFailed: 'Failed to create game',
					updateGameFailed: 'Failed to update game',
					addPlayoffsFailed: 'Failed to add playoffs stage',
					missingOrganizationOrCompetitionContext: 'Missing organization or competition context',
					updateCompetitionFailed: 'Failed to update competition',
					loadGameDataFailed: 'Failed to load game data',
					saveGameFailed: 'Failed to save game',
					providerRequired: 'useCompetitionContext must be used within a CompetitionProvider',
				},
				publicDisplay: {
					loading: 'Loading settings...',
					save: 'SAVE',
					saving: 'SAVING...',
					cancel: 'CANCEL',
					saveSuccess: 'Public display settings saved successfully',
					saveFailed: 'Failed to save public display settings',
					displaySettings: {
						title: 'Display Settings',
						description: 'Choose which sections are visible to the public on the competition page.',
						schedulesAndScores: 'Schedule & Scores',
						standings: 'Standings',
						rosters: 'Rosters',
					},
					competitionDescription: {
						title: 'Competition Description',
						description: 'This text appears at the top of the public competition page.',
						placeholder: 'Enter a description for the competition...',
					},
				},
				scores: {
					title: 'Game Scores',
					subtitle: 'Enter and manage game scores for the selected stage',
					loadingScores: 'Loading scores...',
					noGamesFound: 'No games found',
					noGamesSubtext: 'Games will appear here once they are scheduled',
					noRuleset: {
						title: 'Standings Rules Required',
						message:
							'Before games can be scored, you must review and save the standings rules for this stage. This ensures that standings will be calculated and displayed correctly.',
						buttonText: 'Define Standings Rules',
					},
					editingPlaceholder: 'Edit form coming soon',
					editButton: 'Edit',
					referee: 'Referee',
					seeStandings: 'SEE STANDINGS',
					viewAndEdit: 'Edit Game',
					printScoresheet: 'Print Scoresheet',
					printScoresheetError: 'Failed to generate scoresheet PDF. Please try again.',
					printScoresheetPopupBlocked: 'Allow popups for this site to view the scoresheet PDF in a new tab.',
					printScoresheetLoading: 'Generating scoresheet…',
					teamsRequiredTooltip: 'You cannot update a score unless both teams are assigned',
					tbd: 'TBD',
					subject: 'game',
					errorMessage: 'Failed to load games',
					noScore: 'None',
					scoreDisplay(home: number, away: number) {
						return `${home} - ${away}`;
					},
					tableHeaders: {
						homeTeam: 'Home Team',
						score: 'Score',
						awayTeam: 'Away Team',
						dateTime: 'Date & Time',
						status: 'Status',
					},
					editGame: {
						title: 'Edit Game Score',
						loading: 'Loading game details...',
						notFound: 'Game not found',
						gameInfo: 'Game Information',
						scores: 'Scores',
						homeScore: 'Home Score',
						awayScore: 'Away Score',
						status: 'Game Status',
						sections: {
							overview: 'OVERVIEW',
							results: 'RESULTS',
							statistics: 'STATISTICS',
							notes: 'NOTES',
						},
						overview: {
							vs: 'vs',
							teamTitle: (homeTeam: string, awayTeam: string) => `${homeTeam} vs ${awayTeam}`,
							editSchedule: 'Edit schedule',
							duration: {
								minutes: (mins: number) => `${mins} min`,
								hour: '1 hr',
								hours: (hrs: number) => `${hrs} hrs`,
								hoursAndMinutes: (hrs: number, mins: number) => `${hrs} hr ${mins} min`,
							},
							dateTime: (date: string, startTime: string) => `${date} • ${startTime}`,
							dateTimeRange: (date: string, startTime: string, endTime: string, duration: string) =>
								`${date} • ${startTime} - ${endTime} • (${duration})`,
						},
						options: 'Options',
						scoring: 'Scoring',
						resultsCalculation: 'Results Calculation',
						statusRequired: 'Status*',
						includeInStandings: 'Include in Standings',
						includedInStandings: 'Included in standings',
						includeInStandingsHelp: 'Uncheck to exclude this game from standings calculations',
						overtime: 'Overtime',
						shootout: 'Shootout',
						notes: 'Notes',
						publicNote: 'Public Note',
						publicNotePlaceholder: 'Visible to everyone (e.g., weather delay)',
						privateNote: 'Private Note',
						privateNotePlaceholder: 'Internal use only (e.g., referee feedback)',
						notesHelp: 'Public notes appear on scoreboards. Private notes are for staff only.',
						deleteScore: 'DELETE SCORE',
						deleteConfirm: 'Are you sure you want to delete this score?',
						save: 'Save',
						saving: 'Saving...',
						cancel: 'Cancel',
						updateScore: 'UPDATE SCORE',
						editDescription: (homeTeam: string, awayTeam: string) => `Edit score for ${homeTeam} vs ${awayTeam}`,
						statuses: {
							scheduled: 'Scheduled',
							live: 'Live',
							final: 'Final',
							postponed: 'Postponed',
							cancelled: 'Cancelled',
							suspended: 'Suspended',
							homeForfeit: 'Home Forfeit',
							awayForfeit: 'Away Forfeit',
							doubleForfeit: 'Double Forfeit',
							reopen: 'Reopen',
						},
						standingsNotice: 'Games with this status do not count towards standings',
					},
					validation: {
						scoreRequired: 'Score is required for this game status',
						scoreMinimum: 'Score must be 0 or greater',
						bothScoresRequired: 'Both scores must be provided or both cleared',
					},
				},
				standings: {
					title: 'Standings',
					subtitle: 'View team rankings and statistics',
					loadingStandings: 'Loading standings...',
					noStandings: 'No standings available',
					noStandingsSubtext: 'Standings will be calculated once games have been played',
					division: 'Division',
					noDivisions: 'No divisions found',
				},
				stageSelector: {
					ariaLabel: 'Stage selection',
					preset: 'Preset:',
					resetToDefault: 'Reset to default',
					resetAriaLabel: 'Reset rules to default values',
					addPlayoffs: '+ Playoffs',
					addPlayoffsAriaLabel: 'Add playoffs stage',
					addPlayoffsConfirmation: {
						title: 'Create Playoffs Stage',
						description:
							'Are you sure you want to create a playoffs stage? This will add a new stage to the competition.',
						confirm: 'Create Playoffs',
						creating: 'Creating Playoffs...',
						cancel: 'Cancel',
					},
					sports: {
						soccer: 'Soccer',
						hockey: 'Hockey',
						basketball: 'Basketball',
						football: 'Football',
						baseball: 'Baseball',
						softball: 'Softball',
						volleyball: 'Volleyball',
						lacrosse: 'Lacrosse',
						flagFootball: 'Flag Football',
						tennis: 'Tennis',
						pickleball: 'Pickleball',
						other: 'Custom',
					},
				},
				stageHeader: {
					regularSeason: 'Regular Season',
					playoffs: 'Playoffs',
					stage: 'Stage',
					tbd: 'TBD',
				},
				onboarding: {
					noOnboardingData: 'No onboarding data available',
					title: 'Competition Setup',
					subtitle: 'Configure your league for the season',
					whatYoullConfigure: "What you'll configure",
					configureStep1: 'Set up point values for game outcomes',
					configureStep2: 'Configure ranking criteria and tiebreakers',
					configureStep3: 'Customize standings table and scoresheet fields',
					scheduledDivisions: 'Scheduled divisions',
					teamCount: (count: number) => `${count} teams`,
					gameCount: (count: number) => `${count} games`,
					seasonDateRange: (startDate: string, endDate: string) => `Season: ${startDate} - ${endDate}`,
					moreDivisions: (count: number) => `+${count} more divisions`,
					missingDivisionsNote: 'If you are missing divisions or games, you can finish scheduling in ',
					scheduleGeneratorLink: 'the Schedule Generator',
					beforeStarting: ' before starting the competition.',
					readyQuestion: 'Are you ready to start your competition?',
					yesButton: "YES, LET'S START",
					noButton: 'NOT YET',
					noGamesTitle: 'No Games Scheduled Yet',
					noGamesWarning: 'You need to schedule games before you can set up competition rules.',
					noGamesDescription: 'Use the Schedule Generator to create your league or tournament schedule first.',
					goToSchedule: 'Go to Schedule Generator',
				},
				rules: {
					loading: 'Loading...',
					noRulesFound: 'Set Up Standings Rules',
					noRulesDescription:
						'Define the point system, ranking criteria, and standings columns for this stage. These rules determine how teams are ranked and how standings are displayed.',
					setupRules: 'Set Up Rules',
					discardChanges: 'Discard Changes',
					saveRules: 'Save Rules',
					saving: 'Saving...',
					lockedAlert: {
						title: 'Standings Rules Locked',
						message:
							'These standings rules cannot be modified because games have already been scored. To make changes, please contact support.',
					},
					notifications: {
						saveSuccess: 'Rules saved successfully',
						saveFailed: 'Failed to save rules',
						changesDiscarded: 'Changes discarded',
						resetSuccess: 'Rules reset to defaults and saved',
						resetFailed: 'Failed to reset rules to defaults',
					},
					errors: {
						fetchFailed: 'Failed to load standings rules',
						saveFailed: 'Failed to save standings rules',
						resetFailed: 'Failed to reset standings rules',
					},
					pointsSystem: {
						title: 'Points System',
						caption:
							'Configure how points are awarded for match results. You will not be able to change this after games are scored.',
						winLossLabel: 'Win / Loss',
						win: 'Win',
						loss: 'Loss',
						tie: 'Tie',
						overtime: 'Overtime',
						overtimeWin: 'Overtime Win',
						overtimeLoss: 'Overtime Loss',
						penaltyShootout: 'Penalty Shootout',
						shootoutWin: 'Shootout Win',
						shootoutLoss: 'Shootout Loss',
						forfeit: 'Forfeit',
						forfeitWin: 'Forfeit Win',
						forfeitLoss: 'Forfeit Loss',
					},
					rankingCriteria: {
						title: 'Ranking Criteria',
						caption: 'Drag to reorder. Teams are ranked by the first item, then by tiebreakers below when equal.',
						addTiebreaker: 'Add a tiebreaker',
						tiebreakers: {
							// Universal
							leaguePoints: 'League Points',
							points: 'Total Points',
							wins: 'Total Wins',
							losses: 'Total Losses',
							winPercentage: 'Win Percentage',
							headToHeadRecord: 'Head-to-Head Record',
							headToHeadPoints: 'Head-to-Head Points',
							pointsScored: 'Points Scored',
							pointsAgainst: 'Points Against',
							pointDifferential: 'Point Differential',
							headToHeadPointDifferential: 'Head-to-Head Point Differential',
							fewestLosses: 'Fewest Losses',
							fewestForfeits: 'Fewest Forfeits',
							// Soccer/Hockey/Lacrosse
							goalDifferential: 'Goal Differential',
							goalsFor: 'Goals For',
							goalsAgainst: 'Goals Against',
							headToHeadGoalDifferential: 'Head-to-Head Goal Differential',
							regulationWins: 'Regulation Wins',
							overtimeWins: 'Overtime Wins',
							overtimeLosses: 'Overtime Losses',
							shootoutWins: 'Shootout Wins',
							awayGoals: 'Away Goals',
							fewestRedCards: 'Fewest Red Cards',
							fewestYellowCards: 'Fewest Yellow Cards',
							fewestBlueCards: 'Fewest Blue Cards',
							mostShutouts: 'Most Shutouts',
							// Hockey
							row: 'ROW (Regulation + OT Wins)',
							fewestPenaltyMinutes: 'Fewest Penalty Minutes',
							strengthOfSchedule: 'Strength of Schedule',
							// Baseball/Softball
							runsFor: 'Runs Scored',
							runsAgainst: 'Runs Allowed',
							runDifferential: 'Run Differential',
							battingAverage: 'Team Batting Average',
							era: 'Team ERA',
							qualityStarts: 'Quality Starts',
							// Volleyball
							matchPoints: 'Match Points',
							setDifferential: 'Set Differential',
							setsWon: 'Sets Won',
							setsLost: 'Sets Lost',
							matchWinPercentage: 'Match Win Percentage',
							cumulativeMatchWinPercentage: 'Cumulative Match Win Percentage',
							// Hockey
							krach: 'KRACH',
							// Basketball
							fewestTechnicalFouls: 'Fewest Technical Fouls',
						},
					},
					standingsColumns: {
						title: 'Standings Table',
						caption: 'Drag column headers to reorder. Add or remove columns to customize your standings table',
						preview: 'Preview',
						previewSubtitle: 'Uses mock data',
						addRemoveLabel: 'Add or remove columns',
						required: 'Required',
						columns: {
							rank: 'Rank',
							team: 'Team',
							gp: 'Games Played',
							w: 'Wins',
							l: 'Losses',
							pts: 'Points',
							t: 'Ties',
							otw: 'Overtime Wins',
							otl: 'Overtime Losses',
							sow: 'Shootout Wins',
							sol: 'Shootout Losses',
							gf: 'Goals For',
							ga: 'Goals Against',
							gd: 'Goal Differential',
							pf: 'Points For',
							pa: 'Points Against',
							row: 'ROW',
							rc: 'Red Cards',
							yc: 'Yellow Cards',
							bc: 'Blue Cards',
							so: 'Shutouts',
							pim: 'Penalty Minutes',
							ppg: 'Points Per Game',
							oppPpg: 'Opponent Points Per Game',
							fgPct: 'Field Goal Percentage',
							diff: 'Point Differential',
							rs: 'Runs Scored',
							ra: 'Runs Against',
							rd: 'Run Differential',
							avg: 'Batting Average',
							era: 'ERA',
							sw: 'Sets Won',
							sl: 'Sets Lost',
							sd: 'Set Differential',
							mw: 'Matches Won',
							ml: 'Matches Lost',
							pct: 'Win Percentage',
						},
						abbreviations: {
							rank: '#',
							gp: 'GP',
							pts: 'Pts',
							otw: 'OTW',
							otl: 'OTL',
							sow: 'SOW',
							sol: 'SOL',
							diff: 'Diff',
							row: 'ROW',
							pim: 'PIM',
							era: 'ERA',
							avg: 'AVG',
							pct: 'Win%',
						},
					},
					statistics: {
						title: 'Statistics Tracking',
						caption:
							'Select which statistics to track during games. Some tiebreakers and standings columns require specific statistics to be tracked.',
						toggleAriaLabel: 'Toggle tracking for',
						validationWarning:
							'Some selected tiebreakers or columns require statistics that are not being tracked. Enable the required statistics or remove those items.',
						requiredBy: (items: string) => `Required by: ${items}`,
						tiebreakerWarning: (tiebreakerName: string, missingStats: string) =>
							`${tiebreakerName} requires tracking ${missingStats}. Enable this under Statistics below or remove this tiebreaker.`,
						columnWarning: (columnName: string, missingStats: string) =>
							`${columnName} requires tracking ${missingStats}. Enable ${missingStats} under Rules > Statistics or remove this column.`,
						statLabels: {
							// Universal
							score: 'Score',
							gameDuration: 'Game Duration',
							// Soccer
							goals: 'Goals',
							shots: 'Shots',
							shotsOnTarget: 'Shots on Target',
							cornerKicks: 'Corner Kicks',
							offsides: 'Offsides',
							fouls: 'Fouls',
							possession: 'Possession',
							penaltyKicks: 'Penalty Kicks',
							ownGoals: 'Own Goals',
							substitutions: 'Substitutions',
							yellowCards: 'Yellow Cards',
							redCards: 'Red Cards',
							blueCards: 'Blue Cards',
							// Hockey
							shotsOnGoal: 'Shots on Goal',
							saves: 'Saves',
							powerPlayGoals: 'Power Play Goals',
							shortHandedGoals: 'Short Handed Goals',
							emptyNetGoals: 'Empty Net Goals',
							penaltyMinutes: 'Penalty Minutes',
							faceoffsWon: 'Faceoffs Won',
							plusMinus: 'Plus/Minus',
							goalsAgainstAverage: 'Goals Against Average',
							savePercentage: 'Save Percentage',
							shutouts: 'Shutouts',
							// Basketball
							points: 'Points',
							fieldGoalsMade: 'Field Goals Made',
							fieldGoalsAttempted: 'Field Goals Attempted',
							fieldGoalPercentage: 'Field Goal %',
							threePointersMade: '3-Pointers Made',
							threePointersAttempted: '3-Pointers Attempted',
							threePointPercentage: '3-Point %',
							freeThrowsMade: 'Free Throws Made',
							freeThrowsAttempted: 'Free Throws Attempted',
							freeThrowPercentage: 'Free Throw %',
							rebounds: 'Rebounds',
							assists: 'Assists',
							steals: 'Steals',
							blocks: 'Blocks',
							turnovers: 'Turnovers',
							personalFouls: 'Personal Fouls',
							technicalFouls: 'Technical Fouls',
							timeoutsUsed: 'Timeouts Used',
							// Baseball/Softball
							runs: 'Runs',
							hits: 'Hits',
							errors: 'Errors',
							atBats: 'At Bats',
							rbi: 'RBI',
							doubles: 'Doubles',
							triples: 'Triples',
							homeRuns: 'Home Runs',
							battingAverage: 'Batting Average',
							strikeouts: 'Strikeouts',
							walks: 'Walks',
							inningsPitched: 'Innings Pitched',
							hitsAllowed: 'Hits Allowed',
							runsAllowed: 'Runs Allowed',
							earnedRuns: 'Earned Runs',
							fieldingErrors: 'Fielding Errors',
							teamEra: 'Team ERA',
							// Volleyball
							pointsPerSet: 'Points Per Set',
							setsWon: 'Sets Won',
							setsLost: 'Sets Lost',
							kills: 'Kills',
							aces: 'Aces',
							digs: 'Digs',
							blocksVolleyball: 'Blocks',
							errorsVolleyball: 'Errors',
							pointsScored: 'Points Scored',
							// Lacrosse
							goalsLacrosse: 'Goals',
							shotsLacrosse: 'Shots',
							savesLacrosse: 'Saves',
							penalties: 'Penalties',
							unknown: 'Statistic',
							// Legacy keys (for backwards compatibility with older code)
							fgPercentage: 'Field Goal Percentage',
							ftPercentage: 'Free Throw Percentage',
							fgm: 'Field Goals Made',
							fga: 'Field Goals Attempted',
							threePm: 'Three Pointers Made',
							threePa: 'Three Pointers Attempted',
							ftm: 'Free Throws Made',
							fta: 'Free Throws Attempted',
							battingAvg: 'Batting Average',
							volleyballErrors: 'Volleyball Errors',
						},
					},
					saveConfirmation: {
						title: 'Save Rules',
						description:
							'These rules will apply to all divisions. Make sure all rules are correct before scoring games, as after the first game is scored, you will not be able to update them.',
						save: 'SAVE',
						cancel: 'CANCEL',
					},
					resetConfirmation: {
						title: 'Reset to Default Rules',
						description: 'Are you sure you want to reset to the default rules? All changes will be deleted.',
						warning: 'This cannot be undone.',
						reset: 'RESET',
						cancel: 'CANCEL',
					},
				},
			},
			header: {
				tabs: {
					create: 'Create',
					dashboard: 'Dashboard',
					info: 'Info',
					schedule: 'Schedule',
					scheduler: 'Scheduler',
					participants: 'Participants',
					'team-builder': 'Team Builder',
					products: 'Products',
					pricing: 'Pricing',
					reports: 'Reports',
					competition: 'Scores & Standings',
				},
				publish: 'Publish',
				addResource: 'Add resource',
				registration: 'Registration',
				standings: 'Standings',
				openWebsite: 'Open Website',
				published: 'Published',
				statusUnpublished: 'Unpublished',
				unpublish: 'Unpublish session',
				messages: {
					published: 'Session published successfully',
					unpublished: 'Session unpublished successfully',
					publishFailure: 'Could not publish session, please try again later',
					unpublishFailure: 'Could not unpublish session, please try again later',
				},
			},
			dashboard: {
				countdownWidget: {
					startIn: 'Session starts in',
					endIn: 'Session end in',
					ended: 'Session is ended',
					days: 'days',
					daysCountdown(count: number) {
						return `${count} ${this.days}`;
					},
				},
				productsWidget: {
					addProducts: 'Add product and prices',
					addProductLabel: 'Add product',
					productExist: 'Go to Products tab to view products',
				},
				allocationWidget: {
					noAllocation: 'Allocate event resources',
					partialAllocation: 'There are ~ events without a resource', // Replace ~ with number of events unallocated
					completeAllocation: 'All events have been allocated',
					addResource: 'ADD RESOURCE',
					editResource: 'EDIT RESOURCE',
				},
			},
			info: {
				edit: 'Edit',
				cancel: 'Cancel',
				save: 'Save',
				viewMore: 'View More',
				viewLess: 'View Less',
				basicInfo: {
					title: 'Basic Info',
					age: 'AGE',
					y: 'years',
					m: 'months',
					gender: 'Gender',
					activity: 'Activity',
					levelOfPlay: 'LEVEL OF PLAY',
					facility: 'FACILITY',
				},
				forms: {
					title: 'Forms',
					label: 'Forms',
					placeholder: 'Select',
					link: {
						linkDescription: "Can't find what you're looking for?",
						linkLabelPrefix: 'Create a new form ',
						linkLabel: 'here.',
					},
					failedToFetchForms: 'Failed to load forms. Please try again later.',
					failedToSaveForms: `Failed to save forms. Please try again later or contact ${SUPPORT_EMAIL} if the issue persists.`,
					missingSaveContext: 'Cannot save forms: organization, session, or program is missing.',
				},
				tags: {
					title: 'Tags',
				},
			},
			products: {
				addProduct: 'Add Product',
				inputPlaceholder: 'Search by Name, Date',
				emptyStateLabel: 'There are no products for this session',
				createProduct: 'Create a new product',
				duplicateSuccessMessage: 'Product duplicated successfully',
				archiveSuccessMessage: 'Product deleted successfully',
				duplicateProductName: (name: string) => `Copy - ${name}`,
				purchase: {
					selectCustomer: 'SELECT CUSTOMER',
					schedule: 'schedule',
					selectCustomerSchedule: 'Select customer schedule',
					price: 'PRICE',
					selectAddons: 'SELECT ADDONS',
					perSession: 'Per Session',
					table: {
						columns: {
							name: 'Event',
							emptyName: CHARACHERS.DASH,
							date: 'Date',
							time: 'Time',
							resource: 'Resource',
							availability: 'Availability',
						},
						pagination: {
							events: 'events',
						},
						emptyTable: 'No events',
						timeFormat: (startTime: string, endTime: string) =>
							`${dayjs(startTime, DateTimeFormats.H24_WITH_SECONDS).format(DateTimeFormats.H12_AMPM)} - ${dayjs(
								endTime,
								DateTimeFormats.H24_WITH_SECONDS
							).format(DateTimeFormats.H12_AMPM)}`,
					},
					availability: {
						full: 'Full',
						waitlistAvailable: 'Full (waitlist available)',
						noMaxParticipants: 'Available',
						available: (spotsLeft: number) => `${spotsLeft} spots left`,
					},
					resourceFullAlert: {
						title: 'Session is full',
						description: (customerName = 'the customer') =>
							`This session has reached its capacity. Please choose how you'd like to proceed with registering ${customerName}`,
						registerAnyway: 'REGISTER ANYWAY',
						addToWaitlist: 'ADD TO WAITLIST',
						cancel: 'CANCEL',
					},
					errors: {
						maxQuantity: (quantity: number) =>
							`You may only select a maximum of ${quantity} ${quantity === 1 ? 'event' : 'events'} when purchasing this product`,
						waitlistAndAvailable: 'You cannot select both available and waitlisted events at the same time.',
					},
				},
				utils: {
					productSubTypeInfo: {
						league_v2_captain: 'Captain',
						league_v2_invited_player: 'Invited Player',
						league_v2_player: 'Player',
						league_v2_free_agent: 'Free Agent',
						league_v2_organizer: 'Organizer',
						league_v2_coach: 'Coach',
					},
					all: 'All',
					registration: 'Registration',
					purchase: 'Purchase',
					discountAndPayments: 'Discounts & Payments',
					selectCustomer: 'Select customer ',
					discount: 'Discount',
					until: 'until',
					since: 'since',
					schedule: 'Schedule',
					discounts: 'Discounts',
					deposit: 'Deposit',
					event: 'Event',
					segment: 'Segment',
					events: 'Events',
					segments: 'Segments',
					singleResourceLabel(isEvent: boolean) {
						return `1 ${isEvent ? this.event : this.segment}`;
					},
					quantityResourcesLabel(quantity: number, isEvent: boolean) {
						return `${quantity} ${isEvent ? this.events : this.segments}`;
					},
					allResourcesLabel(isEvent: boolean) {
						return `${this.all} ${isEvent ? this.events : this.segments}`;
					},
					pass: {
						tags: {
							session: {
								title: 'Session Pass',
								color: TagColorsMapper.purple,
							},
							global: {
								title: 'Global Pass',
								color: TagColorsMapper.green,
							},
						},
					},
					menuActions: {
						editPrice: 'Edit product',
						addDiscount: 'Add discount & payments',
						addOns: 'Add add ons',
						duplicateProduct: 'Duplicate product',
						deleteProduct: 'Delete product',
					},
					deletePopup: {
						title: 'Delete Product',
						description: 'Are you sure you want to delete this product from your product list ?',
						mainButton: 'delete',
						subButton: 'Cancel',
					},
					errors: {
						noResources:
							'No resources are available for the selected facility. Please check that the facility has resources configured, or choose a different facility.',
						seasonIdRequiredForFolderedRegistration: 'Season ID is required for FOLDERED_REGISTRATION products',
						alreadySelectedResource: (customerName: string, resourceName: string) =>
							`${customerName} already has ${resourceName} in the cart and can’t be added twice.`,
					},
				},
				selectProductTypePopup: {
					title: 'Select Product Type',
					description: 'Select the type of product you want to create',
					options: [
						{
							label: 'Registration',
							type: ProductType.REGISTRATION,
						},
						{
							label: 'Punch Pass',
							type: ProductType.PUNCH_PASS,
						},
					],
					note: `This pass applies only to this session.\nTo create a global punch pass, click `,
					noteLink: 'here.',
					mainButton: 'Create',
					subButton: 'Cancel',
					createPunchPass: 'Create Punch Pass',
					createProduct: 'Create Product',
				},
				leagueV2: {
					/**
					 * Returns a human readable label for a resource quantity with pluralization and "All" case.
					 * Examples: "1 Event", "2 Events", "All Segments"
					 */
					resourceQuantityLabel: (count: number, total: number, isEvent: boolean): string => {
						const singular = isEvent ? 'Event' : 'Segment';
						const plural = isEvent ? 'Events' : 'Segments';
						if (count === 1) return `1 ${singular}`;
						if (count !== total) return `${count} ${plural}`;
						return `All ${plural}`;
					},
					missingIndividualPlayerProductHelperCard: {
						headline: 'Add Individual Player Registration',
						body: ['Players and free agents aren’t able to register yet.'],
						cta: 'Create a new product',
					},
					missingInvitedPlayerProductHelperCard: {
						headline: 'Add Invited Player Registration',
						body: ['Team managers can’t invite players until this is set up.'],
						cta: 'Create a new product',
					},
					missingTeamProductHelperCard: {
						headline: 'Add Team Manager Registration',
						body: ["Captains, coaches, and organizers can't sign up their teams yet."],
						cta: 'Create a new product',
					},
					scheduler: {
						title: 'League Scheduler',
						fallbackTitle: 'Error Loading Scheduler',
						fallbackMessage: 'There was an error loading the league scheduler. Please try refreshing the page.',
						tryAgain: 'Try Again',
						reloadPage: 'Reload Page',
						loadingText: 'Loading scheduler...',
						headerTitle: (seasonName: string) => `${seasonName} Schedule`,
						defaultHeaderTitle: 'Schedule',
						openScheduler: 'Open League Scheduler',
						// Country/Locale settings
						country: 'US',
						tabs: {
							inputs: 'Inputs',
							results: 'Results',
							sandbox: 'Sandbox',
							quality: 'Quality',
						},
						buttons: {
							discard: 'Discard',
							saveDraft: 'Save Draft',
							draftSaved: 'Draft Saved',
							publish: 'Add to Schedule',
						},
						ariaLabels: {
							formContainer: 'Schedule Generator Configuration',
							formActions: 'Form Actions',
							generatingSchedule: 'Generating schedule, please wait',
							generateSchedule: 'Generate schedule with current configuration',
							cancelButton: 'Cancel schedule generation and return to previous page',
							generateButton: 'Generate schedule with current configuration',
							generatingButton: 'Generating schedule, please wait',
							optimizeButton: 'Optimize schedule to improve quality',
							publishButton: 'Add events to the schedule',
							saveDraftButton: 'Save draft schedule for later use',
							backToEditButton: 'Back to Edit',
							revertChangesButton: 'Revert Changes',
							undoButton: 'Undo',
							redoButton: 'Redo',
							swapButton: 'Swap',
							variantsButton: 'Variants',
							previousButton: 'Previous',
							nextButton: 'Next',
							completeButton: 'Complete',
							regenerateButton: 'Regenerate',
						},

						// Success messages
						success: {
							scheduleGenerated: 'Schedule generated successfully',
							scheduleOptimized: 'Schedule optimized successfully',
							schedulePublished: 'Events added to the season schedule successfully',
							scheduleDiscarded: 'Schedule discarded successfully',
							changesSaved: 'Changes saved successfully',
							configUpdated: 'Schedule configuration updated successfully',
						},

						// Error messages
						errors: {
							seasonFolderNotFound: 'Season folder not found. Please try again.',
							seasonFolderRequiredForConfigUpdate: 'Season folder ID is required to update schedule configuration',
							configUpdateFailed: 'Failed to update schedule configuration',
							saveDraftFailed: 'Failed to save draft schedule',
							noScheduleReturned: 'Schedule generation failed - no schedule returned.',
							generationFailed: 'Failed to generate schedule',
							optimizationFailed: 'Failed to optimize schedule',
							validationFailed: 'Schedule validation failed',
							noScheduleToPublish: 'No schedule to add. Please generate a schedule first.',
							seasonNotPublished:
								'This session must be published before you can add a schedule. Please publish the session first.',
							publishFailed: 'Failed to add schedule to the season',
							noScheduleToSave: 'No schedule to save. Please generate a schedule first.',
							missingDraftId: 'Cannot save schedule: missing draft ID',
							discardFailed: 'Failed to discard schedule',
							deleteScheduleIdentifiersRequired: 'Schedule ID and Season Folder ID are required to delete a schedule.',
							loadingFailed: 'Failed to load schedule data',
							bootstrapFailed: 'Failed to initialize scheduler',
							missingProgramSeasonId: 'Program Season ID is required',
							seasonFolderRequiredForConflicts: 'Season folder is required to check conflicts.',
							networkError: 'Network error occurred while loading data',
							invalidResponse: 'Received invalid response from server',
						},

						suggestions: {
							balance: 'Consider adjusting team constraints to improve balance',
							timeDistribution: 'Try different time slot distributions for better fairness',
							homeAwayBalance: 'Adjust home/away game distribution for better balance',
							constraintCompliance: 'Review constraint settings - some may be too restrictive',
						},

						// Conflict messages
						conflicts: {
							bannerTitle: 'Calendar Conflicts Detected',
							gameConflictsCount: (count: number) =>
								`${count} game${count !== 1 ? 's' : ''} conflict with existing calendar events`,
							moreConflicts: (count: number) => `+${count} more conflict(s)`,
							showLess: 'Show less',
							formatConflictMessage: (
								eventTitle: string,
								resourceName: string,
								date: string,
								startTime: string,
								endTime: string
							) =>
								`Conflicts with "${eventTitle}" on ${resourceName} - ${formatDate(date, DateTimeFormats.DAY_FORMAT)} ${format24HToAmPm(startTime)} - ${format24HToAmPm(endTime)}`,
							formatConflictMessageNoEvent: (resourceName: string, date: string, startTime: string, endTime: string) =>
								`Resource conflict on ${resourceName} - ${formatDate(date, DateTimeFormats.DAY_FORMAT)} ${format24HToAmPm(startTime)} - ${format24HToAmPm(endTime)}`,
							internalResourceConflict: (resourceName: string, gameOne: string, gameTwo: string, date: string) =>
								`${resourceName} is double-booked for ${gameOne} and ${gameTwo} on ${formatDate(date, DateTimeFormats.DAY_FORMAT)}`,
							internalTeamConflict: (teamName: string, gameOne: string, gameTwo: string, date: string) =>
								`${teamName} is scheduled for overlapping games: ${gameOne} and ${gameTwo} on ${formatDate(date, DateTimeFormats.DAY_FORMAT)}`,
						},
						incompleteSchedule: {
							bannerTitle: 'Incomplete Schedule',
							matchupsNotScheduled: (count: number) => `${count} matchup${count !== 1 ? 's' : ''} not scheduled:`,
							moreMatchups: (count: number) => `+${count} more matchup(s)`,
							showLess: 'Show less',
						},
						scheduleValidation: {
							bannerTitle: 'Schedule Validation Issues',
							timeConflictsCount: (count: number) => `${count} time conflict(s) detected`,
							blackoutViolationsCount: (count: number) => `${count} game(s) on blackout dates`,
							outOfBoundsCount: (count: number) => `${count} game(s) outside season bounds`,
							matchupLabel: (homeTeam: string, awayTeam: string) => `${homeTeam} vs ${awayTeam}`,
						},
						common: {
							loading: 'Loading schedule...',
							saving: 'Saving changes...',
							generating: 'Generating schedule...',
							optimizing: 'Optimizing schedule...',
							publishing: 'Submitting schedule...',
							noData: 'No data available',
							optional: 'Optional',
							required: 'Required',
							select: 'Select',
							add: 'Add',
							remove: 'Remove',
							edit: 'Edit',
							delete: 'Delete',
							save: 'Save',
							cancel: 'Cancel',
							confirm: 'Confirm',
							back: 'Back',
							next: 'Next',
							finish: 'Finish',
							close: 'Close',
							minutes: 'minutes',
							min: 'min',
							games: 'games',
							game: 'game',
							teams: 'teams',
							team: 'team',
							weeks: 'weeks',
							week: 'week',
							days: 'days',
							day: 'day',
						},

						// Actions
						actions: {
							previous: 'Previous',
							next: 'Next',
							complete: 'Complete',
							generate: 'Generate Schedule',
							regenerate: 'Regenerate',
							optimize: 'Optimize',
							publish: 'Add to Schedule',
							saveDraft: 'Save Changes',
							backToEdit: 'Back to Edit',
							revertChanges: 'Revert Changes',
							undo: 'Undo',
							redo: 'Redo',
							swap: 'Swap',
							variants: 'Variants',
							reset: 'Reset',
							cancel: 'Cancel',
						},

						// Generating state
						generating: {
							title: 'Generating Schedule...',
							description: 'Please wait while we create your schedule. This may take a few moments.',
						},

						// Teams Section
						teams: {
							title: 'Teams & Divisions',
							description: 'Select the teams and divisions to include in the schedule',
							selectDivisions: 'Select Divisions',
							selectTeams: 'Select Teams',
							selectedTeams: (count: number) => `${count} team${count !== 1 ? 's' : ''} selected`,
							noTeamsSelected: 'No teams selected',
							noDivisions: 'No divisions available',
							noTeamsFound: 'No teams found for this season.',
							selectAll: 'Select All',
							deselectAll: 'Deselect All',
							ungroupedTeams: 'Ungrouped Teams',
							topLevel: 'Ungrouped',
							teamsCount: (count: number) => `${count} team${count !== 1 ? 's' : ''}`,
							selectedTeamsTitle: 'Selected Teams',
							selectedTeamsWithCount: (count: number) => `Selected Teams (${count})`,
							selectedTeamBadge: (divisionName: string, teamName: string) => `${divisionName} - ${teamName}`,
							removeSelectedTeam: (teamName: string) => `Remove ${teamName}`,
							clearAll: 'Clear All',
							selectedCount: (teamCount: number, divisionCount: number) =>
								`Selected ${teamCount} team${teamCount !== 1 ? 's' : ''} across ${divisionCount} division${divisionCount !== 1 ? 's' : ''}. (Note: with an uneven number of teams, your schedule will have bye weeks.)`,
							respectDivisionBoundaries: 'Separate games by division',
							respectDivisionBoundariesTooltip:
								'Use shared time slots across all divisions, but only schedule games between teams in the same parent division.',
							respectDivisionBoundariesDisabledHint: 'Select teams from more than one division to enable this option.',
							byeWeekWarning: 'With an uneven number of teams, your schedule will have bye weeks.',
						},

						// Slots Section
						slots: {
							title: 'Game Slots & Times',
							description: 'Configure when and where games can be played',
							gameDuration: 'Game Duration',
							breakBetweenGames: 'Break Between Games',
							maintenance: 'Maintenance',
							maintenanceName: 'Maintenance Name',
							maintenanceDuration: 'Duration',
							addMaintenance: 'Add maintenance',
							removeMaintenance: 'Remove',
							gameSlots: 'Game Slots',
							dayOfWeek: 'Day of the Week',
							from: 'From',
							to: 'To',
							space: 'Space',
							spaceOptional: 'Space (Optional)',
							noResourceAssigned: 'No resource assigned',
							overflow: 'Overflow',
							addTimeSlot: 'Add Time Slot',
							removeTimeSlot: 'Remove',
							daysOfWeek: {
								sun: 'Sun',
								mon: 'Mon',
								tue: 'Tue',
								wed: 'Wed',
								thu: 'Thu',
								fri: 'Fri',
								sat: 'Sat',
							},
						},

						// Season Dates Section
						seasonDates: {
							title: 'Season Dates',
							description: 'Configure the season timeline and special dates',
							regularSeason: 'Regular Season',
							startDate: 'Start Date',
							fixedEndDate: 'Fixed End Date',
							endDate: 'End Date',
							gamesPerTeam: 'Games Per Team',
							estimatedEndDate: (date: string) => `Estimated: ${date}`,
							playoffs: 'Playoffs',
							includePlayoffs: 'Include Playoffs',
							bracketType: 'Bracket Type',
							singleElimination: 'Single Elimination',
							doubleElimination: 'Double Elimination',
							roundRobin: 'Round Robin',
							numberOfTeams: 'Number of Teams',
							numberOfRounds: 'Number of Rounds',
							blackoutDates: 'Blackout Dates',
							useBlackoutDates: 'Use Blackout Dates',
							addBlackoutDate: 'Add Blackout Date',
							removeBlackoutDate: 'Remove',
							noBlackoutDates: 'No blackout dates configured',
							recommendedHolidays: 'Recommended Holidays',
							teamBlackoutDates: 'Team-Specific Blackout Dates',
							selectTeams: 'Select Teams',
							selectDate: 'Select Date',
							addTeamBlackout: 'Add Team Blackout',
							noTeamBlackouts: 'No team-specific blackout dates',
						},

						// Rules Section
						rules: {
							title: 'Rules & Constraints',
							description: 'Configure scheduling rules and constraints',
							byeWeekPolicy: 'Bye Week Policy',
							skip: 'Skip',
							repeat: 'Repeat',
							random: 'Random',
						},

						// Results Table
						resultsTable: {
							columns: {
								home: 'Home',
								away: 'Away',
								division: 'Division',
								dateTime: 'Date & Time',
								space: 'Space',
								conflicts: 'Conflicts',
								actions: 'Actions',
							},
							noSpaceAssigned: 'No Space Assigned',
							unassignedDivision: 'Unassigned Division',
							crossDivision: 'Cross-division',
							noTeamsSelectedMessage:
								'Please select teams in the Teams section above to add team-specific blackout dates.',
							conflicts: 'Conflicts',
							noConflicts: 'No Conflicts',
							maintenance: 'Maintenance',
							editGame: 'Edit Game',
							deleteGame: 'Delete Game',
							confirmDelete: 'Are you sure you want to delete this game?',
							emptyState: 'No schedule generated yet. Click "Generate Schedule" in the Inputs tab to create one.',
							noGames: 'No games in schedule',
							gameDateDisplay: (date: string, isOvernight: boolean) => `${date}${isOvernight ? ' +1' : ''}`,
							gameTimeRange: (startTime: string, endTime: string) => `${startTime} - ${endTime}`,
							loadingMessage: 'Loading schedule...',
							subject: 'games',
							division: 'Division',
							allDivisions: 'All divisions',
							team: 'Team',
							allTeams: 'All teams',
							weekHeader: (week: number | string) => `Week ${week}`,
							gamesCount: (count: number) => `${count} game${count !== 1 ? 's' : ''}`,
							weekToggleAriaLabel: (weekLabel: string, countLabel: string) => `${weekLabel} - ${countLabel}`,
							viewModes: {
								flat: 'Flat',
								byWeek: 'Weeks',
							},
							divisionFallbackName: (id: number | string) => `Division ${id}`,
							teamFallbackName: (id: number | string) => `Team ${id}`,
							eventTitle: (homeTeamName: string, awayTeamName: string): string => `${homeTeamName} vs ${awayTeamName}`,
						},

						// Sandbox
						sandbox: {
							title: 'Sandbox',
							description: 'Drag and drop games to manually adjust the schedule',
							infoBanner: 'You are working in sandbox mode. Changes made here can be saved or reverted.',
							dragGames: 'Drag games to reschedule',
							rightClickOptions: 'Right-click for options',
							noSchedule: 'No schedule available for sandbox editing.',
							scope: 'Division',
							unassignedVenue: 'Unassigned',
							pagination: (page: number, total: number) => `Week ${page} of ${total}`,
							timeSpace: 'Time / Space',
							overnightTag: ' (Overnight)',
							gameTimeRange: (startTime: string, endTime: string) => `${startTime} - ${endTime}`,
							timeBalanceLabel: 'Time Balance',
							scoreOutOfMax: (max: number) => `/ ${max}`,
							discardEdits: 'Discard Edits',
							occupiedSlot: 'Occupied',
						},

						quality: {
							title: 'Quality',
							scope: 'Scope',
							overall: 'Overall',
							overallScore: (score: number) => `${score}%`,
							notAvailable: 'N/A',
							qualityChecks: 'Quality Checks',
							allPassing: 'All quality checks passing',
							failedChecks: (count: number) => `${count} check${count !== 1 ? 's' : ''} failed`,
							completeness: 'Completeness',
							roundRobinCompleteness: 'Round Robin Completeness',
							gamesPerTeamBalance: 'Games Per Team Balance',
							missingMatchups: (count: number) => `Missing ${count} matchup${count !== 1 ? 's' : ''}`,
							allTeamsScheduled: 'All teams have games scheduled',
							allTimeSlotsUsed: 'All time slots have been utilized',
							noUnassignedGames: 'No unassigned games',
							fairness: 'Fairness',
							timeSlotBalance: 'Time Slot Balance',
							homeAwayBalance: 'Home / Away Balance',
							byeWeekRotation: 'Bye Week Rotation',
							balancedHomeAway: 'Home/Away games are balanced',
							evenDistribution: 'Games evenly distributed across weeks',
							validityChecks: 'Validity Checks',
							noTimeConflicts: 'No Time Conflicts',
							blackoutDatesRespected: 'Blackout Dates Respected',
							withinSeasonBounds: 'Within Season Bounds',
							conflictsDetected: (count: number) => `${count} conflict${count !== 1 ? 's' : ''} detected`,
							blackoutViolations: (count: number) => `${count} blackout violation${count !== 1 ? 's' : ''}`,
							outOfBoundsGames: (count: number) => `${count} game${count !== 1 ? 's' : ''} outside season bounds`,
							timeDistribution: 'Game Time Distribution',
							timeDistributionDescription:
								'This shows how game times are distributed across teams. Numbers represent the count of games at each time slot.',
							dayDistribution: 'Game Day Distribution',
							dayDistributionDescription:
								'This shows how games are distributed across days of the week for each team. Numbers represent the count of games on each day.',
							byeWeekBalance: 'Bye Week Balance',
							byeWeekBalanceDescription: 'Teams are evenly distributed across bye weeks to ensure fairness.',
							overallBalance: 'Overall Balance',
							weekLabel: (week: number) => `Week ${week}`,
							noByeWeek: 'No bye week',
							colorLegend: 'Color Legend',
							distributionTable: {
								team: 'Team',
								totalGames: 'Total Games',
								colorLegend: 'Color Legend',
								legendPercent0: '0%',
								legendPercent1To20: '1-20%',
								legendPercent21To40: '21-40%',
								legendPercent41To60: '41-60%',
								legendPercent61To80: '61-80%',
								legendPercent81To100: '81-100%',
							},
							moreThan: 'More than',
							lessThan: 'Less than',
							leagueMatrix: {
								title: 'League Matrix',
								description:
									'Visual representation of games between teams. Rows show home teams, columns show away teams.',
								home: 'Home',
								away: 'Away',
								total: 'Total',
								teams: 'Teams',
								legend: 'Each cell shows the number of games where the row team plays at home against the column team.',
								noTeamsSelected: 'No teams selected. Please select teams to view the league matrix.',
							},
						},

						// Optimize Dialog
						optimize: {
							title: 'Optimize Schedule',
							description: 'Configure optimization criteria to improve your schedule',
							criteria: 'Optimization Criteria',
							optimizationGoals: 'Optimization Goals',
							constraints: 'Constraints',
							balanceHomeAway: 'Balance home and away games',
							balanceHomeAwayDesc: 'Ensure each team has an equal number of home and away games',
							avoidConsecutiveDays: 'Avoid consecutive game days for teams',
							avoidConsecutiveDaysDesc: 'Minimize games on back-to-back days for the same team',
							preferredTimeSlots: 'Preferred Time Slots (Optional)',
							preferredTimeSlotsDesc: 'Select time slots to prioritize during optimization',
							maxGamesPerWeek: 'Max Games Per Week',
							maxGamesPerWeekDesc: 'Limit the number of games per team per week',
							minRestBetweenGames: 'Min Rest Between Games (hours)',
							minRestBetweenGamesDesc: 'Ensure minimum rest time between games for each team',
							hours: 'hours',
							optimize: 'OPTIMIZE',
							cancel: 'Cancel',
							reset: 'Reset',
							optimizing: 'Optimizing schedule...',
							note: '💡 Optimization will attempt to improve your schedule while maintaining team matchups and game counts. This process may take a few moments.',
						},

						// Publish Dialog
						publish: {
							title: 'Add Events to Schedule',
							conflictsDetected: 'Conflicts Detected',
							noConflictsDetected: 'No Conflicts Detected',
							description:
								'New events will not replace existing ones. Events will appear on the calendar if a space is assigned and on the registration page unless hidden in session settings.',
							publish: 'Add to Schedule',
							cancel: 'Cancel',
							publishing: 'Adding schedule to the season schedule...',
							success: 'Events added to the schedule successfully!',
							eventsCreated: (count: number) => `${count} event${count !== 1 ? 's' : ''} created`,
							slotsCreated: (count: number) => `${count} slot${count !== 1 ? 's' : ''} created`,
						},

						// Edit Game Dialog
						editGame: {
							title: 'Edit Game',
							homeTeam: 'Home Team',
							awayTeam: 'Away Team',
							fields: {
								date: 'Date',
								startTime: 'Start Time',
								endTime: 'End Time',
								space: 'Space',
								division: 'Division',
							},
							conflictsDetected: 'Conflicts Detected',
							warningDetected: 'Warning',
							overnightSlotWarning: 'Ends on following day',
							crossDivisionNotice: (parentName: string | undefined) =>
								parentName
									? `Cross-division matchup. This game will be saved at "${parentName}".`
									: 'Cross-division matchup. This game will be saved at the closest shared parent folder.',
							crossDivisionUnresolvedConflict: 'This game is scheduled between two separate divisions.',
							actions: {
								cancel: 'Cancel',
								save: 'Save Changes',
							},
							ariaLabels: {
								selectHomeTeam: 'Select home team',
								selectAwayTeam: 'Select away team',
								selectDate: 'Select game date',
								selectStartTime: 'Select game start time',
								selectEndTime: 'Select game end time',
								selectSpace: 'Select game space or venue',
								selectDivision: 'Select division',
								conflictsList: 'List of scheduling conflicts',
								formActions: 'Form Actions',
								cancel: 'Cancel editing and close dialog',
								save: 'Save changes to game',
							},
						},

						// Wizard (legacy - keeping for backwards compatibility)
						wizard: {
							teamEntry: {
								title: 'Team Entry',
								description: 'Select teams to include in the schedule',
								addAll: 'Add All',
								removeAll: 'Remove All',
								noTeamsInDivision: 'No teams in this division',
							},
							venueAndScheduleSetup: {
								title: 'Venue & Schedule Setup',
								description: 'Configure venue resources and schedule parameters',
							},
							venueSetup: {
								title: 'Venue Setup',
								description: 'Configure venues and time slots',
								selectResources: 'Select Resources',
								availableDays: 'Available Days',
								timeSlots: 'Time Slots',
								addTimeSlot: 'Add Time Slot',
								startTime: 'Start Time',
								endTime: 'End Time',
								daysOfWeek: {
									sunday: 'Sunday',
									monday: 'Monday',
									tuesday: 'Tuesday',
									wednesday: 'Wednesday',
									thursday: 'Thursday',
									friday: 'Friday',
									saturday: 'Saturday',
								},
							},
							scheduleParameters: {
								title: 'Schedule Parameters',
								description: 'Configure schedule generation parameters',
								seasonDates: 'Season Dates',
								seasonStartDate: 'Season Start Date',
								seasonEndDate: 'Season End Date',
								gameRequirements: 'Game Requirements',
								gameDuration: 'Game Duration',
								gamesPerTeam: 'Games Per Team',
								gamesPerWeek: 'Games Per Week',
								byeWeekPolicy: 'Bye Week Policy',
								blackoutDates: 'Blackout Dates',
								addBlackoutDate: 'Add Blackout Date',
								noBlackoutDates: 'No blackout dates configured',
								optimizationCriteria: 'Optimization Criteria',
							},
							schedulePreview: {
								title: 'Schedule Preview',
								description: 'Review the generated schedule before publishing',
							},
						},
						steps: {
							teamEntry: 'Team Entry',
							venueSetup: 'Venue Setup',
							scheduleParameters: 'Schedule Parameters',
							schedulePreview: 'Schedule Preview',
						},

						resourceConflict: (date: string) => `Space conflict: Resource double-booked on ${date}`,

						// Inputs Tab
						inputsTab: {
							noConfigData: 'No configuration data available',
							sectionTitles: {
								seasonDates: 'Season Dates',
								teams: 'Teams',
								timeSlots: 'Time Slots',
								resources: 'Resources',
								rules: 'Rules & Constraints',
							},
							labels: {
								startDate: 'Start Date',
								endDate: 'End Date',
								gamesPerTeam: 'Games Per Team',
								totalRounds: 'Total Rounds',
								gameDuration: 'Game Duration',
								gamesPerWeek: 'Games Per Week',
								breakBetweenGames: 'Break Between Games',
								preferredDays: 'Preferred Days',
								preferredTimes: 'Preferred Times',
								timeWindows: 'Time Windows',
								byeWeekPolicy: 'Bye Week Policy',
								minimumRestTime: 'Minimum Rest Time',
								maxGamesPerDay: 'Max Games Per Day',
								blackoutDates: 'Blackout Dates',
								teamBlackoutDates: 'Team Blackout Dates',
							},
							emptyStates: {
								noTeams: 'No teams selected',
								noResources: 'No resources assigned',
							},
							units: {
								minutes: 'minutes',
								dates: 'dates',
								teams: 'teams',
							},
							days: {
								0: 'Sun',
								1: 'Mon',
								2: 'Tue',
								3: 'Wed',
								4: 'Thu',
								5: 'Fri',
								6: 'Sat',
							},
							byeWeekPolicies: {
								repeat: 'Repeat',
								random: 'Random',
								unknown: 'Unknown',
							},
						},

						// Calendar View
						calendarView: {
							noData: 'No schedule data available for calendar view.',
							title: (weekNumber: number) => `Schedule Calendar - Week ${weekNumber}`,
							pagination: (current: number, total: number) => `${current} / ${total}`,
							dragInstruction: 'Drag games to reschedule',
							rightClickInstruction: 'Right-click for options',
							contextMenu: {
								editGameTime: 'Edit Game Time',
								deleteGame: 'Delete Game',
							},
							roundLabel: (round: number) => `R${round}`,
							editDialog: {
								title: 'Edit Game Time',
								fields: {
									date: 'Date',
									startTime: 'Start Time',
									endTime: 'End Time',
								},
								actions: {
									cancel: 'Cancel',
									save: 'Save',
								},
							},
						},

						// Form Section Titles
						formSections: {
							teams: 'TEAMS',
							slots: 'SLOTS',
							seasonDates: 'SEASON DATES',
						},

						// Discard Confirmation Dialog
						discardDialog: {
							title: 'Discard Schedule?',
							warning: 'Warning',
							message: 'This will permanently delete the current draft schedule. This action cannot be undone.',
							description: 'You will be returned to the Inputs tab to start over.',
							cancel: 'Cancel',
							discard: 'Discard',
						},

						// Published Schedule Viewer
						publishedScheduleViewer: {
							loading: 'Loading published schedule...',
							errorLoading: `Failed to load the published schedule. Please try again or contact ${SUPPORT_EMAIL} if the issue persists.`,
							noSchedule: {
								title: 'No Published Schedule',
								message: 'This season does not have a published schedule yet.',
							},
							title: 'Published Schedule',
							statusPublished: 'Published',
							eventsCreated: 'Events Created',
							slotsCreated: 'Slots Created',
							totalGames: 'Total Games',
							divisions: 'Divisions',
							publicationDetails: 'Publication Details',
							createdEvents: 'Created Events',
							scheduleConfiguration: 'Schedule Configuration',
							publishedAt: 'Published At',
							seasonFolderId: 'Season Folder ID',
							publishedBy: 'Published By',
							publishedByUserId: (userId: number | string) => `User ID: ${userId}`,
							seasonStart: 'Season Start',
							seasonEnd: 'Season End',
							gameDuration: 'Game Duration',
							gameDurationMinutes: (minutes: number) => `${minutes} min`,
							gamesPerTeam: 'Games Per Team',
							eventsCreatedInCalendar: (count: number) =>
								`${count} event${count !== 1 ? 's' : ''} created in the calendar`,
							publishedScheduleSuccess: (_eventIdsPreview: string, _remainingCount: number) =>
								'All games have been successfully added to the calendar.',
						},

						// Section Components
						sections: {
							// Slots Section
							slots: {
								timePlaceholder: 'HH:MM AM/PM',
								gameDuration: 'Game Duration',
								breakBetweenGames: 'Break Between Games',
								maintenance: 'Maintenance',
								maintenanceSpaceInfo: 'Maintenance slots are added between games only when a space is selected.',
								maintenanceName: 'Maintenance Name',
								duration: 'Duration',
								gameSlots: 'Game Slots',
								dayOfWeek: 'Day of the Week',
								from: 'From',
								to: 'To',
								selectADayOfTheWeekToSeeCapacity: 'Select times and day(s) of the week to see capacity',
								fromTimeMustBeBeforeToTime: 'From time must be before to time',
								fromTimeAndToTimeCannotBeTheSame: 'From time and to time cannot be the same',
								overnightSlotWarning: 'Ends on following day',
								fromTimeAndToTimeMustBePositive: 'From time and to time must be positive',
								totalGamesMessage: (
									totalGames: number,
									totalDays: number,
									gamesPerDay: number,
									gameDuration: number,
									breakTime: number
								) => {
									return `Up to ${totalGames} total across ${totalDays} day${totalDays !== 1 ? 's' : ''} (${gamesPerDay} games/day with ${gameDuration} min games & ${breakTime} min breaks)`;
								},
								space: 'Space (Optional)',
								noResourceAssigned: 'No resource assigned',
								allowOverflow: 'Allow Overflow',
								actions: {
									addMaintenance: 'Add maintenance',
									remove: 'Remove',
									addTimeSlot: 'Add Time Slot',
									removeSlot: 'Remove Slot',
								},
								units: {
									min: 'min',
								},
								days: {
									sun: 'Sun',
									mon: 'Mon',
									tue: 'Tue',
									wed: 'Wed',
									thu: 'Thu',
									fri: 'Fri',
									sat: 'Sat',
								},
							},

							// Blackout Dates Section
							blackoutDates: {
								title: 'Blackout Dates',
								selectDate: 'Select blackout date',
								addDate: 'Add Date',
								recommendedHolidays: 'Recommended Holidays',
								noBlackoutDates: 'No blackout dates added',
								ariaLabels: {
									removeDate: 'Remove blackout date',
								},
								addedBlackoutDatesMessage: (count: number) =>
									`${count} blackout date${count !== 1 ? 's' : ''} added. This will affect the estimated season end date.`,
								holidayChipLabel: (formattedDate: string, holidayName: string) => `${formattedDate} - ${holidayName}`,
								removeTeam: (name: string) => `Remove ${name}`,
							},

							// Team Blackout Dates Section
							teamBlackoutDates: {
								title: 'Team Blackout Dates',
								description: 'Specify dates when specific teams cannot play',
								noTeamsSelectedMessage:
									'Please select teams in the Teams section above to add team-specific blackout dates.',
								selectTeams: 'Select Teams',
								selectedTeams: 'Selected Teams',
								selectedTeamsWithCount: (count: number) => `Selected Teams (${count})`,
								clearAll: 'Clear All',
								selectDate: 'Select Date',
								addTeamBlackout: 'Add Team Blackout',
								noTeamBlackouts: 'No team blackout dates added',
								team: 'Team',
								teamFallbackName: (teamId: number) => `Team ${teamId}`,
								teamBlackoutChipLabel: (teamName: string, formattedDate: string) => `${teamName} - ${formattedDate}`,
								ariaLabels: {
									removeTeamBlackout: 'Remove team blackout date',
								},
								removeTeamBlackout: (name: string) => `Remove ${name}`,
								removeLabel: 'Remove',
								tableLabel: 'Team',
							},

							// Playoffs Config Section
							playoffsConfig: {
								bracketType: 'Bracket Type',
								numberOfTeams: 'Number of Teams',
								numberOfRounds: 'Number of Rounds',
								info: 'Playoff games will be scheduled after the regular season',
								bracketTypes: {
									singleElimination: 'Single Elimination',
									doubleElimination: 'Double Elimination',
									roundRobin: 'Round Robin',
								},
							},

							// Regular Season Dates Section
							regularSeasonDates: {
								title: 'Regular Season Dates',
								startDate: 'Start Date*',
								fixedEndDate: 'Fixed End Date',
								endDate: 'End Date',
								gamesPerTeam: 'Games Per Team',
								tooltipGamesPerTeam: 'Set the number of games each team will play',
								regularSeason: 'Regular Season',
								estimatedEndDate: 'Estimated End Date',
								calculateEndDate: 'Calculate End Date',
								gamesPerTeamTooltip: 'Set the number of games each team will play',
								infoMessage: (weeks: number, endDate: string) =>
									`Based on ${weeks} weeks of games, the season will end approximately on ${endDate}`,
								regularSeasonGames: 'Regular Season Games',
								seasonWillEndAround: (date: string) => `Your season will end around ${date}`,
								couldEndEarlier: (date: string) => `You could end your season earlier on ${date}`,
								mayNeedToExtend: (date: string) => `Your season may need to extend to ${date}`,
								useOptimizedDate: 'Use optimized date',
								scheduleMode: 'How would you like to schedule your season?',
								modeGamesPerTeam: 'Set Games Per Team',
								modeGamesPerTeamDescription:
									"Specify how many games each team will play and we'll calculate the end date",
								modeFixedEndDate: 'Set Season End Date',
								modeFixedEndDateDescription: "Specify when the season should end and we'll calculate games per team",
								expectedEndDate: (date: string) => `Expected end date: ${date}`,
								expectedGamesPerTeam: (games: number) => `Expected games per team: ${games}`,
								estimatedWeeks: (weeks: number) => `Season duration: ${weeks} week${weeks === 1 ? '' : 's'}`,
								teamsWillPlayEachOtherExact: (times: number) =>
									`Teams will play each other exactly ${times} time${times === 1 ? '' : 's'}`,
								teamsWillPlayEachOtherRange: (min: number, max: number) =>
									`Teams will play each other ${min}-${max} times`,
							},

							// Playoffs Section
							playoffs: {
								info: (teams: number, totalTeams: number, rounds: number, bracketType: string) =>
									`${teams} of ${totalTeams} teams will compete in ${rounds} playoff rounds using ${bracketType.replace('-', ' ')} format.`,
								title: 'Schedule playoffs with placeholder teams',
								bracketType: 'Bracket Type',
								numberOfTeams: 'Number of Playoff Teams',
								numberOfRounds: 'Number of Playoff Rounds',
								bracketTypes: {
									singleElimination: 'Single Elimination',
									doubleElimination: 'Double Elimination',
									roundRobin: 'Round Robin',
								},
							},

							// Rules Section
							rules: {
								rotateHomeAway: 'Rotate ref/home/away games',
								banCutDowns: 'Ban cut downs',
							},

							// Teams Section (already done, but adding for completeness)
							teams: {
								selectDivisions: 'Select Divisions',
								selectTeams: 'Select Teams',
								selectedCount: (count: number) => `${count} selected`,
								noTeamsSelected: 'No teams selected',
								noDivisionsAvailable: 'No divisions available',
							},
						},
					},
				},
			},
		},
		shared: {
			registrationValidationError: {
				labelWithColon(label: string) {
					return `${label}:`;
				},
			},
			punchPassEventSelection: {
				punchesRatio(left: number, quantity: number) {
					return `${left}/${quantity}`;
				},
			},
			membershipGatingStep: {
				title: 'Membership Required',
				description:
					'To purchase this product a customer must also purchase a membership. Select the membership and add to cart.',
				back: 'Back',
				selectMembership: 'Select',
				startDate: 'Start Date',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				additionalInfo: (price: number, currency: CurrencySymbolEnum) =>
					`${CHARACHERS.COLON} ${Pricify(price, currency)}`,
				additionalRowInfo: (resourceType: MembershipTypeEnum, customerTypes: CustomerTypeEnum[]) =>
					`Membership Type (${MEMBERSHIP_TYPE_LABELS[resourceType]} - ${customerTypes.map(capitalizeFirstLetter).join(', ')})`,
				gatedMembershipsNoteTitle: (name: string, required?: boolean) =>
					!required
						? ` ${name} owns this membership, but is missing these required products:`
						: `This membership requires the following products:`,
				buildGatedProductLabel: (product: Product) =>
					`${product.name} - ${Pricify(product.currPrice.price, CurrencySymbolEnum[product.prices[0].currency])} ${!product.required ? '(Already owns)' : ''}`,
				futureMembership: (customerName: string, startDate: string) =>
					`${customerName} has a required membership, but it starts on ${formatDateBondTimePackage(startDate, DateTimeFormats.DAY_FORMAT_SLASHED, false)}.`,
				pausedMembership: (customerName: string, restartDate: string) =>
					`${customerName} has the required membership, but it's paused until ${formatDateBondTimePackage(restartDate, DateTimeFormats.DAY_FORMAT_SLASHED, false)}.`,
			},
		},
		punchPassesTable: {
			columns: {
				id: 'ID',
				name: 'Name',
				expiration: 'Expiration',
				quantityDuration: 'Qty / Duration',
				quantity: 'Total Qty',
				price: 'Price',
				holders: 'Pass Holders',
				status: 'Status',
				actions: 'Actions',
				programIds: 'Program',
				programType: 'Program Type',
			},
			tableAction: {
				archiveStatus: (status: string) =>
					status === AdditionalStatusesEnum.ARCHIVED ? 'Unarchive Punch Pass' : 'Archive Punch Pass',
				create: 'Create Punch Pass',
				purchasePunchPass: 'Purchase Pass',
				edit: 'Edit Punch Pass',
			},
			pagination: {
				subjects: {
					passesList: 'punch passes',
				},
			},
			actions: {
				archiveProduct: {
					title: 'Archive Pass',
					description:
						'After Archiving, the punch pass will be removed from the main list and you will be able to find it in the archive',
					archive: 'Archive Pass',
					cancel: 'Cancel',
					success: 'Pass archived successfully',
				},
				filters: {
					statusOptions: {
						[ActivityEnum.ACTIVE]: 'Active',
						[ActivityEnum.INACTIVE]: 'Inactive',
						[AdditionalStatusesEnum.ARCHIVED]: 'Archived',
					},
				},
			},
			state: {
				loading: 'Loading punch passes...',
				noData: 'No punch passes found.',
			},
			parseColumns: {
				quantityDuration: (duration: number, unit = CHARACHERS.DASH, quantity: number) =>
					!duration ? CHARACHERS.DASH : `${quantity} / ${duration} ${unit}${duration > 1 ? 's' : ''}`,
				expiration: (unit = CHARACHERS.DASH, quantity: number) => `${quantity} ${unit}${quantity !== 0 ? 's' : ''}`,
			},
		},
		createSessionPricing: {
			sidebar: {
				emptyState: 'Looks like this session does not contain any segments',
				sessionSchedule: 'Session Schedule',
			},
			header: {
				pricingBreadcrumb: 'pricing',
				steps: ['Product & Pricing', 'Discount & Payments', 'Add Ons'],
			},
		},
		createPass: {
			title: 'Program Pass Profile',
			form: {
				sections: {
					mainDetails: 'MAIN DETAILS',
					pricing: 'PRICING',
					discounts: 'DISCOUNTS',
					payments: 'PAYMENTS',
					access: 'ACCESS',
					addons: 'ADDONS',
				},
				generalDetails: {
					title: 'General Details',
					name: 'Punch Pass Name',
					description: 'Product Description',
					glCodes: {
						placeholder: 'Select GL code',
						label: `Accounting Code`,
						maxSelectionsError: 'You can only select a single Accounting Code',
					},
					application: {
						title: 'Application',
						tooltipContent:
							'Choose which Program Types, Programs, and Sessions this pass applies to. Selecting “All” will include both current and future matches automatically.',
						programReletedSelection: {
							programTypeSelect: {
								select: {
									loading: 'Loading...',
									error: 'Error loading',
									end: 'End of results',
									all: 'All',
								},
								placeholder: 'Select Program Type',
							},
							programSelect: {
								title: 'Programs',
								info: 'Select All to make this pass purchasable in every current and future program within the selected program types.\nAny new programs and sessions you create in those program types will automatically inherit the pass',
								select: {
									loading: 'Loading...',
									error: 'Error loading',
									end: 'End of results',
									all: 'All',
								},
								placeholder: 'Select Program Name',
							},
							sessionSelect: {
								info: 'Select All to make this pass purchasable in every current and future session within the selected programs. Any new session you create in those programs will automatically inherit the pass',
								select: {
									loading: 'Loading...',
									error: 'Error loading',
									end: 'End of results',
									all: 'All',
								},
								placeholder: 'Select Session Name',
								title: 'Sessions',
							},
						},
					},
					onlineSettings: {
						title: 'Online Settings',
						productSettings: {
							byPassScheduleIfPunchPass: 'Bypass schedule selection for consumer registration',
							hideProductFromUser: 'Hide product from user registration',
							hideProductInfoTooltip: 'Hide product info tooltip',
						},
					},
					duration: {
						title: 'Duration',
						fixed: {
							title: 'Fixed',
							subTitle: '(Set a defined time frame for punch pass use)',
							totalQuantity: {
								label: 'Total Quantity',
								tooltip: 'The total number of punches that can be used on the pass',
							},
							timeUnitSelection: {
								placeholder: 'Select',
								options: [
									{ label: 'Day', value: TimeUnit.DAY },
									{ label: 'Week', value: TimeUnit.WEEK },
									{ label: 'Month', value: TimeUnit.MONTH },
									{ label: 'Year', value: TimeUnit.YEAR },
								],
							},
							expiration: {
								label: 'Expiration',
								tooltip: 'The expiration date of the pass',
							},
							quantityLimit: {
								label: 'Quantity Limit',
								tooltip: 'The maximum number of punches that can be used on the pass',
							},
							forEvery: 'for every',
						},
						subscription: {
							title: 'Subscription',
							subTitle: '(Set a punch pass to auto-renew until canceled)',
						},
					},
				},
				pricing: {
					title: 'PRICING',
					productPrice: {
						title: 'Product Price',
						fields: {
							priceLabel: 'Product Price',
						},
					},
					tax: {
						toggleLabel: 'Apply Tax',
					},
				},
				discounts: {
					title: 'DISCOUNTS',
					discount: {
						remove: 'Remove',
						discount: {
							addDiscount: 'Add Discount',
							useDifferentDiscount: 'Use different discount',
							product: 'Product',
							discount: 'Discount',
							price: 'Price',
							isEarlyBird: 'Is Early Bird',
							isLateFee: 'Is Late Fee',
							title: 'Discount',
							info: 'Apply a discount to the product',
							byChecking: 'By checking this box, the discount will be applied to the product',
						},
					},
				},
				payments: {
					title: 'PAYMENTS',
				},
				membershipGating: {
					toggleLabel: 'Membership gating',
				},
				addons: {
					title: 'Add Ons',
					select: 'Add Ons Name',
					timePeriod: 'Time period',
					remove: 'Remove',
					clear: 'Clear',
					staleAddonWarning: 'Selected addon is not available for selected facilities.',
					staleAddonsError: 'Selected addons do not match selected facilities.',
					timePeriodTypes: {
						pass: 'Per Pass',
						event: 'Per Event',
					},
				},
			},
			success: {
				createPunchPass: 'Successfully created punch pass product!',
				edit: (name: string) => `Successfully updated '${name.slice(0, 10)}' punch pass product!`,
			},
			errors: {
				organizationIdRequired: 'Organization ID is required',
				failedToFetch: 'Unable to load the punch pass. Please try again.',
				createPunchPass: 'Failed to create the punch pass. Please try again.',
				editPunchPass: 'Failed to update the punch pass. Please try again.',
				missingField: 'A required field is missing. Please review the form and fill in all required fields.',
				exeedingQuantityLimit: 'Quantity exceeds the allowed limit. Please enter a lower value.',
				exeedingExpirationLimit:
					'The duration window cannot be longer than the expiration period. Please shorten the duration or extend the expiration.',
				missingSelection: 'A required selection is missing. Please complete all required fields before continuing.',
				notValidQuantityLimitation:
					'These settings prevent customers from using all their passes before expiration. Please adjust the quantity limit or expiration date.',
			},
		},
		purchaseSessionProduct: {
			createCustomerStep: {
				title: 'Select Customer',
				description: 'Select the customer you want to register.',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
				nextStep: 'Continue',
				cancel: 'Cancel',
				errors: {
					formContextRequired: 'useCustomerSelectionForm must be used within a FormContext.Provider',
				},
			},
			selectEvents: {
				title: 'Event Selection',
				subject: 'events',
				subtitle: (name: string) => `Select the events you would like to purchase for ${name}.`,
				columns: {
					name: 'Event',
					emptyName: CHARACHERS.DASH,
					date: 'Date',
					time: 'Time',
					space: 'Space',
					spots: 'Spots',
					columnMapper: {
						spots: (limit: number, spots: number, availabilityStatus: SessionRegistrationFlowEnum) => {
							if (!limit) {
								return CHARACHERS.DASH;
							}

							return !spots ? SPOTS_MAP[availabilityStatus] : `${spots}/${limit}`;
						},
						timeRange: (startTime: string, endTime: string) => `${startTime} - ${endTime}`,
						overnightIndicator: (daysDifference: number) => `+${daysDifference}`,
					},
				},
				continue: 'CONTINUE',
				clear: 'CLEAR',
				left: 'events left:',
				errors: {
					maxQuantity: (quantity: number) =>
						`You may only select a maximum of ${quantity} ${quantity === 1 ? 'event' : 'events'} when purchasing this product`,
					waitlistAndAvailable: 'You cannot select both available and waitlisted events at the same time.',
				},
			},
			addonSelectionStep: {
				title: 'Add-on Selection',
				description: 'Would you like to purchase add-ons with this product?',
				select: 'Add Ons Name',
				timePeriod: 'Time period',
				perSession: 'Per Session',
				fields: {
					perSessionAddon: {
						label: 'Per Session Add-on(s)',
						placeholder: 'Select Add-on(s)',
					},
					perResourceAddon: {
						label: 'Per Event Add-on',
						placeholder: 'Select Add-on',
					},
					addon: {
						label: 'Registration Add-on(s)',
						placeholder: 'Select',
					},
					quantity: {
						label: 'Quantity',
						placeholder: '0',
					},
					resources: {
						label: 'Events',
						placeholder: 'Select Events',
					},
				},
				clear: 'Clear',
				back: 'Back',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				addon: 'Add-On',
				eventSelection: {
					placeholder: 'Select',
					label: 'Events',
				},
				addAdditional: 'Add Per Event Add-on',
				remove: 'Remove',
			},
			purchaseSummaryStep: {
				title: 'Purchase Summary',
				description: (fullName: string) => `You are purchasing the following for ${fullName}:`,
				buildAddonLabel: (addon: string, quantity?: number) => `${addon}${quantity ? ` x ${quantity}` : ''}`,
				buildResourceLabel: (resource: IResourceFieldTypes, addons: IAddonWithQuantity[]) => {
					const startDateFormatted = formatDate(
						resource.startDate,
						DateTimeFormats.DAY_FORMAT_WITH_DAY_OF_WEEK,
						resource.timezone
					);
					const endDateFormatted = formatDate(
						resource.endDate ?? resource.startDate,
						DateTimeFormats.DAY_FORMAT_WITH_DAY_OF_WEEK,
						resource.timezone
					);
					const startTimeFormatted = isValidDate(resource.startDate)
						? formatDate(resource.startDate, EDateTimeFormats.H12_AMPM_UPPERCASE, resource.timezone)
						: format24HToAmPm(resource.startTime);
					const endTimeFormatted = isValidDate(resource.endDate)
						? formatDate(resource.endDate, EDateTimeFormats.H12_AMPM_UPPERCASE, resource.timezone)
						: format24HToAmPm(resource.endTime);
					const dateTimePart =
						startDateFormatted === endDateFormatted
							? `${startDateFormatted} ${startTimeFormatted} - ${endTimeFormatted}`
							: `${startDateFormatted} ${startTimeFormatted} - ${endDateFormatted} ${endTimeFormatted}`;
					const addonsPart = !!addons?.length
						? ` - ${addons.map(({ name, quantity }) => `${name}${quantity > 1 ? ` x ${quantity}` : ''}`).join(', ')}`
						: '';
					const schedule = `${dateTimePart}${addonsPart}`;
					return resource.name ? `${resource.name} - ${schedule}` : schedule;
				},
				back: 'Back',
				nextStep: 'ADD TO CART',
				cancel: 'Cancel',
				itemOptions: {
					product: 'Product:',
					membership: 'Membership:',
					addons: 'Add-ons:',
					resources: 'Events:',
					price: 'Price Total (discounts included):',
				},
				all: 'All Events',
			},
		},
		purchaseSegmentProduct: {
			createCustomerStep: {
				title: 'Select Customer',
				description: 'Select the customer you want to register.',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
				nextStep: 'Continue',
				cancel: 'Cancel',
			},
			selectSegments: {
				title: 'Segment Selection',
				subject: 'segments',
				subtitle: (name: string) => `Select the segments you would like to purchase for ${name}.`,
				columns: {
					dayAndTime: 'Date & Time',
					name: 'Segment',
					spots: 'Spots',
					columnMapper: {
						spots: (limit: number, spots: number, availabilityStatus: SessionRegistrationFlowEnum) => {
							if (!limit) {
								return CHARACHERS.DASH;
							}

							return !spots ? SPOTS_MAP[availabilityStatus] : `${spots}/${limit}`;
						},
					},
				},
				continue: 'CONTINUE',
				clear: 'CLEAR',
				left: 'segments left:',
				errors: {
					maxQuantity: (quantity: number) =>
						`You may only select a maximum of ${quantity} ${quantity === 1 ? 'segment' : 'segments'} when purchasing this product`,
					waitlistAndAvailable: 'You cannot select both available and waitlisted segments at the same time.',
				},
				availability: {
					full: 'Full',
					waitlistAvailable: 'Full',
					noMaxParticipants: 'Available',
					available: (spotsLeft: number) => `${spotsLeft} spots left`,
				},
			},
			addonSelectionStep: {
				title: 'Add-on Selection',
				description: 'Would you like to purchase add-ons with this product?',
				select: 'Add Ons Name',
				timePeriod: 'Time period',
				perSession: 'Per Session',
				fields: {
					perSessionAddon: {
						label: 'Per Session Add-on(s)',
						placeholder: 'Select Add-on(s)',
					},
					perResourceAddon: {
						label: 'Per Segment Add-on',
						placeholder: 'Select Add-on',
					},
					addon: {
						label: 'Registration Add-on(s)',
						placeholder: 'Select',
					},
					quantity: {
						label: 'Quantity',
						placeholder: '0',
					},
					resources: {
						label: 'Segments',
						placeholder: 'Select Segments',
					},
				},
				clear: 'Clear',
				back: 'Back',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				addon: 'Add-On',
				segmentSelection: {
					placeholder: 'Select',
					label: 'Segments',
				},
				addAdditional: 'Add Per Segment Add-on',
				remove: 'Remove',
			},
			purchaseSummaryStep: {
				title: 'Purchase Summary',
				description: (fullName: string) => `You are purchasing the following for ${fullName}:`,
				buildAddonLabel: (addon: string, quantity?: number) => `${addon}${quantity ? ` x ${quantity}` : ''}`,
				buildResourceLabel: (resource: IResourceFieldTypes, addons: IAddonWithQuantity[]) =>
					`${resource.name} ${!!addons?.length ? ` - ${addons.map(({ name, quantity }) => `${name}${quantity > 1 ? ` x ${quantity}` : ''}`).join(', ')}` : ''}`,
				back: 'Back',
				nextStep: 'ADD TO CART',
				cancel: 'Cancel',
				itemOptions: {
					product: 'Product:',
					membership: 'Membership:',
					addons: 'Add-ons:',
					resources: 'Segments:',
					price: 'Price Total (discounts included):',
				},
				all: 'All Segments',
			},
		},
		purchasePunchPass: {
			createCustomerStep: {
				title: 'Select Customer',
				description: 'Select a customer to purchase the punch pass for.',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
				nextStep: 'Continue',
				cancel: 'Cancel',
			},
			membershipGatingStep: {
				title: 'Membership Required',
				description:
					'To purchase this pass a customer must also purchase a membership. Select the membership and add to cart.',
				back: 'Back',
				selectMembership: 'Select',
				startDate: 'Start Date',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				additionalInfo: (price: number, currency: CurrencySymbolEnum) =>
					`${CHARACHERS.COLON} ${Pricify(price, currency)}`,
				additionalRowInfo: (resourceType: MembershipTypeEnum, customerTypes: CustomerTypeEnum[]) =>
					`Membership Type (${MEMBERSHIP_TYPE_LABELS[resourceType]} - ${customerTypes.join(', ')})`,
				gatedMembershipsNoteTitle: (name: string, required?: boolean) =>
					!required
						? ` ${name} owns this membership, but is missing these required products:`
						: `This membership requires the following products:`,
				buildGatedProductLabel: (product: RequiredProductDto | Product) =>
					`${product.name} - ${Pricify(product.currPrice.price, CurrencySymbolEnum[product.prices[0].currency])} ${!product.required ? '(Already owns)' : ''}`,
			},
			validateParticipant: {
				title: 'Registration Needs Review',
				subtitle: (customerName: string) =>
					`${customerName} does not meet session registration requirements for the following reasons:`,
				redeemAnyway: 'REGISTER ANYWAY',
				cancel: 'CANCEL',
				errorsMap: {
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: 'Gender Requirement',
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: 'Age Requirement',
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: 'Registration Window',
				},
				errorsDescriptions: {
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: (minAge: number, maxAge: number): string =>
						`${minAge ?? 'No Minimum'} - ${maxAge ?? 'No Maximum'}`,
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: (gender: GenderEnum): string =>
						`${GENDER_MAP[gender]} Only`,
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: (
						startRegistrationDate: string,
						endRegistrationDate: string
					): string => {
						return `${formatDate(startRegistrationDate, EDateTimeFormats.DAY_FORMAT)} - ${formatDate(endRegistrationDate, EDateTimeFormats.DAY_FORMAT)}`;
					},
				},
			},
			selectEvents: {
				title: 'Event Selection',
				subject: 'events',
				onSuccess: (name: string, quantity: number, sessionName: string) =>
					`${name} redeemed ${quantity} events in ${sessionName}!`,
				subtitle: (
					name: string,
					durationQuantity?: number,
					durationWindow?: number,
					durationWindowUnit?: TimeUnit
				): string => {
					const durationString: string = durationWindow
						? `${durationWindow} ${durationWindowUnit}${durationWindow > 1 ? 's' : ''}`
						: '';

					return `Select the events you would like to purchase for ${name}. ${durationQuantity ? `This pass allows ${durationQuantity} punches to be redeemed within ${durationString}.` : ''}`;
				},
				columns: {
					date: 'Date',
					time: 'Time',
					space: 'Space',
					spots: 'Spots',
					timeRange(startTime: string, endTime: string) {
						return `${startTime} - ${endTime}`;
					},
				},
				continue: 'CONTINUE',
				clear: 'CLEAR',
				punchesLeft: 'Punches left:',
			},
			addonSelectionStep: {
				title: 'Add On Selection',
				description: 'Would you like to purchase add ons with this pass?',
				select: 'Add Ons Name',
				timePeriod: 'Time period',
				perPass: 'Per Pass',
				timePeriodTypes: {
					full: 'All Passes',
					session: 'All Passes',
					event: 'Per Pass',
				},
				fields: {
					perPassAddon: {
						label: 'Per Pass Add-on(s)',
						placeholder: 'Select Add-on(s)',
					},
					perEventAddon: {
						label: 'Per Event Add-on',
						placeholder: 'Select Add-on',
					},
					addon: {
						label: 'Add-On',
						placeholder: 'Select',
					},
					quantity: {
						label: 'Quantity',
						placeholder: '0',
					},
					events: {
						label: 'Events',
						placeholder: 'Select Events',
					},
				},
				clear: 'Clear',
				back: 'Back',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				addon: 'Add-On',
				eventSelection: {
					placeholder: 'Select',
					label: 'Events',
				},
				addAdditional: 'Add Add-on',
				addAdditionalPerEvent: 'Add Per Event Add-on',
				remove: 'Remove',
			},
			purchaseSummaryStep: {
				title: 'Purchase Summary',
				description: (fullName: string) => `You are purchasing the following for ${fullName}:`,
				buildAddonLabel: (addon: string, quantity?: number) => `${addon}${quantity ? ` x ${quantity}` : ''}`,
				buildEventLabel: (
					startDate: Date,
					endDate: Date,
					startTime: string,
					endTime: string,
					addons: string[],
					timezone?: string
				) => {
					const startDateFormatted = formatDate(startDate, DateTimeFormats.DAY_FORMAT_WITH_DAY_OF_WEEK, timezone);
					const endDateFormatted = formatDate(
						endDate ?? startDate,
						DateTimeFormats.DAY_FORMAT_WITH_DAY_OF_WEEK,
						timezone
					);
					const dateTimePart =
						startDateFormatted === endDateFormatted
							? `${startDateFormatted} ${format24HToAmPm(startTime)} - ${format24HToAmPm(endTime)}`
							: `${startDateFormatted} ${format24HToAmPm(startTime)} - ${endDateFormatted} ${format24HToAmPm(endTime)}`;

					return `${dateTimePart}${
						!!addons?.length
							? ` - ${addons[0].substring(0, 10)}... ${
									addons.length > 1 ? `${CHARACHERS.PLUS} ${addons.length - 1}` : ''
								}`
							: ''
					}`;
				},
				back: 'Back',
				nextStep: 'ADD TO CART',
				cancel: 'Cancel',
				itemOptions: {
					pass: 'Punch Pass:',
					membership: 'Membership:',
					addons: 'Add-ons:',
					events: 'Events:',
					price: 'Price Total (discounts included):',
				},
			},
		},
		purchaseFolderedRegistration: {
			createCustomerStep: {
				title: 'Select Customer',
				description: 'Select the customer you want to register.',
				link: {
					customerCreationHelperFirst: `Can't find who you're looking for?`,
					customerCreationHelperSecond: `Create a new customer `,
					customerCreationLink: 'here.',
				},
				nextStep: 'Continue',
				cancel: 'Cancel',
			},
			errors: {
				formContextRequired: 'Something went wrong. Please refresh the page and try again.',
			},
			validateParticipant: {
				title: 'Registration Needs Review',
				subtitle: (customerName: string) =>
					`${customerName} does not meet session registration requirements for the following reasons:`,
				redeemAnyway: 'REGISTER ANYWAY',
				cancel: 'CANCEL',
				errorsMap: {
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: 'Gender Requirement',
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: 'Age Requirement',
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: 'Registration Window',
				},
				errorsDescriptions: {
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: (minAge: number, maxAge: number): string =>
						`${minAge ?? 'No Minimum'} - ${maxAge ?? 'No Maximum'}`,
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: (gender: GenderEnum): string =>
						`${GENDER_MAP[gender]} Only`,
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: (
						startRegistrationDate: string,
						endRegistrationDate: string
					): string => {
						return `${formatDate(startRegistrationDate, EDateTimeFormats.DAY_FORMAT)} - ${formatDate(endRegistrationDate, EDateTimeFormats.DAY_FORMAT)}`;
					},
				},
			},
			membershipGatingStep: {
				title: 'Membership Required',
				description: 'To complete this registration, a membership is required. Select the membership and add to cart.',
				back: 'Back',
				selectMembership: 'Select',
				startDate: 'Start Date',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				additionalInfo: (price: number, currency: CurrencySymbolEnum) =>
					`${CHARACHERS.COLON} ${Pricify(price, currency)}`,
				additionalRowInfo: (resourceType: MembershipTypeEnum, customerTypes: CustomerTypeEnum[]) =>
					`Membership Type (${MEMBERSHIP_TYPE_LABELS[resourceType]} - ${customerTypes.join(', ')})`,
				gatedMembershipsNoteTitle: (name: string, required?: boolean) =>
					!required
						? ` ${name} owns this membership, but is missing these required products:`
						: `This membership requires the following products:`,
				buildGatedProductLabel: (product: Product) =>
					`${product.name} - ${Pricify(product.currPrice.price, CurrencySymbolEnum[product.prices[0].currency])} ${!product.required ? '(Already owns)' : ''}`,
			},
			selectGroup: {
				title: 'Select Group',
				description: 'Select an existing group or team, or create a new one for this participant',
				selectLabel: '',
				selectPlaceholder: 'Search for a group...',
				createNewHelperFirst: "Can't find the group you're looking for?",
				createNewHelperSecond: 'Create a new group or team ',
				createNewLink: 'here.',
				nextStep: 'Continue',
				createGroup: {
					title: 'Create New Group',
					description: 'Enter the details for the new group.',
					nameLabel: 'Group Name',
					namePlaceholder: 'Enter group name...',
					typeLabel: 'Group Type',
					parentGroupLabel: 'Parent Group',
					registrationAccessLabel: 'Registration Access',
					registrationAccessTooltip: 'Controls how participants can join this group.',
					saveForm: 'Continue',
					cancelButton: 'Cancel',
				},
			},
			addonSelectionStep: {
				title: 'Add-on Selection',
				description: 'Would you like to purchase add-ons with this registration?',
				select: 'Add Ons Name',
				timePeriod: 'Time period',
				timePeriodTypes: {
					full: 'Per Registration',
					session: 'Per Registration',
					event: 'Per Registration',
				},
				fields: {
					addon: {
						label: 'Registration Add-on(s)',
						placeholder: 'Select',
					},
					quantity: {
						label: 'Quantity',
						placeholder: '0',
					},
				},
				clear: 'Clear',
				back: 'Back',
				skip: 'SKIP',
				addToCart: 'ADD TO CART',
				addon: 'Add-On',
				addAdditional: 'Add Add-on',
				remove: 'Remove',
			},
			purchaseSummaryStep: {
				title: 'Purchase Summary',
				description: (fullName: string) => `You are purchasing the following for ${fullName}:`,
				buildAddonLabel: (addon: string, quantity?: number) => `${addon}${quantity ? ` x ${quantity}` : ''}`,
				addonLineWithQuantity(name: string, quantity: number) {
					return `${name} (x${quantity})`;
				},
				buildResourceLabel: () => '',
				back: 'Back',
				nextStep: 'ADD TO CART',
				cancel: 'Cancel',
				itemOptions: {
					product: 'Product:',
					membership: 'Membership:',
					group: 'Group:',
					addons: 'Add-ons:',
					price: 'Price Total (discounts included):',
				},
				all: '',
			},
		},
		program: {
			wrongPath: 'Oops,looks like wrong path',
			header: {
				tabs: {
					info: 'Info',
					sessions: 'Sessions',
				},
				publish: 'Publish',
				unpublish: 'Unpublish',
				publishSuccess: 'Program published successfully',
				publishFailure: 'Could not publish program, please try again later',
				unpublishFailure:
					'We could not unpublish this program. Please try again. If the problem continues, refresh the page.',
				unpublishSuccess: 'Program set as unpublished',
				published: 'Published',
				archived: 'Archived',
				statusUnpublished: 'Unpublished',
				openWebsite: 'Open Website',
				createSession: 'Create Session',
			},
			info: {
				edit: 'Edit',
				cancel: 'Cancel',
				save: 'Save',
				viewMore: 'View More',
				viewLess: 'View Less',
				basicInfo: {
					title: 'Basic Info',
					age: 'AGE',
					colorSet: 'color set',
					y: (years?: number) => (years === 1 ? 'year' : 'years'),
					m: (months?: number) => (months === 1 ? 'month' : 'months'),
					gender: 'Gender',
					genderDisplay: {
						coEd: 'Co-Ed',
						male: 'Male',
						female: 'Female',
					},
					activity: 'activity',
					levelOfPlay: 'LEVEL OF PLAY',
					ageDesc: {
						from: 'From',
						andUp: 'and up',
						eligibility: 'on',
						old: 'old',
					},
				},
			},
			sessions: {
				table: {
					subject: 'sessions',
					loadingMessage: 'Loading Sessions...',
					noDataMessage: 'No matching sessions found. Try adjusting your filters or adding a new one.',
					errorMessage: 'Failed to load sessions. Please try again or refresh the page.',
					filters: {
						search: { placeholder: 'Search' },
						categories: {},
					},
					columns: {
						id: 'ID',
						name: 'Name',
						gender: 'Gender',
						ageRange: 'Age Range',
						sessionDates: 'Session Dates',
						registrationDates: 'Registration Dates',
						facilityName: 'Facility',
						registrationStatus: 'Registration',
						sessionStatus: 'Session Status',
						includePastSessions: 'Include Past Sessions',
						more: 'More',
					},
					cells: {
						gender: {
							[GenderEnum.OTHER]: 'Gender Neutral',
							[GenderEnum.MALE]: 'Male',
							[GenderEnum.FEMALE]: 'Female',
						},
						registrationStatus: {
							[RegistrationStatusEnum.FUTURE]: 'Future',
							[RegistrationStatusEnum.OPEN]: 'Open',
							[RegistrationStatusEnum.CLOSE]: 'Closed',
							unknown: 'Unknown',
						},
						sessionStatus: {
							[PublishingStatusEnum.DRAFT]: 'Draft',
							[PublishingStatusEnum.PUBLISHED]: 'Published',
							[PublishingStatusEnum.ARCHIVE]: 'Archived',
							[PublishingStatusEnum.UNPUBLISHED]: 'Unpublished',
							[PublishingStatusEnum.CANCELLED]: 'Cancelled',
							[PublishingStatusEnum.CLOSED]: 'Closed',
							unknown: 'Unknown',
						},
						ageRange: {
							allAges: 'All ages',
							upTo: 'Up to',
							yearsPlus: 'y+',
							years: 'y',
							rangeFormat: '{min}-{max}{unit}',
							fromAgeFormat: '{age}{unit}',
							upToFormat: '{upTo} {age}{unit}',
							noValue: '-',
						},
						copyPublicLink: {
							success: 'Public link copied to clipboard',
							error: 'Failed to copy public link',
						},
						includePast: {
							yes: 'Past Sessions',
							no: 'Current & Future Sessions',
						},
					},
					actions: {
						duplicateSession: 'Duplicate Session',
						removeToArchive: 'Archive',
						unarchive: 'Unarchive',
						notify: 'Message Attendees',
						viewSession: 'View Session',
						viewProducts: 'Products',
						viewParticipants: 'Participants',
						viewSchedule: 'Schedule',
						copyPublicLink: 'Copy Public Link',
					},
					tableAction: {
						notifySessions: {
							label: 'Message Attendees',
							tooltip: 'Message Attendees',
						},
						createSession: {
							label: 'Create Session',
							tooltip: 'Create Session',
						},
					},
				},
				errors: {
					fetchAllForNotificationFailed: 'Failed to fetch all sessions for notification',
					archiveSession: 'Failed to archive session. Please try again.',
					duplicateSession: 'Failed to open duplicate session dialog. Please try again.',
					navigateToSession: 'Failed to navigate to session. Please try again.',
					fetchAllSessionsForNotification: 'Failed to fetch all sessions for notification',
				},
			},
		},
		successModal: {
			title: 'Great Session',
			publishedTitle: 'Great Session Published',
			publishedDescription: 'Your new session has been created & published successfully. What’s next?',
			description: "You've successfully created a new session what's next?",
			mainButton: 'Add pricing',
			secondaryButton: 'I’m done for now',
		},
		descriptions: {
			leagues: 'Create new league with seasons and teams',
			tournaments: 'Create new tournament with participants',
			camps: 'Create new camp with seasons and participants',
			classes: 'Create new class with attendees',
			club_teams: 'Create new club teams with participants',
			club_teams_v2: 'Create new club teams with seasons and teams',
			private_lessons: 'Create new private lessons',
			clinics: 'Create new clinic with seasons and attendees',
		},
		activities: 'Programs',
		newActivity: 'New Program',
		addActivity: 'Add New Program',
		dashboard: {
			registrationDates: {
				edit: 'edit',
				startDate: 'REGISTRATION START DATE',
				endDate: 'REGISTRATION END DATE',
				openLimit: 'Event registration open time is limited to',
				closeLimit: 'Event registration close time is limited to',
				earlyBird: 'Early Bird',
				lateFee: 'Late Fee',
				hours: 'Hours',
				days: 'Days',
				weeks: 'Weeks',
				months: 'Months',
			},
		},
		forms: {
			ageUnits: {
				years: 'Years',
				months: 'Months',
			},
			validation: {
				untilDateError: (date: string) => `Please select an end date that falls before ${date}.`,
				required: 'required',
				paymentPlan: {
					custom: {
						mustBeLess: 'must be later than end registration date',
						mustBeFutureDate: 'Installments must be set on a future date',
						percentMoreThanHundred: 'The percentage cannot be more than 100',
						amountMustBeLess: "must be less or equal to product's price",
						mustBeMoreThan: (num: number) => `must be at least ${num}`,
						dateMustBeUnique: 'This date is already used for another installment',
					},
				},
			},
			addNewSeason: {
				title: 'Add New Session',
				productTitle: 'Add New Product',
				duplicateWarning: {
					confirm: 'OKAY',
					updatePaymentPlanTitle: 'Update Payment Plan',
					updatePaymentPlanDescription:
						'The registration end date extends beyond the custom payment plans of duplicated products. These plans have been deactivated and will remain inactive until updated in the Products tab.',
				},
				tabs: {
					basicInfo: 'Basic Info',
					schedule: 'Schedule',
					registrationDate: 'Registration date',
					teams: 'Teams',
				},
				resourceSettingsForm: {
					title: 'CONSUMER SITE DISPLAY',
					description: 'Select the session information you want to hide from the consumer.',
					checkboxLabels: {
						title: 'Consumer registration display',
						isHideEventTimes: 'Hide event days and times from consumer',
						isHideSeasonSchedule: 'Hide full season schedule from consumer',
					},
					checkboxTooltip: {
						isHideEventTimes:
							'Hides auto-generated days and times on the session registration page and when session is surfaced as an active season in program registration.',
						isHideSeasonSchedule: 'Hides the schedule beneath the description on the session registration page.',
					},
				},
				basicInfo: {
					title: 'Basic Info',
					sessionName: 'Session Name',
					shortDescription: 'Short Description',
					longDescription: 'Long Description',
					glCodes: { updateSessions: 'Update session products' },
					maxParticipants: 'Max number of participants',
					maxMaleParticipants: 'Max number of male participants',
					maxFemaleParticipants: 'Max number of female participants',
					enableWaitlist: {
						label: 'Enable participant waitlist',
						tooltip: 'Set a max capacity to enable the waitlist option.',
					},
					isDisplayRemainingSpots: {
						label: 'Display remaining spots to customers',
						tooltip: 'Remaining spots can only be displayed if a max number of participants is set.',
					},
				},
				activities: {
					title: 'Activity',
				},
				sportLockedAfterCompetition: 'Activity cannot be changed after league or tournament setup.',
				levelOfPlay: {
					title: 'Level Of Play',
				},
				membership: {
					title: 'MEMBERSHIP',
					selectLabel: 'select memberships',
				},
				participant: {
					title: 'Participant',
					gender: 'Gender',
					age: 'Age',
				},
				facility: {
					title: 'Facility',
					select: 'Select Program Facility',
				},
				forms: {
					title: 'Forms',
					select: 'Select Forms',
				},
				schedule: {
					title: 'SESSION DATE & TIME',
					startSessionDate: 'Session Start Date',
					endSessionDate: 'Session End Date',
					spaceAllocation: 'Select Space Allocation',
					isConstraint: 'Select session date constraints',
					addSegments: 'Add session segments',
					eventsAddedLater: "Events won't be created. You can add events later from the Schedule tab.",
					sessionOnDays: 'Session Days On',
					startTime: 'Start Time',
					endTime: 'End Time',
					fullDay: 'Full day',
					addTimeSlot: 'Add time slot',
					seasonConstraintsTitle: 'Session Date Constraints',
					constraintName: 'Constraint Name',
					startDate: 'Start Date',
					endDate: 'End Date',
					addNewConstraint: 'Add date constraint',
					view: 'View',
					segmentType: 'Segment Type',
					occurrenceEvery: 'Occurrence Every',
					segmentTitle: 'Session Segment',
					segmentName: 'Segment Name',
					sessionScheduler: 'Session Scheduler',
					selectSpace: 'Select Space Allocation',
					addSegment: 'Add new segment',
					remove: 'Remove',
					onDays: 'On Days',
					hide: 'Hide',
					show: 'Show',
					slot: 'Slot',
					date: 'Date',
					custom: 'Custom',
					week: 'Week',
					month: 'Month',
					slotSegmentName: (day: string, time: string) => `${day} ${time}`,
					weekSegmentName: (counter: number) => `Week ${counter}`,
					monthSegmentName: (counter: number) => `Month ${counter}`,
					multiPeriodSegmentName: (counter: number) => `Segment ${counter}`,
					optionalSegmentNameWithRange: (day: string, open: string, close: string) => `${day}, ${open} - ${close}`,
					optionalSegmentNameWithSingleTime: (day: string, time: string) => `${day}, ${time}`,
					customSegmentCheckboxLabel: (segmentName: string, durationLabel: string) =>
						`${segmentName} (${durationLabel})`,
					disabledSegmentsExplanation:
						'Products cannot be duplicated when switching between Event-based and Segment-based scheduling.',
				},
				registrationDates: {
					sessionDate: {
						title: 'SESSION DATES',
						startDate: 'SESSION START DATE',
						endDate: 'SESSION END DATE',
					},
					registrations: {
						title: 'REGISTRATION',
						info: 'Registration date for this session',
						dates: {
							registrationStartDate: 'Registration Start Date',
							registrationEndDate: 'Registration End Date',
						},
						limitStart: {
							toggle: 'Limit the start registration time',
							label: 'Select start registration time',
							info: 'before the event / segment starts',
						},
						limitEnd: {
							toggle: 'Limit the end registration time',
							label: 'Select end registration time',
							info: 'before the event / segment starts',
						},
						isEarlyBird: {
							toggle: 'Early Bird Registration',
							startDate: 'Start Date',
							endDate: 'End Date',
						},
						isLateFee: {
							toggle: 'Late Fee Registration',
							startDate: 'Start Date',
							endDate: 'End Date',
						},
						registrationTypes: {
							hours: 'Hours',
							days: 'Days',
							weeks: 'Weeks',
							months: 'Months',
						},
					},
				},
				teams: {
					invites: {
						title: 'Invites',
						createInvitedPlayerProduct: {
							label: 'Enable team managers to invite players to their roster',
							description: 'This will automatically create an Invited Player product for $0 that you can modify later',
						},
					},
					nextSteps: {
						title: 'Next Steps',
						step1: 'Configure pricing for captains, players, free agents, and more in the Products tab',
						step2: 'Create divisions and teams from Participants → Groups',
						step3: 'Generate private invite links for any division or team from the Groups table',
						step4: 'Build your game schedule with the Schedule Generator in the Schedule tab',
					},
					rosterRollover: {
						title: 'Roster Rollover',
						description: 'Choose how returning team admins add players from a past team when registering.',
						invite: {
							label: 'Invite players to the new team',
							description: 'Selected past teammates are emailed an invite link to join the new team.',
						},
						auto: {
							label: 'Automatically add players to the new team',
							description: 'Selected past teammates are added to the new team without an invite.',
						},
						autoWarning:
							'Automatically adding players bypasses eligibility restrictions such as age, gender, and membership gating. Selected players are invoiced for the Invited Player product.',
					},
				},
			},
			addRentalProduct: {
				successModal: {
					title: 'Rental product created Successfully',
					thanks: 'Thanks',
				},
				footer: {
					back: 'Back',
				},
				header: {
					title: 'Create New Rental Product',
					editTitle: 'Edit Rental Product',
					cancel: 'Cancel',
					next: 'Next',
					done: 'Done',
					tabs: {
						mainDetails: 'Main Details',
						addons: 'Add ons',
						schedule: 'Schedule',
						onlineBooking: 'Online Booking',
					},
				},
				mainDetails: {
					title: 'PRODUCT DETAILS',
					name: 'Name',
					glCode: 'GL Code',
					description: 'Description',
					activityTypes: 'Activity Types',
					duration: 'Duration',
					bookDurationToggle: 'Customers can book parts of the duration and not only entire blocks of it',
					price: 'Price',
					assignWithResources: 'Assign with resources',
					resourcesInfo:
						'If the resource is not yet established in the system, you will be able to set this later from the resource settings page',
					durationOptions: {
						halfHour: '0.5 hr',
						hour: '1 hr',
						hourAndHalf: '1.5 hr',
						twoHours: '2 hr',
						fullDay: 'Full Day',
						custom: 'Custom',
						minutes: 'Minutes',
						hours: 'Hours',
						days: 'Days',
					},
					taxFrame: {
						title: 'TAX',
						taxToggle: 'Use Tax',
						type: 'Tax Type',
						percent: 'Tax Percent',
						inclusive: 'Inclusive',
						exclusive: 'Exclusive',
					},
					customersFrame: {
						title: 'CUSTOMERS',
						customersToggle: 'Available for all',
						membershipButton: 'Memberships',
						membershipsSelectionPlaceHolder: 'Choose memberships',
						customersButton: 'Customers',
						customersSelectionPlaceHolder: 'Search by name',
						errorMessage: 'Unable to load customers. Please try again.',
					},
					formsAndDocuments: {
						title: 'REQUIRED DOCUMENTS & FORMS',
						formSelectionPlaceHolder: 'Select form',
						formInfo: 'Documents & forms',
						addDocument: 'Add a document',
						dropDocument: 'or drop it here',
					},
				},
				addons: {
					title: 'ADD-ONS',
					clear: 'Clear',
					flatPrice: 'Flat Price',
					Mandatory: 'Mandatory',
					addAddon: 'Add another add-on',
					addonsSelection: 'Choose an Addon',
					priceRelation: {
						label: 'Price per',
						hourly: 'Hour',
						slot: 'Slot',
						reservation: 'Reservation',
					},
				},
				schedule: {
					title: 'BOOKING DAYS AND TIMES',
					daysAndTimesAvailability: 'The days and times your rental product is available:',
					on: 'On',
					from: 'From',
					to: 'To',
					starts: 'Starts',
					ends: 'Ends',
					sameDaysToggle: 'Same in all yearly seasons',
					addAnotherSlot: 'Add another time slot',
				},
				onlineBooking: {
					onlineBookingSegment: {
						title: 'ONLINE BOOKING',
						bookingToggle: 'Available',
						segmentTitle: 'Choose the rental-product online booking permissions',
						instantConformation: {
							title: 'Instant confirmation',
							description:
								'The quickest way for your customers to book your spaces. As long as the calendar shows availability, customers can book spaces and receive instant confirmation.',
						},
						approvalWorkflow: {
							title: 'Request & approval workflow',
							description:
								'All customers can see and request the booking slots available on the calendar but will have to wait for your response and approval to confirm the booking.',
						},
						vettedCustomers: {
							title: 'Vetted customers workflow',
							description:
								'You will be able to mark specific customers to have an instant booking flow. All other customers will have a request workflow.',
							filterMembers: {
								title: 'Instant confirmation applies for:',
								memberships: 'Memberships',
								customers: 'Customers',
								membershipsPlaceHolder: 'Choose memberships',
								customersPlaceHolder: 'Search by name, phone or email address',
							},
						},
					},
					validityPeriod: {
						title: 'VALIDITY PERIOD',
						bookingLimitation: {
							toggle: 'Customer can book up to',
							desc: 'in advance',
						},
						maxBooking: {
							toggle: 'Customer can book maximum',
							desc: 'ahead',
						},
						bookingBetween: {
							toggle: 'Customer can book between',
							starts: 'Starts',
							end: 'Ends',
							yearlyRepeat: '+ Add Yearly Repeat',
							title: 'Yearly Repeat',
							endRepeat: 'End Repeat',
							on: 'On',
							after: 'After',
							occurrences: 'Occurrences',
						},
					},
					payments: {
						title: 'PAYMENTS',
						firstPayment: 'First payment required',
						firstPaymentLabel: 'Minimum amount',
						paymentBeforeBooking: 'On the',
						timeOfPurchase: 'At the time of purchase',
						beforeBooking: 'Before the booking date',
						schedulePayments: 'Schedule Payments',
						paymentsDesc: 'The remainder portion of the total purchase price that will paid after the booking date',
						dueDate: 'Due date',
						installment: 'Installment (max)',
						addPayments: '+ Add another upfront payment',
					},
				},
			},
			segmentProfile: {
				title: 'Segment Profile',
				formTitle: 'Edit Segment',
				errors: {
					failedToFetch: 'Unable to load segment details. Please try again.',
				},
				generalDetails: 'General Details',
				capacityAndWaitlist: 'Capacity & Waitlist',
				isOverridden: 'Override session capacity configuration',
				maxParticipants: 'Max number of participants',
				isWaitlistEnabled: 'Enable participant waitlist',
				isDisplayRemainingSpots: 'Display remaining spots to customers',
				segmentName: 'Segment Name',
				segmentTag: 'Segment tag',
			},
			editSegment: {
				segmentName: 'Segment Name',
				startSessionDate: 'Session Start Date',
				endSessionDate: 'Session End Date',
				isDateConstraint: 'Select session date constraints',
				sessionOnDays: 'Session Days On',
				startTime: 'Start Time',
				endTime: 'End Time',
				isFullDay: 'Full Day',
				cancel: 'Cancel',
				saveSegment: 'Save Segment',
				spaceArray: {
					space: 'Space',
					addSpace: 'Add Space',
					remove: 'Remove',
				},
			},
			editEvent: {
				title: 'Edit Schedule Event',
				multipleEventsTitle: 'Turn on the event attributes you would like to mass edit',
				cancel: 'Cancel',
				save: 'Save',
				successMessage: 'Event updated successfully',
				multipleEventsSuccessMessage: 'Events updated successfully',
				conflictCheckErrorMsg: 'Conflicts could not be checked. Please try again.',
				errorMessage: `Something went wrong. Please try again or contact ${SUPPORT_EMAIL} if the issue persists.`,
				overnightSlotWarning: 'Ends on following day',
				fields: {
					name: 'Event Name',
					eventName: 'Event Name',
					resources: 'Resources',
					eventStartDate: 'Event Start Date',
					eventEndDate: 'Event End Date',
					startDate: 'Event Start Date',
					endDate: 'Event End Date',
					eventTimeOn: 'Event Time On',
					eventStartTime: 'Start Time',
					eventEndTime: 'End Time',
					repeat: 'Repeat',
					resource: 'Resource',
					selectSpace: 'Select Space',
					publicNotes: 'Public Notes',
					privateNotes: 'Private Notes',
					setColor: 'set color',
					selectEventColorSet: 'Select event color set',
					maintenanceBefore: 'Maintenance Before',
					maintenanceAfter: 'Maintenance After',
					maintenanceTime: 'Maintenance time',
					eventSubType: 'Event Type',
					selectEventSubType: 'Select Event Type',
					homeTeam: 'Home Team',
					selectHomeTeam: 'Select Home Team',
					awayTeam: 'Away Team',
					selectAwayTeam: 'Select Away Team',
					team: 'Team',
					selectTeam: 'Select Team',
					tryoutGroup: 'Tryout Group',
					selectTryoutGroup: 'Select Tryout Group',
					tryoutAutoTitle: (groupName: string) => `Tryout - ${groupName}`,
					practiceAutoTitle: (teamName: string) => `${teamName} Practice`,
					enableManualEventName: 'Use custom event name',
					tbd: 'TBD',
					tbdFrom: 'TBD from',
					anyDivision: 'Any Division',
				},
				validation: {
					teamRequired: 'At least one team (home or away) must be selected',
					practiceTeamRequired: 'A team must be selected',
					gameScoreDisabled: 'Event type and teams cannot be modified once a game has been scored',
				},
				eventSubTypes: {
					game: 'Game',
					match: 'Match',
					practice: 'Practice',
					tryout: 'Tryout',
					exhibition: 'Exhibition',
					friendly: 'Friendly',
					playoff: 'Playoff',
					scrimmage: 'Scrimmage',
					final: 'Final',
					other: 'Other',
				},
				confirmationPopup: {
					title: 'Edit Event',
					description: 'There are participants who already registered to the event you wish to edit.',
					checkbox: 'Send email to notify all registered customers',
				},
			},
			createNewProgram: {
				headerDescription: (title: string, programType: string) => `${title} ${programType} program`,
				title: 'Create new',
				programLink: {
					0: 'leagues',
					1: 'tournaments',
					2: 'classes',
					3: 'clinics',
					4: 'camps',
					5: 'private_lessons',
					6: 'club_teams',
					7: 'leagues',
					8: 'tournaments',
					9: 'events',
					10: 'leagues_v2',
					11: 'tournaments_v2',
					12: 'club_teams_v2',
				},
				unknownProgram: 'Unknown Program',
				linkAnchor: '#',
				program: 'program',
				published: 'Published',
				basicInfo: {
					title: 'Basic info',
					colorSet: 'Select Color Set',
					programName: 'Program name',
					shortDescription: 'Short Description',
					longDescription: 'Long Description',
					glCodes: { updateSessions: 'Update sessions and session products' },
					activities: 'Activities',
				},
				level: {
					title: 'Level Of Play',
					description: 'Select level of play for this program?',
					semiPro: 'Semi Pro',
				},
				membership: {
					title: 'Memberships',
					selectLabel: 'Select memberships',
				},
				participants: {
					title: 'Participants',
					gender: 'Gender',
					age: 'Age',
					years: 'Years',
					months: 'Months',
					noMin: 'No min',
					noMax: 'No max',
					ageInfo:
						'Selecting age limit will schedule the age limit as for selected date. The default age limit will be the session start date.',
					ageSwitch: 'Select age restriction cutoff date',
				},
				sports: {
					title: 'Activities Offered',
					markAll: 'Mark All',
					unmarkAll: 'Unmark All',
				},
				forms: {
					title: 'Forms',
					select: 'Select Forms',
				},
				image: {
					title: 'Cover Image',
					description: 'Please upload a cover photo for the program.',
					dragAndDrop: 'Drag and drop an image',
					or: 'or',
					browse: 'browse',
					toChooseATile: 'to choose a file ',
					noLargerThan: 'no larger than 4MB',
				},
				successModal: {
					title: 'Great Program',
					publishedTitle: (title: string, published: string) => `${title} ${published}`,
					description: 'You’ve successfully created a new program',
					whatsNext: 'what’s next?',
					mainButton: 'Thanks, I’m done',
					subButton: 'Create new session',
				},
				actionButtons: {
					cancel: 'Cancel',
					save: 'save',
					saveAndPublish: 'save and publish',
				},
			},
			editProgram: {
				editColorModal: {
					title: 'Edit program color',
					description:
						'This program may have different color set for some sessions/events. Do you want to change the color set for all the sessions/events?',
					mainButton: 'Change all',
					subButton: 'Change only future sessions',
					successMessage: 'Color changed successfully',
					errorMessage: 'The color could not be updated for this program. Please try again.',
				},
			},
			editRegistrationDates: {
				cancel: 'Cancel',
				change: 'Change',
				save: 'save',
				thanks: 'thanks',
				confirmationPopup: {
					title: 'Edit Registration Dates',
					description: 'Do you want to change the registration dates for all the products ?',
					mainButton: 'Change for all products',
					subButton: 'Cancel',
					secondButton: 'Select product',
				},
				selectProduct: {
					selectAll: 'Select All',
					title: 'Select product',
					description: (startFormatted: string, endFormatted: string) =>
						`Please select the products you want to change the registration dates for ${startFormatted} - ${endFormatted}`,
					productDateRange: (startFormatted: string, endFormatted: string) => `${startFormatted} - ${endFormatted}`,
					note: 'NOTE! some product have payment plan that starts before the session end. The payment plan need to be changed and will remain canceled until the update.',
				},
				success: {
					title: 'Registration date changed',
				},
				errors: {
					lateBeforeEarly: {
						late: 'must be after early bird end registration date',
						early: 'must be before late fee start registration date',
					},
					startAfterEnd: {
						start: 'must be before end registration date',
						end: 'must be after start registration date',
					},
					earlyEndBeforeStart: {
						start: 'must be before early bird start registration date',
						early: 'must be after start registration date',
					},
				},
			},
			editSeasonDateAndTimes: {
				title: 'Edit Season Dates',
				activityTimesTitle: 'Activity Times',
				seasonStartDate: 'Season Start Date',
				seasonEndDate: 'Season End Date',
				save: 'Save',
				cancel: 'Cancel',
				activityTimesNotEditable:
					'Activity times and days of the week cannot be edited for a season with existing events.',
				revenueAccrualWarning: 'Editing season start and end date after events exist will affect revenue accrual.',
				errors: {
					startAfterEnd: 'Start date must be before end date',
					cannotEditWithScheduledEvents: 'Season dates cannot be changed this way while events are scheduled.',
				},
				tryAgainText: 'Please adjust the dates accordingly',
				success: {
					title: 'Schedule updated successfully',
				},
			},
			addPricing: {
				productsAndPricing: {
					title: 'PRODUCT & PRICING',
					sessionDates: {
						startDate: 'SESSION START DATE',
						endDate: 'SESSION END DATE',
						title: 'SESSION DATES',
					},
					products: {
						title: 'Product Details',
						view: 'view',
						hide: 'Hide',
						show: 'Show',
						remove: 'Remove',
						fields: {
							name: 'Product Name',
							quantity: 'Quantity',
							isDifferentDates: 'use different registration dates for this product',
							description: 'Product Description',
							price: 'Product Price',
							productSubTypeAsParticipantType: 'Participant Type',
							productSubTypeAsParticipantTypePlaceholder: 'Select participant type',
							prorated: 'Prorated',
							userCanSkip: 'Sell as Punch Pass (user can skip schedule selection)',
							addNewProduct: 'Add a new product',
							isMembershipGating: 'membership gating',
						},
						productSettings: {
							byPassScheduleIfIsAll:
								'Bypass schedule selection for consumer registration (when quantity is set to "All")',
							allowMultipleQuantitiesPurchase: 'Allow this product to be purchased in multiple quantities',
							byPassScheduleIfPunchPass:
								'Bypass schedule selection for consumer registration (when punch pass is selected)',
							hideProductFromUser: 'Hide product from user registration',
							hideProductInfoTooltip:
								'This product will be visible to facility admins only and will not be displayed on the consumer site',
						},
						productSubTypes: {
							[ProductSubTypesEnum.LEAGUE_V2_CAPTAIN]: 'Captain',
							[ProductSubTypesEnum.LEAGUE_V2_COACH]: 'Coach',
							[ProductSubTypesEnum.LEAGUE_V2_FREE_AGENT]: 'Free Agent',
							[ProductSubTypesEnum.LEAGUE_V2_INVITED_PLAYER]: 'Invited Player',
							[ProductSubTypesEnum.LEAGUE_V2_ORGANIZER]: 'Organizer',
							[ProductSubTypesEnum.LEAGUE_V2_PLAYER]: 'Player',
						},
						productSubTypeGroups: {
							team: 'Team',
							invite: 'Invite',
							individual: 'Individual',
						},
						productSubTypeGroupsConfig: [
							{
								label: 'team',
								options: [
									ProductSubTypesEnum.LEAGUE_V2_CAPTAIN,
									ProductSubTypesEnum.LEAGUE_V2_COACH,
									ProductSubTypesEnum.LEAGUE_V2_ORGANIZER,
								],
							},
							{
								label: 'invite',
								options: [ProductSubTypesEnum.LEAGUE_V2_INVITED_PLAYER],
							},
							{
								label: 'individual',
								options: [ProductSubTypesEnum.LEAGUE_V2_FREE_AGENT, ProductSubTypesEnum.LEAGUE_V2_PLAYER],
							},
						],
						quantityOptionLabel: (count: number, total: number, isEvent: boolean): string => {
							if (count === 1) {
								return isEvent ? '1 event' : '1 segment';
							}
							if (count === total) {
								return isEvent ? 'All events' : 'All segments';
							}
							return isEvent ? `${count} events` : `${count} segments`;
						},
						productSubTypeInfo: {
							[ProductSubTypesEnum.LEAGUE_V2_CAPTAIN]: 'Player who can create and purchase a team in registration.',
							[ProductSubTypesEnum.LEAGUE_V2_INVITED_PLAYER]:
								'Player invited to join a specific team. This product will always show on team invites.',
							[ProductSubTypesEnum.LEAGUE_V2_PLAYER]: 'Solo youth player who can register directly into the league.',
							[ProductSubTypesEnum.LEAGUE_V2_FREE_AGENT]:
								'Solo adult player who can register directly into the league.',
							[ProductSubTypesEnum.LEAGUE_V2_ORGANIZER]:
								'Organization or club rep registering a team on behalf of others.  Gender and age verification do not apply to this participant type.',
							[ProductSubTypesEnum.LEAGUE_V2_COACH]:
								'Adult registering and managing a youth team. Use when a coach oversees team creation. Gender and age verification do not apply to this participant type',
						},
					},
					folderedRegistrationSuccessModal: {
						title: 'Finish Registration Setup',
						descriptionStartBold: 'Groups organize teams and players',
						descriptionMiddle:
							' by Division, Age, Gender, or Level of Play. They can be set as open for registration or ',
						descriptionMiddleBold: 'invite-only',
						descriptionMiddleEnd: ' via link.',
						descriptionSecondLineStart: 'Create groups in the ',
						descriptionSecondLineBold: 'Participants tab',
						descriptionSecondLineEnd: ' to complete setup.',
						primaryButton: 'Create a Group',
						secondaryButton: 'Not Now',
					},
				},
				discountsAndPayments: {
					tooltip: 'Inactive discounts will not be applied to the product',
					groupInactiveNotice: (items: IOption[] = []): string =>
						`${items.map(item => item.label).join(', ')} ${items.length > 1 ? 'are' : 'is'} inactive`,
					discount: {
						title: 'Discount',
						info: 'Select multiple discounts from your list or create discounts in organization settings',
						isEarlyBird: 'Early Bird',
						isLateFee: 'Late Fee',
						earlyBirdStartDate: 'Start Date',
						earlyBirdEndDate: 'End Date',
						lateFeeStartDate: 'Start Date',
						lateFeeEndDate: 'End Date',
						addDiscount: 'Add Discount',
						sameDiscount: 'Same discount for all products',
						discountPrice: 'Discount Price',
						product: 'Product',
						discount: 'Discount',
						price: 'Amount',
						earlyBirdHelper: 'Early bird discounts subtract this amount or percent from the base price.',
						lateFeeHelper: 'Late fees add this amount or percent to the base price.',
						useDifferentDiscount: 'Different discount per product',
						byChecking: 'By checking the boxes above you will enable the discounts/fees options',
					},
					payments: {
						title: 'PAYMENTS',
						downPayment: 'Down Payment',
						downPaymentInfo: 'Select payment date or installment with due date',
						rollingPaymentPlanInfo:
							'Select this option for longer duration sessions where you want to start the payment plan a specific no. of months after the consumer registers',
						differentDeposit: 'Different down payment per product',
						minDeposit: 'Deposit Price',
						paymentPlan: 'Payment Plan',
						noPlan: 'No payment plan',
						rollingPlan: 'Rolling',
						customPlan: 'Custom',
						mustSetDownPaymentWithPlan: `please fill in the deposit before you continue`,
						depositCanNotBeMoreThanPrice: "deposit cannot be more than the product's price",
						downPaymentAndCustomPlanInfo:
							'The Deposit price for rolling payment plan and custom plan with percentage allocation will be the minimum amount. For custom plan with dollar allocation the deposit price will be fixed.',
						taxesTitle: 'Taxes',
					},
					remove: 'Remove',
					notAllMandatoryFieldsFilled: 'please fill in the field above before you continue',
					paymentPlan: {
						constants: {
							discountMethod: 'Discount method',
							currencyOptions: [
								{ value: DiscountMethodsEnum.AMOUNT, label: CurrencySymbolEnum.USD },
								{ value: DiscountMethodsEnum.PERCENT, label: CHARACHERS.PERCENT },
							],
							startsInMonths: [
								{ label: 'Immediate', value: '0' },
								{ label: '1 month', value: '1' },
								{ label: '2 months', value: '2' },
								{ label: '3 months', value: '3' },
								{ label: '4 months', value: '4' },
								{ label: '5 months', value: '5' },
								{ label: '6 months', value: '6' },
								{ label: '7 months', value: '7' },
								{ label: '8 months', value: '8' },
								{ label: '9 months', value: '9' },
								{ label: '10 months', value: '10' },
								{ label: '11 months', value: '11' },
								{ label: '12 months', value: '12' },
							],
							maxInstallments: [
								{ label: '1', value: '1' },
								{ label: '2', value: '2' },
								{ label: '3', value: '3' },
								{ label: '4', value: '4' },
								{ label: '5', value: '5' },
								{ label: '6', value: '6' },
								{ label: '7', value: '7' },
								{ label: '8', value: '8' },
								{ label: '9', value: '9' },
								{ label: '10', value: '10' },
								{ label: '11', value: '11' },
								{ label: '12', value: '12' },
								{ label: '13', value: '13' },
								{ label: '14', value: '14' },
								{ label: '15', value: '15' },
								{ label: '16', value: '16' },
								{ label: '17', value: '17' },
								{ label: '18', value: '18' },
								{ label: '19', value: '19' },
								{ label: '20', value: '20' },
							],
							dayOfMonth: [
								{ label: '1st', value: '1' },
								{ label: '2nd', value: '2' },
								{ label: '3rd', value: '3' },
								{ label: '4th', value: '4' },
								{ label: '5th', value: '5' },
								{ label: '6th', value: '6' },
								{ label: '7th', value: '7' },
								{ label: '8th', value: '8' },
								{ label: '9th', value: '9' },
								{ label: '10th', value: '10' },
								{ label: '11th', value: '11' },
								{ label: '12th', value: '12' },
								{ label: '13th', value: '13' },
								{ label: '14th', value: '14' },
								{ label: '15th', value: '15' },
								{ label: '16th', value: '16' },
								{ label: '17th', value: '17' },
								{ label: '18th', value: '18' },
								{ label: '19th', value: '19' },
								{ label: '20th', value: '20' },
								{ label: '21st', value: '21' },
								{ label: '22nd', value: '22' },
								{ label: '23rd', value: '23' },
								{ label: '24th', value: '24' },
								{ label: '25th', value: '25' },
								{ label: '26th', value: '26' },
								{ label: '27th', value: '27' },
								{ label: '28th', value: '28' },
								{ label: '29th', value: '29' },
								{ label: '30th', value: '30' },
								{ label: '31st', value: '31' },
							],
							placeHolder: 'Select...',
						},
						rolling: {
							noOfInstallments: 'No. of installments',
							info: 'Select this option for longer duration sessions where you want to start the payment plan a specific no. of months after the consumer registers',
							dayOfMonth: 'Payments will occur on',
							startsInMonths: 'Start date after purchase',
						},
						custom: {
							info: 'Select this option for shorter sessions / registrations where you want the payment plan to start on a fixed date',
							addInstallment: 'Add installment',
							paymentAllocation: 'Amount',
							paymentAllocationPlaceHolder: 'select amount...',
							selectPaymentDate: ' Payment Date',
							selectPaymentDatePlaceHolder: 'add date...',
							amountLeft: (percentage: number, price: number) => {
								const left: number = price - price * (percentage / 100);

								return `(${Math.abs(round(100 - percentage, 2))}%) $${Math.abs(round(left, 2))} ${
									left < 0 ? 'over' : 'left'
								}`;
							},
							selectOptions: [
								{ label: '%', value: CustomPaymentPlanAllocationEnum.PERCENT },
								{ label: '$', value: CustomPaymentPlanAllocationEnum.FIXED },
							],
						},
					},
				},
				addons: {
					title: 'Add Ons',
					select: 'Add Ons Name',
					timePeriod: 'Time period',
					remove: 'Remove',
					staleAddonWarning: 'Selected addon is not available for selected facilities.',
					staleAddonsError: 'Selected addons do not match selected facilities.',
					timePeriodTypes: {
						full: (isSessionHasSegments?: boolean) => (isSessionHasSegments ? 'All segments' : 'All events'),
						fullForFolderedRegistration: 'Per registration',
						session: 'Per segment',
						event: 'Per event',
					},
				},
			},
			addSpaceAllocation: {
				title: 'SELECT Allocation',
				selectResourceTitle: 'Select Resource Allocation',
				selectSchedule: 'Select Schedule',
				selectResource: 'Select Resource',
				addAllocation: 'Add Allocation',
				allEvents: 'All Events',
				allSegments: 'All Segments',
				remove: 'Remove',
				save: 'Save',
				cancel: 'Cancel',
				resourceAllocation: 'Resource Allocation',
				maintenance: 'Add Maintenance',
				minutes: 'Minutes',
				isMaintenanceAfter: 'Set maintenance after the event',
				isMaintenanceBefore: 'Set maintenance before the event',
				successModal: {
					title: 'Resource Reserved',
					description: 'The resource you selected for the schedule reserved',
					mainButton: 'Thanks',
					subButton: 'Cancel',
				},
			},
			taxable: {
				title: 'Tax',
				toggleLabel: 'Use Tax',
				inclusive: 'Inclusive',
				exclusive: 'Exclusive',
				taxType: 'Tax Type',
				taxPercent: 'Tax Percent',
			},
			duscountsSection: {
				percentageLabel: (percentage: number) => `${percentage}${CHARACHERS.PERCENT}`,
				activityStatusLabelMapper: {
					[ActivityEnum.ACTIVE]: '',
					[ActivityEnum.INACTIVE]: 'Inactive',
				},
			},
		},
		redeemPunchPass: {
			errors: {
				providerRequired: 'useRedeemPunchPassContext must be used within a RedeemPunchPassProvider',
			},
			selectPunchPassHolder: {
				title: 'Select Pass Holder',
				subtitle: 'Select the customer you want to redeem a punch pass for.',
				continue: 'CONTINUE',
				cancel: 'CANCEL',
				placeholder: 'Select',
				additionalInfo(items: string[]) {
					return items.length ? `${CHARACHERS.DASH} ${items.join(` ${CHARACHERS.DASH} `)}` : null;
				},
			},
			validateParticipant: {
				title: 'Registration Requirements Error',
				subtitle: (customerName: string) =>
					`${customerName} does not meet session registration requirements for the following reasons:`,
				redeemAnyway: 'REDEEM ANYWAY',
				cancel: 'CANCEL',
				errorsMap: {
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: 'Gender Requirement',
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: 'Age Requirement',
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: 'Registration Window',
				},
				errorsDescriptions: {
					[ParticipantRegistrationValidationEnum.AGE_VALIDATION]: (minAge: number, maxAge: number): string =>
						`${minAge ?? 'No Minimum'} - ${maxAge ?? 'No Maximum'}`,
					[ParticipantRegistrationValidationEnum.GENDER_VALIDATION]: (gender: GenderEnum): string =>
						`${GENDER_MAP[gender]} Only`,
					[ParticipantRegistrationValidationEnum.REGISTRATION_DATES_VALIDATION]: (
						startRegistrationDate: string,
						endRegistrationDate: string
					): string => {
						return `${formatDate(startRegistrationDate, EDateTimeFormats.DAY_FORMAT)} - ${formatDate(endRegistrationDate, EDateTimeFormats.DAY_FORMAT)}`;
					},
				},
			},
			selectPunchPass: {
				title: 'Select Punch Pass',
				subtitle: (name: string) => `${name} holds multiple passes. Select the pass to redeem from:`,
				continue: 'CONTINUE',
				cancel: 'CANCEL',
				subject: 'passes',
				noPunchesLeftTooltip: 'This pass has no punches left.',
				columns: {
					name: 'Name',
					purchased: 'Purchased',
					expired: 'Expired',
					punches: 'Punches',
					punchesRatio(current: number, total: number) {
						return `${current}/${total}`;
					},
				},
			},
			selectEvents: {
				title: 'Select Events',
				subject: 'events',
				onSuccess: (name: string, quantity: number, sessionName: string) =>
					`${name} redeemed ${quantity} events in ${sessionName}!`,
				subtitle: (
					name: string,
					durationQuantity?: number,
					durationWindow?: number,
					durationWindowUnit?: TimeUnit
				): string => {
					const durationString: string = durationWindow
						? `${durationWindow} ${durationWindowUnit}${durationWindow > 1 ? 's' : ''}`
						: '';

					return `Select the events you would like to redeem for ${name}. ${durationQuantity ? `This pass allows ${durationQuantity} punches to be redeemed within ${durationString}.` : ''}`;
				},
				columns: {
					name: 'Event',
					emptyName: CHARACHERS.DASH,
					date: 'Date',
					time: 'Time',
					space: 'Space',
					spots: 'Spots',
					spotsRatio(attendance: number, limit: number) {
						return `${attendance}/${limit}`;
					},
				},
				redeem: 'REDEEM',
				clear: 'CLEAR',
				punchesLeft: 'Punches left:',
			},
		},
		steps: {
			activities: 'Programs',
			passes: 'Program Passes',
			products: 'Products',
			type: {
				classes: 'classes',
				camps: 'camps',
				clinics: 'clinics',
				0: 'leagues', // ProgramTypeEnum.LEAGUE (Legacy)
				1: 'tournaments', // ProgramTypeEnum.TOURNAMENT (Legacy)
				2: 'classes',
				3: 'clinics',
				4: 'camps',
				5: 'private_lessons',
				6: 'club_teams',
				7: 'leagues',
				8: 'tournaments',
				9: 'events',
				10: 'leagues_v2',
				11: 'tournaments_v2',
				12: 'club_teams_v2',
			},
			typeSingle: {
				0: 'League (Legacy)', // ProgramTypeEnum.LEAGUE
				1: 'Tournament (Legacy)', // ProgramTypeEnum.TOURNAMENT
				2: 'Class',
				3: 'Clinic',
				4: 'Camp',
				5: 'Private Lesson',
				6: 'Club Team (Legacy)', // ProgramTypeEnum.CLUB_TEAM
				7: 'League (Legacy)', // ProgramTypeEnum.PRO_LEAGUE - treated same as LEAGUE
				8: 'Tournament (Legacy)', // No longer in enum, kept for backwards compatibility
				9: 'Event',
				10: 'League',
				11: 'Tournament',
				12: 'Club Team',
			},
			typePlural: {
				0: 'Leagues (Legacy)', // ProgramTypeEnum.LEAGUE
				1: 'Tournaments (Legacy)', // ProgramTypeEnum.TOURNAMENT
				2: 'Classes',
				3: 'Clinics',
				4: 'Camps',
				5: 'Private Lessons',
				6: 'Club Teams (Legacy)', // ProgramTypeEnum.CLUB_TEAM
				7: 'Leagues (Legacy)', // ProgramTypeEnum.PRO_LEAGUE - treated same as LEAGUE
				8: 'Tournaments (Legacy)', // No longer in enum, kept for backwards compatibility
				9: 'Events',
				10: 'Leagues',
				11: 'Tournaments',
				12: 'Club Teams',
			},
			fallbacks: {
				program: 'Program',
				session: 'Session',
			},
			addNewSeason: 'Add New Session',
			editRegistrationDates: 'Edit Registration Date',
			editSeasonDateAndTimes: 'Edit Season Date & Times',
			createNewProgram: 'Create new program',
			addSpaceAllocation: 'Add Space Allocation',
		},
		attendance: {
			attendance: 'Attending',
			checkId: 'Checked In',
			missingPayments: 'Missing payments',
			spaces: 'Spaces',
			showMore: 'Show more',
			showLess: 'Show less',
			seeLess: 'See less',
			seeAll: 'See all',
			undo: 'Undo',
			checkIn: 'Check in',
			processing: 'Processing...',
			eventCheckinSuccess(eventName: string, userName: string) {
				return `${userName} has been checked-in to ${eventName}`;
			},
			eventUndoCheckinSuccess(eventName: string, userName: string) {
				return `${userName} is no longer checked-in to ${eventName}`;
			},
		},
	},
	calendar: {
		facilityMismatchToast: (isBooking: boolean) =>
			`This ${isBooking ? 'booking' : 'event'} is not associated with the facility you're currently viewing.`,
		fullscreenBack: 'Back to session dashboard',
		slotWrapper: { moreOptions: { duplicate: 'duplicate', delete: 'Delete Event' } },
		header: {
			title: 'Calendar',
			newBooking: 'New Reservation',
		},
		title: 'Calendar',
		printButton: 'Print Calendar',
		newBookingButton: 'New Reservation',
		calendarViews: {
			[ECalendarMode.DAILY]: 'Daily',
			[ECalendarMode.WEEKLY]: 'Weekly',
			[ECalendarMode.MONTHLY]: 'Monthly',
			[ECalendarMode.DAYX]: 'Resource',
		},
		filters: {
			title: 'Filters',
			spaces: 'Spaces',
			instructors: 'Instructors',
			activities: 'Activities',
			resourceType: 'Resource Type',
			today: 'Today',
			currentMonth: 'Current Month',
			currentWeek: 'Current Week',
			savedViews: {
				searchPlaceholder: 'Search',
				noOptions: 'No saved views...',
				tags: {
					[FilterGroupEnum.CUSTOM]: 'Custom',
					[FilterGroupEnum.ORGANIZATION]: 'Org',
					[FilterGroupEnum.SYSTEM]: 'System',
				},
			},
			filterSideMenu: {
				title: 'CALENDAR FILTERS',
				tabs: {
					filters: 'Filters',
					savedViews: 'Saved Views',
				},
				editFilterTitle: 'EDIT FILTERED VIEW',
				filterForm: {
					savePopup: {
						title: 'Save Filter',
						description: 'Create a name for your new filter:',
						primaryButton: 'SAVE & APPLY',
						secondaryButton: 'CANCEL',
						placeholder: 'Type here',
						checkboxDescription: {
							primary: 'Make filter default view',
							secondary: 'Specific to this user',
						},
					},
					buttons: {
						save: 'SAVE VIEW',
						apply: 'APPLY',
						clear: 'Clear',
					},
					placeholder: 'Search',
					activities: {
						title: 'Activities',
						tooltip: 'Select activities to filter available spaces and instructors.',
					},
					spaces: {
						title: 'Spaces',
						selectAll: 'All Spaces',
						tooltip: 'Includes all spaces that match the activities selected – now and in the future.',
					},
					instructors: {
						title: 'Instructors',
						selectAll: 'All Instructors',
						tooltip: 'Includes all instructors assigned to the activities selected – now and in the future.',
					},
					additionalInfo: {
						subLine: memoize((resource: any) => {
							if (resource.resourceType === ResourceTypeEnum.SPACE) {
								return `${resource.numberOfChildren} sub-spaces`;
							}

							return resource.sports.map((sport: SportsEnum) => SPORTS_MAP[sport]).join(', ');
						}),
						resourceType: (resource: any) => {
							if (resource.resourceType === ResourceTypeEnum.SPACE) {
								return capitalize(SPACE_SUB_RESOURCE_TYPE_MAP[resource.resourceSubType]);
							}

							return resource.status === ActivityEnum.INACTIVE ? capitalize(resource.status) : '';
						},
					},
					mobileColumns: {
						title: 'Resources per screen',
						description: 'How many resources this view shows side by side on a phone',
						option: (count: number) => String(count),
					},
					selectedCount: (count: number = 0) => `${count} Selected`,
					onSuccess: (name: string) => `${name} has been created!`,
				},
				editFilterForm: {
					success: (name: string) => `${name} has been updated!`,
					footerButtons: {
						cancel: 'Cancel',
						save: 'SAVE',
					},
				},
				savedViews: {
					placeholder: 'Search',
					filterActions: {
						setDefault: 'Make Default View',
						edit: 'Edit View',
						delete: 'Delete View',
					},
					footerButtons: {
						apply: 'APPLY',
						default: 'Go to default view',
					},
					collapsableTitle: 'Saved Views',
					deleteModal: {
						title: 'Delete Filtered View',
						description: 'Are you sure you want to delete this view? You will not be able to undo this action.',
						cancelButton: 'CANCEL',
						deleteButton: 'YES, DELETE',
					},
					onDeleteSuccess: (name: string) => `${name} has been deleted!`,
					onUpdateSuccess: (name: string) => `${name} has been updated!`,
				},
			},
		},
		errors: {
			noPermissions:
				'You do not have permission to perform this action. Please contact your organization administrator to request access.',
			eventUpdate: 'The event could not be updated. Please try again or refresh the calendar.',
			failedToFetchCalendar: 'We were unable to load the calendar. Please try again.',
		},
		notifications: {
			eventUpdated: 'Event updated successfully',
		},
		duplicateSlot: { title: 'Duplicate Slot' },
		editEvent: 'Edit Event',
		editProgramEvent: 'Edit Program Event',
		mobile: {
			views: {
				label: 'Calendar view',
				day: 'Day',
				timeline: 'Timeline',
				agenda: 'Agenda',
			},
			previousDay: 'Previous day',
			nextDay: 'Next day',
			resourcePager: {
				label: (page: number, count: number) => `${page} / ${count}`,
				previous: 'Previous resources',
				next: 'Next resources',
			},
			agenda: {
				filters: {
					all: 'All',
					rentals: 'Rentals',
					internal: 'Internal',
					programs: 'Programs',
					unpaid: 'Unpaid',
					conflicts: 'Conflicts',
				},
				filtersLabel: 'Event filters',
				tags: {
					customer: 'Customer',
					punchPass: 'Punch pass',
					program: 'Program',
					internal: 'Internal',
					maintenance: 'Maintenance',
					paid: 'Paid',
					unpaid: 'Unpaid',
					partiallyPaid: 'Partially Paid',
					refunded: 'Refunded',
					voided: 'Voided',
					pendingApproval: 'Pending approval',
				},
				empty: 'No events on this day',
				noMatches: 'No events match this filter',
				unknownResource: 'Unknown resource',
			},
		},
		dayRangeOptions: [
			{ label: '1 Day', value: 1 },
			{ label: '2 Days', value: 2 },
			{ label: '3 Days', value: 3 },
			{ label: '4 Days', value: 4 },
			{ label: '5 Days', value: 5 },
			{ label: '6 Days', value: 6 },
			{ label: '7 Days', value: 7 },
		],
		viewControls: {
			title: 'Calendar view',
			settings: 'Calendar view settings',
			hours: 'Hours',
			resources: 'Resources',
			gridlines: 'Gridlines',
			gridIncrements: 'Grid increments',
			gridLineLabels: {
				0: 'None',
				5: '5 min',
				15: '15 min',
				30: '30 min',
				45: '45 min',
				60: '1 hr',
			},
			gridIncrementLabels: {
				5: '5 min',
				10: '10 min',
				15: '15 min',
				30: '30 min',
				45: '45 min',
				60: '1 hr',
			},
		},
	},
	season: {
		dashboard: {
			editButton: 'Edit Session',
			seasonDetails: {
				title: 'session details',
				viewMore: 'View more',
			},
			participants: {
				title: 'participants',
				register: 'Participants registered',
				checkedIn: 'Participants checked in',
				checkInButton: 'Check in',
			},
			SeasonDateTime: {
				title: 'session date & time',
				dates: 'dates',
				days: 'days',
			},
			registrationDateTitle: 'session registration date',
			extraDetails: {
				maxMembers: 'Max Members',
				age: 'age',
				gender: 'gender',
			},
			seasonPackage: {
				title: 'Session Package',
				earlyBird: 'Early Bird',
				availableUntil: 'Available Until',
				price: 'Price',
				lateRegistrationPrice: 'Late registration price',
				discount: 'Discount',
				select: 'Select',
			},
			seasonSchedule: {
				title: 'SESSION SCHEDULE',
				eventTimeRange: (days: string, startTime: string, endTime: string) => `${days}, ${startTime} - ${endTime}`,
				eventTimeRangeWithDuration: (days: string, startTime: string, endTime: string, duration: string) =>
					`${days}, ${startTime} - ${endTime} ( ${duration})`,
				tabsName: {
					events: 'Events',
					segments: 'Segments',
				},
				segments: {
					scheduleTitle: 'Segments Schedule',
					table: {
						subject: 'Segments',
						name: 'Name',
						dates: 'Session dates',
						activityTimes: 'Activity Times',
						tag: 'Tag',
						registered: 'Registered',
						waitlist: 'Waitlist',
						edit: 'Edit Segment',
						viewWaitlist: 'View Waitlist',
						deleteEmpty: 'Delete Segment',
						add: 'Add Segment',
						addSuccess: 'Segment added',
						deleteSuccess: 'Segment deleted',
						waitlistEnabled: (value: boolean, waitlistEntriesCount: number) =>
							value || waitlistEntriesCount ? `${waitlistEntriesCount} Waitlisted` : `No Waitlist`,
					},
					addDialog: {
						title: 'Add segment',
						name: 'Segment name',
						startDate: 'Start date',
						endDate: 'End date',
						capacitySection: 'Capacity & Waitlist',
						scheduleSection: 'Dates and activity times',
						isOverridden: 'Override session capacity configuration',
						maxParticipants: 'Max number of participants',
						isWaitlistEnabled: 'Enable participant waitlist',
						isDisplayRemainingSpots: 'Display remaining spots to customers',
						warning:
							'All-segment products will include this segment at the current price. Existing registrants are not added.',
						submit: 'ADD SEGMENT',
						cancel: 'CANCEL',
					},
					deleteDialog: {
						title: (name: string) => `Delete "${name}"?`,
						description:
							"This will permanently delete the segment, including any events and waitlist entries. Session products won't change, but all-segment products will no longer include this segment. This can't be undone.",
						confirm: 'Delete segment',
						cancel: 'Cancel',
					},
					occupiedDeleteTooltip: 'This segment cannot be deleted because it has active registrations.',
					lastSegmentDeleteTooltip: 'The last remaining segment cannot be deleted.',
					addEvents: 'Add Events',
				},
				subject: 'Events',
				action: 'Action',
				tableEmptyState: 'No events found.\nPlease select other dates or create an event.',
				loadingMessage: 'Loading',
				tabs: {
					events: 'Events',
					segments: 'Segments',
				},
				ariaLabels: {
					tabList: 'Schedule navigation',
					tab: 'Schedule tab',
					tabPanel: 'Schedule content',
					treeControls: 'Tree controls',
				},
				actions: {
					edit: 'Edit Event',
					editMultipleEvents: 'Edit Events',
					delete: 'Delete Event',
					deleteMultipleEvents: 'Delete Events',
					duplicate: 'Duplicate Event',
					addEvent: 'Add Event',
					analyzeSchedule: 'Analyze Schedule',
					filterEvents: 'Filter Events',
					futureEvents: 'Future Events',
					pastEvents: 'Past Events',
					notify: 'Message Attendees',
				},
				analysis: {
					title: 'Schedule Analysis',
					subtitle: (gamesCount: number, teamsCount: number) =>
						`${gamesCount} analyzed game${gamesCount === 1 ? '' : 's'} across ${teamsCount} team${teamsCount === 1 ? '' : 's'}`,
					tabs: {
						overview: 'Overview',
						matchups: 'Matchups',
						timeSlots: 'Time Slots',
						byeWeeks: 'Bye Weeks',
						days: 'Days',
					},
					matchups: {
						eventTitle: 'Analysis Matchup',
					},
					overview: {
						missingMatchups: 'Missing Matchups',
					},
					common: {
						passed: 'Passed',
						failed: 'Failed',
						formatPercentage(value: number) {
							return `${Math.round(value)}%`;
						},
					},
					toasts: {
						noData: 'No schedule data found for this season. Please generate schedule first.',
						fetchError: 'Failed to analyze schedule. Please try again.',
					},
				},
				addEventForm: {
					leftWindowTitle: 'Add Event',
					segment: 'Segment',
					segmentPlaceholder: 'Select a segment',
					segmentHint: 'Choose a segment first. Events cannot be added until one is selected.',
					copyParticipantsToggle: 'Copy registered attendees onto the new events',
					copyParticipantsWarning:
						'This segment has registered attendees. Saving will copy them onto the new events.',
					successToast: 'Events added successfully',
					addAnotherEvent: 'Add Another Event',
					addEvents: 'ADD EVENTS',
					save: 'SAVE',
					cancel: 'CANCEL',
					editEvent: 'EDIT',
					eventCardIndex(current: number, total: number) {
						return `${current}/${total}`;
					},
					toolTipContent: 'Please save each event first',
					discardPopUp: {
						title: 'Discard events',
						description: 'Are you sure you want to discard your changes?',
						mainAction: 'DISCARD',
						cancel: 'CANCEL',
					},
				},
				deleteEventPopup: {
					title: 'Delete event',
					deleteEventWithoutProductsWarning: (count: number): string =>
						`Are you sure you want to delete ${count} event${count === 1 ? '' : 's'}? This can't be undone.`,
					deleteEventWithProductsWarning: (count: number): string =>
						`Are you sure you want to delete ${count} event${count === 1 ? '' : 's'}? This can't be undone. Any products connected to ${
							count === 1 ? 'this event' : 'these events'
						} will be automatically updated.`,
					unableToDeleteWithProducts: (count: number): string =>
						`The selected event${count === 1 ? '' : 's'} could not be deleted because of connected products.`,
					unableToDelete: (count: number): string =>
						`The selected event${count === 1 ? '' : 's'} cannot be deleted because of registered participants. To delete the selected event${
							count === 1 ? '' : 's'
						}, move the participants to other events.`,
					someEventsNotDeleted:
						'Some events could not be deleted because they have registered participants. To delete these events, move or remove the participants first.',
					thanks: 'OK, THANKS',
					cancel: 'CANCEL',
					delete: 'DELETE',
					notificationPopup: 'Events Deleted Successfully',
					errorNotificationPopup: 'Some events could not be deleted. Please try again or refresh the page.',
				},
				filter: 'Filter',
				inputPlaceholder: 'Search by Name, Date',
				editSessionTitle: 'Edit Session',
				toolTipContent:
					'This session cannot be edited because it has sold products. To make changes, manage the existing products first.',
				table: {
					name: 'Event Name',
					segment: 'Segment',
					date: 'Date',
					time: 'Time',
					dateTime: 'Date & Time',
					space: 'Space',
					resource: 'Resource',
					teams: 'Teams',
					eventType: 'Event Type',
					homeTeam: 'Home Team',
					awayTeam: 'Away Team',
					teamCellSubtext: (parts: string[]) => parts.join(' - '),
					attending: 'Attending',
					status: 'Status',
					more: 'more',
					editTooltip:
						'Single-event editing is not available while multiple events are selected. Deselect all but one to edit individually.',
					deleteIconToolTip:
						'Single-event deletion is not available while multiple events are selected. Use the bulk delete action instead.',
					conflict: 'Conflict',
					notes: 'Notes',
					waitlistView: 'Waitlist',
					noWaitlist: 'No waitlist',
					noSpace: 'None',
					hasPublicNote: 'Has Public Note',
					hasPrivateNote: 'Has Private Note',
					dayOfWeek: 'Day of Week',
					overnightIndicator: (daysDifference: number) => `+${daysDifference}`,
					overnightIndicatorAriaLabel: (daysDifference: number) =>
						`Overnight event spanning ${daysDifference} ${daysDifference === 1 ? 'day' : 'days'}`,
					additionalSpacesCount(count: number) {
						return `+${count} ${this.more}`;
					},
					attendingCount(count: number) {
						return `${count} ${this.attending}`;
					},
				},
				row: {
					moreMenuOptions: {
						edit: 'Edit Event',
						delete: 'Delete Event',
						notify: 'Message Attendees',
						view_waitlist: 'View Waitlist',
					},
				},
				editSession: {
					title: 'SESSION SCHEDULE',
					save: 'SAVE',
					notificationMessage: 'Schedule updated successfully',
					notificationErrorMessage: 'The schedule could not be saved. Please check your changes and try again.',
					warning: {
						title: 'Create new Products',
						firstSubTitle: 'Please note that this session have already products.',
						secondSubTitle: 'In order to edit the schedule you will need to recreate them.',
						description() {
							return `${this.firstSubTitle} ${this.secondSubTitle}`;
						},
						approve: 'APPROVE',
						cancel: 'CANCEL',
					},
					error: {
						title: 'We could not save changes to this session. Please review your inputs and try again.',
						thanks: 'THANKS',
					},
					editColorModal: {
						title: 'Edit session color',
						description:
							'This session may have different color set for some events. Do you want to change the color set for all the events ?',
						mainButton: 'Change all',
						subButton: 'Change only future events',
						successMessage: 'Color changed successfully',
						errorMessage: 'The color could not be updated for this session. Please try again.',
					},
				},
			},
			scheduledPopover: {
				schedule: 'schedule',
				maxEventsForProduct: (quantity: number) =>
					`You may only select a maximum of ${quantity} ${quantity === 1 ? 'event' : 'events'} when purchasing this product`,
				selectFor: 'Select schedule for',
				labelsActivity: 'sessions activity.',
				price: 'Price',
				selectCustomer: 'Select Customer',
				searchByName: 'Search by name or account',
				add: 'Add',
				date: 'Date',
				time: 'Time',
				resource: 'Resource',
			},
		},
		participants: {
			back: 'BACK',
			select: 'SELECT',
			cancel: 'CANCEL',
			thanks: 'THANKS',
			loadMore: 'LOAD MORE',
			newGroupBtn: 'Create new group',
			ageTag: 'Age',
			registerSuccessNotification: 'Schedule updated successfully',
			details: {
				noEmailAddress: 'No email address available',
			},
			placeHolders: {
				search: 'Search by name, email',
				actionsSelect: 'Actions to select',
				filterSelect: 'Filter',
			},
			moreButton: {
				view: 'View customer details',
				register: 'Register to event',
				moveSessions: 'Move to other sessions',
				moveSegments: 'Move to other segments',
				moveEvents: 'Move to other events',
				remove: 'Remove participant',
				add: 'Add to group',
			},
			noResourcesAvailable: {
				noSessionAvailable: {
					title: 'No Sessions available',
					subTitle: 'There are no additional sessions in the program.',
				},
				noSegmentsAvailable: {
					title: 'No segments available',
					subTitle: 'There are no additional segments in the session.',
				},
				noEventsAvailable: {
					title: 'No events available',
					subTitle: 'The participant is registered to all of the events.',
				},
			},

			createFacility: {
				title: 'Create Facility Profile',
				editTitle: 'Edit Facility Profile',
				editSuccessMessage: 'Facility profile updated successfully',
				tabs: {
					mainDetails: 'Main Details',
					images: 'Images',
					openingHours: 'Opening Hours',
					activityOffered: 'Activity Offered',
					amenities: 'Amenities',
					resources: 'Resources',
				},
			},
			userCardPopup: {
				viewCard: 'View card',
				invoice: 'Invoice',
				receipt: 'Receipt',
				notAvailable: 'n/a',
				priceWithAmount(amount: string) {
					return `$ ${amount}`;
				},
				body: {
					registration: 'Registration Date',
					product: 'Product Purchase',
					schedule: 'Schedule',
					addons: 'Add-Ons',
					applications: 'Application',
					price: 'Price',
					paymentAmount: 'Payment Amount',
					paymentMethod: 'Payment Method',
					seeAll: 'See All',
					seeLess: 'See Less',
					openCard: 'Open Card',
				},
				unknownPrice: 'Unknown',
			},
			moveParticipant: {
				common: {
					movedSuccessfully: {
						title: 'Participant Moved Successfully',
						thanks: 'Thanks',
						proRatedWarning:
							"Please notice that this customer has purchased a ProRated Product, therefore it is possible that he didn't pay the full price of a full session",
					},
				},
				moveParticipantToSegmentCard: {
					body: {
						title: 'Select Schedule',
						subTitle: 'Please select the segment you want to move the participant from',
						noSegmentsAvailable: 'No segments available.',
						successSubTitle: 'Participant moved between segments.',
					},
				},
				moveParticipantToEventCard: {
					body: {
						moveFromTitle: 'Move From',
						moveFromSubtitle: 'Select the event(s) you would like to move the participant from',
						moveToTitle: 'Move To',
						moveToSubtitle: 'Now choose the event(s) you would like to add the participant to',
						noRegisteredEvents: 'This participant is not registered to any events',
						untitledEvent: 'Untitled event',
						eventSchedule: (date: string, time: string) => `${date} ${time}`,
						namedEvent: (name: string, schedule: string) => `${name} - ${schedule}`,
						joinEventNames: (names: string[]) => names.join(', '),
						successModal: {
							subTitle: 'Participant moved between events.',
							movedBetween: (fromEvents: string, toEvents: string) =>
								`Participant moved from ${fromEvents} to ${toEvents}.`,
						},
					},
				},
				moveParticipantToSessionCard: {
					body: {
						resourcesSelection: {
							title: 'Select Schedule',
							subTitle: 'Please select the schedule you want to move the participant to',
							error: 'Please select a resource before continuing.',
							resources: 'resources',
							successfulMove: {
								title: 'Participant moved Successfully to:',
							},
						},
						sessionSelection: {
							title: 'Select Session',
							subTitle: 'Please select the session you want to move the participant from',
							noSessionSelected: 'Please select a session.',
						},
						productSelection: {
							title: 'Select Product',
							subTitle: 'Please select the product you want to move the participant to',
							noProductSelected: 'Please select a product.',
							errorTitle: 'No products available',
							errorDescription: "There's no products for this session.",
						},
						noSessionsAvailable: {
							title: "Participant can't be moved",
							subTitle:
								'This participant cannot be moved because there is only one session in this program. To move this participant, create an additional session in the program first.',
						},
						movedSuccessfully: {
							title: 'Participant Moved Successfully',
							subTitle: 'The participants moved to another session successfully',
							session: 'SESSION',
						},
					},
				},
				removeParticipantsCard: {
					success: 'Participant removed Successfully',
					error: 'We could not remove this participant. Please try again or refresh the page.',
					header: {
						title: 'Remove Participant',
						desc: 'Please select where you would like to remove the participant from',
					},
					options: {
						events: 'Events',
						segments: 'Segments',
						session: 'Session',
					},
					body: {
						removeSession: 'This participant will be removed from this session and all their future events.',
						noEvents: 'The participant is not registered to any events.',
						noSegments: 'The participant is not registered to any segments.',
						eventsTables: {
							columns: {
								date: 'Date',
								time: 'Time',
								resources: 'Resources',
							},
						},
					},
					footer: {
						mainRemove: 'REMOVE',
						secondaryRemove: 'REMOVE & REFUND',
					},
				},
				resources: {
					title: 'Resources',
					resourcesSelect: {
						label: 'Attached',
						placeHolder: 'Select resources',
						info: 'If the resources is not yet established in the system, you will be able to set this later from the resource / facility settings page',
					},
				},
				success: {
					title: 'Facility Profile Created!',
					description: 'You’ve successfully created your facility profile',
					firstFacilityDescription: 'You’ve successfully created your first facility profile',
					whatsNext: 'what’s next?',
					mainButton: 'create resource',
					subButton: 'I’m done for now',
					notification: 'Facility profile created successfully',
				},
			},
			editOrganizationProfile: {
				title: 'Edit Organization Details',
				successMessage: 'Organization profile updated successfully',
			},
			editMaimDetails: {
				title: 'Edit Facility Main Details',
				successMessage: 'Facility main details updated successfully',
			},
			editActivities: {
				title: 'Edit Facility Activities',
				successMessage: 'Facility activities updated successfully',
			},
			editAmenities: {
				title: 'Edit Facility Amenities',
				successMessage: 'Facility amenities updated successfully',
			},
			editOpeningHours: {
				title: 'Edit Facility Opening Hours',
				successMessage: 'Facility opening hours updated successfully',
			},
			editImages: {
				title: 'Edit Facility Images',
				successMessage: 'Facility Images updated successfully',
			},
			registerPopup: {
				submit: 'Select Event',
				schedule: 'Schedule',
				selectSchedule: 'Select customer schedule',
				noPasses: 'does not have any more punch passes to redeem',
				columnLabels: {
					resource: 'Resource',
					date: 'Date',
					time: 'time',
					more: 'more',
					status: 'Status',
					registered: 'Registered',
					apply: 'Apply',
				},
			},
		},
		folders: {
			createGroup: {
				title: 'Group Profile',
				description: 'Create a new group',
				participants: {
					label: 'Participants',
					to: '/tab/participants',
				},
				breadcrumbs: [
					{
						label: 'Create Group',
						to: '/group/details',
					},
				],
				tooltips: {
					groupType: 'Label for the group (e.g. Division, Team, Age Group, Level)',
				},
				header: {
					publish: 'Publish',
					addResource: 'Add resource',
					openWebsite: 'Open Website',
					published: 'Published',
					unpublished: 'Unpublish session',
					back: 'Back',
					title: 'Group Profile',
					messages: {
						createSuccessMessage: (name: string) => `${name} group created!`,
						editSuccessMessage: (name: string) => `${name} group updated!`,
						published: 'Session published successfully',
						unpublished: 'Session unpublished successfully',
					},
				},
				createSuccessMessage: (name: string, participants: number) =>
					`${name} ${participants ? `created and ${participants} participants were added!` : 'group created!'}`,
				editSuccessMessage: (name: string) => `${name} group updated!`,
				mainDetails: {
					title: 'Main Details',
					name: 'Group Name',
					type: 'Group Type',
					parentGroup: 'Parent Group',
					registrationAccess: {
						name: 'Registration Access',
						open: 'Open',
						inviteLinkOnly: 'Invite Link Only',
						tooltip:
							'Open groups will show in consumer registration.  Invite Link only groups will be hidden unless coming from an invite link.',
					},
					logo: 'Group Logo',
					groupLogo: {
						label: 'Group Logo',
						defaultAlt: 'group',
					},
					dropzone: 'Browse or Take a Photo',
					about: 'About Group',
					resetGroup: {
						button: 'Reset Group to Default',
						confirmation: {
							dialog: {
								title: 'Reset Group to Default',
								message:
									'Are you sure you want to reset this group to its default settings? This will restore the default name, type, parent group, and logo, and any custom changes will be lost.',
								confirmButtonText: 'RESET',
							},
							onSuccessMessage: 'Group has been reset to default successfully!',
						},
					},
				},
				restrictions: {
					title: 'Restrictions',
					infoText: 'Restrictions do not apply to non-players like coaches and organizers.',
					sections: {
						genderRestrictions: 'Gender',
						ageRestrictions: 'Age',
						noAgeRestriction: 'None',
						restrictAgeAtRegistration: 'Restrict age at time of registration',
						restrictBirthdate: 'Restrict by date of birth',
						capacity: 'Capacity',
					},
					toggles: {
						restrictPlayerGender: 'Restrict player gender',
						restrictByGender: 'Restrict by gender',
					},
					fields: {
						allowedGenders: 'Select Allowed Genders',
						minAge: 'Min Age (years)',
						maxAge: 'Max Age (years)',
						bornOnOrAfter: 'Born on or after',
						bornOnOrBefore: 'Born on or before',
						maxSubfolders: 'Max Subfolders',
						maxUsers: 'Max Users',
					},
					placeholders: {
						minAge: 'Min age',
						maxAge: 'Max age',
						bornOnOrAfter: 'mm/dd/yyyy',
						bornOnOrBefore: 'mm/dd/yyyy',
						maxSubfolders: 'Max subfolders',
						maxUsers: 'Max users',
					},
					capacity: {
						teams: {
							toggle: 'Teams',
							description: '(Limit a number of teams who can register to this group)',
							maxTeams: 'Max Number of Teams',
							maxPlayersPerTeam: 'Max Number of Players Per Team',
						},
						individuals: {
							toggle: 'Individuals',
							description: '(Limit a number of individual players who can register to this group)',
							descriptionNonLeague: '(Limit the number of individuals who can register to this group)',
							maxPlayers: 'Max Number of Players',
							maxIndividuals: 'Max Number of Individuals',
						},
					},
				},
				utils: {
					duplicateGroup: {
						duplicateDefaultName: (name: string) => `Copy - ${name}`,
					},
					categoryFormat: (category: string) => `- ${category}`,
				},
			},
		},
		sessionParticipants: {
			participants: {
				noDataProps: {
					labels: {
						title: 'There are no participants here!',
						description: 'Start adding your participants',
					},
				},
				removeSessionParticipant: {
					title: `Remove Participant`,
					descriptionWithKnownInvoice: (name: string): string =>
						`${name} will be removed from the session.\nIf you choose to refund, you will be directed to the connected invoice to process a refund.`,
					descriptionWithUnkownInvoice: (name: string): string =>
						`${name} will be removed from the session.\nIf you choose to refund, you will be directed to ${name}'s invoice page to refund all of the related invoices.`,
					descriptionWithPunchCard: (name: string): string =>
						`${name} will be removed from the session and their punch passes will be returned. You can process a refund through the connected invoice.\n\nTo remove from a specific event instead, cancel and use "Remove from Event".`,
					primaryButton: 'Remove & Refund',
					secondaryButton: 'Remove',
					tertiaryButton: 'cancel',
					success: 'Participant has been successfully removed from session!',
					error: 'We could not remove this participant. Please try again or refresh the page.',
				},
				removeParticipantRegistration: {
					title: `Remove Registration`,
					description: (name: string): string =>
						`${name} will have this registration removed.\nIf you choose to refund, you will be directed to the connected invoice to process a refund.`,
					primaryButton: 'Remove & Refund',
					secondaryButton: 'Remove',
					tertiaryButton: 'cancel',
					success: 'Registration has been successfully removed!',
					error: 'Failed to remove registration',
				},
				removeEventsParticipant: {
					title: `Remove Participant`,
					descriptionWithKnownInvoice: (name: string): string =>
						`Select the events you would like to remove ${name} from.\nIf you choose to refund, you will be directed to the connected invoice to process a refund.`,
					descriptionWithUnkownInvoice: (name: string): string =>
						`Select the events you would like to remove ${name} from.\nIf you choose to refund, you will be directed to ${name}'s invoice page to refund all of the related invoices.`,
					primaryButton: 'Remove & Refund',
					secondaryButton: 'Remove',
					success: 'Participant has been successfully removed from events!',
					error: 'We could not remove this participant. Please try again or refresh the page.',
					table: {
						subject: 'events',
						loadingMessage: 'Loading Events...',
						noDataMessage: 'No Events Available',
						errorMessage: 'Failed to load events. Please try again.',
						columns: {
							date: 'Date',
							time: 'Time',
							space: 'Space',
						},
						timeRange(startTime: string, endTime: string) {
							return `${startTime} ${CHARACHERS.DASH} ${endTime}`;
						},
						spaceList(resourceNames: string[]) {
							return resourceNames.join(`${CHARACHERS.COMMA} `);
						},
					},
				},
				removeSegmentsParticipant: {
					title: `Remove Participant`,
					descriptionWithKnownInvoice: (name: string): string =>
						`Select the segments you would like to remove ${name} from.\nIf you choose to refund, you will be directed to the connected invoice to process a refund.`,
					descriptionWithUnkownInvoice: (name: string): string =>
						`Select the segments you would like to remove ${name} from.\nIf you choose to refund, you will be directed to ${name}'s invoice page to refund all of the related invoices.`,
					primaryButton: 'Remove & Refund',
					secondaryButton: 'Remove',
					success: 'Participant has been successfully removed from events!',
					error: 'We could not remove this participant. Please try again or refresh the page.',
					table: {
						subject: 'segments',
						loadingMessage: 'Loading Segments...',
						noDataMessage: 'No Segments Available',
						errorMessage: 'Failed to load segments. Please try again.',
						columns: {
							name: 'Name',
							dates: 'Session dates',
						},
						dateRange(startDate: string, endDate: string) {
							return `${startDate} ${CHARACHERS.DASH} ${endDate}`;
						},
					},
				},
				registerParticipant: {
					missingPunchPasses: (name: string = 'Participant'): string =>
						`${name} does not have any punch passes products`,
					registerSuccessNotification: 'Schedule updated successfully',

					title: (name: string) => `Redeem Punches from ${name}`,
					description: {
						noPasses: (name: string): string => `${name} does not have any more punch passes to redeem`,
						remainingPasses: (name: string, remainingPasses: number, totalPasses: number): string =>
							`${name} has ${remainingPasses}/${totalPasses} left`,
						exceededPasses: (name: string, remainingPasses: number, totalPasses: number): string =>
							`${name} has exceeded the available passes.\nRemaining: ${remainingPasses}/${totalPasses}`,
					},
					primaryButton: 'Select Events',
					secondaryButton: 'cancel',
					success: 'Participant has been successfully registered for events.',
					error: 'Failed to register participant. Please try again.',
					table: {
						subject: 'events',
						loadingMessage: 'Loading Events...',
						noDataMessage: 'No Events Available',
						errorMessage: 'Failed to load events. Please try again.',
						columns: {
							date: 'Date',
							time: 'Time',
							space: 'Space',
							status: 'Status',
						},
						filters: {
							categories: {
								date: {
									title: 'Range Date',
									options: { Future: 'Future Events', Past: 'Past Event' },
								},
								// facility: {
								// 	title: 'FACILITIES',
								// }
								// role: 'ROLES',
							},
						},
					},
				},
				viewParticipant: {
					dialogAriaLabel: 'Participant Details',
					header: {
						ariaLabelGoToProfile: (name: string): string => `Go to ${name} Profile`,
						ariaLabelGoToSessionDashboard: (name: string): string => `Go to ${name} the session dashboard`,
					},
					invoices: {
						linkListName: 'Invoices',
						ariaLabel: (id: number): string => `Go To invoice datail number ${id}`,
					},
					questionnaires: {
						copyAriaLabel: (text: string): string => `Copy ${text}`,
						successMessageCss: 'Copied',
						waiverNotice: 'Waiver Notice',
						noQuestionnaires: 'No Questionnaires Available',
						agreed: 'Agreed',
					},
					sessionDetails: {
						activityAriaLabel: (name: string): string => `Session ${name}`,
						scheduleAriaLabel: 'Schedule',
					},
					errors: {
						failedParticipantResources: 'Failed to load participant resources',
						failedSegments: 'Failed to load participant segments',
						retry: 'Retry',
					},
					loading: {
						title: 'Loading',
						description: 'Loading Participant Info...',
					},
				},
				table: {
					subject: 'participants',
					loadingMessage: 'Loading Participants...',
					noDataMessage: 'No participants found',
					errorMessage: 'Failed to load participants. Please try again.',
					filters: {
						search: { placeholder: 'Search' },
						categories: {
							status: {
								title: 'STATUS',
								options: { [ActivityEnum.ACTIVE]: 'Active', [ActivityEnum.INACTIVE]: 'Inactive' },
							},
							// facility: {
							// 	title: 'FACILITIES',
							// }
							// role: 'ROLES',
						},
					},
					columns: {
						subGroup: {
							participant: 'Paticipant',
							level: 'Level',
							team: 'Team',
							productType: 'ProductType',
							payment: 'Payment',
							waiver: 'Waiver',
						},
						single: {
							firstName: 'First Name',
							lastName: 'Last Name',
							gender: 'Gender',
							age: 'Age',
							folderName: 'Group',
							registrationDate: 'Registration Date',
							participantTypes: 'Role',
							product: 'Product',
							payment: 'Payment',
							waiver: 'Waiver',
							jerseyNumber: 'Jersey Number',
							position: 'Position',
						},
						roleFilter: {
							[DisplayRoleEnum.CAPTAIN]: 'Captain',
							[DisplayRoleEnum.COACH]: 'Coach',
							[DisplayRoleEnum.ORGANIZER]: 'Organizer',
							[DisplayRoleEnum.PLAYER]: 'Player',
						},
						actions: 'Actions',
					},
					cells: {
						gender: {
							[GenderEnum.OTHER]: 'Gender Neutral',
							[GenderEnum.MALE]: 'Male',
							[GenderEnum.FEMALE]: 'Female',
						},
						product: {
							tooltip: (count: number): string => `+${count} More...`,
						},
						payment: {
							tooltip: (sign: string, currentPaidAmount: number, fullPrice: number): string =>
								`${sign}${currentPaidAmount}/${sign}${fullPrice}`,
							filter: {
								[PaymentStatusEnum.FULLY_PAID]: 'Paid',
								[PaymentStatusEnum.NOT_PAID]: 'Unpaid',
								[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partial',
							},
						},
						waiver: {
							signed: 'Signed',
							notSigned: 'Not Signed',
							filter: {
								[SignWaiverEnum.SIGNED]: 'Signed',
								[SignWaiverEnum.UNSIGNED]: 'Not Signed',
							},
						},
					},
					actions: {
						createGroup: 'Create Group',
						moveGroup: 'Move to Group',
						emailParticipants: 'Email Participants',
						copyFormLink: 'Copy form link',
						sendForm: 'Send form(s)',
						viewRegistration: 'View Registration Details',
						editPlayerInfo: 'Edit Player Info',
						removeFromSession: 'Remove from Session',
						removeParticipantRegistration: 'Remove Registration',
						removeFromEvents: 'Remove from Events',
						removeFromSegments: 'Remove from Segments',
						moveTo: 'Move To other Events',
						registerToEvent: 'Redeem Punch Pass',
						moveSegments: 'Move to Other Segments',
						moveEvents: 'Move to Other Events',
						addAPassHolder: 'Add a Pass Holder',
					},
					editPlayerInfo: {
						title: 'Edit Player Info',
						description: (participantName: string): string => `Update ${participantName}'s team info`,
						currentRoleLabel: 'Current Role',
						roleLabel: 'Team Role',
						rolePlaceholder: 'Select a role',
						jerseyNumberLabel: 'Jersey Number',
						jerseyNumberPlaceholder: 'Enter number',
						jerseyNumberError: 'Jersey number must be 0 or greater',
						positionLabel: 'Position',
						positionPlaceholder: 'Enter or select position',
						primaryButton: 'SAVE',
						secondaryButton: 'CANCEL',
						roles: {
							[ProductSubTypesEnum.LEAGUE_V2_CAPTAIN]: 'Captain',
							[ProductSubTypesEnum.LEAGUE_V2_COACH]: 'Coach',
							[ProductSubTypesEnum.LEAGUE_V2_ORGANIZER]: 'Organizer',
							[ProductSubTypesEnum.LEAGUE_V2_PLAYER]: 'Player',
						},
						success: (participantName: string): string => `${participantName}'s player info was updated.`,
						error: 'Unable to update player info.',
						noAdminWarning: {
							message:
								"This team will no longer have an admin. Without a Captain, Coach, or Organizer, the team won't be able to manage the roster or send invite links.",
						},
					},
					notification: {
						allSelectedParticipantsIn: (sessionName: string): string => `All selected participants in ${sessionName}`,
					},
					formLinks: {
						copySuccess: 'Form links copied',
						copyError: 'Unable to copy form links',
						noForms: 'This session has no forms attached',
						selectParticipants: 'Select specific participants to copy form links',
						selectOneParticipant:
							'Select one participant. Form links are personal and cannot be sent in bulk.',
						emailSubject: (participantName: string, sessionName: string): string =>
							`Forms to complete for ${participantName} – ${sessionName}`,
						emailGreeting: 'Hello,',
						emailIntro: (participantName: string, sessionName: string, formCount: number): string =>
							formCount === 1
								? `Please complete the following form for ${participantName} for ${sessionName}:`
								: `Please complete the following forms for ${participantName} for ${sessionName}:`,
						emailThanks: 'Thank you!',
						formFallback: (questionnaireId: number): string => `Form ${questionnaireId}`,
					},
				},
			},
			shared: {
				cells: {
					payment: {
						tooltip: (sign: string, currentPaidAmount: number, fullPrice: number): string =>
							`${sign}${currentPaidAmount}/${sign}${fullPrice}`,
						filter: {
							[PaymentStatusEnum.FULLY_PAID]: 'Paid',
							[PaymentStatusEnum.NOT_PAID]: 'Unpaid',
							[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partial',
						},
					},
					waiver: {
						signed: 'Signed',
						notSigned: 'Not Signed',
						filter: {
							[SignWaiverEnum.SIGNED]: 'Signed',
							[SignWaiverEnum.UNSIGNED]: 'Not Signed',
						},
					},
				},
			},
			groups: {
				noDataProps: {
					labels: {
						title: 'There are no groups here!',
						description: 'Start adding your groups',
					},
				},

				moveParticipantsIntoGroups: {
					title: 'Move Participants',
					description: (participants: { name: string }[]): string =>
						participants.length > 1
							? `Select an existing group to move ${participants[0].name} & ${participants.length - 1} others to.`
							: `Select an existing group to move ${participants[0].name} to.`,
					selectAllDescription: 'Choose a group to move all selected participants to.',
					helperLabel1: "Can't find what you're looking for?",
					helperLabel2: 'Create a new group ',
					helperLabelButton: 'here.',
					alreadyAssigned: 'Already In the selected group',
					confirmButtonText: 'MOVE',
					confirmButtonTextWithWarning: 'MOVE ANYWAY',
					cancelButtonText: 'CANCEL',
					placeholder: 'Search by Name',
					notification: {
						success: (participants: { name: string }[], groupName: string): string =>
							participants.length > 1
								? `${participants[0].name} & ${participants.length - 1} others moved to ${groupName}!`
								: `${participants[0].name} moved to ${groupName}!`,
						error: (participants: { name: string }[], groupName: string): string =>
							participants.length > 1
								? `Failed to move ${participants[0].name} & ${participants.length - 1} others to ${groupName}!`
								: `Failed to move ${participants[0].name} to ${groupName}!`,
						selectAllSuccess: (movedCount: number, groupName: string): string =>
							`${movedCount} participants moved to ${groupName}!`,
						selectAllError: (groupName: string): string => `Failed to move participants to ${groupName}!`,
					},
					capacityWarning: {
						message: (spotsAvailable: number, currentCount: number, maxCount: number, spotsNeeded: number): string =>
							`This group has ${spotsAvailable} spot${spotsAvailable !== 1 ? 's' : ''} remaining (${currentCount}/${maxCount} players). Moving ${spotsNeeded} participant${spotsNeeded !== 1 ? 's' : ''} will exceed the capacity limit`,
					},
					restrictionWarnings: {
						genderNotAllowed: (userGender: string, allowedGenders: string): string =>
							`User gender ${userGender} is not allowed. Allowed genders: ${allowedGenders}`,
						ageTooYoung: (userAge: number, minAge: number): string =>
							`User age ${userAge} is below the minimum age of ${minAge}`,
						ageTooOld: (userAge: number, maxAge: number): string =>
							`User age ${userAge} exceeds the maximum age of ${maxAge}`,
						bornTooEarly: (birthDate: string, requiredDate: string): string =>
							`User birth date ${birthDate} is before the required "born on or after" date ${requiredDate}`,
						bornTooLate: (birthDate: string, requiredDate: string): string =>
							`User birth date ${birthDate} is after the required "born on or before" date ${requiredDate}`,
						genericRestriction: (message: string): string => `${message}`,
					},
				},

				moveGroupIntoGroups: {
					title: 'Move Group',
					description: (groupNames: string[]): string =>
						groupNames?.length > 1
							? `Select an existing group to move ${groupNames[0]} & ${groupNames?.length - 1} others to.`
							: `Select an existing group to move ${groupNames[0]} to.`,
					helperLabel1: "Can't find what you're looking for?",
					helperLabel2: 'Create a new group ',
					helperLabelButton: 'here.',
					alreadyAssigned: 'Already In the selected group',
					confirmButtonText: 'MOVE',
					confirmButtonTextWithWarning: 'MOVE ANYWAY',
					cancelButtonText: 'CANCEL',
					placeholder: 'Search by Name',
					notification: {
						success: (groupName: string, toGroupName: string): string => `${groupName} moved to ${toGroupName}!`,
						error: (groupName: string, toGroupName: string): string => `${groupName} failed to move to ${toGroupName}!`,
					},
					capacityWarning: {
						message: (slotsAvailable: number, currentCount: number, maxCount: number, slotsNeeded: number): string =>
							`This group has ${slotsAvailable} team slot${slotsAvailable !== 1 ? 's' : ''} remaining (${currentCount}/${maxCount} teams). Moving ${slotsNeeded} group${slotsNeeded !== 1 ? 's' : ''} will exceed the capacity limit.`,
					},
				},

				deleteGroup: {
					cannotDeleteTitle: 'Cannot Delete Group',
					okButton: 'OK',
					title: (hasContent?: boolean): string => (hasContent ? `Move Participants` : `Delete Group`),
					description: (groupName: string, hasContent?: boolean): string =>
						hasContent
							? `Before deleting ${groupName}, select a new group for \n its subgroups and participants.`
							: `Deleting ${groupName} will erase all details and configured settings.\nAre you sure you want to delete?`,
					primaryButton: (hasContent?: boolean): string => (hasContent ? 'MOVE & DELETE' : 'YES, DELETE'),
					secondaryButton: 'Cancel',
					success: (groupName: string): string => `${groupName} has been deleted!`,
					error: (groupName: string): string => `Failed to delete ${groupName}!`,
					futureEventsError: (count: number): string =>
						`This group is included in ${count} upcoming event${count === 1 ? '' : 's'}. Past events will remain unchanged.\n\nTo delete this group, first remove it from the upcoming events either by editing or deleting those events. Once done, return here to complete the deletion.`,
				},

				table: {
					subject: 'groups',
					loadingMessage: 'Loading Groups...',

					filters: {
						search: { placeholder: 'Search' },
						categories: {
							status: {
								title: 'STATUS',
								options: { [ActivityEnum.ACTIVE]: 'Active', [ActivityEnum.INACTIVE]: 'Inactive' },
							},
							// facility: {
							// 	title: 'FACILITIES',
							// }
							// role: 'ROLES',
						},
					},
					columns: {
						group: 'Group',
						groupType: 'Group Type',
						groupParent: 'Parent Group',
						participants: 'Participants',
						waivers: 'Waivers',
						payments: 'Payments',
						capacity: 'Capacity',
						registrationAccess: 'Access',
						actions: 'Actions',
					},
					cells: {
						product: {
							tooltip: (count: number) => `+${count} More...`,
						},
						payment: {
							paidAmountPrefix(currency: string, paidAmount: string | number) {
								return `${currency}${paidAmount} / `;
							},
							tooltip: (sign: string, currentPaidAmount: number, fullPrice: number): string =>
								`${sign}${currentPaidAmount}/${sign}${fullPrice}`,
							filter: {
								[PaymentStatusEnum.FULLY_PAID]: 'Paid',
								[PaymentStatusEnum.NOT_PAID]: 'Unpaid',
								[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partial',
							},
						},
						capacity: {
							error: 'Error loading capacity',
							teamsCapacityLine: (current: number, max: number): string => `${current}/${max} Teams`,
							playersCapacityLine: (current: number, max: number): string => `${current}/${max} Players`,
							individualsCapacityLine: (current: number, max: number): string => `${current}/${max} Individuals`,
						},
					},
					actions: {
						createGroup: 'Create Group',
						editGroup: 'Edit Group Details',
						moveGroup: 'Move Group',
						duplicateGroup: 'Duplicate Group',
						deleteGroup: 'Delete Group',
						emailGroups: 'Email Groups',
						generateInviteLink: 'Generate Invite Link',
					},
				},

				groupForm: {
					mainDetails: {
						title: 'Main Details',
						name: {
							label: 'Group Name',
							placeholder: 'Enter group name',
							tooltip: 'Group name is required',
							tooltipErrorEmpty: 'Group name is required',
							error: 'Group name is required',
						},
						type: {
							label: 'Group Type',
							placeholder: 'Select group type',
							tooltip: 'Group type is required',
							error: 'Group type is required',
						},
						parentGroup: {
							label: 'Parent Group',
							placeholder: 'Select parent group',
							tooltip: 'Parent group is required',
							error: 'Parent group is required',
						},
						groupLogo: {
							label: 'Group Logo',
							defaultAlt: 'group',
						},
					},
					restrictions: {
						title: 'Restrictions',
						groupGender: {
							label: 'Group Gender',
							placeholder: 'Select Gender',
							tooltip: 'Group gender required',
							error: 'Group gender required',
						},
						minAge: {
							label: 'Min Age',
							placeholder: 'Select minimum age',
							tooltip: 'Minimum age is required',
							error: 'Minimum age is required',
						},
						maxAge: {
							label: 'Max Age',
							placeholder: 'Select maximum age',
							tooltip: 'Maximum age is required',
							error: 'Maximum age is required',
						},
						minParticipants: {
							label: 'Min Participants',
							placeholder: 'Select minimum participants',
							tooltip: 'Minimum participants is required',
							error: 'Minimum participants is required',
						},
						maxParticipants: {
							label: 'Max Participants',
							placeholder: 'Select maximum participants',
							tooltip: 'Maximum participants is required',
							error: 'Maximum participants is required',
						},
					},
					actions: {
						submit: 'Submit',
						cancel: 'Cancel',
					},
					verification: {
						success: 'Group created successfully',
						error: 'Failed to create group',
					},
				},
			},
			waitlist: {
				table: {
					subject: 'waitlist',
					loadingMessage: 'Loading waitlist...',
					noDataMessage: 'No waitlisted participants found.',
					errorMessage: 'Failed to load the waitlist. Please try again.',
					columns: {
						owner: 'Name',
						dateJoined: 'Date Joined ',
						waitlistFor: 'Waitlist For',
						product: 'Product',
						price: 'Price',
						availability: 'Availability',
						allEvents: 'All Events',
					},
					all: (isSegmented: boolean) => `All ${isSegmented ? 'segments' : 'events'}`,
					actions: { delete: 'Remove from waitlist', email: 'Email waitlist participants' },
					rowActions: { delete: 'Remove', register: 'Register', contact: 'Contact' },
					deleteModal: {
						title: 'Remove From Waitlist',
						description: (selectedRows: WaitlistColumnDef[], isAll: boolean) => {
							if (selectedRows.length > 1 || isAll) {
								return 'Are you sure you want to remove all selected participants from the session waitlist?';
							}

							const name = selectedRows[0].ownerName?.name || 'Participant';
							return `${name} will be removed from the session waitlist. Are you sure you want to remove?`;
						},
						primaryButton: 'Remove',
						successMessage: (isSingle: boolean) =>
							isSingle ? 'Customer removed from the waitlist ' : 'Customers removed from waitlist successfully',
					},
					registerModal: {
						title: 'Register Participant',
						//titleExpired: 'All events are in the past',
						description: (customerName: string) => `You are registering ${customerName} to the following:`,
						primaryButton: 'register',
						primaryButtonExpired: 'GOT IT',
						secondaryButton: 'cancel',
						body: {
							details: {
								schedule: {
									title: 'Schedule:',
									all: (isSegmented: boolean) => `All ${isSegmented ? 'Segments' : 'Events'}`,
									status: {
										[AvailabilityStatusEnum.AVAILABLE]: 'Available',
										[AvailabilityStatusEnum.EXPIRED]: 'Expired',
										[AvailabilityStatusEnum.UNAVAILABLE]: 'Full',
										[AvailabilityStatusEnum.PARTIALLY_AVAILABLE]: 'Partially Available',
									},
								},
								product: { title: 'Product:' },
								addOns: {
									title: 'Add-ons:',
									none: 'None',
									addonWithQuantity(name: string, quantity: number) {
										return `${name} x ${quantity}`;
									},
								},
								priceTotal: { title: 'Price Total (discounts included):' },
							},
							notice: {
								unavailable: 'One or more events are still full. Would you like to register the customer anyway?',
								expired:
									'All events in the schedule have already passed. To register the participant, please select a different schedule or session.',

								partiallyExpiredAll:
									'Some events in this schedule have already occurred. The customer will be registered and invoiced for future events only.',
								partiallyExpired:
									'Some events in the schedule have already occurred. To add the participant to future events, please complete the registration manually.',
								missingRequiredMembership:
									'This program requires a membership the customer does not have. Registering will not add it automatically.',
							},
						},
						successMessage: {
							firstPart: (customerName: string) => `${customerName} registered! To view invoice and charge`,
							secondPart: 'click here',
						},
						noWaitlistEntryErrorMessage: `Unable to complete registration. Please refresh and try again, or contact ${SUPPORT_EMAIL}.`,
						notFoundWaitlistEntryErrorMessage:
							'This participant is no longer on the waitlist. Please refresh the list and try again.',
					},
					notifyModal: {
						title: 'New Message',
						subtitle: 'This message will be sent to all participants of the selected events',
						toCopy: {
							toParticipant: (participantName: string) => `To: ${participantName}`,
							toParticipantAndMore: (userName: string, participantCount: number) =>
								`To: ${userName} + ${participantCount - 1} more participants`,
							toAllXParticipants: (numberOfParticipants: number) =>
								`To: All ${numberOfParticipants} participants in waitlist`,
						},
						onSuccessMessage: (participantName?: string) =>
							participantName
								? `Message has been sent to ${participantName}!`
								: 'Message has been sent to the selected participants!',
					},
				},
				joinWaitlist: {
					success: 'Customer added to the waitlist successfully',
					error: 'Failed to add customer to the waitlist',
				},
			},
			tabs: {
				tabsName: {
					[ParticipantsTabs.INDIVIDUALS]: 'Individuals',
					[ParticipantsTabs.GROUPS]: 'Groups',
					[ParticipantsTabs.WAITLIST]: 'Waitlist',
				},
				actions: {
					ImportRosterTemplate: 'Import Roster Template',
				},
				ariaLabels: {
					actionBar: 'Action Bar',
					tabs: {
						tabList: 'Tab List',
						tab: 'Tab',
						tabPanel: 'Tab Panel',
					},
					treeControls: 'Tree Controls',
				},
			},
			sideBar: {
				displayLabels: {
					emptyStateMessage: 'No filter options available',
					loadingStateMessage: 'Loading...',
					searchPlaceholder: 'Search',
					truncatedText: (limit: number) => `+${limit} more not shown`,
					depthLimitedText: 'Depth limit reached',
					ariaLabels: {
						treeContainer: 'Group filter tree navigation',
						searchInput: 'Search groups',
						treeList: 'Groups list',
						tree: 'Groups tree',
						treeItem: (label: string) => `Group: ${label}`,
						expandButton: (label: string, isExpanded: boolean) =>
							isExpanded ? `Collapse ${label}` : `Expand ${label}`,
						selectButton: (label: string, isSelected: boolean) =>
							isSelected ? `${label}, selected` : `Select ${label}`,
						loadingState: 'Loading groups',
						emptyState: 'No groups available',
						moreOptionsButton: (label: string) => `More options for ${label}`,
					},
				},
				ariaLabels: {
					open: 'Expand Sidebar',
					close: 'Collapse Sidebar',
				},
				tooltips: {
					expand: 'Expand Sidebar',
					collapse: 'Collapse Sidebar',
				},
				moreOptions: {
					createGroup: 'Create Group',
					editGroupDetails: 'Edit Group Details',
					duplicateGroup: 'Duplicate Group',
					analyzeSchedule: 'Analyze Schedule',
					renameGroup: 'Rename Group',
					deleteGroup: 'Delete Group',
				},
				renameGroup: {
					title: 'Rename Group',
					description: (name: string) => `Rename "${name}"`,
					inputLabel: 'Group Name',
					confirmButtonText: 'Rename',
					cancelButtonText: 'Cancel',
					notification: {
						success: (oldName: string, newName: string) => `Group "${oldName}" renamed to "${newName}"`,
						error: (name: string) => `Failed to rename group "${name}"`,
					},
				},
			},
		},
	},
	eventRegistrationModal: {
		start: 'Start',
		end: 'End',
		durationWithParentheses: (duration: string) => `(${duration})`,
		dateTimeRangeLabel: (startDate: string, startTime: string, endDate: string, endTime: string) =>
			`${startDate}, ${startTime} - ${endDate}, ${endTime}`,
		dateTimeRangeSameDateLabel: (startDate: string, startTime: string, endTime: string) =>
			`${startDate}, ${startTime} - ${endTime}`,
		purchased: 'purchased',
		registered: 'Registered',
		checkedIn: 'Checked in',
		missingPayments: 'Missing payments',
		paid: 'Paid',
		partiallyPaid: 'Partially Paid',
		register: 'Register',
		checkIn: 'Check in',
		noLocation: 'No location set as of yet',
		refresh: 'Refreshing...',
		more: 'More',
		undo: 'Undo',
		checkInAction: 'Check In',
		table: {
			name: 'Name',
			team: 'Team',
			dob: 'Date of birth',
			age: 'Age',
			waiver: 'Waiver',
			addons: 'Add ons',
			passesLeft: 'Passes left',
			emptyTableMessage: 'No participants',
			passesFrom: '/',
		},
		filters: {
			selectPlaceholder: 'Filter',
			searchPlaceHolder: 'Search by name, date',
			status: 'Status',
			checkedIn: 'Checked in',
			notCheckedIn: 'Not checked in',
			participantWith: 'Participant with',
			addons: 'Add ons',
			noAddons: 'No add ons',
			waiver: 'Waiver',
			noWaiver: 'No waiver',
			paymentStatus: 'Payment status',
			paid: 'Paid',
			unpaid: 'Unpaid',
			partiallyPaid: 'Partially paid',
			installments: 'Installments',
			allTeams: 'All Teams',
			team: 'Team',
		},
		edit: 'Edit',
		printOptions: 'Print Options',
		printRoster: 'Print Roster',
		printRosterError: 'Failed to generate roster PDF. Please try again.',
		printRosterPopupBlocked: 'Allow popups for this site to view the roster PDF in a new tab.',
		printRosterLoading: 'Generating roster…',
	},
	cart: {
		descriptionLabels: {
			[CartItemDescriptionEnum.RESERVATION_ADDON]: 'Reservation Addon',
			[CartItemDescriptionEnum.SLOT_ADDON]: 'Slot Addon',
			[CartItemDescriptionEnum.HOUR_ADDON]: 'Hourly Addon',
			[CartItemDescriptionEnum.RESERVATION_TYPE_LESSON]: 'Lesson',
			[CartItemDescriptionEnum.RESERVATION_TYPE_RENTAL]: 'Rental',
			[CartItemDescriptionEnum.GENERAL_ADDON]: 'General Addon',
			[CartItemDescriptionEnum.PER_EVENT_ADDON]: 'Per Event',
			[CartItemDescriptionEnum.PER_SEGMENT_ADDON]: 'Per Segment',
			league_v2_captain: 'Captain',
			league_v2_invited_player: 'Invited Player',
			league_v2_player: 'Player',
			league_v2_free_agent: 'Free Agent',
			league_v2_organizer: 'Organizer',
			league_v2_coach: 'Coach',
			globalPass: 'Global Pass',
		},
		cartHeader: 'Cart',
		cartCustomer: { addPayingCustomer: 'Add paying customer', clearCustomer: 'Clear customer' },
		cartHeaderCount: (size: number) => ` (${size})`,
		errors: {
			cartIdNotSet: 'Something went wrong with your cart. Please refresh the page and try again.',
			cartAlreadyInvoiced: 'This cart has already been invoiced and cannot be modified.',
			[CART_ERROR_CODES.PAYOUT_ACCOUNT_DIFFERENT]:
				"You can't add this item — it pays out to a different bank account than what's already in the cart. Remove the current items to switch accounts, or use a separate cart.",
		},
		closeCartAlert: {
			title: 'Close Cart',
			message: 'Closing the cart will remove all items. Are you sure?',
			confirmButtonText: 'Close',
			cancelButtonText: 'Cancel',
		},
		feeWarning: 'Notice! Some payment methods may include a transaction fee.',
		quantity: 'Quantity',
		billedTo: 'Billed to',
		CreateInvoiceConfirmation: {
			title: 'Create Invoice?',
			description: 'Click create to generate an unpaid invoice for this customer',
			mainButton: 'Create',
			subButton: 'Cancel',
		},
		UpdateInvoiceConfirmation: {
			title: 'Update Invoice?',
			description: 'Click update to add these unpaid items to the selected invoice',
			mainButton: 'Update',
			subButton: 'Cancel',
		},
		moreActions: {
			CREATE_INVOICE: 'Create Invoice',
			UPDATE_INVOICE: 'Update Invoice',
			ADD_TO_INVOICE: 'Add to Invoice',
		},
		attachedInvoice: 'Attached to Invoice',
		willBeAttached: 'Items will be attached to invoice',
		actions: {
			charge: 'Charge',
			invoice: 'Invoice',
			clear: 'Clear',
			finishAndLeaveBalance: 'Finish & Leave Balance',
			cancelSale: 'Cancel Sale',
			cancelSaleSkipped: `Unable to cancel the sale. Please try again or contact ${SUPPORT_EMAIL}.`,
			cancelSaleFailed: 'Unable to cancel the sale automatically. Please go to the invoice to void it manually.',
			complete: 'Complete',
			discount: {
				invoicedCart: 'Cannot apply a discount to an invoiced cart',
				reservationInCart: 'Discounts on carts with reservation items are currently unsupported',
				zeroPriceCart: 'Cannot apply a discount to a cart with a price of 0.',
				emptyCart: 'Cannot apply a discount to an empty cart',
				hasNoPermissions: 'You do not have permission to apply discounts',
				discount: 'Discount',
			},
		},
		invoiceModal: {
			title: 'Invoice Cart',
			description: 'Would you like to create a new invoice or add to existing?',
			primaryButton: 'Create Invoice',
			secondaryButton: 'Add to Existing',
			successMessage: {
				addToExistingFirstPart: 'Items added to invoice!',
				createFirstPart: 'Invoice created successfully!',
				leaveFirstPart: 'Remaining balance has been left due on the invoice.',
				secondPart: 'View Invoice',
			},
		},
		selectCustomer: {
			title: 'Select Customer',
			description: 'Choose the customer who will be paying for this cart.',
			customerCreationLink: 'here.',
			confirmButton: 'CONFIRM',
			cancelButton: 'CANCEL',
			link: {
				customerCreationHelperFirst: `Can't find who you're looking for?`,
				customerCreationHelperSecond: `Create a new customer `,
				customerCreationLink: 'here.',
			},
		},
	},
	terminal: {
		station: 'Station',
		alreadyPaired: 'Already paired to terminal',
		serialNumber: 'serial number',
		disconnect: 'Disconnect',
		title: 'Station Setup',
		setup: 'Setup station',
		swipe: {
			readerResponse: 'Waiting for reader response...',
			callToAction: 'Waiting for Customer to Insert a Card...',
			collectingInput: 'Waiting for customer to approve card storage...',
			processing: 'Processing Payment...',
			processingSetupIntent: 'Processing Card Setup...',
			paymentFlowCanceled: 'Terminal payment flow canceled',
			collectInputCanceled: 'Terminal input flow canceled',
			customerCanceledOnReader: 'Customer canceled on the reader',
			pendingPaymentFailed:
				'The payment was not recorded, but the reader may still complete the charge. Verify on the reader or Stripe before retrying.',
			paymentOutcomeTimeout:
				"We couldn't confirm the terminal payment result. Please check the reader before trying again.",
			refundOutcomeTimeout:
				"We couldn't confirm the terminal refund result. Please check the reader before trying again.",
			refundFlowCanceled: 'Terminal refund flow canceled',
			refundNotAvailable: 'Terminal not available for refund',
			collectInputTimeout:
				"We couldn't confirm the terminal input result. Please check the reader before trying again.",
		},
		status: {
			online: 'Online',
			offline: 'Offline',
			paired: 'already paired',
		},
		actionNotification: {
			readerBusy: 'The terminal is busy with another action. Please try again in a moment.',
			takeOver: 'Take over',
			actionOverridden: 'Your terminal action was taken over by another user.',
			authorizationInProgress: 'A card is being authorized on this terminal. Please try again in a moment.',
			readerOffline: 'The terminal is offline. Make sure it is powered on and connected, then try again.',
			readerTimeout: 'The terminal did not respond in time. Check the terminal for a prompt before retrying.',
		},
		errors: {
			noReaders:
				'No terminals are available for this facility. Please contact support to ensure your terminal is set up and activated.',
			failedToConnect:
				'We could not connect to the terminal. Please ensure it is powered on and connected to the same network, then try again.',
			failedToDiscover:
				'No terminals were discovered. Please check that the terminal is powered on and on the same Wi-Fi network.',
			facilityAccessFailed: 'Failed to load facility access',
		},
		simulation: {
			label: 'Simulate Terminal',
			cardNumberLabel: 'Simulated Terminal Card Number',
		},
		setupLink: 'Setup station.',
		connectionFailed: {
			title: 'Could not connect to terminal.',
			faqPrefix: 'To resolve this issue, view the ',
			faqSuffix: 'or reconnect from ',
		},
		actionErrors: {
			organizationRequired: 'Organization is required',
			terminalReaderRequired: 'Terminal reader is required',
		},
		selectors: {
			facility: {
				label: 'facility*',
				placeholder: 'Choose your facility',
			},
			stations: {
				label: 'station*',
				placeholder: 'Choose your station',
				loading: 'loading stations...',
			},
			terminals: {
				info: {
					faqPrefix: "Can't find your terminal? Review the ",
					supportMessage: 'For further assistance, click Support to chat with the team for troubleshooting.',
					prefix: 'If a terminal is not on the list, please contact ',
					suffix: ' to ensure it is set up and activated.',
				},
				label: 'terminal',
				placeholder: 'Choose your terminal',
				loading: 'loading terminals...',
			},
		},
		createStation: {
			title: 'Create station',
			description: (facilityName: string) => `Create a new station for ${facilityName}.`,
			nameLabel: 'Station name',
			namePlaceholder: 'Enter station name',
			successMessage: (stationName: string) => `"${stationName}" was created successfully.`,
			errorMessage: 'Failed to create station. Please try again.',
			link: {
				linkDescription: "Can't find what you're looking for?",
				linkLabelPrefix: 'Create a new station ',
				linkLabel: 'here.',
			},
		},
	},
	receipts: {
		invoice: 'Invoice',
		receipt: 'Receipt',
		number: 'no.',
		subtotal: 'Subtotal',
		total: 'Total Amount',
		thankU: 'Thank You!',
		quantity: 'Quantity',
		x: 'x',
		tax: 'Tax',
		taxInc: 'Tax Inc.',
		customerFullNameLastFirst: (lastName: string, firstName: string): string => `${lastName} ${firstName}`,
		taxExclWithPercent: (percent: string | number): string => `${TranslationEn.payments.items.taxExc} (${percent}%)`,
		taxIncWithPercent: (percent: string | number): string => `${TranslationEn.payments.items.taxInc} (${percent}%)`,
		cardPaymentDisplay: (brand: string, lastFour: string): string => `${brand} ${lastFour}`,
	},
	components: {
		note: 'Note',
		notes: 'Notes',
		optional: '(Optional)',
		labelWithRequired: (label: string, isRequired: boolean) => (isRequired ? `${label} *` : label),
		labelWithIndex: (label: string, index: number) => `${label} #${index}`,
		timeAndDuration: (startTime: string, endTime: string, duration: string) => `${startTime} - ${endTime} ${duration}`,
		avatar: {
			profilePictureAlt: 'User profile picture',
			profilePictureAltWithLabel: (label: string) => `${label} profile picture`,
		},
		breadcrumb: {
			customersPrefix: 'customers >',
		},
		multiSelect: {
			outsideParent: 'MultiSelect compound components must be used within a MultiSelect parent',
			defaultFieldNotConfigured: 'MultiSelect: default field name is not configured',
			selectFieldNotConfigured: 'MultiSelect: select field name is not configured',
		},
		addonsQuery: {
			outsideProvider: 'useAddonsQueryOptions must be used within an AddonsQueryProvider',
		},
		durationLabel: (value: string, unit: string) => `${value} ${unit}`,
	},
	days: {
		2: 'Mon',
		3: 'Tue',
		4: 'Wed',
		5: 'Thu',
		6: 'Fri',
		7: 'Sat',
		8: 'Sun',
	},
	orderedDays: {
		0: 'Sun',
		1: 'Mon',
		2: 'Tue',
		3: 'Wed',
		4: 'Thu',
		5: 'Fri',
		6: 'Sat',
	},
	forms: {
		generic: {
			abandonUnsavedChangesConfirmation: {
				title: 'Discard Changes?',
				description: 'Leaving without saving will undo any changes you made.  Are you sure you want to leave?',
				primaryButton: 'Yes, Discard & Leave',
				secondaryButton: 'No, Stay',
			},
		},
		newBooking: {
			steps: {
				basicInfo: 'Basic Info',
				summary: 'Summary',
			},
			booking: 'Booking',
			bookingSummary: 'Booking Summary',
			externalEvent: 'External event',
			internalEvent: 'Internal event',
			maintenance: 'Maintenance',
			private: 'Private',
			addTitle: 'Add Title',
			invoiceDetails: 'Invoice Details',
			resource: 'Resource',
			time: { starts: 'Starts', ends: 'Ends' },
			addTimeSlot: 'Add time slot',
			remove: 'Remove',
			timeSlot: 'TIME SLOT',
			rate: 'Rate',
			rateInfo: 'This is the hourly rate to charge your customer',
			reservationNote: 'Reservation Note ',
			publicNotes: 'Public Notes',
			spaceAvailable: 'Space available for others',
			repeat: 'Repeat',
			maintenanceTime: 'Maintenance time',
			maintenanceTimeTitle: 'Maintenance time title',
			min: 'Min',
			hour: 'Hour',
			beforeTheEvent: 'Before the event',
			afterTheEvent: 'After the event',
			atTheBeginningOfTheEvent: 'At the beginning of the event',
			atTheEndOfTheEvent: 'At the end of the event',
			NewMaintenanceTime: 'New maintenance time',
			preparationTime: 'Preparation time',
			addOns: 'Add-Ons',
			newAddOn: 'New add-on',
			selectAddOn: '  Select add-on',
			discardBookingDetails: 'Discard booking details',
			warning: 'Warning',
			AnyChangesYouHaveMade: 'Any changes you have made to the schedule',
			willBeErased: 'will be erased if you go back.',
			goBackAndDiscard: 'go back and Discard',
			frequencies: 'Frequencies',
			every: 'Every',
			on: 'On',
			after: 'After',
			endRepeat: 'End repeat',
			occurrences: 'occurrences',
			eventWillOccurEvery: 'Event will occur every',
			everyDay: 'every day',
			editEvent: 'Edit Event',
			saveChanges: 'Save Changes',
			hold: 'Hold',
			addToCart: 'Add to cart',
			saveToCart: 'Save To Cart',
			Hold: 'Hold',
			publicNotesInfo: 'public notes - will appear in TV schedule',
			book: 'book',
			scheduleHold: 'Schedule Hold',
			holdDescription: 'The schedule you have set will be on hold and be blocked from any online bookings.',
			yesHold: 'Yes, Hold',
			internalSuccessMessage:
				'Great! You have placed a hold on the calendar and can review it in the reservations page or edit via the calendar',
			bookingMaintenance: 'Booking Maintenance',
			bookingDescription:
				'Your maintenance slot will be marked on the calendar and you will be able to filter and issue a report for it',
			yesBook: 'Yes, Book',
			maintenanceSuccessMessage: 'Congrats! Your maintenance slot is booked.',
			package: 'Package',
			editRecurringEvent: 'Edit recurring event',
			thisEventOnly: 'This event only',
			thisAndFollowingEvents: 'This and following events',
			allEvents: 'All events',
			save: 'Save',
			cancel: 'Cancel',
			deleteEvent: 'Delete Event',
			reservationNoteInfo: 'This is a general note for the reservation that is private and visible only to you',
			confirmationModal: {
				title: 'Delete Event',
				description: 'Are you sure you want to delete this event?',
				mainButton: 'Delete',
				subButton: 'Cancel',
			},
		},
		newCustomer: {
			title: 'Create a new customer',
			description: 'Enter the following details to create a new customer before continuing with the reservation.',
			fields: {
				firstName: 'First Name',
				lastName: 'Last Name',
				phoneNumber: 'Phone No.',
				email: 'Email',
				dateOfBirth: 'Date of Birth',
				gender: 'Gender',
			},
			warning: `Once saved, a welcome email will automatically be\nsent to the above address with the option to\nreset password for the customer’s online profile.`,
		},
		pauseMembershipMembers: {
			undoPauseModal: {
				title: 'Cancel Scheduled Pause',
				description:
					'Are you sure you want to cancel the scheduled pause? Any details you have entered will not be saved.',
				mainButton: 'Cancel Pause',
				subButton: 'Go back',
			},
		},
		newReservation: {
			validation: {
				quantityMustBeAtLeastOneIfProvided: 'Quantity must be at least 1 if provided',
			},
			membershipGatingModal: {
				title: 'Membership Required',
				description: (productName: string) =>
					`To book "${productName}" a customer must also purchase a membership. Select the membership and add to cart.`,
				selectMembership: 'Select',
				startDate: 'Start Date',
				additionalInfo: (price: number, currency: CurrencySymbolEnum) =>
					`${CHARACHERS.COLON} ${Pricify(price, currency)}`,
				additionalRowInfo: (resourceType: MembershipTypeEnum, customerTypes: CustomerTypeEnum[]) =>
					`Membership Type (${MEMBERSHIP_TYPE_LABELS[resourceType]} - ${customerTypes.join(', ')})`,
				mainButton: (totalSteps: number, currentStep: number) =>
					currentStep !== totalSteps - 1 ? 'CONTINUE' : 'ADD TO CART',
				skip: 'SKIP',
				gatedMembershipsNoteTitle: 'This membership requires the following products:',
			},
			missingReservationIdError: 'Something went wrong. Please close and reopen the reservation, then try again.',
			redeem: {
				conflictTitle: 'Time Slot Conflict',
				conflict: (count: number) =>
					`There are ${count} conflict(s) with the selected time-slots.`,
				redeemAnyway: 'Redeem anyway',
				resolveConflicts: 'Go to conflicts',
				dismiss: 'Dismiss',
				redeem: 'Redeem',
				ready: 'The pass selected can be redeemed now!',
				errors: {
					requiresCheckout: 'This booking needs checkout — continue to cart',
				},
			},
			resetAddonsWarningModal: {
				title: 'Are you sure?',
				description: 'Updating these settings will reset your add-ons selection! Are you sure you want to proceed?',
				mainAction: 'Let me edit',
				cancel: 'Cancel',
			},
			header: {
				title: 'Reservation',
				sideView: 'Side View',
				expandView: 'Expand View',
			},
			step1: {
				title: 'RESERVATION DETAILS',
				reservationTitle: {
					label: 'Reservation Name',
					placeholder: 'Title here',
				},
				reservationType: {
					label: 'Reservation type',
					options: { [ReservationTypeEnum.RENTAL]: 'Customer', [ReservationTypeEnum.INTERNAL]: 'Internal' },
				},
				reservationDetails: {
					title: 'Reservation Details',
					customer: {
						customerCreationHelperFirst: '',
						customerCreationHelperSecond: `Create a new customer `,
						customerCreationLink: 'here.',
						searchFamilyStep: {
							title: 'Create New Customer',
							description:
								'Would you like to add this new customer to an existing family or create them as a new individual?\nFamily members can be added to new individuals later.',
							placeholder: 'Search for a family',
							mainButton: 'Create new',
							secondButton: 'Add to Family',
							searchInput: {
								placeholder: 'Search for family',
							},
						},
						createCustomerStep: {
							generateFamilyName: (lastName: string) => `${lastName}'s family`,
							formLabels: {
								firstName: 'First Name',
								lastName: 'Last Name',
								phoneNumber: 'Phone No.',
								email: 'Email',
								dateOfBirth: 'Date of Birth',
								gender: 'Gender',
								address: 'Address',
							},
							informational: {
								welcomeEmail: `Once saved, a welcome email will automatically be sent to the above address\nwith the option to reset password for the customer's online profile.`,
								customerOfReservation: `Note: If you create multiple customers, the first one will be set as the primary family member, and the most recently added customer will be selected for the next action.`,
							},
							title: (isFamily: boolean) => (isFamily ? 'Create New Family Member' : 'Create New Customer'),
							description: (isFamily: boolean) =>
								isFamily
									? 'Please enter the following information to add a new family member'
									: 'Please enter the following information to create a new customer.',
							mainButton: 'Create',
							secondButton: 'Cancel',
							errors: {
								familyAccountIdNotFound: `Failed to add member to the family account. Please try again or contact ${SUPPORT_EMAIL}.`,
								primaryCustomerNotFound:
									'Unable to create the family account. A primary member is required. Please add one and try again.',
							},
						},
						conclusionStep: {
							newMemberSummary: (name: string) =>
								`${name} has been created successfully.\nWould you like to add a family member to the customer you’ve created?`,
							title: 'Add Family Member',
							mainActionButtonText: 'I’m Done',
							secondaryActionButtonText: 'Add Family member',
						},
					},
				},
				resources: 'Resources',
				reservationNotes: {
					title: 'Reservation Notes',
				},
				notes: {
					privateButtonLabel: 'Private Note',
					privateLabel: 'Event private note',
					publicButtonLabel: 'Add Events Public Note',
					publicLabel: 'Event public note',
				},
				errors: { selectCustomer: 'Please select a customer before continuing.' },
			},
			step2: {
				title: 'SEGMENTS',
				notes: {
					privateButtonLabel: 'Private Note',
					privateLabel: 'Reservation private note',
					publicButtonLabel: 'Add Reservation Public Note',
					publicLabel: 'Reservation public note',
				},
				eventDetails: { eventInputTitle: 'Event Name', visibilityTitle: 'Visibility' },
				productsAndResources: {
					title: 'Event Products & Resources',
					subTitle: (count: number) => `${count} matching products available`,
					spaces: {
						title: 'Space',
					},
					instructors: {
						title: 'Instructor',
					},
					sports: {
						title: 'Activity',
						selectedSpaceAndInstructorDontMatch: 'Selected instructor & space do not match',
						selectedInstructorDoesNotMatch: 'Selected instructor does not match',
						selectedSpaceDoesNotMatch: 'Selected space does not match',
					},
					products: {
						title: 'Product',
						productTypes: {
							[ProductSubTypesEnum.GROUP_RENTAL]: 'Group',
							[ProductSubTypesEnum.PER_PARTICIPANT_RENTAL]: 'Per Participant',
							[ProductSubTypesEnum.RENTAL]: 'Rental',
						},
						allProductsSelected: 'Lowest price product(s)',
						participants: 'participants',
						noProducts: {
							main: 'Sorry, there are no products setup for the selected activity and spaces/ instructors.',
							secondary: 'Click here to view your products.',
						},
						error: 'A product must be matched to each of the resources selected above.',
						resourceUnavailable: 'Space or instructors selected are not available for this product',
						selectAll: 'Auto-select lowest price product(s)',
					},
				},
				pass: {
					segmentType: {
						label: 'Segment type',
						rental: 'Rental product',
						pass: 'Pass product',
					},
					mode: {
						label: 'Pass selection',
						redeem: 'Redeem',
						purchase: 'Purchase',
					},
					select: {
						label: 'Pass',
						placeholder: 'Select',
						noOwned: 'No matching passes found.',
						noPurchasable: 'No pass products match the filters.',
					},
					errors: {
						passRequired: 'Select a pass to redeem.',
						productRequired: 'Select a pass product.',
						outOfPasses: 'User is out of passes. Create another booking and buy another pass to add more time',
					},
					duration: {
						max: (duration: string) => `The remaining punch duration allows for a maximum of ${duration}.`,
					},
					warnings: {
						expiresBeforeSlot: (date: string) =>
							`This pass expires on ${date}, before the slot date. You can still continue.`,
					},
					option: {
						punches: (n: number) => `(${n === 1 ? '1 punch' : `${n} punches`})`,
						punchesRatio: (left: number, total: number) => `(${left}/${total})`,
						expires: (date: string) => `Exp. ${date}`,
						perDuration: (duration: string) => `per ${duration}`,
					},
				},
				participants: {
					participantCountTitle: 'Number of Participants',
					customerSelectTitle: 'Participating Customers',
				},
				eventSchedule: {
					title: 'Event Schedule',
					start: 'Start',
					end: 'End',
					remove: 'Remove',
					warnDescription: (resources: string[]) =>
						`Note: ${resources.map(capitalize).join(' and ')} ${
							resources.length > 1 ? 'are' : 'is'
						} not available at the times selected, but you can still proceed with booking.`,
					errors: {
						mustChooseEndTime: 'Must choose end time',
						endTimeEarlierThanStartTime: 'End time must be later than start time',
						endDateEarlierThanStartDate: 'End date must not be earlier than start date',
						over24Hours: 'Event cannot be longer than 24 hours',
					},
				},
				repeatSettings: {
					frequency: 'Frequency',
					every: 'Every',
					repeat: 'Repeat',
					frequencies: {
						daily: 'Daily',
						weekly: 'Weekly',
						monthly: 'Monthly',
					},
					occurrences: 'Number of Occurrences',
					endDate: 'End Date',
					errors: {
						[dateTimeErrorCodes.invalidDateRange]: 'Invalid date range',
						[dateTimeErrorCodes.invalidRepeatEvery]: 'Invalid repeat every option',
						[dateTimeErrorCodes.invalidFrequency]: 'Invalid frequency option',
						[dateTimeErrorCodes.missingSeriesData]: 'Missing series data',
					},
				},
				eventNotes: {
					title: 'Event Notes',
					addPublic: 'Add Public Notes',
					addPrivate: 'Add Private Notes',
					clearPublic: 'Clear Public Notes',
					clearPrivate: 'Clear Private Notes',
				},
				addTimeSlots: 'Add time slot',
				mismatchSlotsError: (slot: ProblematicSlotDto, space: IdAndNameDto) => {
					return `Slot ${formatToDayAndTime(slot.startDate, slot.startTime)} till ${formatToDayAndTime(
						slot.endDate,
						slot.endTime
					)} for space "${slot.spaceName ?? space?.name ?? 'N/A'}" has no matching products.`;
				},
				reservationIdRequired: 'Something went wrong. Please close and reopen the reservation, then try again.',
			},
			step4: {
				title: 'EXTRAS',
				reservationAddons: {
					title: 'Reservation Add-ons',
				},
				segmentsAddons: {
					title: 'Segments Add-ons',
					segments: 'Segments',
				},
			},
			step5: {
				title: 'PRICING',
				pricingConfiguration: 'Pricing Configuration',
				radios: {
					products: { title: 'Products', description: 'Price per products' },
					categories: { title: 'Categories', description: 'Total price per category' },
					total: { title: 'Total', description: 'Total reservation price' },
				},
				details: {
					products: {
						title: 'Products',
						item: {
							label: (name: string, price: string, duration: string) => `${name} | ${price} / ${duration}`,
							helpers: {
								occurrences: (occurrences: number, duration?: string) =>
									`Total occurrences: ${toFixed(occurrences, 2)} (increments of ${duration})`,
								customPricingSchedule: 'Custom Pricing Schedule:',
								discountRemoved: (discountName: string): string => `${discountName} no longer applied`,
								discount: (discountName: string, percentage: number): string =>
									`${discountName}: ${formatPercentage(Math.abs(percentage) * -1)}`,
								resetPriceTooltip: (entitled: boolean) => `Reset ${entitled ? 'Entitlement' : 'Price'}`,
							},
						},
					},
					addons: {
						title: 'Add-ons',
						reservationAddons: 'Reservation Add-ons',
						item: {
							label: (name: string, price: string, duration: string) => `${name} | ${price} / ${duration}`,
							helpers: {
								quantity: (quantity: number) => `Quantity: ${toFixed(quantity, 2)}`,
								resetPriceTooltip: 'Reset Price',
							},
						},
					},
					subtotal: (description?: string) => `Subtotal ${description || ''}`,
					total: 'Total',
					reservationTotal: { label: 'Reservation total price' },
					subTotalDescription: '(All categories)',
					discountsTotal: 'Total Discounts',
				},
			},
			step3: {
				title: 'CONFLICTS',
				noConflicts: 'No conflicts found',
				numberOfConflicts: (counter: number) => `${counter} conflicts in reservation.`,
				showConflictsOnly: 'Show conflicts only',
				filter: {
					header: { slots: (counter: number) => `${counter} slots`, selectAll: '	Select All' },
					list: {
						segments: 'SEGMENTS',
						days: 'DAYS',
						months: 'MONTHS',
						spaces: 'SPACES',
						instructors: 'INSTRUCTORS',
					},
				},
				deleteSlot: {
					successMessageCss: 'Slot deleted successfully',
					modale: {
						title: 'Delete Event',
						description: 'Are you sure you want to delete this event?\nYou will not be able to undo this action.',
						secondaryButton: 'CANCEL',
						primaryButton: 'Yes, Delete',
					},
				},
			},
			segment: 'Segment',
			deleteSegment: 'Delete Segment',
			addNewButtonTooltip: 'Add segment',
			deleteSegmentModal: {
				title: 'Delete Segment',
				description: 'Are you sure you want to delete this segment of events? You will not be able to undo this action',
				mainButton: 'Yes, delete Series',
				subButton: 'Cancel',
			},
			newSegmentModal: {
				title: 'New Segment',
				description: 'Add a new segment of events to your reservation to easily differentiate between event types',
				duplicate: 'Duplicate',
				mainButton: 'duplicate',
				subButton: 'Skip',
				secondButton: 'Cancel',
			},
			changeProductModal: {
				title: 'Product Validation',
				description:
					'The data you’ve selected to edit may affect the product or product pricing.\nWould you like to keep the current product and override \npricing and validation or change the product?',
				note: '\nNote: Selecting "Change Product" may erase your add-ons.',
				mainButton: 'Keep & Override',
				secondButton: 'Change product',
				subButton: 'Cancel',
			},
			restorePunchesModal: {
				title: 'Return punches to pass?',
				description: (punches: number, duration: string, passName: string): string => {
					const punchLabel: string = punches === 1 ? '1 punch' : `${punches} punches`;

					if (!passName) {
						return `This change frees ${punchLabel}.`;
					}

					return `This change frees ${punchLabel} (${duration}) from ${passName}.`;
				},
				restore: (punches: number): string => `Return ${punches === 1 ? '1 punch' : `${punches} punches`}`,
				keep: (punches?: number) => `Keep ${punches === 1 ? '1 punch' : `${punches} punches`}`,
				cancel: 'Cancel',
			},
			tabs: {
				details: 'Reservation Details',
				segments: 'Segment Details',
				summary: 'Conflicts',
				pricing: 'Pricing',
				extras: 'Extras',
			},
			eventDetails: {
				title: 'Event Title',
				evenTypeList: {
					public: { title: 'Public Event', description: 'Anyone can see event details' },
					private: { title: 'Private Event', description: 'Only admins can see event details' },
				},
				eventTypeLabel: 'Event Type',
			},
			discardModal: {
				title: 'Discard reservation details?',
				mainActionButtonText: 'DISCARD',
				cancelButtonText: 'CANCEL',
				description: '',
			},
			reservationWarningModal: {
				title: 'Discard Changes?',
				anyChangesYouHaveMade: 'Any changes you have made to the schedule',
				willBeErased: 'will be erased if you go back.',
				mainAction: 'go back and Discard',
				cancel: 'CANCEL',
			},
			holdForReservationModal: {
				title: 'Hold For Reservation',
				description:
					'This will create the reservation in an “Invoice” status. You will then be able to go into the reservation and invoice your customer based on their usage of the reservation',
				mainAction: 'yes, HOLD',
				cancel: 'CANCEL',
			},
			editRecurringEventModal: {
				title: 'Edit recurring event',
				options: {
					thisEventOnly: 'This event only',
					thisAndFollowingEvents: 'This and following events',
					allEvents: 'All events',
				},
				mainButton: 'ok',
				subButton: 'cancel',
			},
			singleEdit: {
				title: 'Edit Event',
				conflictsWarning: {
					thisEventHas: 'This event has',
					conflicts: 'conflicts',
					message: (count: number): string => `This event has ${count} conflicts.`,
				},
				selectAllSlotsLabel: (count: number): string => `${count} Slots`,
				editMaintenance: 'Edit Maintenance',
				expandButtonTooltip: { sideView: 'Side View', expandView: 'Expand View' },
				reservation: { title: 'Reservation' },
				actionButtons: { save: 'save', cancel: 'cancel' },
				tabs: { details: 'Details', pricing: 'Pricing' },

				successMessage: 'Event updated successfully',
				pendingPaymentError: 'You cannot edit the price of an event with a pending payment.',
			},
			editSlot: {
				errorMessages: {
					getSlot: 'Unable to load the event details. Please try again.',
					updateSlot: 'Unable to save event changes. Please try again.',
				},
			},
			massEdit: {
				successMessage: 'Events successfully updated!',
				mainPage: { title: 'Select Slots to Edit' },
				header: {
					labels: {
						resources: 'Resources',
						eventTitle: 'Event Title',
						isPrivate: 'isPrivate',
						activity: 'Activity',
						addOns: 'Add-Ons',
						publicNote: 'Slots public note',
						privateNote: 'Slots private note ',
						maintenance: 'Maintenance',
						dateAndTime: 'Date & Time / Duration',
					},
				},
				cardTitle: 'EVENTS MASS EDIT',
				individual: { title: 'Individual Mass Edit' },
				collectively: { title: 'Collective Mass Edit' },
				massEditModal: {
					title: 'Mass Edit',
					subTitle: 'slots',
					sectionSelect: {
						placeholder: 'Select sections',
						label: 'What data of the event slots would you like to edit?',
						options: {
							[SectionToEditEnum.TITLE]: 'Event Title',
							[SectionToEditEnum.PRIVACY_SETTING]: 'Event Type',
							[SectionToEditEnum.SPACE]: 'Space',
							[SectionToEditEnum.INSTRUCTORS]: 'Instructors',
							[SectionToEditEnum.ACTIVITY_TYPE]: 'Activity',
							[SectionToEditEnum.PRODUCT]: 'Product',
							[SectionToEditEnum.DATE_AND_TIME]: 'Date & Time / Duration',
							[SectionToEditEnum.TIME]: 'Time / Duration',
							[SectionToEditEnum.DATE]: 'Day / Date',
							[SectionToEditEnum.MAINTENANCE]: 'Maintenance',
							[SectionToEditEnum.PUBLIC_NOTE]: 'Public Notes',
							[SectionToEditEnum.PRIVATE_NOTE]: 'Private Notes',
							[SectionToEditEnum.ADD_ONS]: 'Add-Ons',
							[SectionToEditEnum.COLOR_SET]: 'Color Set',
						},
					},
					howToEditRadios: {
						label: 'How would you like to edit this across the selected slots?',
						individually: { title: 'Individually', description: 'Different edit for each slot' },
						collectively: { title: 'Collectively', description: 'Same edit for all slots' },
					},
					notification:
						'Collectively editing parameters with different values between slots will override the existing data.',
					mainButton: 'next',
					subButton: 'Cancel',
					slotCountDescription: (count: number, subTitle: string) => `${count} ${subTitle}`,
				},
				deleteSlotsModal: {
					title: {
						firstPart: 'You’re about to delete',
						secondPart: 'slots from this reservation',
						withCount: (count: number): string => `You’re about to delete ${count} slots from this reservation`,
					},
					description: 'Deleted slots cannot be recovered and their data will be permanently lost.',
					mainAction: 'back to selection',
					subButton: 'Delete Permanently',
				},
				editSlotsModal: {
					title: {
						firstPart: 'You’re about to edit',
						secondPart: 'slots from this reservation',
						withCount: (count: number): string => `You’re about to edit ${count} slots from this reservation`,
					},
					description: 'Confirming changes will replace the existing data with the changes you’ve made.',
					mainAction: 'Confirm changes',
					secondButton: 'View changes',
					subButton: 'Cancel',
				},
				previewChangesModal: {
					title: 'Slots have been edited',
					subTitle: {
						viewing: 'Viewing',
						changes: 'changes',
					},
					info: 'Confirming changes will replace the existing data with the changes you’ve made.',
					actionButtons: { cancel: 'cancel', confirmChanges: 'Confirm changes' },
					changesTable: {
						columns: {
							eventTitle: 'Event Title',
							eventType: 'Event Type',
							resourceAndActivity: 'Resource & Activity',
							addons: 'Add-ons',
							date: 'Date',
							time: 'Time & Duration',
							maintenance: 'Maintenance',
							notes: 'Notes',
							publicNote: 'Public Note',
							privateNote: 'Private Note',
						},

						addons: { viewAddons: 'view Addons' },
						notes: { viewNotes: 'View notes', publicNote: 'Public note', privateNote: 'Private note' },
						eventType: { public: 'Public', private: 'Private' },
						items: 'items',
						collectiveChanges: { header: { title: 'Collective Changes' } },
					},
				},
				productsValidationErrorModal: {
					title: 'Product Validation',
					individualDescription:
						'The data you’ve edited is no longer compatible with the selected products of these slots:',
					collectiveDescription: 'The data you’ve edited is no longer compatible with the selected product.',
					primaryButton: 'OKAY',
				},
				validationResaultModal: {
					title: (numberOfSlots: number) => `Mass Editing ${numberOfSlots} Slots`,
					description:
						'Approving the changes you made will replace existing data. \nThe invoice will be updated to reflect the new price:',
					totalPriceChanged: (totalPrice: number) => `Total price change: ${Pricify(totalPrice)}`,
					originalTotalPrice: 'Original Price Total:',
					newTotalPrice: 'New Price Total:',
					primaryButton: 'APPROVE CHANGES',
					secondaryButton: 'DISMISS',
				},
			},
			duplicateSlot: {
				title: 'Duplicate event',
				successMessage: 'Slot was duplicated successfully',
				errMessages: {
					noProduct:
						'No rental product is configured for this schedule and activity. Please contact your administrator to set up pricing, or choose a different time slot.',
					genericError: 'Something went wrong while duplicating the slot. Please try again.',
				},
				saveModalOld: {
					title: 'Duplicate Slot',
					description: {
						slotPrice: 'The price of the slot is',
						addonsPrice: 'The price of the addons for this slot is',
						total: 'Total',
						addToInvoiceQuestion: 'would you like to add it to the invoice?',
					},
					mainButton: 'Add to Balance',
					secondButton: 'Leave as is',
					subButton: 'cancel',
				},
				saveModal: {
					title: 'Duplicate Slot',
					statusInvoiceDescription:
						'The new slot will be added to the same reservation invoice of the slot you are duplicating',
					total: 'Total',
					description: 'Would you like to add the slot to the current invoice?',
					mainButton: 'Add to current invoice',
					secondButton: 'new invoice',
					subButton: 'cancel',
					addToOrder: 'Add to order',
				},
			},

			actions: {
				errors: {
					generalError: 'Something went wrong while processing your request. Please try again or refresh the page.',
				},
			},
		},
		newReservationDepricated: {
			header: {
				sideView: 'Side View',
				expandView: 'Expand View',
			},
		},
		addToReservationDetails: {
			reservation: 'Reservation:',
		},
		eventConflicts: (conflictsCount: number) =>
			`Event has ${conflictsCount} conflict${conflictsCount === 1 ? '' : 's'}`,
		slotForm: {
			header: { tabs: { details: 'Details', extras: 'Extras', pricing: 'Pricing' } },
			details: { title: 'EVENT DETAILS' },
			extras: { addons: 'Slot-Addons' },
		},
		validation: {
			untilDateError: (date: string) => `Please select an end date that falls before ${date}.`,
			pastDateError: 'Date cannot be in the past',
			futureBirthDateError: 'Birthdate cannot be in the future',
			notBeforeError: 'cannot be before',
			notBeforeWithLabel: (label: string) => `cannot be before ${label}`,
			required: 'required',
			invalidHexColor: 'Invalid hex color',
			invalidValue: 'Invalid',
			invalidLowValue: 'Inavalid low value',
			invalidHighValue: 'Invalid high value',
			min: (amount: number): string => `Please enter a value greater than or equal to ${amount}`,
			max: (amount: number): string => `Please enter a value less than or equal to ${amount}`,
			oneOf: (items: string[]): string => `Please select at least one of ${items.join(', ')}`,
		},
		blocks: {
			quantity: { label: 'Quantity' },
			productCategory: {
				label: 'Product Category',
			},
			visibilityBlock: {
				label: 'visibility',
				options: [
					{ label: 'Public', value: VisibilityEnum.PUBLIC },
					{ label: 'Private', value: VisibilityEnum.PRIVATE },
					//Hide is not for next phases{ label: 'Hide', value: VisibilityEnum.HIDE },
				],
				info: `Choose how the reservation events appear on external screens. These can also be modified at the segment or event level.\nPublic: Displays the reservation name \nPrivate: Shows slots as 'Private Event'`,
				//Hide is not for next phases
				//info: `Choose how the reservation events appear on external screens. These can also be modified at the segment or event level.\nPublic: Displays the reservation name \nPrivate: Shows slots as 'Private Event' \nHide: Hides all slots in the reservation completely`,
			},
			dayMonthFormBlock: { secondaryLabel: '(select day and month)', startDate: 'Start Date', endDate: 'End Date' },
			selectTaxBlock: {
				label: 'Tax',
				deactivated: 'Deactivated',
				addTax: 'Add tax',
				required: 'Select a tax',
				calculationType: (isInclusive: boolean) => (isInclusive ? 'Inclusive' : 'Exclusive'),
				taxLabel: (name: string, rate: string, calculationType: string) => `${name} - ${rate} - ${calculationType}`,
				link: {
					linkDescription: 'Can’t find what you’re looking for?',
					linkLabelPrefix: 'Create a new tax ',
					linkLabel: 'here.',
				},
			},
			taxFormBlock: {
				title: 'Tax Settings',
				taxType: {
					label: 'Tax Type',
					options: [
						{ label: 'Inclusive', value: BooleanString.True },
						{ label: 'Exclusive', value: BooleanString.False },
					],
				},
				taxPercentage: 'Tax Percentage',
			},
			glCodes: {
				accountingCodes: 'Accounting codes',
				label: 'Code',
				placeholder: 'Select',
				maxSelectionsError:
					"You've reached the maximum number of accounting codes that can be selected. Remove one to add another.",
				addAccountingCode: 'Add Accounting Code',
				remove: 'Remove',
				link: {
					linkDescription: "Can't find what you're looking for?",
					linkLabelPrefix: 'Create a new accounting code ',
					linkLabel: 'here.',
				},
				types: 'Type',
				typeAlreadySelected: (type: string) => `${type} type already selected`,
				staleGlCodeWarning: (codeName: string) => `"${codeName}" is no longer available for the selected facilities.`,
				staleGlCodesError: 'Selected accounting codes do not match selected facilities.',
			},
			gender: 'Gender',
			genderAriaLabel: 'gender',
			TimeSlotBlock: {
				title: 'TIME SLOT',
				titleWithIndex: (index: number) => `TIME SLOT #${index}`,
				remove: 'Remove',
				TimePicker: {
					duration: { toggleText: 'Duration', title: 'Ends' },
					time: { starts: 'Starts', ends: 'Ends' },
					allDay: 'All day',
					operatingHours: 'Operating Hours',
					durationEnd: 'Ends',
				},
				maintenanceToggle: 'maintenance',
			},
			TimeSlotArray: {
				addTimeSlot: 'Add time slot',
				addDescription:
					'Each time slot will refer to the resources you set for this segment. To set a different resource, add another segment',
			},
			maintenanceForm: {
				title: 'Maintenance-time Name',
				newMaintenanceTime: 'Add maintenance',
				duration: 'Duration',
				startTime: 'Start-time',
				options: {
					beforeTheEvent: 'Before the event',
					afterTheEvent: 'After the event',
					atTheBeginningOfTheEvent: 'At the beginning of the event',
					atTheEndOfTheEvent: 'At the end of the event',
				},
			},
			addons: {
				add: 'Add Add-ons',
				removeAddon: 'Remove Add-ons',
				title: 'Add-Ons',
				newAddon: 'New add-on',
				remove: 'Remove',
				clear: 'Clear',
				removeTooltip: 'Remove add-on',
				placeHolders: { addon: 'add-on', selectVariant: 'Select variant', quantity: 'Qty' },
			},
			resources: { title: 'resources', activity: { label: 'Activity' } },
			PublicPrivateNotes: {
				or: 'or',
				publicNotes: {
					label: 'Reservation public note',
					info: 'some inf',
				},
				privateNotes: { label: 'Reservation private note', info: 'some info' },
			},
			publicNote: { addLabel: 'Add Public Note', clearLabel: 'Clear Public Note' },
			privateNote: { addLabel: 'Add Private Note', clearLabel: 'Clear Private Note' },
			priceAndTimeFrame: { helperContent: 'Slots count' },
			amountBlock: { amount: 'amount', type: 'type' },
			timeUnitSelection: {
				label: 'Time Unit',
				options: [
					{ label: 'Day', value: TimeUnit.DAY },
					{ label: 'Week', value: TimeUnit.WEEK },
					{ label: 'Month', value: TimeUnit.MONTH },
					{ label: 'Year', value: TimeUnit.YEAR },
				],
			},
			monthPicker: [
				{ label: 'Jan', value: '1' },
				{ label: 'Feb', value: '2' },
				{ label: 'Mar', value: '3' },
				{ label: 'Apr', value: '4' },
				{ label: 'May', value: '5' },
				{ label: 'Jun', value: '6' },
				{ label: 'Jul', value: '7' },
				{ label: 'Aug', value: '8' },
				{ label: 'Sep', value: '9' },
				{ label: 'Oct', value: '10' },
				{ label: 'Nov', value: '11' },
				{ label: 'Dec', value: '12' },
			],
			dayPicker: [
				{ label: 'Mon', value: DayPickerEnum.MONDAY },
				{ label: 'Tue', value: DayPickerEnum.TUESDAY },
				{ label: 'Wed', value: DayPickerEnum.WEDNESDAY },
				{ label: 'Thu', value: DayPickerEnum.THURSDAY },
				{ label: 'Fri', value: DayPickerEnum.FRIDAY },
				{ label: 'Sat', value: DayPickerEnum.SATURDAY },
				{ label: 'Sun', value: DayPickerEnum.SUNDAY },
			],
			dayPickerFull: [
				{ label: 'Monday', value: DayPickerEnum.MONDAY },
				{ label: 'Tuesday', value: DayPickerEnum.TUESDAY },
				{ label: 'Wednesday', value: DayPickerEnum.WEDNESDAY },
				{ label: 'Thursday', value: DayPickerEnum.THURSDAY },
				{ label: 'Friday', value: DayPickerEnum.FRIDAY },
				{ label: 'Saturday', value: DayPickerEnum.SATURDAY },
				{ label: 'Sunday', value: DayPickerEnum.SUNDAY },
			],
			durationPicker: [
				{ label: '0.5 hr', value: DurationMinutesEnum.HalfHour },
				{ label: '1 hr', value: DurationMinutesEnum.OneHour },
				{ label: '1.5 hr', value: DurationMinutesEnum.OneAndHalfHour },
				{ label: '2 hr', value: DurationMinutesEnum.TwoHours },
				{ label: 'Full Day', value: DurationMinutesEnum.FullDay },
				{ label: 'Custom', value: DurationMinutesEnum.Custom },
			],
			durationBlock: {
				quantity: 'Quantity',
				unitType: 'Unit Type (minutes, hours, days)',
				durationOptions: [
					{ label: 'Minutes', value: 'minutes' },
					{ label: 'Hours', value: 'hours' },
					{ label: 'Days', value: 'days' },
				],
			},
			timesBlock: { from: { label: 'From' }, to: { label: 'To' } },
			daysAndTimesArray: {
				addTimeSlot: 'Add time slot',
				errors: { overlappingOpeningTimes: 'Schedules overlap. Please review and adjust your schedule settings.' },
			},

			customPricingSchedule: {
				title: 'Custom Pricing Schedule',
				subTitle: 'Set different rates based on schedule',
				tooltip:
					'Do you offer peak and seasonal pricing? Instead of creating multiple similar products, you can configure your seasonal pricing here, and Bond will auto-calculate the right price to use based on each rental schedule. The default rate will be used outside of these custom pricing schedules',
				addPricingSchedule: 'Add New Custom Pricing Schedule',
				overlappingErrorMessage: 'Pricing schedules overlap. Please review and adjust your schedule settings.',
			},
			facilitiesAndScheduleArray: {
				addFacility: 'Add another facility',
				removeSchedule: 'Remove Schedule',
				facilitiesTooltip: 'You can select one or multiple facilities for a single schedule.',
				alreadyAssigned: 'Already assigned to another schedule',
			},
			facilities: { label: 'Facilities', placeholder: 'Select', allFacilities: 'Select All' },
			stations: { label: 'Stations', placeholder: 'Select stations', allStations: 'All Stations' },
			singleFacility: { label: 'Facility', placeholder: 'Select' },
			activities: {
				label: 'Activities',
				placeholder: 'Select',
				allActivities: 'All Activities In Selected Facilities',
			},
			programTypes: {
				label: 'Program Type',
			},
			rentalProducts: { label: 'Rental Products' },
			removeSelectionWarning: {
				title: 'Warning',
				primaryButton: "Yes, i'm sure",
				secondaryButton: 'Cancel',
			},
			instructors: { label: 'Instructors' },
			spaces: { label: 'Spaces' },
			customers: { label: (isMultiple: boolean) => (isMultiple ? 'Customers' : 'Customer') },
			customerGating: {
				title: 'Gating',
				tooltip:
					'Gating controls who can access this rental. Make it available to everyone, selected customers, or selected memberships. Customer and membership gating can’t be used together.',
				isForAllCustomers: 'Available to all customers',
				isForSelectedCustomers: 'Available to selected customers',
				isForMembershipMembers: 'Available to selected memberships',
				membershipLabel: 'Memberships',
				membershipPlaceholder: 'Select',
				validation: {
					gatingTypeRequired: 'Please select a gating type',
					customersRequired: 'Please select at least one customer',
					membershipsRequired: 'Please select at least one membership',
				},
			},
			bookingPayment: {
				title: 'Booking payment',
				sectionLabel: 'Online Booking Deposit',
				payInFull: 'Pay in full at booking',
				noPayment: 'No payment required at booking',
				collectDeposit: 'Collect a deposit',
				deposit: {
					placeholder: '0.00',
					helper:
						'This amount is charged per base time unit and scales with the reservation duration. For example, a $10 deposit on a 4-hour booking = $40 due at booking.',
				},
				validation: {
					typeRequired: 'Please select a booking payment option',
					depositRequired: 'Please enter a deposit amount',
					depositMin: (currency: CurrencySymbolEnum) => `Deposit must be at least ${Pricify(0.01, currency)}`,
					depositMustBeLessThanPrice: (price: number, currency: CurrencySymbolEnum) =>
						`Deposit must be less than ${Pricify(price, currency)}`,
				},
			},
			rentalProductForms: {
				title: 'Forms',
				label: 'Forms',
				placeholder: 'Select',
				link: {
					linkDescription: "Can't find what you're looking for?",
					linkLabelPrefix: 'Create a new form ',
					linkLabel: 'here.',
				},
				failedToFetchForms: 'Failed to load forms. Please try again later.',
				failedToSaveForms: `Failed to save forms. Please try again later or contact ${SUPPORT_EMAIL} if the issue persists.`,
			},
			rentalPunchPassForms: {
				title: 'Forms & Documents',
				label: 'Forms Upon Purchase',
				additionalLabel: 'Forms Upon Redemption',
				placeholder: 'Select',
				link: {
					linkDescription: "Can't find what you're looking for?",
					linkLabelPrefix: 'Create a new form ',
					linkLabel: 'here.',
				},
				failedToFetchForms: 'Failed to load forms. Please try again later.',
				tooltip:
					'Forms upon purchase are completed when the pass is purchased. Forms upon redemption are completed when the pass is redeemed.',
			},
			participantPrice: {
				min: 'Min. Participants',
				max: 'Max. Participants',
				participantPrice: 'Participant Price',
				groupPrice: 'Group Price',
			},
			participantPriceArray: {
				add: 'Add pricing parameter',
				remove: 'Remove pricing parameter',
			},
			extraParticipents: {
				maxParticipants: 'Max. Participants',
				extraParticipantPrice: 'Extra Participant Price',
			},
		},
		reservation: {
			addSegment: {
				header: {
					title: 'Add new segment',
					tabs: { details: 'Details', conflicts: 'Conflicts', extras: 'Extras', pricing: 'Pricing' },
				},
				extras: { title: 'EXTRAS', segmentAddons: 'Segment Add-ons' },
				footer: { save: 'save', next: 'next' },
				details: 'DETAILS',
				addSegmentModal: {
					title: 'Add segment to reservation',
					addToInvoice: {
						description: 'Would you like to add segment to invoice?',
						mainButton: 'Add to order',
						subButton: 'New invoice',
					},
					addToPayment: {
						description: 'To what invoice would you like to add the segment?',
						mainButton: { existing: 'Add to existing invoice', current: 'Add to current invoice' },
						secondButton: 'New invoice',
						subButton: 'Add to order',
					},
					successMessage: 'Segment Added Successfully',
				},
			},
		},
		programEvent: {
			conflicts: {
				notification: {
					hasConflicts: 'This event has conflicts',
					cta: 'open',
				},
			},
			discardModal: {
				title: 'Discard event details?',
				mainActionButtonText: 'DISCARD',
				cancelButtonText: 'CANCEL',
				description: 'Any changes you have made to the event will be discarded',
			},
			noResourceId: 'Event could not be saved because no space is assigned. Please select a space and try again.',
			sessionHydrationError: 'We could not load this event’s session details. Retry before editing the event.',
			gameScoreCheckError: 'We could not verify whether this event has a score. Retry before editing teams.',
			conflictEventLoadError: 'We could not load the complete event details. Retry before editing the event.',
			retry: 'Retry',
		},
	},
	conflicts: {
		panel: {
			infoMessage: 'For changing event space you can select it for use drag & drop mode or edit event details manually',
			conflictsSolved: 'Conflict resolved',
			done: 'Done',
		},
		conflictsModal: {
			title: 'There are conflicts in this event',
			mainButton: 'Approve',
			subButton: 'Back to editing',
			bodyTitle: 'By changing this event you created new conflict on',
		},
	},
	general: {
		buttons: {
			next: 'next',
			cancel: 'Cancel',
			create: 'Create',
			discard: 'discard',
			delete: 'Delete',
			back: 'Back',
			ok: 'ok',
			okay: 'OKAY',
			save: 'save',
			viewAll: 'view all',
			remove: 'Remove',
			add: 'add',
			clear: 'clear',
		},
		placeholder: { select: 'Select', richText: 'Type here...', number: '0' },
	},
	lastLoginIndicator: {
		never: 'Never logged in',
		lastLogin: 'Last login:',
		withDate: (date: string) => `Last login: ${date}`,
	},
	addCustomer: 'add a customer',
	lists: {
		frequencies: [
			{ label: 'Daily', value: 'daily' },
			{ label: 'Weekly', value: 'weekly' },
			// { label: 'Monthly', value: 'monthly' }, // not supported for now
		],
		everyDay: [
			{ label: '1 Day', value: '1' },
			{ label: '2 Day', value: '2' },
			{ label: '3 Day', value: '3' },
			{ label: '4 Day', value: '4' },
		],
		everyWeek: [
			{ label: '1 Week', value: '1' },
			{ label: '2 Week', value: '2' },
			{ label: '3 Week', value: '3' },
		],
		everyMonth: [{ label: '1 Month', value: '1' }],
		visibilityOptions: [
			{ value: VisibilityEnum.PRIVATE, label: 'Private' },
			{ value: VisibilityEnum.PUBLIC, label: 'Public' },
		],
		dayOfWeekList: [
			{
				label: 'M',
				value: 2,
			},
			{
				label: 'T',
				value: 3,
			},
			{
				label: 'W',
				value: 4,
			},
			{
				label: 'T',
				value: 5,
			},
			{
				label: 'F',
				value: 6,
			},
			{
				label: 'S',
				value: 7,
			},
			{
				label: 'S',
				value: 8,
			},
		],
	},
	buttons: {
		save: 'save',
		cancel: 'cancel',
		done: 'done',
		next: 'next',
		continue: 'continue',
		savChanges: 'SAVE CHANGES',
		edit: 'edit',
		goBack: 'Go Back',
		confirm: "Yes, I'm sure",
	},
	reconciliation: {
		shiftReconciledSuccess: 'Shift reconciled successfully',
		closingAmountUpdatedSuccess: 'Closing amount updated successfully',
		title: 'Reconciliation',
		shiftId: 'Shift Id',
		dates: 'Dates',
		open: 'Open',
		close: 'Close',
		stillOpen: 'Still Open',
		station: 'Station',
		status: 'Status',
		openBy: 'Opened by',
		closeBy: 'Closed by',
		shiftStarted: 'Shift Started',
		shiftEnded: 'Shift Ended',
		activeNow: 'Active Now',
		facility: 'Facility',
		filters: {
			byStatus: 'Filter by status',
			byStations: 'Filter by Station',
			openSince: 'Opened since',
			closeBefore: 'Closed before',
			closedByCashier: 'Closed by (Cashier)',
			closedByManager: 'Closed by (Manager)',
			reconciledBy: 'Reconciled by',
		},
		actions: {
			reviewAndReconcile: 'Review & Reconcile',
		},
		table: {
			subject: 'shifts',
			noDataMessage: 'No shifts found',
			loadingMessage: 'Loading shifts...',
			errorMessage: 'Failed to load shifts. Please try again.',
		},
		dateRangePlaceholder: 'Select date range',
		clearDateRange: 'Clear',
		header: {
			title: 'Reconciliation',
			breadcrumb: { label: 'Reconciliation', to: RECONCILIATION_PATH },
		},
		statusLabels: {
			open: 'Open',
			closed: 'Closed',
			reconciled: 'Reconciled',
			closed_by_manager: 'Closed by Manager',
		},
		popup: {
			shiftNum: 'Shift #',
			openedBy: 'Opened By:',
			closedBy: 'Closed By:',
			totalCredit: 'Total Card :',
			totalCreditInTerminal: 'Total Card on terminal :',
			totalCheck: ' Total Check :',
			totalGiftCard: 'Total Gift Card :',
			totalAch: 'Total ACH :',
			totalCash: 'Total Cash :',
			totalOther: 'Total Other :',
			openingCash: 'Opening Cash :',
			closingCashier: 'Closing Cash Cashier :',
			closingManager: 'Closing Cash Manager Amount',
			cancel: 'Cancel',
			set: 'Set',
			reconcile: 'Reconcile',
			overAndShort: 'Over Short',
			over: 'Over',
			short: 'Short',
			expectedCash: 'Expected Cash',
		},
	},
	expandableText: { read: 'Read', more: 'More', less: 'Less' },
	googleAddress: {
		label: 'Address',
		placeholder: 'Enter full address',
		requiredLabel: (label: string) => `${label} *`,
		formatStreet,
		geocodingNoResults: 'No results found for that address. Please try a different address.',
		incompleteAddress: 'Please enter a full address (street, city, state/province, ZIP, country).',
		fields: {
			street: 'Address',
			city: 'City',
			state: 'State / Province',
			zip: 'ZIP code',
			country: 'Country',
		},
		placeholders: {
			street: 'Enter address',
			city: 'Enter city',
			state: 'Enter state',
			zip: 'Enter zipcode',
			country: 'Enter country',
		},
	},
	permissions: {
		header: {
			title: 'Roles & Permissions',
		},
		roles: {
			editRole: 'Edit Role',
			addUsers: 'Add Users',
			update: 'Update',
			choosePermissions: 'Choose Permission to this role',
			createNewRole: 'Create New Role',
			createRole: 'Create Role',
			roleName: 'Role Name',
			userInRole: 'Users in Role:',
			userRole: 'Users => Role',
			noUserInRole: 'Seems there is no users in this role',
			usersToAdd: 'Users to Add:',
		},
		notAuthorized: {
			mainLabel: 'You do not have the necessary permission to proceed.',
			subLabel: 'Please contact your manager for assistance.',
		},
	},
	timeFrame: { min: 'Min', hour: 'Hour' },
	settings: {
		basicBreadcrumbs: [
			{ label: 'Settings', to: ORGANIZATION_PATH },
			{ label: 'Organization', to: ORGANIZATION_PATH },
		],
		newOrganization: 'New Organization',
		title: 'Settings',
		tabs: {
			[SETTINGS_TABS.ORGANIZATION]: { label: 'Organization' },
			[SETTINGS_TABS.EMPLOYEES]: { label: 'Employees' },
			[SETTINGS_TABS.FINANCIAL]: { label: 'Financial' },
			[SETTINGS_TABS.HISTORY]: { label: 'History' },
		},
		history: {
			entityTypeLabels: AUDIT_ENTITY_TYPE_LABELS,
			table: {
				subject: 'actions',
				columns: {
					createdAt: 'Date',
					actor: 'Actor',
					action: 'Action',
					entityType: 'Entity type',
					area: 'Area',
					entityName: 'Entity',
					platform: 'Platform',
					record: 'Record',
					flow: 'Flow',
					parser: {
						record: {
							name: (name: string) => upperFirst(name),
							idPrefix: (id: number) => `ID ${id}`,
						},
						actor: {
							unknown: 'Unknown',
							viewProfile: 'View profile',
						},
						actorType: {
							staff: 'Staff',
							consumer: 'Consumer',
							[AuditActorTypeEnum.SYSTEM]: 'System',
						},
						area: [
							{ value: AuditAreaEnum.RESERVATIONS, label: 'Reservations' },
							{ value: AuditAreaEnum.PROGRAMS, label: 'Programs' },
							{ value: AuditAreaEnum.MEMBERSHIPS, label: 'Memberships' },
							{ value: AuditAreaEnum.COMMERCE, label: 'Commerce' },
							{ value: AuditAreaEnum.FINANCE, label: 'Finance' },
							{ value: AuditAreaEnum.CUSTOMERS, label: 'Customers' },
							{ value: AuditAreaEnum.SETTINGS, label: 'Settings' },
							{ value: AuditAreaEnum.COMMUNICATIONS, label: 'Communications' },
							{ value: AuditAreaEnum.FORMS, label: 'Forms' },
						],
					},
				},
				filters: {
					actions: [
						{ value: AuditActionTypeEnum.CREATE, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.CREATE] },
						{ value: AuditActionTypeEnum.UPDATE, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.UPDATE] },
						{ value: AuditActionTypeEnum.MASS_EDIT, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.MASS_EDIT] },
						{ value: AuditActionTypeEnum.DELETE, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.DELETE] },
						{ value: AuditActionTypeEnum.CANCEL, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.CANCEL] },
						{ value: AuditActionTypeEnum.ARCHIVE, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.ARCHIVE] },
						{ value: AuditActionTypeEnum.REFUND, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.REFUND] },
						{ value: AuditActionTypeEnum.PURCHASE, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.PURCHASE] },
						{ value: AuditActionTypeEnum.VOID, label: AUDIT_ACTION_TYPE_LABELS[AuditActionTypeEnum.VOID] },
					],
					flows: [
						{ value: AuditActionNameEnum.CONNECTED, label: 'Connected' },
						{ value: AuditActionNameEnum.ISSUED, label: 'Issued' },
						{ value: AuditActionNameEnum.REDEEMED, label: 'Redeemed' },
						{ value: AuditActionNameEnum.JOINED, label: 'Joined' },
						{ value: AuditActionNameEnum.SIGNED, label: 'Signed' },
						{ value: AuditActionNameEnum.DUPLICATED, label: 'Duplicated' },
						{ value: AuditActionNameEnum.PURCHASED, label: 'Purchased' },
						{ value: AuditActionNameEnum.REGISTERED, label: 'Registered' },
						{ value: AuditActionNameEnum.SOLD, label: 'Sold' },
						{ value: AuditActionNameEnum.EDITED, label: 'Edited' },
						{ value: AuditActionNameEnum.MOVED, label: 'Moved' },
						{ value: AuditActionNameEnum.PUBLISHED, label: 'Published' },
						{ value: AuditActionNameEnum.UNPUBLISHED, label: 'Unpublished' },
						{ value: AuditActionNameEnum.APPROVED, label: 'Approved' },
						{ value: AuditActionNameEnum.REJECTED, label: 'Rejected' },
						{ value: AuditActionNameEnum.RESCHEDULED, label: 'Rescheduled' },
						{ value: AuditActionNameEnum.PAUSED, label: 'Paused' },
						{ value: AuditActionNameEnum.RESUMED, label: 'Resumed' },
						{ value: AuditActionNameEnum.PROMOTED, label: 'Promoted' },
						{ value: AuditActionNameEnum.CHECKED_IN, label: 'Checked in' },
						{ value: AuditActionNameEnum.UNDID, label: 'Undid' },
						{ value: AuditActionNameEnum.APPLIED, label: 'Applied' },
						{ value: AuditActionNameEnum.COLLECTED, label: 'Collected' },
						{ value: AuditActionNameEnum.RECONCILED, label: 'Reconciled' },
						{ value: AuditActionNameEnum.SENT, label: 'Sent' },
						{ value: AuditActionNameEnum.MERGED, label: 'Merged' },
						{ value: AuditActionNameEnum.ACTIVATED, label: 'Activated' },
						{ value: AuditActionNameEnum.DEACTIVATED, label: 'Deactivated' },
						{ value: AuditActionNameEnum.CHANGED, label: 'Changed' },
						{ value: AuditActionNameEnum.MADE_DEFAULT, label: 'Made default' },
						{ value: AuditActionNameEnum.MADE_ADMIN, label: 'Made admin' },
						{ value: AuditActionNameEnum.SCHEDULED, label: 'Scheduled' },
						{ value: AuditActionNameEnum.REMOVED, label: 'Removed' },
						{ value: AuditActionNameEnum.VOIDED, label: 'Voided' },
						{ value: AuditActionNameEnum.MASS_MOVED, label: 'Mass moved' },
						{ value: AuditActionNameEnum.DUPLICATED_SLOTS, label: 'Duplicated slots' },
						{ value: AuditActionNameEnum.ADDED_SEGMENTS, label: 'Added segments' },
						{ value: AuditActionNameEnum.EDITED_SLOTS, label: 'Edited slots' },
						{ value: AuditActionNameEnum.ADDED_ADDONS, label: 'Added add-ons' },
						{ value: AuditActionNameEnum.EDITED_ADDONS, label: 'Edited add-ons' },
						{ value: AuditActionNameEnum.REMOVED_ADDONS, label: 'Removed add-ons' },
						{ value: AuditActionNameEnum.INVOICED, label: 'Invoiced' },
						{ value: AuditActionNameEnum.CANCELLED_SLOTS, label: 'Cancelled slots' },
					],
					platforms: [
						{ value: PlatformsEnum.BO, label: 'Backoffice' },
						{ value: PlatformsEnum.CONSUMER, label: 'Consumer' },
						{ value: PlatformsEnum.CRON, label: 'Cron' },
						{ value: PlatformsEnum.IMPORT, label: 'Import' },
					],
					entityTypes: [
						{ value: ResourceNameTypeEnum.EMPLOYEE, label: 'Employee' },
						{ value: ResourceNameTypeEnum.RESERVATION, label: 'Reservation' },
					],
					searchBy: {
						placeholder: 'Search by',
						actor: 'Actor',
						record_id: 'Record ID',
						record_name: 'Record name',
					},
					dateRange: {
						last24Hours: 'Last 24hr',
						last7Days: 'Last Week',
						last30Days: 'Last Month',
						notAfterError: 'Cannot select dates in the future',
					},
				},
				actionBar: {
					searchPlaceholder: 'Search',
				},
			},
			actionPage: {
				fallbackTitle: 'Action',
				recordSubtitle: (id: number, name: string) => `ID ${id} - ${upperFirst(name)}`,
				relatedRecordFallback: (entityType: string, id: number) => `${entityType} ${id}`,
				actorWithType: (name: string, type: string) => `${name} (${type})`,
				breadcrumbs: {
					history: 'History',
				},
				sections: {
					changes: 'Changes',
					relatedRecords: 'Related records',
				},
				empty: {
					changes: 'No fields were changed as part of this action.',
					relatedRecords: 'There are no linked records for this action.',
				},
				table: {
					subject: 'changes',
					emptyMessage: ({ parentType, parentName, parentId, type }: AuditActionDetailsResponseDto) =>
						parentName
							? `${AUDIT_ENTITY_TYPE_LABELS[parentType]} '${parentName}' was ${AUDIT_ACTION_TYPE_LABELS[type]}`
							: `${AUDIT_ENTITY_TYPE_LABELS[parentType]} ${parentId} was ${AUDIT_ACTION_TYPE_LABELS[type]}`,
					columns: {
						entity: 'Entity',
						propertyName: 'Field',
						oldValue: 'Before',
						newValue: 'After',
						parser: {
							entity: {
								name: (name: string) => upperFirst(name),
								idPrefix: (id: number | string) => `ID ${id}`,
								secondaryDetails: (id: number | string, entityType?: string) =>
									`${entityType ? `${entityType} - ` : ''}ID ${id}`,
								approvalStatus: {
									[ReservationStatusEnum.APPROVED]: 'Approved',
									[ReservationStatusEnum.REJECTED]: 'Rejected',
									[ReservationStatusEnum.CANCELED]: 'Canceled',
									[ReservationStatusEnum.PLANNED]: 'Planned',
									[ReservationStatusEnum.AWAITING_ADMIN]: 'Awaiting Admin',
								},
								paymentStatus: {
									[ReservationExtendedEnum.PURCHASE_ORDER]: 'Purchase Order',
									[PaymentStatusEnum.NOT_PAID]: 'Not Paid',
									[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partial Payment',
									[PaymentStatusEnum.FULLY_PAID]: 'Fully Paid',
									[PaymentStatusEnum.REFUNDED]: 'Refunded',
									[PaymentStatusEnum.DISCOUNT]: 'Discount',
									[PaymentStatusEnum.REVERT_DISCOUNT]: 'Revert Discount',
									[PaymentStatusEnum.REVERT]: 'Revert',
									[PaymentStatusEnum.PENDING]: 'Pending',
									[PaymentStatusEnum.RETRY_IN_PROGRESS]: 'Retry in Progress',
								},
							},
							namedEntity: (name: string, id: number | string) => `${name}(ID ${id})`,
							fieldValue: (field: string, value: string) => `${field}: ${value}`,
						},
					},
					actionBar: {
						searchPlaceholder: 'Search',
					},
				},
			},
		},
		organization: {
			noOrganizationProfile: {
				welcome: 'Welcome! 🎉',
				description: "Create your organization profile and let's get started",
				button: 'create organization profile',
			},
			activities: {
				editModal: {
					title: 'Activities',
					subTitle: 'Choose all the activities you offer throughout the year',
					cancel: 'cancel',
					saveChanges: 'save changes',
				},
			},
			facility: {
				createOrganizationNote:
					"Create your organization profile first so you'll be able to start creating a facility profile",
				title: 'FACILITY',
				noFacilities: 'No facilities have been created for your organization.',
				youCan: 'You can',
				createFacility: 'create a facility profile',
				now: 'now.',
				create: 'create',
				createNew: 'create new',
				status: {
					1: 'Unpublish',
					2: 'Published',
				},
			},
			profile: {
				title: 'PROFILE',
				list: { about: 'Organization Details', brandings: 'Brand Colors', generalWaiver: 'General Waiver' },
			},
			facilities: {
				title: 'FACILITIES',
				list: {
					facilitiesManagement: 'Facilities Management',
				},
			},
			devices: {
				title: 'DEVICES',
				list: {
					scanners: 'Scanners',
				},
			},
			resources: {
				title: 'RESOURCES',
				list: {
					spaces: 'Spaces',
					instructors: 'Instructors',
				},
			},
			services: { title: 'SERVICES', list: { activities: 'Activities' } },
			marketing: { title: 'MARKETING', list: { conversion_analytics: 'Conversion Analytics' } },
		},
		employees: {
			employees: {
				title: 'Employees',
				list: {
					employee_accounts: 'Employee Accounts',
					notificationGroups: 'Notification Groups',
				},
			},
			roles: {
				title: 'ROLES & PERMISSIONS',
				list: { roles: 'Roles Management' },
			},
		},
		notificationGroups: {
			header: {
				title: 'Notification Groups',
				breadcrumb: { label: 'Notification Groups', to: '/organization/notification-groups' },
			},
			actions: {
				add: 'Add Subscription',
				delete: 'Delete',
				edit: 'Edit',
			},
			table: {
				subject: 'notification subscriptions',
				filters: {
					notificationType: 'Notification Type',
					facilities: 'Facilities',
				},
				columns: {
					employee: 'Name',
					email: 'Email',
					notificationType: 'Notification Type',
					facilities: 'Facilities',
					actions: 'Actions',
				},
			},
			form: {
				employeeLabel: 'Employee',
				employeePlaceholder: 'Select employee',
				employeeFallback: (userId: number) => `Employee #${userId}`,
				notificationTypeLabel: 'Notification Type',
				notificationTypePlaceholder: 'Select notification type',
				facilitiesDisabledInfo: 'Facility selection is unavailable for this notification type.',
				allFacilities: 'All facilities',
				facilityNoAccess: 'Employee has no access to this facility',
			},
			dialog: {
				createTitle: 'Add Notification Subscription',
				editTitle: 'Edit Facilities Scope',
				confirm: 'Save',
				cancel: 'Cancel',
			},
			states: {
				createSuccess: 'Notification subscription created successfully.',
				createError: 'Unable to create notification subscription.',
				createDuplicateError: 'This employee already has a subscription for this notification type.',
				updateSuccess: 'Notification subscription updated successfully.',
				updateError: 'Unable to update notification subscription.',
				deleteConfirmTitle: 'Delete notification subscription',
				deleteConfirmMessage: 'Are you sure you want to delete this notification subscription?',
				deleteSuccess: 'Notification subscription deleted successfully.',
				deleteError: 'Unable to delete notification subscription.',
				facilitiesLoadError: 'Unable to load facilities for the selected employee.',
			},
			notificationTypes: {
				bookingConfirmed: 'Booking confirmed',
				bookingChanged: 'Booking changed',
				bookingDeleted: 'Booking deleted',
				financeUpdates: 'Finance updates',
				waitlistUpdates: 'Waitlist updates',
				bookingRequested: 'Booking requested',
				bookingApproved: 'Booking approved',
				bookingRejected: 'Booking rejected',
				disputeUpdates: 'Dispute updates',
				teamUpdates: 'Team updates',
			},
		},
		financial: {
			breadcrumbs: {
				finance: 'Finance',
				payments: 'Payments',
			},
			payments: {
				title: 'PAYMENTS',
				list: {
					paymentProcessing: 'Payment Processing',
					taxes: 'Taxes',
					reconciliation: 'Reconciliation',
					terminalPaymentMethodCapture: 'Terminal Payment Method Capture',
				},
			},
			discounts: { title: 'DISCOUNTS', list: { promoCodes: 'Promo Codes', entitlementGroups: 'Discount Groups' } },
			stations: {
				title: 'POINT OF SALE',
				list: { stationSetup: 'Station Setup', terminalShop: 'Terminal Shop', tips: 'Tips' },
			},
			accounting: {
				title: 'ACCOUNTING',
				list: { accountingCodes: 'Accounting Codes' },
			},
		},
		payoutAccounts: {
			header: {
				title: 'Payment Processing',
				subtitle:
					'Connect a processor to accept card, ACH, and terminal payments, and choose which facilities it covers.',
				breadcrumb: {
					label: 'Payment Processing',
					to: ORG_BANK_ACCOUNTS_PATH,
				},
			},
			banner: {
				title: 'Facilities that cannot take payments',
				body: 'These facilities have no processor yet. Assign them to a connected processor, or connect a new one.',
				listToggle: (count: number) => (count === 1 ? '1 facility' : `${count} facilities`),
			},
			table: {
				subject: 'processors',
				actions: {
					create: 'Connect a processor',
					editFacilities: 'Assign facilities',
					completeSetup: 'Resume connection',
					bankDetails: 'Add bank details',
				},
				columns: {
					providerId: 'Account',
					status: 'Status',
				},
				organizationDefault: 'All facilities (default)',
				filters: {
					options: {
						[LinkedAccountStatus.PENDING]: 'Setup incomplete',
						[LinkedAccountStatus.PRE_PENDING]: 'Setup incomplete',
						[LinkedAccountStatus.MISSING_BANK]: 'Missing bank details',
						[LinkedAccountStatus.MISSING_REQUIREMENTS]: 'Missing requirements',
						[LinkedAccountStatus.ACTIVE]: 'Connected',
					},
				},
				unauthorizedFacilitiesTooltip:
					'You can view this processor but cannot edit it, because it covers facilities you cannot access.',
			},
			dialog: {
				create: {
					title: 'Connect a processor',
					description:
						'First select the facilities this processor will collect payments for. Then click Connect — you will be redirected to the processor to create the account.',
					placeholder: 'Select facilities',
					confirm: 'Connect',
				},
				edit: {
					title: 'Assign facilities',
					description: 'Choose which facilities this processor collects payments for. Click Save to update coverage.',
					placeholder: 'Select facilities',
					confirm: 'Save',
				},
				cancel: 'Cancel',
				alreadyAssigned: 'Already assigned',
				bankDetailsTitle: 'Add bank details',
				bankDetailsSubTitle:
					'Add the bank account where customer payments should be deposited. Until this is complete, we cannot transfer funds. {contact support} for any questions',
			},
		},
		tips: {
			header: {
				title: 'Tip Settings',
				breadcrumb: { label: 'Tips' },
			},
			table: {
				subject: 'tip configurations',
				actions: {
					create: 'Create Tip Configuration',
					delete: 'Delete',
					edit: 'Edit',
					duplicate: 'Duplicate',
				},
				columns: {
					facilityNames: 'Facilities',
					type: 'Tipping mode',
					config: 'Options',
					updatedAt: 'Last updated',
				},
				filters: {
					tippingMode: 'Tipping mode',
					options: {
						[TippingModeEnum.FIXED]: 'Fixed Amount',
						[TippingModeEnum.PERCENTAGE]: 'Percentage',
						[TippingModeEnum.SMART]: 'Smart Tips',
					},
				},
				columnsContent: {
					config: {
						primaryContent: (values: string[]) => values.join(', '),
						secondaryContent: (fixedAmounts: string[], threshold: string) =>
							`(${fixedAmounts.join(', ')} below ${threshold})`,
					},
				},
				deleteSingleConfirm: 'Are you sure you want to delete this tip configuration?',
				deleteMultipleConfirm: (count: number) => `Are you sure you want to delete ${count} tip configuration(s)?`,
				toast: {
					deletedSingle: 'Tip configuration deleted. Changes will take effect within 10 minutes.',
					deletedMultiple: 'Tip configurations deleted. Changes will take effect within 10 minutes.',
					deleteFailedSingle: 'Failed to delete tip configuration.',
					deleteFailedMultiple: 'Failed to delete tip configurations.',
				},
				unauthorizedFacilitiesTooltip:
					'You do not have permission to modify tips associated with unauthorized facilities.',
			},
			tipConfigProfile: {
				title: 'Tip Configuration',
				breadcrumbs: { label: 'Tip Configuration', to: '/organization/tips/profile' },
				createSuccessMessage: 'Tipping configuration created. Changes will take effect within 10 minutes.',
				updateSuccessMessage: 'Tipping configuration updated. Changes will take effect within 10 minutes.',
				unknownTippingMode: (type: TippingModeEnum) => `Unknown tipping mode: ${type}`,
				mainDetails: {
					title: 'MAIN DETAILS',
					description: 'Choose the facilities this terminal tipping rule applies to and how tips are calculated.',
					facilitiesTooltip: 'Choose which facilities these tipping settings apply to.',
					facilityNoLocation: 'No terminals linked to this location',
					tippingMode: 'Tipping mode',
					tipAmounts: ['Tip Amount 1', 'Tip Amount 2', 'Tip Amount 3'],
					threshold: 'Threshold',
					percentageHelperText:
						'Enter optional tip percentages between 1% and 50% (displayed top to bottom on the reader).',
					fixedHelperText: 'Enter optional tip amounts (displayed top to bottom on the reader)',
					smartThresholdHelperText: 'Set a threshold to switch between fixed tips and percentages.',
					smartFixedHelperText: 'Enter optional tip amounts shown below the threshold (top to bottom on the reader)',
					smartPercentageHelperText:
						'Enter optional tip percentages between 1% and 50% shown above the threshold (top to bottom on the reader)',
				},
			},
		},
		formProfile: {
			title: {
				create: 'Create form',
				edit: 'Edit form',
			},
			fieldValidationErrors: {
				required: 'This field is required.',
				max: 'This value is too long.',
				invalidRange: 'Enter a valid range where the first number is not greater than the second.',
				minOptions: 'Add at least two options.',
			},
			formsList: { label: 'Forms', to: '/organization/forms' },
			createSuccessMessage: 'Form created successfully',
			updateSuccessMessage: 'Form updated successfully',
			details: {
				title: 'Name',
				titlePlaceholder: 'Untitled form',
				duplicateTitle: (name: string) => `${name} (copy)`,
			},
			questions: {
				emptyTitle: 'No questions yet',
				emptyDescription: 'Add questions one at a time. Start with customer details, a waiver, or a custom question.',
				emptyError: 'Add at least one question before saving.',
				addQuestion: 'Add question',
				addQuestionDescription: 'Select one or more question types, then add them to this form.',
				addSelected: 'Add selected',
				alreadyAdded: 'Already added',
				preview: 'Preview',
				previewDescription: 'This is how questions appear to customers during registration and checkout.',
				previewEmpty: 'Add a question to preview this form.',
				untitledQuestion: 'Untitled question',
				inactive: 'Inactive',
				needsAttention: 'Needs attention',
				makeRequired: 'Required',
				deleteQuestion: 'Delete',
				moveUp: 'Move up',
				moveDown: 'Move down',
				questionType: 'Question type',
				question: 'Question',
				agreementText: 'Text',
				limitAnswerTo: 'Character limit',
				characters: 'characters',
				yesNoHelper: 'Customer chooses Yes or No.',
				multipleSelectOptions: 'Allow multiple selections from these options',
				singleSelectOptions: 'Allow a single selection from these options',
				addOption: 'Add option',
				option: 'Option',
				removeOption: 'Remove',
				numberRange: 'Number range',
				to: 'to',
				fileUploadHelper: 'Customer will upload a file.',
				dateHelper: 'Customer will pick a date.',
				groups: {
					customerInfo: 'Customer details',
					agreements: 'Agreements',
					custom: 'Custom questions',
				},
				questionTypes: {
					tShirtSize: 'T-shirt size',
					phoneNumber: 'Phone number',
					emailAddress: 'Email address',
					address: 'Address',
					dateOfBirth: 'Date of birth',
					preferredTeam: 'Preferred team',
					waiver: 'Waiver',
					termsAndConditions: 'Terms and conditions',
					customQuestion: 'Custom question',
					divider: 'Divider',
				},
				questionDescriptions: {
					tShirtSize: 'Customer chooses a size: XS, S, M, L, XL, XXL, XXXL.',
					phoneNumber: 'Customer provides a phone number.',
					emailAddress: 'Customer provides an email address.',
					address: 'Customer provides a home address.',
					dateOfBirth: 'Customer provides a date of birth.',
					preferredTeam: 'Customer selects a preferred team from your rosters. Hidden if no teams exist.',
					waiver: 'Customer reads and signs this waiver.',
					termsAndConditions: 'Customer agrees to these terms and conditions.',
				},
				customTypes: {
					freeText: 'Short answer',
					yesNo: 'Yes / No',
					multipleChoice: 'Multiple choice',
					singleChoice: 'Single choice',
					numeric: 'Numeric',
					date: 'Date',
					fileUpload: 'File upload',
					waiver: 'Custom waiver',
				},
				customerFacingLabels: {
					preferredTeam: 'Preferred Team',
					birthDate: 'Birth Date',
					address: 'Address',
					emailAddress: 'Email Address',
					phoneNumber: 'Phone Number',
					tShirtSize: 'T-Shirt Size',
					termsAndConditions: 'T&C',
					waiver: 'Waiver',
				},
				customerPreview: {
					stepTitle: 'Additional Information',
					stepSubtitle: 'Complete the required forms and documents',
					ariaLabel: 'Customer form preview',
					closeAriaLabel: 'Close preview',
					waiverAcknowledgement: 'I have read and agree to the above',
					fileUploadHint: 'Acceptable file formats for upload: jpg, .png, .webp and .pdf',
					uploadFile: 'Upload file',
					datePlaceholder: 'mm / dd / yyyy',
					selectAnOption: 'Select an option',
					selectSize: 'Select size',
					yes: 'Yes',
					no: 'No',
					tShirtSizes: {
						extraSmall: 'XS',
						small: 'S',
						medium: 'M',
						large: 'L',
						extraLarge: 'XL',
						doubleExtraLarge: 'XXL',
						tripleExtraLarge: 'XXXL',
					},
					addressFields: {
						street: 'Address',
						city: 'City',
						state: 'State / Province',
						zip: 'ZIP code',
						country: 'Country',
					},
					addressPlaceholders: {
						street: 'Enter full address',
						city: 'Enter city',
						state: 'Enter state',
						zip: 'Enter zipcode',
						country: 'Enter country',
					},
				},
			},
		},
		terminalPaymentMethodCapture: {
			title: 'Terminal Payment Method Capture',
			back: 'Back',
			getMethodCaptureDescription: (value: TerminalPaymentMethodCaptureEnum) => {
				switch (value) {
					case TerminalPaymentMethodCaptureEnum.NONE:
						return 'None';
					case TerminalPaymentMethodCaptureEnum.ASK:
						return 'Ask Customer';
					case TerminalPaymentMethodCaptureEnum.REQUIRE:
						return 'Require Save';
				}
			},
			recurringBilling: {
				title: 'RECURRING BILLING',
				description: 'Covers all rolling memberships that automatically renew and bill on a repeating schedule.',
			},
			oneTimePurchase: {
				title: 'ONE-TIME PURCHASE',
				description:
					'Covers all non-recurring purchases where a card can be saved to a registered customer account for future use.',
				noteLabel: 'Note:',
				note: 'Mobile wallets cannot be saved to customer accounts for future use. Additionally, card storage is not available for anonymous guest checkouts.',
			},
			options: {
				dontSave: {
					title: "Don't Save",
					description: 'Processes the current payment only, the card is not saved to their account',
				},
				askCustomer: {
					title: 'Ask Customer',
					description: 'Gives the customer the choice to save their card for future use',
				},
				requireSave: {
					title: 'Require Save',
					description: 'Customer must approve card storage in order to complete the transaction',
				},
			},
			saveSuccessMessage: 'Payment method capture settings saved successfully',
		},
		terminalShop: {
			title: 'Terminal Shop',
			breadcrumb: {
				finance: 'Finance',
			},
			tabs: {
				shop: 'Shop',
				orders: 'Orders',
			},
			stripeRequired: 'Connect and activate your Stripe account before using Terminal Shop.',
			goToPayoutAccounts: 'Go to Payment Processing',
			sessionError: 'Terminal Shop is unavailable right now. Please try again later or contact support.',
			retry: 'Try again',
		},
		facilities: {
			header: {
				title: 'Facilities',
				breadcrumb: {
					label: 'Facilities Management',
					to: FACILITIES_PATH,
				},
			},
			noFacilities: {
				title: 'There are no facility yet!',
				description: 'Start adding facilities',
				createButton: 'create facility profile',
			},
			createOrganizationProfile: {
				welcome: 'Welcome! 🎉',
				description: "Create your organization profile first so you'll be able to start creating a facility profile",
				createButtonProfile: 'create organization profile',
			},
			searchPlaceholder: 'Search by Name',
			newFacilityButton: 'Create new facility',
			facilityTable: {
				subject: 'facility',
				columns: {
					facilityName: 'Facility Name',
					name: 'Name',
					location: 'Location',
					activities: 'Activities',
					openingHours: 'Opening Hours',
					status: 'Status',
				},
				activities: {
					viewMore: (count: number) => `+${count} more`,
				},
				actions: {
					createFacility: 'Create New Facility',
				},
				status: {
					published: 'Published',
					unpublished: 'Unpublished',
				},
			},
		},
		marketing: {
			conversion_analytics: {
				header: {
					title: 'Conversion Analytics',
					breadcrumb: {
						label: 'Conversion Analytics',
						to: CONVERSION_ANALYTICS_PATH,
					},
				},
				inputs: {
					GA4MeasurementId: {
						label: 'GA4 Measurement ID',
						placeholder: 'G-XXXXXXXXXX',
					},
					GTMContainerId: {
						label: 'GTM Container ID',
						placeholder: 'GTM-XXXXXXX',
					},
				},
				subTitle: 'tracking setup',
				description:
					'Connect your analytics tools to start collecting data on checkout behavior from Bond. Need help? See our',
				saveMessage: 'Tracking setup saved successfully',
				errorMessage: 'Failed to save settings. Please try again.',
				links: {
					tutorialLink: 'tutorial',
				},
			},
		},
		scanners: {
			title: 'Scanners',
			tabs: {
				scanner: { label: 'Scanner Test', to: SCANNERS_TEST_PATH },
				audio: { label: 'Audio', to: SCANNERS_AUDIO_PATH },
			},
			breadcrumbs: [
				{ label: 'Settings', to: '/' },
				{ label: 'Organization', to: ORGANIZATION_PATH },
				{ label: 'Scanners', to: SCANNERS_TEST_PATH },
			],
			scannerTest: {
				headline: 'Scanner Test',
				subhead: 'Connect your scanner to this device. Then scan the codes below to test your scanner.',
				qrSectionHeadline: 'QR Code Test',
				barcodeSectionHeadline: 'Barcode Test',
				imageAlt: {
					qrCode: 'QR Code',
					barcode: 'Barcode',
				},
				qrSuccess: 'QR code scanned successfully',
				barcodeSuccess: 'Barcode scanned successfully',
				otherSuccess: code => `Code ${code} was scanned. Please try scanning the codes on your screen.`,
			},
			audio: {
				headline: 'Scanner Audio',
				subhead: 'Control audio indicators for customer check-in',
				titles: {
					CheckInSuccess: 'Check-in Success',
					CheckInWarn: 'Check-in with Warning',
					CheckInError: 'Check-in Fail',
				},
				overrideButtonCopy: 'UPLOAD',
				overrideSuccess: 'Audio has been updated successfully!',
				fileTooBig: 'File is too big. Please upload an audio file under 1 MB.',
				resetButtonCopy: 'Reset',
			},
		},
		resources: {
			header: {
				title: 'Spaces',
				breadcrumb: {
					label: 'Spaces',
					to: SPACES_PATH,
				},
			},
			noResources: {
				title: 'There are no resources here!',
				description: 'Start adding your resources ',
				createButton: 'create resource profile',
			},
			createOrganizationProfile: {
				welcome: 'Welcome! 🎉',
				description: "Create your organization profile first so you'll be able to start creating a resource profile",
				createButtonProfile: 'create organization profile',
			},
			createFacilityProfile: {
				noFacilities: 'There are no facility yet!',
				description: "Create a facility profile first so you'll be able to start creating a resource profile",
				createButtonProfile: 'create facility profile',
			},
			newSpaceButton: 'Create new space',
			resourceTypeModal: {
				title: 'Choose Resource Type',
				subTitle: 'Pick the resource you want to create in order to fill in the info, rules, pricing and more!',
				cancel: 'Cancel',
				create: 'create ',
			},
			filters: {
				allTypes: 'All Types',
				allFacilities: 'All Facilities',
				searchPlaceholder: 'Search by name',
			},
			resourceType: { space: 'space', personalTrainer: 'personal Trainer' },
			spaceTypes: [
				'Court',
				'Field',
				'Room',
				'Diamond',
				'Rink',
				'Studio',
				'Pool',
				'Batting Cage',
				'Shelter',
				'Golf simulator',
				'Bay',
			],
			resourceTable: {
				subject: 'resources',
				actions: {
					createSpace: 'Create Space',
					search: {
						placeholder: 'search',
					},
					filters: {
						categories: {
							facility: 'FACILITY',
							activity: 'ACTIVITY',
							bookableOnline: {
								yes: 'Yes',
								no: 'No',
							},
						},
					},
				},
				columns: {
					spaceName: 'Space Name',
					type: 'Type',
					properties: 'Properties ',
					location: 'Location',
					activityOffered: 'Activity offered',
					isBookableOnline: 'Available Online',
				},
				rowActionsPopup: {
					edit: { label: 'Edit Space Details' },
				},
				activities: {
					viewMore: (count: number) => `+${count} more`,
				},
			},
		},
		facility: {
			mainDetails: {
				title: 'MAIN DETAILS',
				location: 'Location',
				email: 'Email',
				phone: 'Phone',
				timezone: 'Time zone:',
				edit: 'edit',
				shortDescription: 'Short Description',
				longDescription: 'Long Description',
				rulesInfo: 'Rules / Info',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
			activities: {
				title: 'ACTIVITIES OFFERED',
				editModal: {
					title: 'Activity ',
					subTitle: 'Choose all the activities you offer throughout the year ',
					cancel: 'cancel',
					saveChanges: 'save changes',
				},
			},
			openingHours: { title: 'OPENING HOURS' },
			amenities: { title: 'AMENITIES' },
			resources: {
				newButtonText: 'new',
				title: 'RESOURCES',
				noResources: 'No resources have been created for your organization.',
				youCan: 'You can',
				createResource: 'create a resources profile',
				now: 'now.',
			},
			edit: 'edit',
		},
		resource: {
			mainDetails: {
				title: 'MAIN DETAILS',
				location: 'Location',
				edit: 'edit',
				shortDescription: 'Short Description',
				longDescription: 'Long Description',
				viewMore: 'View More',
				viewLess: 'View Less',
				availableOnline: 'Available Online',
				notAvailableOnline: 'Not Available Online',
			},
			properties: {
				title: 'PROPERTIES',
				edit: 'edit',
				ages: 'Ages',
			},
			activities: {
				title: 'ACTIVITIES OFFERED',
				editModal: {
					title: 'Activity ',
					subTitle: 'Choose all the activities you offer throughout the year ',
					cancel: 'cancel',
					saveChanges: 'save changes',
				},
			},
			openingHours: { title: 'OPENING HOURS' },
			amenities: { title: 'AMENITIES' },
			products: {
				title: 'PRICE & PACKAGES',
				createNew: 'create new',
				edit: 'edit',
				add: 'add',
				noProduct: 'No rental product has been assigned to your resource.',
				youCan: 'You can',
				createNewProduct: 'create a new rental product',
				now: 'now',
				linkToRentalsText: 'Click here to see the rental products',
				columns: {
					glCode: 'GL Code',
					name: 'Name',
					activityType: 'Activity type',
					duration: 'Duration',
					availability: 'Availability',
					price: 'Price',
					tableAction: {
						edit: 'Edit product',
					},
				},
				columnsFormat: {
					overflowCount: (count: number) => `+${count} more...`,
					availabilityOverflowCount: (count: number) => `+${count} More...`,
				},
			},
			resources: {
				title: 'RESOURCES',
				noResources: 'No resources have been created for your organization.',
				youCan: 'You can',
				createResource: 'create a resources profile',
				now: 'now.',
			},
			edit: 'edit',
		},
		forms: {
			createOrganizationProfile: {
				title: 'Create Organization Profile',
				tabs: { mainDetails: 'Main Details', activityOffered: 'Activity Offered' },
				success: {
					title: 'Nice Profile !',
					description: 'You’ve successfully created your organization profile',
					whatsNext: ' what’s next?',
					mainButton: 'create a facility profile',
					subButton: 'I’m done for now',
					notification: 'Your organization has been successfully created!',
				},
				mainDetails: {
					information: 'This is the information that we’ll display on your public pages to your customers',
					title: 'main details',
					name: 'Name',
					aboutUs: 'About Us',
					location: 'Location',
					timeZoneInfo: 'Your time zone (and time) will update automatically based on your location in the world',
					emailAddress: 'Email Address',
					invalidEmail: 'Enter a valid email address',
					phoneNumber: 'Phone Number',
					facebook: 'Facebook',
					x: 'X',
					instagram: 'Instagram',
					addAnother: 'Add another',
					socialTypes: {
						1: 'Facebook',
						2: 'X',
						3: 'Linkedin',
					},
				},
				sportActivity: {
					title: 'ACTIVITIES',
					subTitle: 'Choose all the activities you offer throughout the year',
					back: 'Back',
				},
			},

			createFacility: {
				title: 'Create Facility Profile',
				editTitle: 'Edit Facility Profile',
				editSuccessMessage: 'Facility profile updated successfully',
				tabs: {
					mainDetails: 'Main Details',
					images: 'Images',
					openingHours: 'Opening Hours',
					activityOffered: 'Activity Offered',
					amenities: 'Amenities',
					resources: 'Resources',
				},
				mainDetails: {
					information: 'This is the information that we’ll display on your public pages to your customers',
					title: 'main details',
					name: 'Name',
					location: 'Location',
					email: 'Email',
					phone: 'Phone',
					invalidEmail: 'Enter a valid email address',
					invalidPhone: 'Enter a valid phone number',
					timeZoneInfo: 'Your time zone (and time) will update automatically based on your location in the world',
					shortDescription: 'Short Description',
					shortDescriptionInfo: 'Briefly introduce the facility, keep it short and simple!',
					longDescription: 'Long Description',
					longDescriptionInfo:
						'This is the place to tell your customers about all the amazing things your facility offers',
					uploadDocument: 'Upload document',
					rulesInfo: 'Rules / Info',
					rulesInfoInfo: '',
				},
				images: {
					title: 'IMAGES',
					description:
						'The main cover image will be presented as the hero image on your public facility page. Make sure you pick an amazing photo to show your customers what an awesome facility you have!',
					coverImage: 'Cover Image',
					gallery: 'Gallery',
				},
				openingHours: {
					title: 'OPENING HOURS ',
					info: 'The opening hours of your facility will be displayed on the public web page to keep your customers informed',
					on: 'On',
					from: 'From',
					to: 'To',
					addAnotherTimeSlot: 'Add another time slot',
				},
				activitiesOffered: {
					title: 'ACTIVITIES OFFERED',
					markAll: 'Mark all',
					unmarkAll: 'Unmark all',
				},
				amenities: {
					title: 'AMENITIES',
				},
				resources: {
					title: 'Resources',
					resourcesSelect: {
						label: 'Attached',
						placeHolder: 'Select resources',
						info: 'If the resources is not yet established in the system, you will be able to set this later from the resource / facility settings page',
					},
				},
				success: {
					title: 'Facility Profile Created!',
					description: 'You’ve successfully created your facility profile',
					firstFacilityDescription: 'You’ve successfully created your first facility profile',
					whatsNext: 'what’s next?',
					mainButton: 'create resource',
					subButton: 'I’m done for now',
					notification: 'Facility profile created successfully',
				},
			},
			editOrganizationProfile: {
				title: 'Edit Organization Details',
				successMessage: 'Organization profile updated successfully',
			},
			organizationBrandings: {
				title: 'Edit Brand Colors',
				breadcrumbLabel: 'Brand Colors',
				sectionTitle: 'Brand Colors',
				sectionDescription: 'These colors apply to the consumer site.',
				successMessage: 'Organization brand colors updated successfully',
				fields: {
					primaryColor: 'Primary Color',
					primaryColorDescription: 'Page header and navigation',
					secondaryColor: 'Secondary Color',
					secondaryColorDescription: 'Buttons, loading state, and accents',
					textColor: 'Text Color',
					textColorDescription: 'Labels and body text',
				},
			},
			organizationGeneralWaiver: {
				title: 'General Waiver',
				breadcrumbLabel: 'General Waiver',
				sectionTitle: 'General Waiver Form',
				sectionDescription: 'Pick the form to use for your general waiver.',
				successMessage: 'General waiver updated successfully',
				fetchErrorMessage: 'Failed to load forms',
				fields: {
					questionnaire: 'Form',
					questionnairePlaceholder: 'Select',
					questionnaireRequired: 'Select a form before saving.',
				},
				link: {
					livePage: 'Go to live page',
					linkDescription: "Can't find what you're looking for?",
					linkLabelPrefix: 'Create a new form ',
					linkLabel: 'here.',
				},
			},
			editMaimDetails: {
				title: 'Edit Facility Main Details',
				successMessage: 'Facility main details updated successfully',
			},
			editActivities: {
				title: 'Edit Facility Activities',
				successMessage: 'Facility Activities updated successfully',
			},
			editAmenities: {
				title: 'Edit Facility Amenities',
				successMessage: 'Facility amenities updated successfully',
			},
			editOpeningHours: {
				title: 'Edit Facility Opening Hours',
				successMessage: 'Facility opening hours updated successfully',
			},
			editImages: {
				title: 'Edit Facility Images',
				successMessage: 'Facility Images updated successfully',
			},
			createResource: {
				title: 'Create new',
				titleWithResourceType: (title: string, resourceType: string, resource: string) =>
					`${title} ${resourceType} ${resource}`,
				edit: 'Edit',
				resource: 'resource',
				editTitle: 'Edit Resource Profile',
				editSuccessMessage: 'Resource profile updated successfully',
				tabs: {
					mainDetails: 'Main Details',
					properties: 'Properties',
					openingHours: 'Opening Hours',
					activityOffered: 'Activity Offered',
					amenities: 'Amenities',
					relationships: 'Relationships',
					priceAndPackages: 'Price & Packages',
				},
				mainDetails: {
					description: 'This is the information that we’ll display on your public pages to your customers',
					title: 'main details',
					name: 'Name',
					isBookableOnline: 'Space can be booked online',
					assignWithFacility: 'Assign with facility',
					information:
						'If the facility not yet established in the system, you will be able to set this later from the facility / resource settings page',
					shortDescription: 'Short Description',
					shortDescriptionInfo:
						'This is the place for a quick highlight of your resource, enter up to 250 characters that will show on the public consumer facing page',
					longDescription: 'Long Description',
					longDescriptionInfo:
						'This is the place to provide more details and info about your resource, enter up to 10,000 characters that will show on the public consumer facing page',
				},
				images: {
					title: 'IMAGES',
					description:
						'Add a beautiful image of the resource you are offering you customers. This will be showcased on the public page of the resource. Recommended ratio of the image is 16:9 and maximum size of 4MB.',
					coverImage: 'Cover Image',
				},
				Properties: {
					title: 'PROPERTIES',
					indoor: 'indoor',
					outdoor: 'Outdoor',
					width: 'Width',
					length: 'Length',
					measurementOptions: { feet: 'feet', yard: 'yard' },
					surface: 'Surface',
					surfaceInfo:
						'Set the surface type of your resource, this will help your customers search and find what they are looking for',
					ages: 'Ages',
					surfaceOptions: [
						'Hardwood',
						'Grass',
						'Turf',
						'Asphalt',
						'Sand',
						'Field Turf',
						'Astro Turf',
						'Ice',
						'Activity Court',
					],
				},
				openingHours: {
					title: 'OPENING HOURS ',
					sameAsFacility: 'Same as the facility',
					description: 'The days and times your resource is available to book:',
					on: 'On',
					from: 'From',
					to: 'To',
					addAnotherTimeSlot: 'Add another time slot',
					noFacilityOpeningHours: 'No opening hours found',
				},
				activitiesOffered: {
					title: 'ACTIVITIES OFFERED',
					selectAll: 'Select all',
					deselectAll: 'Deselect all',
				},
				amenities: {
					title: 'AMENITIES',
				},
				success: {
					title: 'Resource Profile Created!',
					description: 'You’ve successfully created your Resource profile',
					whatsNext: 'what’s next?',
					mainButton: 'create a new rental product',
					subButton: 'I’m done for now',
					notification: 'Resource profile created successfully',
				},
			},
			editResourceMaimDetails: {
				title: 'Edit Resource Main Details',
				successMessage: 'Resource main details updated successfully',
			},
			editResourceActivities: {
				title: 'Edit Resource Activities',
				successMessage: 'Resource activities updated successfully',
			},
			editResourceAmenities: {
				title: 'Edit Resource Amenities',
				successMessage: 'Resource amenities updated successfully',
			},
			editResourceOpeningHours: {
				title: 'Edit Resource Opening Hours',
				successMessage: 'Resource opening hours updated successfully',
			},
			editResourceImages: {
				title: 'Edit Resource Images',
				successMessage: 'Resource Images updated successfully',
				errorMessages: {
					facilityIdNotFound:
						'This resource is not assigned to any facility. Please assign it to a facility before editing images.',
				},
			},
			editProperties: {
				title: 'Edit Resource Properties',
				successMessage: 'Resource Properties updated successfully',
			},
			accountingCodesProfile: {
				title: 'Accounting Code Profile',
				breadcrumbs: { label: 'Accounting Code', to: ACCOUNTING_CODES_PROFILE_PATH },
				createSuccessMessage: 'Accounting code created successfully',
				updateSuccessMessage: 'Accounting code updated successfully',
				updateCodeConfirmationTitle: 'Changes to Accounting Code',
				updateCodeConfirmationMessage:
					'This change will be applied to all associated products or other linked resources (if any). Are you sure you want to proceed?',
				updateCodeConfirmationConfirmButtonText: "I'M SURE",
				form: {
					title: 'Main Details',
					code: { label: 'Code', placeholder: 'Type here' },
					facilitiesTooltip: 'Select one or more facilities this accounting code applies to.',
					typeUpdateDisabled:
						'This accounting code is in use and its type cannot be changed. Changing the type could create conflicts with products that already use this code.',
					appliesTo: {
						label: 'Can Apply To',
						tooltipLabel: 'Choose where this accounting code can be selected (e.g. Products, Programs, Taxes).',
						placeholder: 'Select',
						options: [
							{
								value: BooleanString.False,
								label: 'All',
							},
							{
								value: `${GlResourceTypeEnum.PRODUCT}`,
								label: 'All Products',
							},
							{
								value: `${GlResourceTypeEnum.PRODUCT}.${ProductTypesEnum.REGISTRATION}`,
								label: 'Programs Products',
							},
							{ value: `${GlResourceTypeEnum.PRODUCT}.${ProductTypesEnum.RESERVATION}`, label: 'Rental Products' },
							{ value: `${GlResourceTypeEnum.PRODUCT}.${ProductTypesEnum.GOODS}`, label: 'Commerce Products' },
							{ value: `${GlResourceTypeEnum.PROGRAM}`, label: 'Programs' },
							{ value: `${GlResourceTypeEnum.PROGRAM_SEASON}`, label: 'Sessions' },
							{ value: `${GlResourceTypeEnum.TAX}`, label: 'Taxes' },
							{ value: `${GlResourceTypeEnum.DISCOUNT}`, label: 'Discounts' },
						],
					},
					category: {
						label: 'Category',
						tooltipLabel:
							'Assign the accounting code to a Category so that codes can be organized and grouped consistently.',
						placeholder: 'Select',
					},
					statusActive: 'Active',
					statusInactive: 'Inactive',
				},
			},
			taxesProfile: {
				title: 'Taxes Profile',
				breadcrumbs: { label: 'Taxes Profile', to: TAXES_PROFILE_PATH },
				createSuccessMessage: 'Tax created successfully',
				updateSuccessMessage: 'Tax updated successfully',
				updateTaxConfirmationTitle: 'Changes to Tax',
				updateTaxConfirmationMessage:
					'This update will affect all associated products (if any). Are you sure you want to continue?',
				updateTaxConfirmationConfirmButtonText: "I'M SURE",
				form: {
					title: 'Main Details',
					name: { label: 'Tax Name', placeholder: 'Enter tax name' },
					rate: { label: 'Tax Rate', placeholder: 'Enter tax rate' },
					calculationType: {
						label: 'Tax Calculation',
						options: [
							{
								label: 'Exclusive',
								description: 'Tax is added on top of the product price.',
								value: BooleanString.False,
							},
							{
								label: 'Inclusive',
								description: 'Tax is already included in the product price.',
								value: BooleanString.True,
							},
						],
					},
				},
			},
		},
		promoCodes: {
			header: { titel: 'Promo Codes', breadcrumbs: { label: 'Promo Codes', to: PROMO_CODES_PATH } },
			noDataProps: {
				labels: {
					title: 'There are no codes here!',
					description: 'Start adding your promo codes discount ',
					createButton: 'create promo codes',
				},
			},

			table: {
				subject: 'promo-codes',
				filters: { search: { placeholder: 'Search by Name or Code' }, date: { placeholder: 'Select date' } },
				culumns: {
					code: 'Promo Code',
					name: 'Name',
					availability: 'Availability',
					amount: 'Amount',
					redeemed: 'Redeemed',
					public: 'Public',
					active: 'Active',
				},

				activeToggleLabels: {
					errorMessage: 'Failed to update the promo code status. Please try again.',
					successMessage: {
						activated: 'Promo code has been activated!',
						deactivated: 'Promo code has been deactivated!',
					},
					toggleSuccessNotification: (count: number, message: string) => `${count > 1 ? count : ''} ${message}`,
				},
				morMenuOptions: { [MorMenuEnum.EDIT]: 'Edit Promo code', [MorMenuEnum.DELETE]: 'Delete Promo code' },
				morMenuActions: {
					delete: {
						modal: {
							title: 'Delete Promo code',
							mainButton: 'okay',
							description: 'Please note this promo code will be deleted.',
							subButton: 'cancel',
						},
					},
				},
			},
			createPromoCode: {
				createTitle: 'Create New Promo Code',
				editTitle: 'Edit Promo Code',
				primaryButtonTextSave: 'Save',
				primaryButtonTextNext: 'Next',
				submit: 'Submit',
				formBodyIdo: 'For Ido',
				tabs: { details: 'Details', manageSelectedProduct: 'Manage Selected Product' },
				createSuccessNessage: 'The promo code has been created successfully',
				editSuccessNessage: 'The promo code has been edited successfully',
				details: {
					title: 'promo codes',
					promoCodesDetails: 'Promo codes details',
					nameLabel: 'Name',
					codeLabel: 'Code text',
					codeLimitations: (minPromoCodeLength: number, maxPromoCodeLength: number) =>
						`Codes may include letters, numbers and special characters. Between ${minPromoCodeLength} and ${maxPromoCodeLength} characters.`,

					descriptionLabel: 'description',
					association: {
						promoCodeAssociationText: 'Select the promo code association',
						promoCodeAssociationInfo:
							'To attach your promo code to products such as program, memberships etc. select to apply to specific items.\nTo attach your promo code to any cart regardless of the products purchased, select to apply to entire purchase.\n' +
							'With each option, you can limit the number of times the promo code may be used.\n' +
							'This limit must not exceed the total limit (below).',
						applyToSpecificProductsLabel: 'Apply to specific product(s)',
						limitUsesPerParticipantText: 'Limit uses per participant',
						applyToEntirePurchaseLabel: 'Apply to entire purchase',
						promoCodeTotalLimitText: 'Select the promo code total limit',
						promoCodeTotalLimitInfo: 'You can set a limit for the total number of times your promo code may be used.',
						limitTotalNumberOfUsesText: 'Limit total number of uses',
						limitUsesPerPayingCustomer: 'Limit uses per paying customer',
						minValError:
							'Invalid limit. The value entered cannot be lower than the number of times this code has already been used.',
					},
					dates: {
						title: 'Dates',
						startDateLabel: 'start date',
						endDateLabel: 'End date (voluntary)',
						datePlaceholder: 'Select Date',
						notBeforeText: 'start date',
						notBeforeTimeMessage: 'cannot be before start date',
					},
				},
				relatedProducts: {
					schema: {
						invalidSession: 'invalid session',
						invalidMembershipType: 'invalid membership type',
						invalidMembership: 'invalid membership',
					},
					titles: {
						all: 'Promo Code Association',
						memberships: 'MEMBERSHIPS',
						programs: 'PROGRAMS',
					},
					programs: {
						programTypeSelectionLabels: {
							class: 'Classes',
							clinc: 'Clinics',
							camp: 'Camps',
							lesson: 'Private Lessons',
							clubTeam: 'Club Teams (Legacy)',
							clubTeamV2: 'Club Teams',
							leagueV2: 'Leagues',
							tournamentV2: 'Tournaments',
						},
						programTypeSelect: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
							},
							placeholder: 'Select Program Type',
						},
						programSelect: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
								allGroupsTextPrimary: 'Select All Programs',
								allGroupsTextSecondary: '(deselect to clear all)',
							},
							placeholder: 'Select Program Name',
						},
						sessionSelect: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
								allGroupsTextPrimary: 'Select All Sessions',
								allGroupsTextSecondary: '(deselect to clear all)',
								noOptionsMessage: 'No sessions found in this program',
							},
							placeholder: 'Select Session Name',
						},
						productSelect: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
								allGroupsTextPrimary: 'Select All Products',
								allGroupsTextSecondary: '(deselect to clear all)',
								noOptionsMessage: 'No products found in this session',
							},
							placeholder: 'Select Product Name',
						},
						checkbox: {
							label: 'Apply promo code to all programs products',
						},
					},
					memberships: {
						checkbox: {
							label: 'Apply promo code to all memberships products',
						},
						rolling: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
							},
							placeholder: 'Select Rolling Memberships',
						},
						fixed: {
							select: {
								selectAll: 'Select All (deselect to clear all)',
								loading: 'Loading...',
								error: 'Error loading',
								end: 'End of results',
							},
							placeholder: 'Select Fixed Memberships',
						},
						typeToLabelMapper: {
							[MembershipTypeEnum.FIXED]: 'Fixed',
							[MembershipTypeEnum.ROLLING]: 'Rolling',
						},
					},
					allProducts: {
						checkbox: {
							label: 'Apply promo code to all items across all categories.',
						},
						tooltip:
							'Select this option to activate your promo code for the entire cart or invoice (excluding add-ons).',
					},
					programTypeMapper: {
						[ProgramTypesEnum.LESSON]: 'Private Lessons',
						[ProgramTypesEnum.CAMP]: 'Camps',
						[ProgramTypesEnum.CLASS]: 'Classes',
						[ProgramTypesEnum.CLINIC]: 'Clinics',
						[ProgramTypesEnum.CLUB_TEAM]: 'Club Teams (Legacy)',
						[ProgramTypesEnum.CLUB_TEAM_V2]: 'Club Teams',
						[ProgramTypesEnum.LEAGUE_V2]: 'Leagues',
						[ProgramTypesEnum.TOURNAMENT_V2]: 'Tournaments',
					},
				},
			},
		},
		employeeAccounts: {
			header: { title: 'Employees', breadcrumbs: { label: 'Employees Management', to: EMPLOYEES_ACCOUNTS_PATH } },
			noDataProps: {
				labels: {
					title: 'There are no employees here!',
					description: 'Start adding your Employees',
					createButton: 'create Employee',
				},
			},

			table: {
				subject: 'employees',
				filters: {
					search: { placeholder: 'Search' },
					categories: {
						status: {
							title: 'STATUS',
							options: { [ActivityEnum.ACTIVE]: 'Active', [ActivityEnum.INACTIVE]: 'Inactive' },
						},
						// facility: {
						// 	title: 'FACILITIES',
						// }
						// role: 'ROLES',
					},
				},
				tableAction: {
					create: 'Create Employee',
				},
				columns: {
					firstName: 'First Name',
					lastName: 'Last Name',
					email: 'Email',
					referenceId: 'Ref ID',
					lastLogin: 'Last Login',
					roles: 'Roles',
					status: 'Status',
					customerId: 'Customer ID',
					actions: 'Actions',
				},
				moreMenuOptions: {
					[MoreMenuEnumEmployee.EDIT]: 'Edit Employee Details',
					//TODO: uncomment when the feature is ready
					// [MorMenuEnumEmployee.ARCHIVED]: 'Archived Employee',
					// [MorMenuEnumEmployee.UNARCHIVED]: 'Unarchived Employee',
					[MoreMenuEnumEmployee.VIEW]: 'View Customer Profile',
				},
				updateStatus: (status: EmployeeStatus) =>
					`${status === EmployeeStatus.ACTIVE ? 'Deactivate' : 'Activate'} Employee`,
				activeToggleLabels: {
					errorDeactivateEmployeeMessage:
						'To deactivate this employee, please deactivate their instructor profile first.',
					successMessage: {
						activated: 'The related instructor resource has been activated!',
						deactivated: 'The related instructor resource has been deactivated!',
					},
				},

				morMenuActions: {
					delete: {
						modal: {
							title: 'Delete Employee Account',
							mainButton: 'okay',
							description: 'Please note this employee account will be deleted.',
							subButton: 'cancel',
						},
					},
				},
				loadingMessage: 'Loading Employees...',
			},
			employee: {
				contextRequiredError: 'useEmployeeProfileContext must be used within an EmployeeProfileProvider',
				header: {
					title: 'Employee Profile',
					breadcrumb: {
						label: 'Employee Profile',
						to: CURRENT_PAGE,
					},
				},
				profile: {
					personalDetails: {
						title: 'personal details',
						details: {
							firstName: 'First Name',
							lastName: 'Last Name',
							gender: 'Gender',
							birthday: 'Date of Birth',
							birthdayPlaceholder: 'Select',
						},
					},
					existingCustomerPopup: {
						title: 'Existing Customer',
						description:
							'This email address is already associated with a customer account. Do you want to proceed and link this customer to an employee account?',
						mainActionLabel: 'Continue',
						secondaryActionLabel: 'Cancel',
					},
					deactivateInstructorResource: {
						title: 'Deactivate Instructor Resource',
						description:
							'Deactivating this employee or removing "instructor" role will also deactivate their instructor resource.',
						primaryButton: 'Yes',
						secondaryButton: 'Not Now',
					},
					activateInstructorResource: {
						title: 'Activate Instructor Resource',
						description:
							'This employee has an inactive instructor resource. Would you like to reactivate their instructor resource?',
						primaryButton: 'Yes',
						secondaryButton: 'Not Now',
					},
					createInstructorResource: {
						title: 'Create Instructor Resource',
						description:
							'This employee has been assigned an “instructor” role. Would you like to create an instructor resource for this employee?',
						primaryButton: 'Yes',
						secondaryButton: 'Not Now',
					},
					employementDetails: {
						title: 'Employment details',
						details: {
							email: 'Email Address',
							emailNote: 'Email will be sent to the employee to set their password',
							refId: 'Reference ID',
							refIdInfo: 'This is the unique identifier for the employee payroll system',
							rolesInfo: 'To learn more about each default role, click ',
							rolesInfoLinkText: 'here',
							startDate: 'Employment Start Date',
							startDatePlaceholder: 'Select',
							endDate: 'Employment End Date',
							endDatePlaceholder: 'Select',
							facilityAccess: 'Facility Access',
							defaultFacility: 'Default Facility View',
							allFacilities: 'All Facilities',
							chooseDefaultFacilityView: 'Choose Default Facility View',
						},
						additinalDetails: {
							roles: 'Roles',
							selectRoles: 'Select Roles',
							payRate: 'Pay Rate',
						},
					},
					contactDetails: {
						title: 'contact details',
						phoneNumber: 'Phone No.',
						addressLabel: 'Address',
					},
					sucssesMessage: {
						create: 'Employee has been successfully created!',
					},
				},
				statusUpdatedMessage: 'Employee status has been updated successfully!',
				successMessage: 'Employee profile has been updated successfully!',
				errors: {
					emailAlreadyInUse: 'This email address is already associated with another account.',
					crossOrganizationAccess: `This employee's profile cannot be edited here. Please contact ${SUPPORT_EMAIL} for assistance.`,
					updateFailed: 'Failed to update employee profile. Please try again.',
				},
			},
		},
		rolesAndPermissions: {
			facilityAccess: {
				disabledTooltip: 'You do not have the necessary permission to manage organization-level roles.',
			},
			header: { title: 'Roles', breadcrumbs: { label: 'Roles & Permissions', to: ROLES_MANAGEMENT_PATH } },
			noData: 'There are no roles here!',
			loading: 'Loading Roles...',
			table: {
				subject: 'roles',
				filters: {
					search: {
						placeholder: 'Search by Name',
					},
					type: {
						default: 'Default',
						custom: 'Custom',
					},
					categories: {
						roleTypeFilter: {
							title: 'TYPE',
							options: { default: 'Default Role', custom: 'Custom Role' },
						},
					},
				},
				columns: {
					id: 'ID',
					roleName: 'Role Name',
					type: 'Type',
					activeUsersCount: 'Active Employees',
					modified: 'Modified',
				},
				moreMenuOptions: {
					[MoreMenuEnumRole.EDIT]: 'Edit Role',
					[MoreMenuEnumRole.DUPLICATE]: 'Duplicate Role',
					[MoreMenuEnumRole.DELETE]: 'Delete Role',
					[MoreMenuEnumRole.RESET]: 'Reset Role',
				},
				roleTypeLabels: {
					default: 'Default Role',
					custom: 'Custom Role',
					modified: 'Modified',
				},
				tablesActions: {
					createRole: 'Create a role',
				},
			},
			role: {
				header: {
					title: 'Role Profile',
					breadcrumb: {
						label: 'Role Profile',
						to: CURRENT_PAGE,
					},
				},
				profile: {
					roleDetails: {
						title: 'Role Details',
						details: {
							name: 'Name',
							description: 'Description',
						},
					},
					permissions: {
						title: 'Permissions',
						permissionList: {
							title: 'Permissions List',
							searchPlaceholder: 'Search by Permission Name',
						},
					},
					successMessage: 'Role profile has been updated successfully!',
				},
			},
			createRole: {
				tabs: {
					details: 'Main Details',
					permissions: 'Permissions',
					assignedEmployees: 'Assigned Employees',
				},
				createSuccessMessage: 'Role has been created successfully!',
				editSuccessMessage: 'Role has been updated successfully!',
				roleDetails: {
					title: 'Role Details',
					name: 'Role Name',
					about: 'About Role',
					resetRole: {
						button: 'Reset Role to Default',
						confirmation: {
							dialog: {
								title: 'Reset Role to Default',
								message:
									'Are you sure you want to reset this role to its default settings? This will restore the default name, description, and permissions, and any custom changes will be lost.',
								confirmButtonText: 'RESET',
							},
							onSuccessMessage: 'Role has been reset to default successfully!',
						},
					},
				},
				permissions: {
					title: 'Permissions',
					permissionList: {
						title: 'Permissions List',
						searchPlaceholder: 'Search by Permission Name',
					},
					activateAll: 'Activate all',
					activateAllInGroup: (groupTitle: string) => `Activate all ${groupTitle.toLowerCase()}`,
					noPermissionsSet: {
						title: 'No Permissions Set',
						message:
							'No permissions have been set for this role. Assigned users won’t be able to access the Back Office. Are you sure you want to proceed without permissions?',
						confirmButtonText: "YES, I'M SURE",
					},
				},
				header: {
					title: 'Role Profile',
					breadcrumbs: {
						label: 'Role Profile',
						to: CURRENT_PAGE,
					},
				},
				duplicateDefaultName: (name: string) => `Copy - ${name}`,
				permissionsGroups: [
					{
						title: 'CALENDAR PERMISSIONS',
						permissions: [
							{
								name: 'View Calendar Events',
								description: 'Access the calendar to view events',
							},
							{
								name: 'Book Reservations',
								description: 'Create new reservations, including both customer and internal types',
							},
						],
					},
					{
						title: 'RENTAL PERMISSIONS',
						permissions: [
							{
								name: 'View Reservations',
								description: 'View rentals reservations',
							},
							{
								name: 'Manage Reservations',
								description: 'Edit or delete rental slots, add segments, and manage add-ons',
							},
							{
								name: 'Edit Reservation Slot Notes',
								description:
									'Allows to edit the notes for reservation slots without altering other reservation details',
							},
							{
								name: 'Manage Rental Products',
								description: 'Create, edit, or delete rental products',
							},
						],
					},
					{
						title: 'PROGRAMS PERMISSIONS',
						permissions: [
							{
								name: 'View & Sell Programs',
								description: 'View programs, sessions, and sell associated products',
							},
							{
								name: 'Manage Programs',
								description: 'Create and edit programs, session details, schedules, and spaces',
							},
							{
								name: 'Publish Programs',
								description: 'Publish or unpublish programs and sessions',
							},
							{
								name: 'Manage Program Products',
								description: 'Create, edit or delete products for programs',
							},
							{
								name: 'View & Manage Program Waitlist',
								description: 'View, add, register, and remove participants from session waitlists',
							},
							{
								name: 'Email Program Attendees',
								description: 'Send emails to attendees registered in programs directly from the program module',
							},
							{
								name: 'Check-In Participants',
								description: 'Check in participants in programs events',
							},
						],
					},
					{
						title: 'CUSTOMER PERMISSIONS',
						permissions: [
							{
								name: 'View Customers Accounts',
								description: 'Access customer profiles and their account details',
							},
							{
								name: 'Manage Due Dates',
								description: 'Allows setting, editing, or removing due dates on invoices',
							},
							{
								name: 'Process Refunds & Voids',
								description: 'Process refunds or voids specific items',
							},
							{
								name: 'Apply Discounts',
								description: 'Apply custom or promotional discounts to invoices',
							},
							{
								name: 'Set Scheduled Payments',
								description: 'Configure scheduled payments on invoices',
							},
							{
								name: 'Remove Payment Methods',
								description: 'Delete saved payment methods from a customer’s account',
							},
							{
								name: 'Merge Customers',
								description: 'Allows to merge customers.',
							},
							{
								name: 'Manage customer profiles',
								description: 'Allows staff to edit customer profile details on behalf of the customer.',
							},
						],
					},
					{
						title: 'MEMBERSHIP PERMISSIONS',
						permissions: [
							{
								name: 'View & Sell Memberships',
								description: 'View membership details and process membership sales',
							},
							{
								name: 'Manage Memberships',
								description: 'Create or edit memberships',
							},
							{
								name: 'Pause Memberships',
								description: 'Pause active memberships temporarily',
							},
							{
								name: 'Manage Membership Members',
								description: 'Cancel memberships and manage members in family memberships',
							},
						],
					},
					{
						title: 'COMMERCE PERMISSIONS',
						permissions: [
							{
								name: 'View & Sell Commerce Products',
								description: 'Access the commerce module and sell products',
							},
							{
								name: 'Manage Commerce Products',
								description: 'Create, edit, or delete products and add-ons',
							},
						],
					},
					{
						title: 'PAYMENT PERMISSIONS',
						permissions: [
							{
								name: 'Create or Add to Invoices',
								description:
									'Create new invoices from the cart, or add items to an existing invoice from the cart or invoice page',
							},
							{
								name: 'Process Transactions With Card Terminal',
								description: 'Take payments from the cart or invoice using "Card Terminal" payment method',
							},
							{
								name: 'Process Transactions With Card',
								description: 'Take payments from the cart or invoice using "Card" payment method',
							},
							{
								name: 'Process Transactions With ACH',
								description: 'Take payments from the cart or invoice using "ACH" payment method',
							},
							{
								name: 'Process Transactions With Check',
								description: 'Take payments from the cart or invoice using "Check" payment method',
							},
							{
								name: 'Process Transactions With Cash',
								description: 'Take payments from the cart or invoice using "Cash" payment method',
							},
							{
								name: 'Process Transactions With Credit Balance',
								description: 'Take payments from the cart or invoice using "Balance" payment method',
							},
							{
								name: 'Process Transactions With Gift Card',
								description: 'Take payments from the cart or invoice using "Gift Card" payment method',
							},
							{
								name: 'Process Transactions With Other',
								description: 'Take payments from the cart or invoice using "Other" payment method',
							},
						],
					},
					{
						title: 'COMMUNICATION PERMISSIONS',
						permissions: [
							{
								name: 'Manage Communication',
								description:
									'Access the communication module to send blast emails and manage transactional notifications',
							},
						],
					},
					{
						title: 'FORMS PERMISSIONS',
						permissions: [
							{
								name: 'Forms Management',
								description: 'Can create and edit forms attached to registrations',
							},
						],
					},
					{
						title: 'SETTINGS PERMISSIONS',
						permissions: [
							{
								name: 'View Settings',
								description: 'View organization settings',
							},
							{
								name: 'View & Manage Employees',
								description:
									'Access employees profiles and perform actions like creating, editing, or deactivating accounts',
							},
							{
								name: 'View & Manage Roles',
								description: 'Access roles to create, edit, assign, or delete roles and manage associated permissions',
							},
							{
								name: 'View & Manage Taxes',
								description: 'Access taxes to create, edit, or delete organization taxes',
							},
							{
								name: 'View & Manage Payment Processing',
								description:
									'Access Payment Processing under Settings > Finance to connect a processor, assign facilities, resume onboarding, and update bank details',
							},
							{
								name: 'View & Manage Accounting Codes',
								description: 'Allows to view, add, edit, and delete accounting codes.',
							},
							{
								name: 'View & Manage Discounts',
								description: 'Allows to view, add, edit, and delete discount groups and promo codes.',
							},
							{
								name: 'Manage tips settings',
								description: 'Allows configuring how tips are presented and applied during checkout.',
							},
						],
					},
					{
						title: 'TERMINAL SETTINGS PERMISSIONS',
						permissions: [
							{
								name: 'Manage Terminal Settings',
								description: 'Access the terminal settings to manage payment method capture',
							},
							{
								name: 'Override Terminal Card Storage',
								description: 'Override the card storage settings for the terminal',
							},
						],
					},
					{
						title: 'REPORTING PERMISSIONS',
						permissions: [
							{
								name: 'Manage Reporting',
								description: 'Access the reporting module to view reports',
							},
						],
					},
					{
						title: 'MARKETING PERMISSIONS',
						permissions: [
							{
								name: 'View Marketing Analytics',
								description: 'View Google Analytics and Google Tag Manager settings',
							},
							{
								name: 'Edit Marketing Analytics',
								description: 'Edit Google Analytics and Google Tag Manager settings',
							},
						],
					},
					{
						title: 'HISTORY',
						permissions: [
							{
								name: 'View History',
								description:
									"View the organization's audit trail (History) — who changed a record, when, and what it was before",
							},
						],
					},
				],
			},
			deleteRole: {
				noUserAttached: {
					dialog: {
						title: 'Delete Role',
						message:
							'Deleting this role will erase all details and configured permissions. Are you sure you want to delete?',
						confirmButtonText: 'YES, DELETE',
					},
					successMessage: 'Role has been deleted successfully!',
				},
				withUsersAttached: {
					dialog: {
						title: 'Delete Role',
						message:
							'Deleting this role may leave some employees without a role, restricting their access to the Back Office. Are you sure you want to continue?',
						confirmButtonText: 'YES, DELETE',
					},
					successMessage: 'Role has been deleted successfully!',
				},
			},
			assignEmployees: {
				assignPopup: {
					title: 'Select Employees',
					helperLabel1: "Can't find who you're looking for?",
					helperLabel2: 'Create a new employee ',
					helperLabelButton: 'here.',
					alreadyAssigned: 'Already Assigned to this role',
					inactiveEmployeeAdditionalRow: 'Inactive',
					confirmButtonText: 'ASSIGN',
					cancelButtonText: 'CANCEL',
					placeholder: 'Search by Name',
					notification: {
						success: 'Employee(s) were assigned to the role.',
						error: 'Failed to assign employee(s).',
					},
				},
				reassignPopup: {
					title: 'Reassign Employees',
					message1: 'Select one or more roles from the dropdown below to',
					message2: 'reassign the selected employee(s)',
					placeholder: 'Select roles...',
					confirmButtonText: 'REASSIGN',
					cancelButtonText: 'CANCEL',
					notification: {
						success: 'Employee(s) were reassigned to the selected roles',
						error: 'Failed to reassign employee(s)',
					},
				},
				removePopup: {
					title: 'Remove Employees from Role',
					message:
						'The selected employee(s) will lose this role’s permissions and may no longer have access to the Back Office. Are you sure you want to proceed with their removal?',
					confirmButtonText: 'YES, REMOVE',
					cancelButtonText: 'CANCEL',
					notification: {
						success: 'Employee(s) successfully removed!',
						error: 'Error: Employee(s) failed to remove. Please try again later.',
						failedToRemoveRolesApiError: 'Failed to remove roles - api error',
					},
				},
				rowActions: {
					reassign: 'Reassign',
					removeFromRole: 'Remove from Role',
				},
				instructors: {
					navigateToInstructors: 'Go to instructor resource page for complete instructor setup',
				},
				tableActions: {
					assign: 'Assign Employees',
					reassign: 'Reassign Employees',
					remove: 'Remove Employees',
					disableReassign:
						'Bulk reassign is disabled for the Instructor role.\nYou can reassign employees individually',
					disableRemove: 'Bulk removal is disabled for the Instructor role.\nYou can remove employees individually',
				},
			},
		},
		organizationTaxes: {
			header: {
				title: 'Taxes',
				breadcrumb: {
					label: 'Taxes',
					to: `${TAXES_PATH}/${OrganizationTaxesTabsEnum.TAX_RATES}`,
				},
			},
			tabs: {
				[OrganizationTaxesTabsEnum.TAX_RATES]: 'Tax Rates',
				[OrganizationTaxesTabsEnum.CATEGORY_TAX_DEFAULTS]: 'Category Tax Defaults',
			},
			categoryTaxDefaults: {
				categories: {
					[ProductTypesEnum.RESERVATION]: 'Rentals',
					[ProductTypesEnum.REGISTRATION]: 'Programs',
					[ProductTypesEnum.MEMBERSHIP]: 'Memberships',
					[ProductTypesEnum.GOODS]: 'Commerce',
					[ProductTypesEnum.PACKAGE]: 'Packages',
				},
				setDefaultCategoryTax: {
					title: 'Changes to Default Tax',
					message:
						'You’re updating the default tax for this category. New products will use the new setting. If you update all products, only those using the current default will change. Custom taxes stay the same, and past invoices won’t be affected.',
					newProductsOnly: 'New Products Only',
					updateAllProducts: 'Update All Products',
					successMessage: 'Default category tax has been set successfully!',
					successMessageWithoutDialog:
						'Default tax set. New products in this category will now include this tax by default.',
				},
				currentlyActiveTaxes: (count: number) => `${count} activated`,
			},
			table: {
				actions: {
					create: 'Create Tax',
				},
				subject: 'taxes',
				moreMenuOptions: {
					activate: 'Activate Tax',
					edit: 'Edit Tax',
					deactivate: 'Deactivate Tax',
					delete: 'Delete Tax',
				},
				columns: {
					name: 'Name',
					rate: 'Rate',
					calculationType: 'Calculation Type',
					productsAssigned: 'Products Assigned',
					updatedAt: 'Updated',
					status: 'Status',
				},
				filters: {
					calculationType: {
						all: 'All',
						exclusive: 'Exclusive',
						inclusive: 'Inclusive',
					},
					status: {
						all: 'All',
						active: 'Active',
						inactive: 'Inactive',
					},
				},
				defaultTaxesLabel: (types?: ProductTypesEnum[]) => (types?.length ? `Default in ${types.join(', ')}` : ''),
			},
			actions: {
				deleteTaxes: {
					confirmation: {
						title: 'Taxes In Use',
						message:
							'The tax is currently assigned to products. If you delete it, the tax will be removed from all assigned products, it will no longer be available for future use, and past invoices that used this tax will remain unchanged.',
						confirmButtonText: 'DELETE TAX',
					},
					successMessage: 'Taxes have been deleted successfully!',
				},
				taxDeactivation: {
					dialog: {
						title: 'Deactivate Tax',
						message:
							'You’re deactivating this tax. It can’t be used for new products going forward. If you choose to update existing products, the tax will be removed from those using it. Past invoices won’t be affected.',
						newProductsOnly: 'NEW PRODUCTS ONLY',
						updateAllProducts: 'UPDATE ALL PRODUCTS',
					},
					successMessage: 'Tax has been deactivated successfully!',
				},
				taxActivation: {
					successMessage: 'Tax has been activated successfully!',
				},
			},
		},
		accountingCodes: {
			header: {
				title: 'Accounting Codes',
				breadcrumb: {
					label: 'Accounting Codes',
					to: ACCOUNTING_CODES_PATH,
				},
			},
			table: {
				actions: {
					create: 'Create Accounting Code',
					massApply: 'Edit where codes apply',
				},
				subject: 'accounting codes',
				loadingMessage: 'Loading accounting codes...',
				noDataMessage: 'No matching accounting codes found. Try adjusting your filters or adding a new one.',
				errorMessage: 'Failed to load accounting codes. Please refresh the page or try again later.',
				moreMenuOptions: {
					edit: 'Edit Code',
					duplicate: 'Duplicate Code',
					activate: 'Activate Code',
					deactivate: 'Deactivate Code',
					delete: 'Delete Code',
				},
				columns: {
					code: 'Code',
					type: 'Type',
					category: 'Category',
					resourcesAssigned: 'Resources Assigned',
					updatedAt: 'Updated',
					status: 'Status',
				},
				filters: {
					status: {
						active: 'Active',
						inactive: 'Inactive',
					},
				},
			},
			actions: {
				activateSuccess: 'Accounting code activated successfully!',
				deactivateSuccess: 'Accounting code deactivated successfully!',
				deleteSuccess: 'Accounting code deleted successfully!',
			},
			deleteConfirmation: {
				title: 'Accounting Code In Use',
				message: (resourcesCount: number) =>
					`This accounting code is currently assigned to ${resourcesCount} resources.\nDeleting it will remove the code from all associated\nresources. Are you sure you want to proceed?`,
				confirmButtonText: 'DELETE ACCOUNTING CODE',
			},
			massEditApplyTo: {
				title: 'Can Apply To',
				description: 'Choose where the selected accounting code can be applied.',
				confirmButtonText: 'APPLY',
				cancelButtonText: 'CANCEL',
				successMessage: 'Accounting code applied successfully!',
				allOption: {
					label: 'All',
					value: null,
				},
			},
		},
		entitlementGroups: {
			header: {
				title: 'Discount Groups',
				breadcrumb: {
					label: 'Discount Groups',
					to: ENTITLEMENT_GROUPS_PATH,
				},
			},
			table: {
				actions: {
					create: 'Create Discount Group',
				},
				strings: {
					subject: 'discount groups',
					loadingMessage: 'Loading discount groups...',
					noDataMessage: 'No matching discount groups found. Try adjusting your filters or adding a new one.',
					errorMessage: 'Failed to load discount groups. Please refresh the page or try again later.',
				},
				moreMenuOptions: {
					edit: 'Edit Group',
					associatedProducts: 'View Assigned Products',
					activate: 'Activate Group',
					deactivate: 'Deactivate Group',
				},
				columns: {
					id: 'ID',
					name: 'Name',
					type: 'Type',
					productsCount: '# Products',
					status: 'Status',
				},
				filters: {
					type: {
						membership: 'Membership',
						question: 'Question',
						externalValidation: 'External validation',
					},
					status: {
						active: 'Active',
						inactive: 'Inactive',
					},
				},
			},
			activateConfirmation: {
				title: 'Activate Discount Group',
				message: 'Activating this discount group will apply its value to assigned to products at checkout.',
				confirmButtonText: 'ACTIVATE',
			},
			deactivateConfirmation: {
				title: 'Deactivate Discount Group',
				message:
					'Deactivating this discount group will leave it assigned to products but its value will not apply at checkout',
				confirmButtonText: 'DEACTIVATE',
			},
			actions: {
				onStatusChange: (name: string) => `${name} status updated!`,
			},
			form: {
				title: 'Discount Groups Profile',
				submitButton: 'SAVE',
				tabs: { mainDetails: 'Main Details', assignedProducts: 'Assigned Products' },
				mainDetailsCard: { title: 'Main Details' },
				sections: {
					generalInformation: 'General Information',
					assignment: 'Assignment',
				},
				fields: {
					name: { label: 'Group Name' },
					type: { label: 'Group Type' },
					assignment: {
						[ResourceNameTypeEnum.MEMBERSHIP]: { label: 'Memberships' },
						[EXTERNAL_VALIDATION_TERMS_TYPE]: { label: 'Providers' },
					},
					discountPercent: {
						label: 'Discount',
						tooltip:
							'This is the default % assigned to rental products using this group. It can be overridden at the product level.',
					},
				},
				discountChangeDialog: {
					title: 'Update Discount',
					description:
						'You can update all products using this discount group in future purchases (not past invoices), or use this value for only new products assigned to the group going forward.',
					primaryButton: 'UPDATE ALL',
					secondaryButton: 'ONLY NEW',
					cancelButton: 'CANCEL',
				},
				success: {
					create: (name: string) => `${name} created!`,
					update: (name: string) => `${name} updated!`,
				},
				productsTable: {
					strings: {
						subject: 'assigned products',
						loadingMessage: 'Loading assigned products...',
						noDataMessage: 'No assigned products found.',
						errorMessage: 'Failed to load assigned products. Please refresh the page or try again later.',
					},
					columns: {
						name: 'Name',
						type: 'Type',
						price: 'Price',
						discount: 'Discount',
						actions: 'Actions',
					},
					filters: {
						type: {
							[ProductTypesEnum.RESERVATION]: 'Rental',
							[ProductTypesEnum.REGISTRATION]: 'Program',
							[ProductTypesEnum.FOLDERED_REGISTRATION]: 'League',
						},
					},
					moreMenuOptions: {
						removeDiscount: 'Remove Discount',
					},
					removeDiscountConfirmation: {
						title: 'Remove Discount',
						message: 'Are you sure you want to remove this discount? This action cannot be undone.',
						confirmButtonText: 'REMOVE',
					},
					removeDiscountSuccess: 'Discount removed successfully',
				},
				membershipGatingOptions: {
					additionalInfo: (price: number, currency: CurrencySymbolEnum) =>
						`${CHARACHERS.DASH} ${Pricify(price, currency)}`,
					additionalRowInfo: (resourceType: MembershipTypeEnum, customerTypes: CustomerTypeEnum[]) =>
						`${customerTypes.map(capitalizeFirstLetter).join(', ')} - ${MEMBERSHIP_TYPE_LABELS[resourceType]}`,
				},
			},
		},
		instructors: {
			header: {
				title: 'Instructors',
				breadcrumb: {
					label: 'Instructors',
					to: INSTRUCTORS_PAGE,
				},
			},
			noDataPage: {
				title: 'There are no instructors yet!',
				description: 'Start adding instructors',
				createButton: 'create instructor profile',
			},
			table: {
				actions: {
					createInstructor: 'Create Instructor',
					search: {
						placeholder: 'Search',
					},
					filters: {
						categories: {
							instructorStatus: {
								title: 'INSTRUCTOR STATUS',
								options: { [ActivityEnum.ACTIVE]: 'Active', [ActivityEnum.INACTIVE]: 'Inactive' },
							},
							facility: 'FACILITY',
							activity: 'ACTIVITY',
							bookableOnline: {
								yes: 'Yes',
								no: 'No',
							},
						},
					},
				},
				subject: 'instructors',
				columns: {
					id: 'ID',
					firstName: 'First Name',
					lastName: 'Last Name',
					email: 'Email',
					status: 'Status',
					facilities: 'Facilities',
					activities: 'Activities',
					referenceId: 'Ref ID',
					isBookableOnline: 'Available Online',
				},
				rowActionsPopup: {
					[RowActionsEnum.EDIT]: { label: 'Edit Instructor Details' },
					status: {
						[RowActionsEnum.ACTIVATE]: {
							label: 'Activate Instructor',
							successMessage: 'Instructor has been activated!',
						},
						[RowActionsEnum.DEACTIVATE]: {
							label: 'Deactivate Instructor',
							successMessage: 'Instructor has been deactivated!',
						},
					},
					[RowActionsEnum.EDIT_EMPLOYEE]: { label: 'Edit Employee Details' },
					errorMessage:
						'Cannot activate this instructor. The associated employee may be inactive or missing the instructor role. Please check the employee profile.',
				},
				activities: {
					viewMore: (count: number) => `+${count} more`,
				},
			},
			profile: {
				header: {
					title: 'Instructor Profile',
					breadcrumb: {
						label: 'Instructor Profile',
						to: CURRENT_PAGE,
					},
					tabs: (isCreate: boolean) => ({
						'general-settings': {
							label: 'General Settings',
						},
						products: {
							label: 'Products',
							isDisabled: isCreate,
						},
						'online-profile': {
							label: 'Online Profile',
							isDisabled: true,
						},
					}),
				},
				generalSettings: {
					mainDetails: {
						title: 'main details',
						employeeSelect: { label: 'Employee', placeholder: 'Select' },
						createEmployee: {
							description: 'Can’t find who you’re looking for? Create a new employee ',
							link: 'here',
						},
						editEmployee: {
							link: 'Go to employee settings',
						},
						details: [
							{ key: EmployeeFieldsEnum.firstName, label: 'First Name' },
							{ key: EmployeeFieldsEnum.lastName, label: 'Last Name' },
							{ key: EmployeeFieldsEnum.phoneNumber, label: 'Phone Number' },
							{ key: EmployeeFieldsEnum.email, label: 'Email' },
						],
					},
					schedule: {
						title: 'FACILITIES & SCHEDULE',
						info: 'Set your instructor’s schedule for all or select facilities.',
					},
					employeeNoAccess: 'Employee does not have access to this facility',
					sucssesMessage: {
						create: 'Instructor has been successfully created!',
					},
					warningDescription: `Removing a facility will block the instructor's availability for corresponding bookings and registrations for this facility. Existing sessions and bookings will not be affected. Are you sure you want to continue?`,
				},
				products: {
					instructionDetails: {
						title: 'INSTRUCTION DETAILS',
						activities: {
							tooltip: `Select the activities this instructor offers. These activities will determine the services and programs they can be booked for.  If you don't see an expected activity, please ensure it is set up at the selected facilities.`,
							warningDescription: `Removing an activity will block the instructor's availability for corresponding bookings and registrations for this activity. Existing sessions and bookings will not be affected. Are you sure you want to continue?`,
						},
						programTypes: {
							tooltip:
								'Select the program types this instructor teaches for each activity. This enables the instructor to be assigned to these programs.',
						},
						rentalProducts: {
							tooltip:
								'Select rental products to enable bookings for this instructor from the back office. To also allow this instructor to be booked online for these products, toggle the “allow online booking” switch to green.  If you don’t see a rental product, then make sure both the product and instructor are enabled for the selected facilities and activities',
						},
						isBookableOnline: 'Instructor can be booked online ',
						warningDescription: `Removing an activity, program type or rental product will block the instructor's availability for corresponding bookings and registrations for this activity / program type. Existing sessions and bookings will not be affected. Are you sure you want to continue?`,
					},
				},
				successMessage: 'Instructor profile has been updated successfully!',
			},
		},
	},
	rentalProducts: {
		profile: {
			header: {
				title: 'Product Profile',
				breadcrumb: {
					label: 'Product Profile',
					to: '#',
				},
				tabs: (isCreate: boolean) => ({
					'general-settings': {
						label: 'General Settings',
					},
					pricing: {
						label: 'Pricing',
						isDisabled: isCreate,
					},
					'online-settings': {
						label: 'Online Settings',
						isDisabled: isCreate,
					},
				}),
			},
			onlineSettings: {
				mainDetails: {
					title: 'Main Details',
					onlineBookingEnabled: 'Available for online booking',
					onlineProductName: {
						label: 'Online Product Name',
						helper: 'This is the name displayed when booking this product online',
					},
					fixOnlineDuration: {
						label: 'Fix online duration',
						tooltip: "When selected, customers booking this product online can only book the product's duration amount",
					},
					productPhoto: {
						label: 'Product Photo',
						altLabel: 'product',
						removeLabel: 'Remove photo',
					},
				},
				onlineSchedule: {
					title: 'Online Schedule',
					addSchedule: 'Add New Online Schedule',
					helper:
						'By default, products will be available as long as the resource is available. Add a custom schedule here if you want to further restrict the availability of this product for online booking.',
					overlappingError: 'Schedules overlap. Please review and adjust your schedule settings.',
				},
				successMessage: {
					create: 'Online settings saved successfully!',
					update: 'Online settings updated successfully!',
				},
			},
			generalSettings: {
				mainDetails: {
					title: 'Main Details',
					productName: 'Product Name',
					tooltips: {
						facilitiesTooltip:
							'Editing your selections will clear activities and resources, and you will need to re-select them',
						activitiesTooltip: 'Editing your selections will clear resources, and you will need to re-select them',
					},
					about: {
						label: 'About Product',
					},
				},
				resourceAssignment: {
					title: 'Resource Assignment',
					spaces: { helper: 'If you can’t find a space you want, make sure you’ve selected the correct facilities.' },
					instructors: {
						helper: 'If you can’t find a instructor you want, make sure you’ve selected the correct facilities.',
						spaceWithInstructors:
							'These instructors cannot be booked online. They are assigned to this product for internal tracking purposes only.',
						instructorRequired:
							'This category is set up for instructor bookings. At least one instructor is required for this product.',
					},
					invalidResourcesModal: {
						title: 'Configuration Mismatch',
						description: (invalidResources: InvalidResourceDto[]) => {
							const groupedByReason = groupBy(invalidResources, resource =>
								resource.reasonType === InvalidResourceReasonsEnum.FACILITY ? 'facility' : 'activity'
							);

							return Object.entries(groupedByReason)
								.map(([reason, resources]) => {
									const verb = resources.length === 1 ? 'is' : 'are';
									return `${resources
										.flatMap(resource => resource.name)
										.join(', ')} ${verb} not available at the ${reason} level.`;
								})
								.join('\n');
						},
					},
				},
			},
			pricing: {
				title: 'Pricing',
				duration: { title: 'Duration' },
				defaultPricing: {
					title: 'Default Pricing',
					pricingSettingsError:
						'Changing the price type has caused a conflict with your current settings. Please review and update your pricing configuration.',
					priceType: {
						title: 'Price Type',
						tooltip: {
							main: 'Price type determines how customers are charged for reservations. For standard rentals, choose Rental. To charge each participant, select Price per Participant. For a set number participants under one invoice with a set price, choose Group.',
							additionalInfo:
								'Leave the default rate blank if you want this product to be available ONLY during the scheduled price times',
						},
						priceType: 'Price Type',
						rentalPrice: 'Rental Price',
						priceCannotBeLessThanDeposit:
							'Price cannot be less than the deposit. Please update either the price or the deposit amount.',
						pricePerRental: { label: 'Price per Rental', rentalPrice: 'rental Price' },
						pricePerParticipant: 'Price per Participant',
						pricePerGroup: 'Price per Group',
					},
					participantAddition: {
						title: 'Participant Addition',
						tooltip:
							'Participant Addition setting allows staff to exceed maximum capacity for a group or private lesson',
						dont: 'Don’t Allow Extra Participants (above max.)',
						allow: 'Allow Extra Participants (above max.)',
					},
					taxSettings: { title: 'Tax Settings' },
				},
				validation: {
					rentalPriceMustExceedDeposit: (deposit: number, currency: CurrencySymbolEnum) =>
						`Rental price must be greater than the booking deposit (${Pricify(deposit, currency)}).`,
				},
			},
			addons: {
				title: 'ADD-ONS',
				addon: 'Add-on',
				placeholder: 'Select',
				staleAddonWarning: 'Selected addon is not available for selected facilities.',
				staleAddonsError: 'Selected addons do not match selected facilities.',
				level: 'Price per (hour, slot, reservation)',
				priceRelation: {
					label: 'Price per',
					hourly: 'Hour',
					slot: 'Slot',
					reservation: 'Reservation',
				},
				price: 'price',
				addAddon: 'Add another add-on',
				removeAddon: 'Remove add-on',
			},
			sucssesMessage: {
				create: 'Rental Product has been successfully created!',
				edit: 'Rental Product has been updated successfully!',
			},
			entitlements: {
				title: 'Discounts',
				validation: {
					invalidValue: 'Invalid value',
				},
				labels: {
					groups: 'Membership',
					discount: 'Discount',
					add: 'Add a Membership Discount',
					remove: 'Remove',
					status: {
						[ActivityEnum.ACTIVE]: 'Active',
						[ActivityEnum.INACTIVE]: 'Inactive',
					},
					noticeLabel: (items: IOption[]): string => {
						return `${items.map(item => item.label).join(', ')} ${items.length > 1 ? 'are' : 'is'} inactive`;
					},
				},
			},
		},
		passes: {
			title: 'Pass Profile',
			breadcrumb: 'Passes',
			toasts: {
				created: 'Rental pass created successfully!',
				updated: 'Rental pass updated successfully!',
			},
			pricing: {
				title: 'Pricing',
				defaultPricing: 'Default Pricing',
				quantitySettings: 'Quantity Settings',
				duration: 'Duration',
				passPrice: 'Pass Price',
				tax: 'Tax',
				settings: {
					title: 'Fixed',
					subTitle: '(Set a defined time frame for punch pass use)',
					totalQuantity: {
						label: 'Total Quantity',
						tooltip: 'The total number of punches that can be used on the pass',
					},
					timeUnitSelection: {
						placeholder: 'Select',
						options: [
							{ label: 'Day', value: TimeUnit.DAY },
							{ label: 'Week', value: TimeUnit.WEEK },
							{ label: 'Month', value: TimeUnit.MONTH },
							{ label: 'Year', value: TimeUnit.YEAR },
						],
					},
					expiration: {
						label: 'Expiration',
						tooltip: 'The expiration date of the pass',
					},
					quantityLimit: {
						label: 'Quantity Limit',
						tooltip: 'The maximum number of punches that can be used on the pass',
					},
					forEvery: 'for every',
				},
			},
			onlineSettings: {
				mainDetails: {
					onlineProductName: 'Online Pass Name',
				},
			},
			editConfirmation: {
				title: 'Save Changes',
				description:
					'Changes to this pass will apply to future purchases only. Existing passes already sold will keep their current settings.',
				cancel: 'Cancel',
				save: 'Save',
			},
		},
	},
	existingReservation: {
		singleEdit: {
			title: 'You’re about to edit a reservation event',
			successMessage: 'The event was edited',
			productUpdateError: 'The event could not be updated with the new product. Please try again or contact support.',
			selectAction: {
				title: 'Edit event',
				subtitle: 'Would you like to edit the event?',
				description: 'Approving these changes will update the event and adjust the associated price.',
				descriptionIncrease: 'The difference in price will be added to the invoice.',
				descriptionDecrease: 'The difference in price will be removed from the invoice.',
				panel: { items: 'items', item: 'item' },
				customError: `We could not process the refund for the price difference automatically. Please contact ${SUPPORT_EMAIL} to complete the refund.`,
				backToEdit: 'Back to editing',
				current: 'ADD TO CURRENT INVOICE',
				multiple: 'ADD TO EXISTING INVOICE',
				order: 'Add to order',
				dismiss: 'Dismiss',
				confirm: 'CONFIRM CHANGES',
				approve: 'APPROVE',
				refund: 'CONTINUE TO REFUND',
				originalTotal: 'Original total price was',
				purchaseOrder: 'The selected event currently has a status of order',
				newTotal: 'Total price changed to',
				totalRemove: 'Total price to remove',
				totalAdd: 'Total price to add',
				couldNotRefundTitle: 'This event could not be refunded',
				couldNotRefundMessage: `We could not process the refund for the price difference automatically. Please contact ${SUPPORT_EMAIL} to complete the refund.`,
			},
		},
		massEdit: {
			successMessage: 'The events were edited',
			editSlotsModal: {
				title: {
					firstPart: 'You’re about to edit',
					secondPart: 'slots from this reservation',
					withCount: (count: number): string => `You’re about to edit ${count} slots from this reservation`,
				},
				description: {
					orderStatus: 'Confirming changes will replace the existing data with the changes you’ve made.',
					financialChanges:
						'Confirming changes will replace the existing data with the changes you’ve made. There was a financial difference that needed to be reduce from the invoice.',
					noFinancialChanges:
						'Confirming changes will replace the existing data with the changes you’ve made. There was no financial difference that needed to be done from the invoice.',
				},
				financialDetails: {
					originalInvoice: {
						part1: 'Original invoice is',
						part2: {
							refund: ' Total amount to refund',
							append: ' Total added amount',
							void: ' Total reduce amount',
						},
						summaryWithPrices: (originalPrice: string, secondLabel: string, secondPrice: string): string =>
							`Original invoice is ${originalPrice}. ${secondLabel} ${secondPrice}`,
					},
					totalPrice: 'Total price of the invoice',
					totalPriceWithAmount: (amount: string): string => `Total price of the invoice ${amount}`,
				},
				mainAction: {
					withRefund: 'continue to refund',
					noRefund: 'Confirm changes',
				},
				secondButton: 'View changes',
				subButton: 'Dismiss',
			},
			successModal: {
				title: 'Edit Events',
				description: 'The reservation events were changed successfully',
				mainAction: 'approve',
				secondButton: 'View invoice',
			},
		},
	},
	filterPaymentMethods: {
		balance: 'Credit Balance',
		[PaymentMethodTypeEnum.ACH]: 'ACH',
		card: 'Card on File',
		cash: 'Cash',
		check: 'Check',
		other: 'Other',
		[PaymentMethodTypeEnum.CARD_ON_TERMINAL]: 'Card Terminal',
		migrated: 'Migrated',
		[PaymentMethodTypeEnum.GIFT_CARD]: 'Gift Card',
		[PaymentMethodTypeEnum.LOST_DEBT]: 'Lost Debt',
		[PaymentMethodTypeEnum.NOT_SET]: 'Not Set',
	},
	chooseInvoice: {
		title: 'Select Invoice',
		customer: 'Customer',
		goBack: 'Go back',
		addToInvoice: 'Add to Invoice',
		subject: 'Invoices',
		incompatibleBankAccountTooltip:
			"You can't add to this invoice — it pays out to a different bank account than the items already on it. Select another invoice, or create a new one.",
		notConnectedBankAccountTooltip:
			"The facility doesn't have a connected processor yet, so its items can't be charged. Connect it in Settings > Payment Processing.",
		formatters: {
			customerContact: (email: string, phoneNumber: string) => `${email} ${phoneNumber}`,
			itemsAddedHeading: (invoiceId: number) => `Items added to invoice #${invoiceId}`,
		},
		addedItemsColumnTitle: 'Added Items',
	},
	financialImplications: {
		approveButton: 'APPROVE',
		dismissButton: 'Dismiss',
		confirm: 'CONFIRM CHANGES',
		approve: 'APPROVE',
		refund: 'CONTINUE TO REFUND',
		descriptionWithPrice: (subtitle: string, formattedPrice: string) => `${subtitle} ${formattedPrice}`,
		totalPunchesReturn: 'Total punches to return',
		totalPunchesRedeem: 'Total punches to redeem',
	},
	deleteEvent: {
		slot: {
			financialImplications: {
				action: {
					title: 'Delete Event Completed',
					subtitle: 'Total price of deleted event is',
					description:
						'This event was deleted from the reservation. In order to complete this process, please select one of the following options',
					pricingSummary: {
						descriptionIncrease: 'The difference in price will be added to the invoice.',
						descriptionDecrease: 'The difference in price will be removed from the invoice.',
						originalTotal: 'Original total price was',
						purchaseOrder: 'The selected event is in order status',
						newTotal: 'Total price changed to',
						totalRemove: 'Total price to remove',
						totalAdd: 'Total price to add',
					},
				},
				fail: {
					title: 'This action could not be finished',
					description: `The action could not be completed. Please try again, or contact ${SUPPORT_EMAIL} if the problem continues.`,
					buttonText: 'APPROVE',
				},
			},
			successModal: {
				refund: {
					title: 'Delete event completed',
					description: 'Invoice line item was deleted',
					buttonText: 'APPROVE',
				},
				voidItem: {
					title: 'Invoice line item was voided',
					description: 'The invoice will remain with a balance of',
					descriptionWithBalance: (remainingBalance: string) =>
						`The invoice will remain with a balance of ${remainingBalance}`,
					buttonText: 'APPROVE',
				},
				leaveBalance: {
					title: 'The invoice will remain with the previous balance',
					description: 'The deleted event had a sum of',
					descriptionWithBalance: (remainingBalance: string) => `The deleted event had a sum of ${remainingBalance}`,
					buttonText: 'APPROVE',
				},
			},
			failureModal: {
				title: 'This action could not be finished',
				message: `The action could not be completed. Please try again, or contact ${SUPPORT_EMAIL} if the problem continues.`,
			},
		},
	},
	allocations: {
		panel: {
			title: 'Add space allocations',
			SELECT: {
				subtitle: 'Select all ~ events', // replace ~ with number of events
			},
			INDIVIDUAL: {
				subtitle: 'Individually',
			},
			COLLECTIVELY: {
				subtitle: 'Collectively',
			},
			footerButtons: {
				cancel: 'CANCEL',
				next: 'NEXT',
			},
			filters: {
				attendanceOptions: ['With attendance', 'Without attendance'],
				sections: [/*'Segment',*/ 'Month', 'Day', 'Attendance'],
			},
		},
		eventCard: {
			attending: 'Attending',
			attendingCount: (count: number) => `${count} Attending`,
		},
	},
	discardAllocationModal: {
		title: 'Discard changes?',
		description: 'The changes you have made will be discarded',
		mainActionButtonText: 'DISCARD',
		cancelButtonText: 'Dismiss',
	},
	confirmationModal: {
		title: 'You are about to edit ~ from this session', // replace ~ with 'X event(s)'
		description: "Confirming changes will replace the existing data with the changes you've made",
		mainActionButtonText: 'CONFIRM CHANGES',
		cancelButtonText: 'Dismiss',
	},
	massEditModal: {
		title: 'Add Resource',
	},
	massAllocationPanel: {
		notificationSuccessMsg: 'Events allocated successfully!',
		conflictCheckErrorMsg: 'Events allocated successfully, but conflicts could not be checked.',
	},
	questionnaires: {
		createSuccess: 'Questionnaire saved successfully',
		createError: 'The questionnaire could not be saved. Please check your questions and try again.',
		updateSuccess: 'Questionnaire updated successfully',
		updateError: 'The questionnaire could not be updated. Please check your changes and try again.',
		loadError: 'Error while loading form',
		invalidFormId: 'This form id is invalid.',
		unsupportedQuestionType: 'This form contains a question type that cannot be edited.',
		organizationAccessDenied: 'You do not have access to this form.',
		management: {
			header: {
				title: 'Forms',
			},
			table: {
				subject: 'forms',
				columns: {
					title: 'Form Title',
					id: 'Form ID',
					createdAt: 'Created Date',
				},
				actions: {
					create: 'Create Form',
					edit: 'Edit Form',
					duplicate: 'Duplicate Form',
					preview: 'Preview Form',
					retry: 'Retry',
				},
				searchPlaceholder: 'Search',
				states: {
					loading: 'Loading forms...',
					empty: 'No forms have been created yet.',
					noSearchResults: 'No forms match your search.',
					error: 'Forms could not be loaded. Please try again.',
				},
			},
		},
		editor: {
			createTitle: 'CREATE QUESTIONNAIRE',
			editTitle: 'EDIT QUESTIONNAIRE',
			setUpCustomApplicationForm: 'SET UP YOUR CUSTOM APPLICATION FORM',
			questionnaireTitle: 'QUESTIONNAIRE TITLE',
			questionDescription:
				'Use the toggles to choose which questions appear on your form. Drag and drop to change the order. Mark questions as mandatory or optional, and add custom questions if needed.',
			complete: 'COMPLETE',
			organizationQuestions: {
				waiver: 'WAIVER',
				addMandatoryWaiverSigningStep: 'Add a mandatory waiver signing step.',
				waiverSigning: 'WAIVER SIGNING',
				questions: 'QUESTIONS',
				defaultQuestionDescription:
					'Use the toggles to choose which questions appear on your form. Drag and drop to change the order. Mark questions as mandatory or optional, and add custom questions if needed.',
				makeMandatory: 'Make Mandatory',
				deleteQuestion: 'Delete Question',
				questionTypes: {
					tShirtSize: 'T-SHIRT SIZE',
					phoneNumber: 'PHONE NUMBER',
					emailAddress: 'EMAIL ADDRESS',
					address: 'ADDRESS',
					dateOfBirth: 'DATE OF BIRTH',
					preferredTeam: 'PREFERRED TEAM',
					termsAndConditions: 'TERMS AND CONDITIONS',
					customQuestions: 'CUSTOM QUESTIONS',
				},
				questionDescriptions: {
					tShirtSize: 'Customer will choose a T-Shirt size from these options - XS, S, M, L, XL, XXL, XXXL',
					phoneNumber: 'Customer will be asked to provide a phone number',
					emailAddress: 'Customer will be asked to provide an email address',
					address: 'Customer will be asked to provide a home address',
					dateOfBirth: 'Customer will be asked to provide a date of birth',
					termsAndConditions: 'Customer will be asked to agree to the terms and conditions',
					preferredTeam:
						'Customer will be able to select a preferred team from the list of teams you created. In the case none exist in your rosters, this question will not be displayed',
				},
				questionType: 'Question Type',
				freeText: 'Free Text',
				yesNoQuestion: 'Yes / No question',
				multipleChoice: 'Multiple Choice',
				singleChoice: 'Single Choice',
				numeric: 'Numeric',
				date: 'Date',
				uploadFile: 'Upload File',
				waiverOption: 'Waiver',
				question: 'Question',
				limitAnswerTo: 'Limit answer to',
				characters: 'Characters',
				singleSelectYesNo: 'Customer will have a single select option between Yes and No',
				multipleSelectOptions: 'Customer will have a multiple select option between the following',
				singleSelectOptions: 'Customer will have a single select option between the following',
				addAnswerOption: (maximumOptions: number): string => `ADD ANSWER OPTION (up to ${maximumOptions} options)`,
				numberRange: 'Customer will choose a number in following range',
				to: 'TO',
				fileUpload: 'Customer will upload a file',
				addCustomQuestion: 'ADD CUSTOM QUESTION',
			},
		},
	},
	venuePackageCard: {
		assignedTo: 'Assigned To',
		duration: {
			halfHour: '1/2 hour',
			oneHour: '1 hour',
			oneAndHalfHours: '1.5 hours',
			twoHours: '2 hours',
			minutes: (duration: number): string => `${duration} minutes`,
		},
		size: {
			quarter: 'Quarter',
			third: 'Third',
			half: 'Half',
			full: 'Full',
		},
		price: (price: number): string => `$${price}`,
	},
	glCodes: {
		errorFetching: 'We could not load the accounting codes. Please refresh the page or try again.',
		other: 'Other',
		noSessionAccountingCodes:
			'There are no accounting codes in this session.\nYou can edit the basic info to add accounting codes.',
	},
	selectPayingCustomer: {
		selectedCustomer: 'Selected Customer',
		title: 'Select Paying Customer',
		description: 'Would you like to charge this customer \n or a member of their linked accounts?',
		invalidSelectedCustomerInfo:
			'One or more customers in this cart are not linked to the cart owner.\n To continue this purchase, select a new customer to charge.',
		actionButtonText: 'Continue',
		subButtonText: 'cancel',
	},
	paymentStatusToColorMapper: {
		[PaymentStatusEnum.FULLY_PAID]: TagColorsMapper.green.primary,
		[PaymentStatusEnum.NOT_PAID]: TagColorsMapper.red.primary,
		[PaymentStatusEnum.PARTIAL_PAYMENT]: TagColorsMapper.yellow.primary,
		[PaymentStatusEnum.VOID]: TagColorsMapper.liteGray.primary,
		[PaymentStatusEnum.REFUNDED]: TagColorsMapper.turquoise.primary,
		[PaymentStatusEnum.PENDING]: TagColorsMapper.yellow.primary,
		[PaymentStatusEnum.DISPUTED]: TagColorsMapper.orange.primary,
		chargeback: TagColorsMapper.red.primary,
	},
	paymentStatusToLabelMapper: {
		[PaymentStatusEnum.FULLY_PAID]: 'Paid',
		[PaymentStatusEnum.NOT_PAID]: 'Unpaid',
		[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partially Paid',
		[PaymentStatusEnum.VOID]: 'Void',
		[PaymentStatusEnum.REFUNDED]: 'Refunded',
		[PaymentStatusEnum.PENDING]: 'Pending',
		[PaymentStatusEnum.DISPUTED]: 'Disputed',
		chargeback: 'Chargeback',
		[FuturePaymentStatusEnum.PAST_DUE]: 'Unpaid',
	},
	paymentsTableLabelMapper: {
		[PaymentStatusEnum.FULLY_PAID]: 'Paid',
		[PaymentStatusEnum.NOT_PAID]: 'Failed',
		[PaymentStatusEnum.PARTIAL_PAYMENT]: 'Partially Paid',
		[PaymentStatusEnum.REFUNDED]: 'Refunded',
		[PaymentStatusEnum.VOID]: 'Void',
		[PaymentStatusEnum.PENDING]: 'Pending',
		[PaymentStatusEnum.DISPUTED]: 'Disputed',
		chargeback: 'Chargeback',
	},
	richTextEditor: {
		mediaAllowedCaption: 'Supported image file types: JPG, PNG, Gif, Webp, Tiff',
		uploadImageError: 'Error uploading image',
		pasteLimitReachedWarning: 'You have reached the maximum character limit; not all content was pasted.',
		pasteExceedsLimitError: 'Pasting this content exceeds the maximum character limit.',
	},
	notifications: {
		errorBoundary: {
			fallbackHeadline: 'Something went wrong !!!',
		},
		page: {
			headline: 'Communications',
			tabs: {
				blasts: {
					title: 'Blasts',
					blastFlowButtonCopy: 'Create New Message',
					blastFlow: {
						title: 'Message Recipient Group',
						subtitle: 'Select the desired category of customers you would like to send your message to.',
						options: {
							customers: {
								title: 'Customers',
							},
							leagues: {
								title: 'Leagues',
							},
						},
					},
					customerBlastPage: {
						title: 'New Customer Blast',
						querySection: {
							title: 'Customers',
							sendToAllLabel: 'Send this message to all customers across the organization',
							personalDetailsSectionTitle: 'Personal Details',
							genderSectionTitle: 'Gender',
							genderInputPlaceholder: 'Gender',
							ageSectionTitle: 'Age',
							ageInputPlaceholder: 'Age',
							birthdaySectionTitle: 'Birthday Range',
							monthInputPlaceholder: 'Month',
							dayInputPlaceholder: 'Day',
							familyDetailsSectionTitle: 'Family Details',
							userRoleInputPlaceholder: 'User Role (primary, dependent, independent)',
						},
						selectedParametersSection: {
							title: 'Selected Parameters',
							allCustomers: 'All Customers',
							noneSelectedLabel: 'No parameters have been selected',
							gender: 'Gender',
							ageRange: 'Age Range',
							anyAge: 'any age',
							ageRangeTag: (lowerBound: string, upperBound: string): string => `${lowerBound} - ${upperBound}`,
							birthdayRange: 'Birthday Range',
							birthdayRangeTag: (startMonth: string, startDay: number, endMonth: string, endDay: number): string =>
								`${startMonth} ${startDay} - ${endMonth} ${endDay}`,
							userRole: 'User Role',
							clearButtonText: 'clear',
						},
						createNotificationSection: {
							title: 'Message Content',
						},
						smartFieldsSection: {
							title: 'Smart Fields',
							placeholder: 'TODO - actual smart fields (they do work! try adding {{first_name}} in your email body)',
						},
						previewSection: {
							title: 'Preview',
							placeholder: 'TODO - a preview with the smart tags filled in using some test data',
						},
					},
					leagueBlastPage: {
						title: 'New League Blast',
					},
				},
				settings: {
					title: 'Automated Messages',
					outboundPreferencesButtonCopy: 'Predefined Automated Messages',
					outboundPreferences: {
						title: 'Predefined Automated Messages',
						status: {
							enabled: 'Active',
							disabled: 'Inactive',
							n_a: 'N/A',
						},
						searchPlaceholder: 'Search',
						indexTable: {
							columnTitles: {
								category: 'Category',
								message: 'Message Title',
								externalEmailStatus: 'External Email',
								internalEmailStatus: 'Internal Email',
							},
							templateGroupToTitles: {
								//CUSTOMER ACCOUNT
								customer_account_bond_welcome: {
									category: 'Bond Customer Account',
									message: 'Welcome Message',
								},
								customer_account_setup: {
									category: 'Login / Signup',
									message: 'Customer Invite',
								},
								employee_account_setup: {
									category: 'Login / Signup',
									message: 'Employee Invite',
								},
								customer_account_family_welcome: {
									category: 'Family Account',
									message: 'Welcome Message',
								},
								//MEMBERSHIP
								membership_registration_confirmation: {
									category: 'Membership',
									message: 'Registration Confirmation',
								},
								membership_renewal_failed: {
									category: 'Membership',
									message: 'Renewal Failed',
								},
								membership_renewal_confirmation: {
									category: 'Membership',
									message: 'Renewal Confirmation',
								},
								//REGISTRATION
								registration_program_season_confirmation: {
									category: 'Registration',
									message: 'Program Registration Confirmation',
								},
								registration_league_program_season_confirmation: {
									category: 'Registration',
									message: 'League / Tournament Registration Confirmation',
								},
								punch_pass_redemption: {
									category: 'Registration',
									message: 'Punch Pass Redemption',
								},
								registration_event_change: {
									category: 'Registration',
									message: 'Event Change',
								},
								session_available_spots: {
									category: 'Session',
									message: 'Available Spots in Session',
								},
								//LEAGUE
								league_captain_join_confirmation: {
									category: 'League',
									message: 'Player Join Confirmation - Sent to Captain',
								},
								league_user_join_confirmation: {
									category: 'League',
									message: 'Player Join Confirmation - Sent to User',
								},
								league_user_invite: {
									category: 'League',
									message: 'Player Invite',
								},
								//RESERVATION
								reservation_update: {
									category: 'Reservation',
									message: 'Reservation Updated',
								},
								//FINANCE
								finance_installment_retry: {
									category: 'Finance',
									message: 'Installment Retry',
								},
								finance_installment_failed: {
									category: 'Finance',
									message: 'Installment Failed',
								},
								finance_payment_receipt: {
									category: 'Finance',
									message: 'Payment Receipt',
								},
								finance_payment_request: {
									category: 'Finance',
									message: 'Payment Request',
								},
								finance_send_invoice: {
									category: 'Finance',
									message: 'Send Invoice',
								},
								finance_invoice_published: {
									category: 'Finance',
									message: 'Invoice Published',
								},
								finance_payment_past_due: {
									category: 'Finance',
									message: 'Future Installment is Past Due',
								},
								finance_invoice_past_due: {
									category: 'Finance',
									message: 'Invoice Past Due',
								},
								ach_payment_failed: {
									category: 'Finance',
									message: 'ACH Payment Failed',
								},
								//PAUSE/RESUME
								membership_pause: {
									category: 'Membership',
									message: 'Pause Membership',
								},
								resume_membership_pause: {
									category: 'Membership',
									message: 'Membership Resumed',
								},
								booking_confirmation: {
									category: 'Reservation',
									message: 'Booking Confirmation',
								},
								booking_rejected: {
									category: 'Reservation',
									message: 'Booking Declined',
								},
								booking_approved: {
									category: 'Reservation',
									message: 'Booking Approved',
								},
								booking_requested: {
									category: 'Reservation',
									message: 'Booking Requested',
								},
								waitlist_confirmation: {
									category: 'Waitlist',
									message: 'Waitlist Confirmation',
								},
							},
							templateKeyToStatusColumnId: {
								//CUSTOMER ACCOUNT
								welcome_to_family_account: 'externalEmailStatus',
								welcome_to_bondsports: 'externalEmailStatus',
								invite_customer: 'externalEmailStatus',
								invite_employee: 'externalEmailStatus',
								//MEMBERSHIP
								admin_membership_registration_confirmation: 'internalEmailStatus',
								user_membership_registration_confirmation: 'externalEmailStatus',
								admin_renew_membership_failed: 'internalEmailStatus',
								consumer_renew_membership_confirmation: 'externalEmailStatus',
								//REGISTRATION
								admin_program_season_registration_confirmation: 'internalEmailStatus',
								user_program_season_registration_confirmation: 'externalEmailStatus',
								user_league_program_season_registration_confirmation: 'externalEmailStatus',
								admin_league_program_season_registration_confirmation: 'internalEmailStatus',
								event_change_consumer_notify: 'externalEmailStatus',
								session_available_spots_admin: 'internalEmailStatus',
								punch_pass_redemption_admin: 'internalEmailStatus',
								punch_pass_redemption_customer: 'externalEmailStatus',
								//LEAGUE
								captain_team_join_confirmation: 'externalEmailStatus',
								user_team_join_confirmation: 'externalEmailStatus',
								user_team_invite: 'externalEmailStatus',
								//RESERVATION
								reservation_update_notify: 'externalEmailStatus',
								booking_confirmation_admin: 'internalEmailStatus',
								booking_confirmation_consumer: 'externalEmailStatus',
								booking_rejected_admin: 'internalEmailStatus',
								booking_rejected_customer: 'externalEmailStatus',
								booking_approved_admin: 'internalEmailStatus',
								booking_approved_customer: 'externalEmailStatus',
								booking_requested_admin: 'internalEmailStatus',
								booking_requested_customer: 'externalEmailStatus',
								//FINANCE
								future_installment_retry_processing_notify_customer: 'externalEmailStatus',
								future_installment_failed_notify_customer: 'externalEmailStatus',
								consumer_payment_receipt: 'externalEmailStatus',
								payment_request_admin: 'internalEmailStatus',
								payment_request_user: 'externalEmailStatus',
								send_invoice_to_user: 'externalEmailStatus',
								invoice_published: 'externalEmailStatus',
								past_due_payment_admin: 'internalEmailStatus',
								past_due_payment_customer: 'externalEmailStatus',
								past_due_invoice_admin: 'internalEmailStatus',
								past_due_invoice_customer: 'externalEmailStatus',
								ach_payment_failed_admin: 'internalEmailStatus',
								ach_payment_failed_customer: 'externalEmailStatus',
								//PAUSE/RESUME
								pause_resume_admin: 'internalEmailStatus',
								pause_resume_user: 'externalEmailStatus',
								pause_user: 'externalEmailStatus',
								admin_pause_user: 'internalEmailStatus',
								// WAITLIST
								waitlist_confirmation_admin: 'internalEmailStatus',
								waitlist_confirmation_user: 'externalEmailStatus',
							},
						},
						edit: {
							title: (a: string, b: string) => `${a}: ${b}`,
							saveSuccessful: 'Message has been successfully updated!',
							enabledToggle: 'Activate',
							revert: {
								buttonCopy: 'Revert to original',
								confirmationDialog: {
									title: 'Revert to Original?',
									description: 'You will lose any changes you have made.  Are you sure you want to revert?',
									mainButtonText: 'Yes, Revert',
									cancelButtonText: 'No',
								},
							},
							composer: {
								toEmailsInsideLeftLabel: 'To: Triggered Recipients',
								submitButtonText: 'Save Changes',
							},
							smartFields: {
								title: 'Smart Fields',
							},
							preview: {
								title: 'Preview',
							},
						},
						leaveConfirmationDialog: {
							title: 'Discard Changes?',
							description:
								'Leaving this tab without saving it will undo any changes you made.  Are you sure you want to leave?',
							mainButtonText: 'Yes, Discard & Leave',
							cancelButtonText: 'No, Stay',
						},
					},
				},
			},
		},
		leaveConfirmationDialog: {
			title: 'Are You Sure?',
			description:
				'If you leave now, your information will not be saved.  Are you sure you want to discard this message?',
			mainButtonText: 'Yes, Discard',
			cancelButtonText: 'No, Stay',
		},
		configModal: {
			title: 'Message Recipient Group',
			subtitle: 'Select the groups you would like to send your message to.',
			actionButton: 'Next',
			cancelButton: 'Cancel',
			pastEventsLabel: 'Participants of past events in selected session(s)',
			currentAndFutureEventsLabel: 'Participants of current / future events in selected session(s)',
		},
		modalCopy: {
			title: 'New Message',
			subtitle: 'This message will be sent to all participants of the selected events',
		},
		folderModalCopy: {
			title: 'New Message',
			subtitle: 'This message will be sent to all selected participants.',
		},
		folderToCopy: {
			toUserAndMoreParticipants: (userName: string, participantCount: number) =>
				`To: ${userName} + ${participantCount - 1} more participants`,
			toParticipants: (participantCount: number) => `To: ${participantCount} participants`,
			toParticipantsInFolders: (folderCount: number) => `To: All participants in ${folderCount} folders`,
		},
		defaultFromDisplayName: 'no-reply',
		fromEmail: (displayName?: string) => {
			const fromEmailAddress = 'no-reply@mailer.bondsports.co';
			return displayName ? `"${displayName}" <${fromEmailAddress}>` : fromEmailAddress;
		},
		forms: {
			subjectLine: {
				eventTitleWithDateTime: (title: string, date: string, time: string) => `${title} - ${date} - ${time}`,
				sessionAndEventTitle: (sessionName: string, eventTitle: string) => `${sessionName}, ${eventTitle}`,
			},
			labels: {
				to: (attendeeCount: number) => `To: ${attendeeCount} ${attendeeCount > 1 ? 'attendees' : 'attendee'}...`,
				toIsTooLarge: (max: String) =>
					`Too many recipients. The maximum supported is ${max}. Please narrow your audience filters and send in separate batches.`,
				toAtLeast: (attendeeCount: number) => `To: ${Math.max(1, attendeeCount)}+ attendees...`,
				toAll: 'To: All attendees of all selected events...',
				expandSection: (sectionTitle: string) => `Expand ${sectionTitle}`,
				collapseSection: (sectionTitle: string) => `Collapse ${sectionTitle}`,
				cc: 'CC:',
				bcc: 'BCC:',
				subject: 'Subject:',
				replyTo: 'Reply To:',
				from: 'From: ',
				body: '',
				logoToggle: 'Add logo',
				commercialMessageToggle: 'This is a promotional message.',
			},
			helpers: {
				to: 'Add additional email addresses separated by commas',
			},
			placeholders: {
				replyTo: 'Please select an email address',
			},
			ctas: {
				send: 'Send',
				cancel: 'Cancel',
				showCC: '+CC',
				showBCC: '+BCC',
				next: 'Next',
				back: 'Back',
			},
			errorMessages: {
				needValidEmailString: 'Please enter valid email addresses, separated by commas.',
				needValidEmail: 'must be a valid email address',
				requiredWhenNoAttendees: 'A "To" address is required when there are no attendees in the selected events.',
				requiredWhenCcBccPresent: 'A "To" address is required when CC or BCC is provided.',
				required: 'This field is required.',
			},
		},
		api: {
			errorPartial: (succeeded: number, failed: number) =>
				`We sent ${succeeded} of ${succeeded + failed} messages successfully. ${failed} could not be delivered. Please check the recipients and try resending.`,
			errorAll: `No messages were sent. Please check your internet connection and try again. If the problem continues, contact ${SUPPORT_EMAIL}.`,
			success: 'Message has been sent to all selected participants!',
			successButZeroRecipients: 'There were no recipients to send to.',
			successWithBackgroundSend: (approximate: number) => `Sending ${approximate} messages in the background...`,
			noRecipientsFromQuery: {
				message: 'The parameters selected did not match any customers.',
				tryAgainText: 'Please try again with different parameters.',
			},
		},
		interpolations: {
			errorBadTag: 'Bad Tag: ',
			errorSyntax: "There is an error in the template. Look for unclosed curly braces, like '{{'.",
			// additional "ghost" example data that is not included with the InsertableContent
			exampleData: {
				segments: [
					{
						name: 'First Segment',
						start_day_date: 'Thursday, February 22nd, 2024',
						start_time: '4:20 am',
						end_day_date: 'Thursday, February 22nd, 2024',
						end_time: '5:20 am',
						starts_ends_same_day: true,
					},
					{
						name: 'Second Segment',
						start_day_date: 'Thursday, February 29nd, 2024',
						start_time: '4:20 am',
						end_day_date: 'Thursday, February 29th, 2024',
						end_time: '5:20 am',
						starts_ends_same_day: true,
					},
				],
				events: [
					{
						space_name: 'First Space',
						start_time: '4:20 am',
						start_day_date: 'Thursday, February 29nd, 2024',
						end_day_date: 'Thursday, February 29th, 2024',
						end_time: '5:20 am',
						starts_ends_same_day: true,
					},
					{
						space_name: 'Second Space',
						start_time: '4:20 am',
						start_day_date: 'Thursday, February 29nd, 2024',
						end_day_date: 'Thursday, February 29th, 2024',
						end_time: '5:20 am',
						starts_ends_same_day: true,
					},
				],
				groups: [
					{
						group_name: 'U10 Boys',
						group_type: 'Team',
						parent_group_name: 'Division A',
						parent_group_type: 'Division',
					},
				],
				changes: [
					{
						field_label: 'Name',
						old_value: 'John Smith',
						new_value: 'Jane Smith',
					},
					{
						field_label: 'Email',
						old_value: 'old@example.com',
						new_value: 'new@example.com',
					},
				],
				global_digital_identifier_image_url:
					'https://res.cloudinary.com/rcenter/image/upload/v1754427852/twf3oriog87dpmwhj41f.png',
			},
		},
	},
	replaceFlow: {
		header: {
			header: 'Change Payment Method',
			body: 'Select new payment method',
			subText: 'Notice! Some payment methods may include a transaction fee.',
		},
		success: {
			header: 'Payment Method Changed',
			body: 'Your payment method has been successfully updated.\nAll future charges for this purchase will be billed to:',
			button: 'Done',
		},
	},
	directImageUploader: {
		defaultUploadCta: 'Browse or Take a Photo',
		browseToUploadImage: 'Browse to upload an image',
		uploadPictureAriaLabel: 'upload picture',
		removeCoverImageAriaLabel: 'Remove cover image',
	},
	faq: {
		linkTitle: 'FAQ document',
		shortTitle: 'FAQs',
	},
	validations: {
		familyAccountIdNotFound: `Failed to add member to the family account. Please try again or contact ${SUPPORT_EMAIL}.`,
		duplicateEmail: 'This email already exists',
		invalidTime: 'Invalid time',
		pastTimeError: 'Time cannot be in the past',
		notBeforeTimeErrorMessage: 'Cannot be before the start time.',
		overlappingQuantity: 'Must be greater than the previous maximum value.',
		maxSmallerThenMin: 'Must be equal to or greater than the minimum value.',
		mustBeLargerThan: (min: number) => `must be greater than or equal to ${min}`,
		required: 'required',
		dateValidation: {
			startDatePast: 'Start date cannot be in the past',
			endDatePast: 'End date cannot be in the past',
			startAfterEnd: 'Start date must be before end date',
			endMustBeAfterStart: 'End date must be after start date',
			invalidDate: 'Invalid date',
		},
	},
	hyphen: '-',
	parentheses: (string: string) => `(${string})`,
	withTrailingComma: (value: string) => `${value},`,
	formatDateRange: (startDate: string, endDate: string) => `${startDate} - ${endDate}`,
	formatWithHyphen: (str1: string, str2: string) => `${str1} - ${str2}`,
	formatWithSpace: (str1: string, str2: string) => `${str1} ${str2}`,
	joinWithComma: (items: string[]) => items.join(','),
	joinWithCommaAndSpace: (items: string[]) => items.join(', '),
	formatPercentageRounded: (value: number) => `${Math.round(value)}%`,
	formatWithTrailingHyphen: (str: string) => `${str} -`,
	formatWithSlash: (str1: string, str2: string) => `${str1}/${str2}`,
	userIdentification: {
		scanSuccessIdentifierMiss: code =>
			`No customer found for this code. Please try again or search for the customer manually.`,
	},
	context: {
		organization: { errorMessage: 'Something went wrong. Please refresh the page and try again.' },
	},
	tax: 'Tax',
	scheduleString: (startDate: string, startTime: string, endDate: string, endTime: string) =>
		`${startDate} (${startTime}) - ${endDate} (${endTime})`,
	formatId: (id: number) => `#${id}`,
	forceRefresh: {
		title: 'New Version Available',
		description: 'For the best experience, please refresh the page to continue with the latest updates.',
		primaryActionLabel: 'Refresh Now',
	},
	xmore: (count: number) => `+${count} more`,
	contactSupport: {
		label: 'contact support',
		placeholder: '{contact support}',
	},
	duplicateDefaultPrefix: (name: string) => `Copy - ${name}`,
	authentication: {
		login: {
			email: 'Email',
			password: 'Password',
			forgotPassword: 'Forgot your password?',
			linkText: "Don't have an account?",
			linkButton: 'Sign up here',
			submit: 'Sign In',
			title: 'Log in to Bond Sports',
			separator: 'Or Use',
			tosText: 'By continuing, you agree to Bond Sports',
			tosButton: 'Terms of Service',
			incorrectEmailOrPasswordError: 'Incorrect Email Or Password!',
			errors: {
				[QueryParamsErrorCodesEnum.UNAUTHORIZED]:
					'Access to Back Office is invite-only. Please contact your manager to get started!',
			},
		},
		resetPassword: {
			title: 'Reset Password',
			resetMessage: (maskedEmail: string) => {
				return `We’ve sent a password reset code to ${maskedEmail}. Enter it below to reset your password.`;
			},
			code: 'Code',
			newPassword: 'New Password',
			repeatPassword: 'Enter New Password Again',
			submit: 'Change Password',
			sendNewCodeMessage: 'Haven’t received a code?',
			sendNewCodeButton: 'Send new code',
			repeatPasswordErrorMessage: 'Passwords do not match!',
			passwordErrors: {
				length: 'Password must be at least 8 characters long',
				uppercase: 'Password must contain an uppercase letter',
				lowercase: 'Password must contain a lowercase letter',
				number: 'Password must contain a number',
			},
		},
		chooseEmail: {
			title: 'Reset Password',
			subtitle: 'Forgot your password? Enter your email below and we will send you a code to reset your password.',
			submit: 'Send me a code',
			noLinkButton: 'Back to login',
			label: 'Email',
		},
		changePassword: {
			title: 'Change Password',
			subtitle: 'Please enter your new password below.',
			passwordLabel: 'New Password',
			repeatPasswordLabel: 'Confirm New Password',
			submit: 'Change Password',
			passwordDidNotMatch: 'Passwords do not match!',
			passwordErrors: {
				length: 'Password must be at least 8 characters long',
				uppercase: 'Password must contain an uppercase letter',
				lowercase: 'Password must contain a lowercase letter',
				number: 'Password must contain a number',
			},
		},
		signup: {
			email: 'Email',
			password: 'Password',
			linkText: 'Already have an account?',
			linkButton: 'login here',
			submit: 'Sign Up',
			title: 'Sign Up for Bond Sports',
			separator: 'Or Use',
			tosText: 'By continuing, you agree to Bond Sports',
			tosButton: 'Terms of Service',
			firstName: 'First Name',
			lastName: 'Last Name',
			passwordErrors: {
				length: 'Password must be at least 8 characters long',
				uppercase: 'Password must contain an uppercase letter',
				lowercase: 'Password must contain a lowercase letter',
				number: 'Password must contain a number',
			},
		},
		confirm: {
			subtitle: 'We sent a code to your email. Enter the code here to confirm your account.',
			title: 'Verify Email',
			label: 'Verification Code',
			submit: 'Confirm Account',
			sendNewCodeMessage: 'Haven’t received a code?',
			sendNewCodeButton: 'Send new code',
		},
	},
};

export type TranslationKeys = typeof TranslationEn;
